/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * Fiddy API
 * Documentation interne — **nesso dev only**.

## Auth

Deux headers requis sur tous les endpoints protégés :
- `Authorization: Bearer <JWT>` — obtenu via `POST /auth` (expire après 30 min, refresh via `POST /auth/refresh`)
- `App-Id: <workspace_app_id>`

## Conventions

- Pagination : `data[]` + objet `pagination`
- Erreurs : schéma `HttpError` (`code` + `message`)
- Validation : `422` avec tableau `violations`

## Docs

- Accéder à [Swagger](/)
- Accéder à [Scalar](/scalar)

 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

/**
 * Creates a user token.
 * @summary Login
 */
export const loginCheckPostHeader = zod.object({
  "App-Id": zod.string()
})

export const loginCheckPostBody = zod.object({
  "email": zod.string(),
  "password": zod.string()
})

export const loginCheckPostResponse = zod.object({
  "token": zod.string(),
  "refreshToken": zod.string(),
  "refreshTokenExpiresAt": zod.number()
})


/**
 * Extract token from magic link and provide token
 * @summary Autologin via magic link token
 */
export const postAuthAutologinHeader = zod.object({
  "App-Id": zod.string()
})

export const postAuthAutologinBody = zod.object({
  "token": zod.string().describe('One-time token received by email (magic link)')
})

export const postAuthAutologinResponse = zod.object({
  "token": zod.string(),
  "refreshToken": zod.string(),
  "refreshTokenExpiresAt": zod.number()
})


/**
 * Refresh token
 * @summary Refresh token
 */
export const postAuthRefreshHeader = zod.object({
  "App-Id": zod.string()
})

export const postAuthRefreshBody = zod.object({
  "refreshToken": zod.string()
})

export const postAuthRefreshResponse = zod.object({
  "token": zod.string(),
  "refreshToken": zod.string(),
  "refreshTokenExpiresAt": zod.number()
})


/**
 * Add log to Sentry
 * @summary Add log to Sentry
 */
export const postLogsBody = zod.object({
  "message": zod.string()
})


/**
 * Handle help request & send email
 * @summary Handle help request
 */
export const postHelpBody = zod.object({
  "message": zod.string(),
  "reason": zod.string()
})


/**
 * Ask for a password reset
 * @summary Ask for a password reset
 */
export const postForgotPasswordHeader = zod.object({
  "App-Id": zod.string(),
  "FP-provider": zod.string().optional()
})

export const postForgotPasswordBody = zod.object({
  "email": zod.string()
})


/**
 * Validate token
 * @summary Validate token
 */
export const getForgotPasswordParams = zod.object({
  "tokenValue": zod.string()
})

export const getForgotPasswordHeader = zod.object({
  "FP-provider": zod.string().optional()
})

export const getForgotPasswordResponse = zod.object({
  "user": zod.object({
  "id": zod.number(),
  "email": zod.string()
}),
  "expired": zod.boolean()
})


/**
 * Submit new password
 * @summary Submit new password
 */
export const postForgotPasswordTokenParams = zod.object({
  "tokenValue": zod.string()
})

export const postForgotPasswordTokenHeader = zod.object({
  "FP-provider": zod.string().optional()
})

export const postForgotPasswordTokenBodyPlainPasswordRegExp = new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d).+$');


export const postForgotPasswordTokenBody = zod.object({
  "plainPassword": zod.string().regex(postForgotPasswordTokenBodyPlainPasswordRegExp)
})


/**
 * Get api public tokens of the current user
 * @summary Get api public tokens of the current user
 */
export const apiAdminapitokensGetCollectionResponseNameMin = 3;
export const apiAdminapitokensGetCollectionResponseNameMax = 100;



export const apiAdminapitokensGetCollectionResponseItem = zod.object({
  "id": zod.number().describe('Api Token ID'),
  "name": zod.string().min(apiAdminapitokensGetCollectionResponseNameMin).max(apiAdminapitokensGetCollectionResponseNameMax).describe('Name of the token'),
  "createdAt": zod.string().datetime({}).describe('Date and time when the token was created')
})
export const apiAdminapitokensGetCollectionResponse = zod.array(apiAdminapitokensGetCollectionResponseItem)


/**
 * Create a new api public token
 * @summary Create a new api public token
 */
export const apiAdminapitokensPostBodyNameMin = 3;
export const apiAdminapitokensPostBodyNameMax = 100;



export const apiAdminapitokensPostBody = zod.object({
  "name": zod.string().min(apiAdminapitokensPostBodyNameMin).max(apiAdminapitokensPostBodyNameMax).describe('Name of the token')
})


/**
 * Delete an api public token
 * @summary Delete an api public token
 */
export const apiAdminapitokensIdDeleteParams = zod.object({
  "id": zod.string().describe('ApiToken identifier')
})


/**
 * Create a booster on the current workspace
 * @summary Create a booster
 */
export const apiAdminboostersPostBodyTitleMax = 255;

export const apiAdminboostersPostBodyBoosterReferencesItemMinQuantityDefault = 1;
export const apiAdminboostersPostBodyBoosterReferencesItemMinQuantityMin = 0;

export const apiAdminboostersPostBodyBoosterReferencesItemMaxQuantityMin = 0;

export const apiAdminboostersPostBodyBoosterReferencesItemCoefficientMin = 0;



export const apiAdminboostersPostBody = zod.object({
  "title": zod.string().max(apiAdminboostersPostBodyTitleMax).describe('Title of the booster'),
  "description": zod.string().nullish().describe('Description of the booster'),
  "startDate": zod.string().datetime({}).describe('Start date of the booster'),
  "endDate": zod.string().datetime({}).describe('End date of the booster'),
  "boosterReferences": zod.array(zod.object({
  "reference": zod.string().describe('Boosted reference'),
  "minQuantity": zod.number().min(apiAdminboostersPostBodyBoosterReferencesItemMinQuantityMin).default(apiAdminboostersPostBodyBoosterReferencesItemMinQuantityDefault).describe('Minimum cumulated quantity (included) from which the coefficient applies'),
  "maxQuantity": zod.number().min(apiAdminboostersPostBodyBoosterReferencesItemMaxQuantityMin).nullish().describe('Maximum cumulated quantity (included) up to which the coefficient applies, null for no upper bound'),
  "coefficient": zod.number().min(apiAdminboostersPostBodyBoosterReferencesItemCoefficientMin).describe('Points multiplier applied on quantities of this tier, 0 gives no boosted points')
})).optional()
})


/**
 * Delete a booster. Only boosters that have not started yet can be deleted.
 * @summary Delete a booster
 */
export const apiAdminboostersIdDeleteParams = zod.object({
  "id": zod.string().describe('Booster identifier')
})


/**
 * Update a booster
 * @summary Update a booster
 */
export const apiAdminboostersIdPatchParams = zod.object({
  "id": zod.string().describe('Booster identifier')
})

export const apiAdminboostersIdPatchBodyTitleMax = 255;

export const apiAdminboostersIdPatchBodyBoosterReferencesItemMinQuantityDefault = 1;
export const apiAdminboostersIdPatchBodyBoosterReferencesItemMinQuantityMin = 0;

export const apiAdminboostersIdPatchBodyBoosterReferencesItemMaxQuantityMin = 0;

export const apiAdminboostersIdPatchBodyBoosterReferencesItemCoefficientMin = 0;



export const apiAdminboostersIdPatchBody = zod.object({
  "title": zod.string().max(apiAdminboostersIdPatchBodyTitleMax).optional().describe('Title of the booster'),
  "description": zod.string().nullish().describe('Description of the booster'),
  "startDate": zod.string().datetime({}).optional().describe('Start date of the booster'),
  "endDate": zod.string().datetime({}).optional().describe('End date of the booster'),
  "boosterReferences": zod.array(zod.object({
  "reference": zod.string().describe('Boosted reference'),
  "minQuantity": zod.number().min(apiAdminboostersIdPatchBodyBoosterReferencesItemMinQuantityMin).default(apiAdminboostersIdPatchBodyBoosterReferencesItemMinQuantityDefault).describe('Minimum cumulated quantity (included) from which the coefficient applies'),
  "maxQuantity": zod.number().min(apiAdminboostersIdPatchBodyBoosterReferencesItemMaxQuantityMin).nullish().describe('Maximum cumulated quantity (included) up to which the coefficient applies, null for no upper bound'),
  "coefficient": zod.number().min(apiAdminboostersIdPatchBodyBoosterReferencesItemCoefficientMin).describe('Points multiplier applied on quantities of this tier, 0 gives no boosted points')
})).optional()
})

export const apiAdminboostersIdPatchResponseTitleMax = 255;

export const apiAdminboostersIdPatchResponseBoosterReferencesItemReferenceBrandMax = 100;

export const apiAdminboostersIdPatchResponseBoosterReferencesItemReferenceProductLineMax = 100;

export const apiAdminboostersIdPatchResponseBoosterReferencesItemReferenceNameMax = 100;

export const apiAdminboostersIdPatchResponseBoosterReferencesItemReferenceUniqueCodeMax = 50;

export const apiAdminboostersIdPatchResponseBoosterReferencesItemReferencePointValueMin = 0;

export const apiAdminboostersIdPatchResponseBoosterReferencesItemMinQuantityDefault = 1;
export const apiAdminboostersIdPatchResponseBoosterReferencesItemMinQuantityMin = 0;

export const apiAdminboostersIdPatchResponseBoosterReferencesItemMaxQuantityMin = 0;

export const apiAdminboostersIdPatchResponseBoosterReferencesItemCoefficientMin = 0;



export const apiAdminboostersIdPatchResponse = zod.object({
  "id": zod.number().describe('Booster ID'),
  "title": zod.string().max(apiAdminboostersIdPatchResponseTitleMax).describe('Title of the booster'),
  "description": zod.string().nullish().describe('Description of the booster'),
  "startDate": zod.string().datetime({}).describe('Start date of the booster'),
  "endDate": zod.string().datetime({}).describe('End date of the booster'),
  "boosterReferences": zod.array(zod.object({
  "id": zod.number().optional().describe('BoosterReference ID'),
  "reference": zod.object({
  "id": zod.number().describe('Reference ID'),
  "brand": zod.string().max(apiAdminboostersIdPatchResponseBoosterReferencesItemReferenceBrandMax).describe('Brand of the reference'),
  "productLine": zod.string().max(apiAdminboostersIdPatchResponseBoosterReferencesItemReferenceProductLineMax).nullish().describe('Product line of the reference'),
  "name": zod.string().max(apiAdminboostersIdPatchResponseBoosterReferencesItemReferenceNameMax).describe('Name of the reference'),
  "uniqueCode": zod.string().max(apiAdminboostersIdPatchResponseBoosterReferencesItemReferenceUniqueCodeMax).describe('Unique code of the reference'),
  "pointValue": zod.number().min(apiAdminboostersIdPatchResponseBoosterReferencesItemReferencePointValueMin).describe('Point amount given foreach quantity bought, adjusted by the current company\'s point coefficient. May be null in the GET /references response if the workspace hides reference points'),
  "tags": zod.array(zod.string()).optional().describe('List of keyword tags for this reference')
}),
  "minQuantity": zod.number().min(apiAdminboostersIdPatchResponseBoosterReferencesItemMinQuantityMin).default(apiAdminboostersIdPatchResponseBoosterReferencesItemMinQuantityDefault).describe('Minimum cumulated quantity (included) from which the coefficient applies'),
  "maxQuantity": zod.number().min(apiAdminboostersIdPatchResponseBoosterReferencesItemMaxQuantityMin).nullish().describe('Maximum cumulated quantity (included) up to which the coefficient applies, null for no upper bound'),
  "coefficient": zod.number().min(apiAdminboostersIdPatchResponseBoosterReferencesItemCoefficientMin).describe('Points multiplier applied on quantities of this tier, 0 gives no boosted points'),
  "boostedPointValue": zod.number().nullish()
})).optional(),
  "status": zod.string().nullable().describe('Current status of the booster')
})


/**
 * Get boosters collection
 * @summary Get boosters collection
 */
export const apiBoostersGetCollectionQueryPageDefault = 1;export const apiBoostersGetCollectionQueryPerPageDefault = 30;
export const apiBoostersGetCollectionQueryPerPageMin = 0;
export const apiBoostersGetCollectionQueryPerPageMax = 30;



export const apiBoostersGetCollectionQueryParams = zod.object({
  "page": zod.number().default(apiBoostersGetCollectionQueryPageDefault).describe('The collection page number'),
  "perPage": zod.number().min(apiBoostersGetCollectionQueryPerPageMin).max(apiBoostersGetCollectionQueryPerPageMax).default(apiBoostersGetCollectionQueryPerPageDefault).describe('The number of items per page')
})

export const apiBoostersGetCollectionResponseTitleMax = 255;



export const apiBoostersGetCollectionResponseItem = zod.object({
  "id": zod.number().describe('Booster ID'),
  "title": zod.string().max(apiBoostersGetCollectionResponseTitleMax).describe('Title of the booster'),
  "description": zod.string().nullish().describe('Description of the booster'),
  "startDate": zod.string().datetime({}).describe('Start date of the booster'),
  "endDate": zod.string().datetime({}).describe('End date of the booster'),
  "status": zod.string().nullable().describe('Current status of the booster'),
  "referencesCount": zod.number().optional()
})
export const apiBoostersGetCollectionResponse = zod.array(apiBoostersGetCollectionResponseItem)


/**
 * Get a booster by ID
 * @summary Get a booster by ID
 */
export const apiBoostersIdGetParams = zod.object({
  "id": zod.string().describe('Booster identifier')
})

export const apiBoostersIdGetResponseTitleMax = 255;

export const apiBoostersIdGetResponseBoosterReferencesItemReferenceBrandMax = 100;

export const apiBoostersIdGetResponseBoosterReferencesItemReferenceProductLineMax = 100;

export const apiBoostersIdGetResponseBoosterReferencesItemReferenceNameMax = 100;

export const apiBoostersIdGetResponseBoosterReferencesItemReferenceUniqueCodeMax = 50;

export const apiBoostersIdGetResponseBoosterReferencesItemReferencePointValueMin = 0;

export const apiBoostersIdGetResponseBoosterReferencesItemMinQuantityDefault = 1;
export const apiBoostersIdGetResponseBoosterReferencesItemMinQuantityMin = 0;

export const apiBoostersIdGetResponseBoosterReferencesItemMaxQuantityMin = 0;

export const apiBoostersIdGetResponseBoosterReferencesItemCoefficientMin = 0;



export const apiBoostersIdGetResponse = zod.object({
  "id": zod.number().describe('Booster ID'),
  "title": zod.string().max(apiBoostersIdGetResponseTitleMax).describe('Title of the booster'),
  "description": zod.string().nullish().describe('Description of the booster'),
  "startDate": zod.string().datetime({}).describe('Start date of the booster'),
  "endDate": zod.string().datetime({}).describe('End date of the booster'),
  "boosterReferences": zod.array(zod.object({
  "id": zod.number().optional().describe('BoosterReference ID'),
  "reference": zod.object({
  "id": zod.number().describe('Reference ID'),
  "brand": zod.string().max(apiBoostersIdGetResponseBoosterReferencesItemReferenceBrandMax).describe('Brand of the reference'),
  "productLine": zod.string().max(apiBoostersIdGetResponseBoosterReferencesItemReferenceProductLineMax).nullish().describe('Product line of the reference'),
  "name": zod.string().max(apiBoostersIdGetResponseBoosterReferencesItemReferenceNameMax).describe('Name of the reference'),
  "uniqueCode": zod.string().max(apiBoostersIdGetResponseBoosterReferencesItemReferenceUniqueCodeMax).describe('Unique code of the reference'),
  "pointValue": zod.number().min(apiBoostersIdGetResponseBoosterReferencesItemReferencePointValueMin).describe('Point amount given foreach quantity bought, adjusted by the current company\'s point coefficient. May be null in the GET /references response if the workspace hides reference points'),
  "tags": zod.array(zod.string()).optional().describe('List of keyword tags for this reference')
}),
  "minQuantity": zod.number().min(apiBoostersIdGetResponseBoosterReferencesItemMinQuantityMin).default(apiBoostersIdGetResponseBoosterReferencesItemMinQuantityDefault).describe('Minimum cumulated quantity (included) from which the coefficient applies'),
  "maxQuantity": zod.number().min(apiBoostersIdGetResponseBoosterReferencesItemMaxQuantityMin).nullish().describe('Maximum cumulated quantity (included) up to which the coefficient applies, null for no upper bound'),
  "coefficient": zod.number().min(apiBoostersIdGetResponseBoosterReferencesItemCoefficientMin).describe('Points multiplier applied on quantities of this tier, 0 gives no boosted points'),
  "boostedPointValue": zod.number().nullish()
})).optional(),
  "status": zod.string().nullable().describe('Current status of the booster')
})


/**
 * Check the health of a cart
 * @summary Check the health of a cart
 */
export const apiCarthealthcheckPostBodyItemsItemQuantityMin = 0;



export const apiCarthealthcheckPostBody = zod.object({
  "items": zod.array(zod.object({
  "product": zod.string().nullable().describe('Product IRI'),
  "quantity": zod.number().min(apiCarthealthcheckPostBodyItemsItemQuantityMin).nullable().describe('Requested quantity')
}))
})

export const apiCarthealthcheckPostResponseItemsItemQuantityMin = 0;

export const apiCarthealthcheckPostResponseIsValidDefault = true;

export const apiCarthealthcheckPostResponse = zod.object({
  "items": zod.array(zod.object({
  "product": zod.string().nullable().describe('Product IRI'),
  "quantity": zod.number().min(apiCarthealthcheckPostResponseItemsItemQuantityMin).nullable().describe('Requested quantity'),
  "issue": zod.string().nullish().describe('Issue code found for this item, checked in order, null if valid'),
  "isValid": zod.boolean().optional()
})),
  "isValid": zod.boolean().describe('Whether every item in the cart is valid')
})


/**
 * Retrieves the collection of Changelog resources.
 * @summary Retrieves the collection of Changelog resources.
 */
export const adminChangelogsQueryPageDefault = 1;export const adminChangelogsQueryPerPageDefault = 30;
export const adminChangelogsQueryPerPageMin = 0;
export const adminChangelogsQueryPerPageMax = 30;

export const adminChangelogsQueryOrderTitleDefault = "asc";export const adminChangelogsQueryOrderTagDefault = "asc";export const adminChangelogsQueryOrderDescriptionDefault = "asc";export const adminChangelogsQueryOrderTargetDefault = "asc";export const adminChangelogsQueryOrderCreatedAtDefault = "asc";

export const adminChangelogsQueryParams = zod.object({
  "page": zod.number().default(adminChangelogsQueryPageDefault).describe('The collection page number'),
  "perPage": zod.number().min(adminChangelogsQueryPerPageMin).max(adminChangelogsQueryPerPageMax).default(adminChangelogsQueryPerPageDefault).describe('The number of items per page'),
  "search": zod.string().optional().describe('Search in title, description'),
  "createdAt[before]": zod.string().optional(),
  "createdAt[strictly_before]": zod.string().optional(),
  "createdAt[after]": zod.string().optional(),
  "createdAt[strictly_after]": zod.string().optional(),
  "title": zod.string().optional(),
  "description": zod.string().optional(),
  "tag": zod.string().optional(),
  "tag[]": zod.array(zod.string()).optional(),
  "target": zod.string().optional(),
  "target[]": zod.array(zod.string()).optional(),
  "order[title]": zod.enum(['asc', 'desc']).default(adminChangelogsQueryOrderTitleDefault),
  "order[tag]": zod.enum(['asc', 'desc']).default(adminChangelogsQueryOrderTagDefault),
  "order[description]": zod.enum(['asc', 'desc']).default(adminChangelogsQueryOrderDescriptionDefault),
  "order[target]": zod.enum(['asc', 'desc']).default(adminChangelogsQueryOrderTargetDefault),
  "order[createdAt]": zod.enum(['asc', 'desc']).default(adminChangelogsQueryOrderCreatedAtDefault)
})

export const adminChangelogsResponse = zod.object({
  "data": zod.array(zod.unknown()),
  "pagination": zod.object({
  "first": zod.number(),
  "current": zod.number(),
  "last": zod.number(),
  "previous": zod.number(),
  "next": zod.number(),
  "totalItems": zod.number(),
  "perPage": zod.number()
})
}).and(zod.object({
  "data": zod.array(zod.object({
  "id": zod.number().describe('Changelog ID'),
  "title": zod.string().describe('Changelog title'),
  "tag": zod.enum(['feature', 'improvement', 'bugfix']).describe('Changelog tag'),
  "description": zod.string().describe('Changelog details'),
  "media": zod.union([zod.object({
  "pathUri": zod.string().nullable().describe('Media path to S3')
}),zod.null()]).optional(),
  "target": zod.enum(['admins', 'sales', 'users']).describe('Target users group for this changelog entry'),
  "createdAt": zod.string().datetime({}).optional().describe('Creation date')
}).describe('Retrieve the list of changelog entries')).optional()
}))


/**
 * Creates a Changelog resource.
 * @summary Creates a Changelog resource.
 */
export const apiAdminchangelogsPostBody = zod.object({
  "title": zod.string().describe('Changelog title'),
  "tag": zod.enum(['feature', 'improvement', 'bugfix']).describe('Changelog tag'),
  "description": zod.string().describe('Changelog details'),
  "media": zod.string().nullish().describe('IRI of the related media'),
  "target": zod.enum(['admins', 'sales', 'users']).describe('Target users group for this changelog entry')
}).describe('Create a new changelog entry')


/**
 * Removes the Changelog resource.
 * @summary Removes the Changelog resource.
 */
export const apiAdminchangelogsIdDeleteParams = zod.object({
  "id": zod.string().describe('Changelog identifier')
})


/**
 * Updates the Changelog resource.
 * @summary Updates the Changelog resource.
 */
export const apiAdminchangelogsIdPatchParams = zod.object({
  "id": zod.string().describe('Changelog identifier')
})

export const apiAdminchangelogsIdPatchBody = zod.object({
  "title": zod.string().optional().describe('Changelog title'),
  "tag": zod.enum(['feature', 'improvement', 'bugfix']).optional().describe('Changelog tag'),
  "description": zod.string().optional().describe('Changelog details'),
  "media": zod.string().nullish().describe('IRI of the related media'),
  "target": zod.enum(['admins', 'sales', 'users']).optional().describe('Target users group for this changelog entry')
}).describe('Partially update a changelog entry')

export const apiAdminchangelogsIdPatchResponse = zod.object({
  "id": zod.number().describe('Changelog ID'),
  "title": zod.string().describe('Changelog title'),
  "tag": zod.enum(['feature', 'improvement', 'bugfix']).describe('Changelog tag'),
  "description": zod.string().describe('Changelog details'),
  "media": zod.union([zod.object({
  "pathUri": zod.string().nullable().describe('Media path to S3')
}),zod.null()]).optional(),
  "target": zod.enum(['admins', 'sales', 'users']).describe('Target users group for this changelog entry'),
  "createdAt": zod.string().datetime({}).optional().describe('Creation date')
}).describe('Retrieve the list of changelog entries')


/**
 * Retrieves the collection of Changelog resources.
 * @summary Retrieves the collection of Changelog resources.
 */
export const apiChangelogsGetCollectionQueryPageDefault = 1;export const apiChangelogsGetCollectionQueryPerPageDefault = 30;
export const apiChangelogsGetCollectionQueryPerPageMin = 0;
export const apiChangelogsGetCollectionQueryPerPageMax = 30;



export const apiChangelogsGetCollectionQueryParams = zod.object({
  "page": zod.number().default(apiChangelogsGetCollectionQueryPageDefault).describe('The collection page number'),
  "perPage": zod.number().min(apiChangelogsGetCollectionQueryPerPageMin).max(apiChangelogsGetCollectionQueryPerPageMax).default(apiChangelogsGetCollectionQueryPerPageDefault).describe('The number of items per page'),
  "search": zod.string().optional().describe('Search in title, description'),
  "createdAt[before]": zod.string().optional(),
  "createdAt[strictly_before]": zod.string().optional(),
  "createdAt[after]": zod.string().optional(),
  "createdAt[strictly_after]": zod.string().optional(),
  "title": zod.string().optional(),
  "description": zod.string().optional(),
  "tag": zod.string().optional(),
  "tag[]": zod.array(zod.string()).optional(),
  "onlyNew": zod.string().optional().describe('Retourne uniquement les changelogs plus récents que la dernière connexion')
})

export const apiChangelogsGetCollectionResponse = zod.object({
  "data": zod.array(zod.unknown()),
  "pagination": zod.object({
  "first": zod.number(),
  "current": zod.number(),
  "last": zod.number(),
  "previous": zod.number(),
  "next": zod.number(),
  "totalItems": zod.number(),
  "perPage": zod.number()
})
}).and(zod.object({
  "data": zod.array(zod.object({
  "id": zod.number().describe('Changelog ID'),
  "title": zod.string().describe('Changelog title'),
  "tag": zod.enum(['feature', 'improvement', 'bugfix']).describe('Changelog tag'),
  "description": zod.string().describe('Changelog details'),
  "media": zod.union([zod.object({
  "pathUri": zod.string().nullable().describe('Media path to S3')
}),zod.null()]).optional(),
  "target": zod.enum(['admins', 'sales', 'users']).describe('Target users group for this changelog entry'),
  "createdAt": zod.string().datetime({}).optional().describe('Creation date')
}).describe('Retrieve the list of changelog entries')).optional()
}))


/**
 * Retrieves a Changelog resource.
 * @summary Retrieves a Changelog resource.
 */
export const apiChangelogsIdGetParams = zod.object({
  "id": zod.string().describe('Changelog identifier')
})

export const apiChangelogsIdGetResponse = zod.object({
  "id": zod.number().describe('Changelog ID'),
  "title": zod.string().describe('Changelog title'),
  "tag": zod.enum(['feature', 'improvement', 'bugfix']).describe('Changelog tag'),
  "description": zod.string().describe('Changelog details'),
  "media": zod.union([zod.object({
  "pathUri": zod.string().nullable().describe('Media path to S3')
}),zod.null()]).optional(),
  "target": zod.enum(['admins', 'sales', 'users']).describe('Target users group for this changelog entry'),
  "createdAt": zod.string().datetime({}).optional().describe('Creation date')
}).describe('Retrieve the list of changelog entries')


/**
 * Retrieves the collection of Company resources.
 * @summary Retrieves the collection of Company resources.
 */
export const apiAdmincompaniesGetCollectionQueryPageDefault = 1;export const apiAdmincompaniesGetCollectionQueryPerPageDefault = 30;
export const apiAdmincompaniesGetCollectionQueryPerPageMin = 0;
export const apiAdmincompaniesGetCollectionQueryPerPageMax = 30;

export const apiAdmincompaniesGetCollectionQueryOrderNameDefault = "asc";export const apiAdmincompaniesGetCollectionQueryOrderCreatedAtDefault = "asc";export const apiAdmincompaniesGetCollectionQueryOrderPointCoeffDefault = "asc";export const apiAdmincompaniesGetCollectionQueryOrderTypologyNameDefault = "asc";

export const apiAdmincompaniesGetCollectionQueryParams = zod.object({
  "page": zod.number().default(apiAdmincompaniesGetCollectionQueryPageDefault).describe('The collection page number'),
  "perPage": zod.number().min(apiAdmincompaniesGetCollectionQueryPerPageMin).max(apiAdmincompaniesGetCollectionQueryPerPageMax).default(apiAdmincompaniesGetCollectionQueryPerPageDefault).describe('The number of items per page'),
  "name": zod.string().optional(),
  "uniqueCode": zod.string().optional(),
  "siren": zod.string().optional(),
  "tva": zod.string().optional(),
  "addressLine1": zod.string().optional(),
  "city": zod.string().optional(),
  "zipcode": zod.string().optional(),
  "country.alpha3": zod.string().optional(),
  "country.alpha3[]": zod.array(zod.string()).optional(),
  "comment": zod.string().optional(),
  "responsible.user.fullname": zod.string().optional().describe('Search in concatenated fields: companyResponsibles.responsible.user.firstname   companyResponsibles.responsible.user.lastname'),
  "search": zod.string().optional().describe('Search in name, uniqueCode, addressLine1, zipcode, city, country.alpha3, companyResponsibles.responsible.uniqueCode, typology.name'),
  "lastStepReached[]": zod.array(zod.string()).optional(),
  "typology[]": zod.array(zod.string()).optional(),
  "status[]": zod.array(zod.enum(['company.status.unregistered', 'company.status.registered', 'company.status.blocked', 'company.status.inactive'])).optional(),
  "order[name]": zod.enum(['asc', 'desc']).default(apiAdmincompaniesGetCollectionQueryOrderNameDefault),
  "order[createdAt]": zod.enum(['asc', 'desc']).default(apiAdmincompaniesGetCollectionQueryOrderCreatedAtDefault),
  "order[pointCoeff]": zod.enum(['asc', 'desc']).default(apiAdmincompaniesGetCollectionQueryOrderPointCoeffDefault),
  "order[typology.name]": zod.enum(['asc', 'desc']).default(apiAdmincompaniesGetCollectionQueryOrderTypologyNameDefault),
  "order[acquiredPoints]": zod.enum(['asc', 'desc']).optional(),
  "order[caAmount]": zod.enum(['asc', 'desc']).optional(),
  "order[balance]": zod.enum(['asc', 'desc']).optional(),
  "order[commercial]": zod.enum(['asc', 'desc']).optional(),
  "order[lastStepReached]": zod.enum(['asc', 'desc']).optional(),
  "order[registeredAt]": zod.enum(['asc', 'desc']).optional(),
  "sales[]": zod.array(zod.string()).optional(),
  "balance[gte]": zod.string().optional().describe('Filter companies with balance greater than or equal to this value'),
  "balance[lte]": zod.string().optional().describe('Filter companies with balance less than or equal to this value'),
  "acquiredPoints[gte]": zod.string().optional().describe('Filter companies with acquired points greater than or equal to this value'),
  "acquiredPoints[lte]": zod.string().optional().describe('Filter companies with acquired points less than or equal to this value'),
  "registeredAt[after]": zod.string().optional().describe('Filter companies registered after this date (format: Y-m-d or ISO 8601)'),
  "registeredAt[before]": zod.string().optional().describe('Filter companies registered before this date (format: Y-m-d or ISO 8601)'),
  "pointCoeff[gte]": zod.string().optional().describe('Filter companies with coefficient greater than or equal to this value'),
  "pointCoeff[lte]": zod.string().optional().describe('Filter companies with coefficient less than or equal to this value')
})

export const apiAdmincompaniesGetCollectionResponseDataItemNameMax = 100;

export const apiAdmincompaniesGetCollectionResponseDataItemUniqueCodeMax = 50;


export const apiAdmincompaniesGetCollectionResponseDataItemUniqueCodeRegExp = new RegExp('^([a-zA-Z0-9]+)$');
export const apiAdmincompaniesGetCollectionResponseDataItemSirenMax = 9;


export const apiAdmincompaniesGetCollectionResponseDataItemSirenRegExp = new RegExp('^([0-9]*)$');
export const apiAdmincompaniesGetCollectionResponseDataItemTvaMax = 20;

export const apiAdmincompaniesGetCollectionResponseDataItemAddressLine1Min = 7;
export const apiAdmincompaniesGetCollectionResponseDataItemAddressLine1Max = 255;

export const apiAdmincompaniesGetCollectionResponseDataItemAddressLine2Max = 255;

export const apiAdmincompaniesGetCollectionResponseDataItemAddressLine3Max = 255;

export const apiAdmincompaniesGetCollectionResponseDataItemZipcodeMin = 4;
export const apiAdmincompaniesGetCollectionResponseDataItemZipcodeMax = 20;

export const apiAdmincompaniesGetCollectionResponseDataItemCityMax = 100;

export const apiAdmincompaniesGetCollectionResponseDataItemStatusDefault = "company.status.unregistered";export const apiAdmincompaniesGetCollectionResponseDataItemLogicStepHistoryItemLogicTypeStepNameMax = 50;

export const apiAdmincompaniesGetCollectionResponseDataItemTypologyNameMax = 100;

export const apiAdmincompaniesGetCollectionResponseDataItemResponsiblesItemUserAvatarMax = 255;

export const apiAdmincompaniesGetCollectionResponseDataItemResponsiblesItemUniqueCodeMax = 50;


export const apiAdmincompaniesGetCollectionResponseDataItemResponsiblesItemUniqueCodeRegExp = new RegExp('^([a-zA-Z0-9]+)$');
export const apiAdmincompaniesGetCollectionResponseDataItemLastStepReachedNameMax = 50;



export const apiAdmincompaniesGetCollectionResponse = zod.object({
  "data": zod.array(zod.unknown()),
  "pagination": zod.object({
  "first": zod.number(),
  "current": zod.number(),
  "last": zod.number(),
  "previous": zod.number(),
  "next": zod.number(),
  "totalItems": zod.number(),
  "perPage": zod.number()
})
}).and(zod.object({
  "data": zod.array(zod.object({
  "id": zod.number().describe('Company ID'),
  "name": zod.string().max(apiAdmincompaniesGetCollectionResponseDataItemNameMax).describe('Company name'),
  "uniqueCode": zod.string().max(apiAdmincompaniesGetCollectionResponseDataItemUniqueCodeMax).regex(apiAdmincompaniesGetCollectionResponseDataItemUniqueCodeRegExp).describe('Company unique code (SIREN or TVA or whatever)'),
  "siren": zod.string().max(apiAdmincompaniesGetCollectionResponseDataItemSirenMax).regex(apiAdmincompaniesGetCollectionResponseDataItemSirenRegExp).nullish().describe('Company SIREN'),
  "tva": zod.string().max(apiAdmincompaniesGetCollectionResponseDataItemTvaMax).nullish().describe('Company TVA'),
  "addressLine1": zod.string().min(apiAdmincompaniesGetCollectionResponseDataItemAddressLine1Min).max(apiAdmincompaniesGetCollectionResponseDataItemAddressLine1Max).describe('Company address line 1'),
  "addressLine2": zod.string().max(apiAdmincompaniesGetCollectionResponseDataItemAddressLine2Max).nullish().describe('Company address line 2'),
  "addressLine3": zod.string().max(apiAdmincompaniesGetCollectionResponseDataItemAddressLine3Max).nullish().describe('Company address line 3'),
  "zipcode": zod.string().min(apiAdmincompaniesGetCollectionResponseDataItemZipcodeMin).max(apiAdmincompaniesGetCollectionResponseDataItemZipcodeMax).describe('Company zipcode'),
  "city": zod.string().max(apiAdmincompaniesGetCollectionResponseDataItemCityMax).describe('Company city'),
  "country": zod.object({
  "name": zod.string().describe('Country name')
}).optional(),
  "createdAt": zod.string().datetime({}).describe('Company creation date'),
  "status": zod.enum(['company.status.unregistered', 'company.status.registered', 'company.status.blocked', 'company.status.inactive']).describe('Company status (read-only, computed from managers statuses)'),
  "registeredAt": zod.string().datetime({}).nullish().describe('Datetime where the first managed completed registration was done'),
  "logicStepHistory": zod.array(zod.object({
  "logicTypeStep": zod.object({
  "id": zod.number().optional().describe('Step ID'),
  "name": zod.string().max(apiAdmincompaniesGetCollectionResponseDataItemLogicStepHistoryItemLogicTypeStepNameMax).describe('Step name')
}),
  "createdAt": zod.string().datetime({}).describe('Step history creation datetime')
})).optional(),
  "typology": zod.union([zod.object({
  "name": zod.string().max(apiAdmincompaniesGetCollectionResponseDataItemTypologyNameMax).describe('Name of the typology')
}),zod.null()]).optional(),
  "caAmount": zod.number().describe('CA amount of the company'),
  "acquiredPoints": zod.number().describe('Total of acquired points'),
  "pointCoeff": zod.number().nullish().describe('Coefficient used to calculate points (depending conversion type)'),
  "comment": zod.string().nullish().describe('Comment about the company'),
  "responsibles": zod.array(zod.object({
  "user": zod.object({
  "fullname": zod.string().describe('User fullname'),
  "avatar": zod.string().max(apiAdmincompaniesGetCollectionResponseDataItemResponsiblesItemUserAvatarMax).nullish().describe('User avatar'),
  "isDeleted": zod.boolean().describe('Whether the entity has been soft-deleted')
}),
  "uniqueCode": zod.string().min(1).max(apiAdmincompaniesGetCollectionResponseDataItemResponsiblesItemUniqueCodeMax).regex(apiAdmincompaniesGetCollectionResponseDataItemResponsiblesItemUniqueCodeRegExp).optional().describe('User unique code')
})).optional(),
  "lastStepReached": zod.union([zod.object({
  "id": zod.number().optional().describe('Step ID'),
  "name": zod.string().max(apiAdmincompaniesGetCollectionResponseDataItemLastStepReachedNameMax).describe('Step name')
}),zod.null()]).optional(),
  "balance": zod.number().describe('Balance of the company')
})).optional()
}))


/**
 * Add a new company
 * @summary Add a new company
 */
export const apiAdmincompaniesPostBodyNameMax = 100;

export const apiAdmincompaniesPostBodyUniqueCodeMax = 50;


export const apiAdmincompaniesPostBodyUniqueCodeRegExp = new RegExp('^([a-zA-Z0-9]+)$');
export const apiAdmincompaniesPostBodySirenMax = 9;


export const apiAdmincompaniesPostBodySirenRegExp = new RegExp('^([0-9]*)$');
export const apiAdmincompaniesPostBodyTvaMax = 20;

export const apiAdmincompaniesPostBodyAddressLine1Min = 7;
export const apiAdmincompaniesPostBodyAddressLine1Max = 255;

export const apiAdmincompaniesPostBodyAddressLine2Max = 255;

export const apiAdmincompaniesPostBodyAddressLine3Max = 255;

export const apiAdmincompaniesPostBodyZipcodeMin = 4;
export const apiAdmincompaniesPostBodyZipcodeMax = 20;

export const apiAdmincompaniesPostBodyCityMax = 100;



export const apiAdmincompaniesPostBody = zod.object({
  "name": zod.string().max(apiAdmincompaniesPostBodyNameMax).describe('Company name'),
  "uniqueCode": zod.string().max(apiAdmincompaniesPostBodyUniqueCodeMax).regex(apiAdmincompaniesPostBodyUniqueCodeRegExp).describe('Company unique code (SIREN or TVA or whatever)'),
  "siren": zod.string().max(apiAdmincompaniesPostBodySirenMax).regex(apiAdmincompaniesPostBodySirenRegExp).nullish().describe('Company SIREN'),
  "tva": zod.string().max(apiAdmincompaniesPostBodyTvaMax).nullish().describe('Company TVA'),
  "addressLine1": zod.string().min(apiAdmincompaniesPostBodyAddressLine1Min).max(apiAdmincompaniesPostBodyAddressLine1Max).describe('Company address line 1'),
  "addressLine2": zod.string().max(apiAdmincompaniesPostBodyAddressLine2Max).nullish().describe('Company address line 2'),
  "addressLine3": zod.string().max(apiAdmincompaniesPostBodyAddressLine3Max).nullish().describe('Company address line 3'),
  "zipcode": zod.string().min(apiAdmincompaniesPostBodyZipcodeMin).max(apiAdmincompaniesPostBodyZipcodeMax).describe('Company zipcode'),
  "city": zod.string().max(apiAdmincompaniesPostBodyCityMax).describe('Company city'),
  "countryAlpha3": zod.string().describe('Company country alpha3'),
  "responsiblesUniqueCodes": zod.string().nullish().describe('User unique code(s) to link to the company, separated by \"|\" for multiple'),
  "typologyName": zod.string().nullish().describe('The typology name to which the company belongs'),
  "pointCoeff": zod.number().nullish().describe('Coefficient used to calculate points (depending conversion type)'),
  "comment": zod.string().nullish().describe('Comment about the company')
})


/**
 * Import list of companies
 * @summary Import list of companies
 */
export const companiesImportHeaderDryRunDefault = false;

export const companiesImportHeader = zod.object({
  "dry-run": zod.boolean().optional().describe('Set to true to perform a dry run import (optional)')
})

export const companiesImportBodyDataItemNameMax = 100;

export const companiesImportBodyDataItemUniqueCodeMax = 50;


export const companiesImportBodyDataItemUniqueCodeRegExp = new RegExp('^([a-zA-Z0-9]+)$');
export const companiesImportBodyDataItemSirenMax = 9;


export const companiesImportBodyDataItemSirenRegExp = new RegExp('^([0-9]*)$');
export const companiesImportBodyDataItemTvaMax = 20;

export const companiesImportBodyDataItemAddressLine1Min = 7;
export const companiesImportBodyDataItemAddressLine1Max = 255;

export const companiesImportBodyDataItemAddressLine2Max = 255;

export const companiesImportBodyDataItemAddressLine3Max = 255;

export const companiesImportBodyDataItemZipcodeMin = 4;
export const companiesImportBodyDataItemZipcodeMax = 20;

export const companiesImportBodyDataItemCityMax = 100;



export const companiesImportBody = zod.object({
  "data": zod.array(zod.object({
  "name": zod.string().max(companiesImportBodyDataItemNameMax).describe('Company name'),
  "uniqueCode": zod.string().max(companiesImportBodyDataItemUniqueCodeMax).regex(companiesImportBodyDataItemUniqueCodeRegExp).describe('Company unique code (SIREN or TVA or whatever)'),
  "siren": zod.string().max(companiesImportBodyDataItemSirenMax).regex(companiesImportBodyDataItemSirenRegExp).nullish().describe('Company SIREN'),
  "tva": zod.string().max(companiesImportBodyDataItemTvaMax).nullish().describe('Company TVA'),
  "addressLine1": zod.string().min(companiesImportBodyDataItemAddressLine1Min).max(companiesImportBodyDataItemAddressLine1Max).describe('Company address line 1'),
  "addressLine2": zod.string().max(companiesImportBodyDataItemAddressLine2Max).nullish().describe('Company address line 2'),
  "addressLine3": zod.string().max(companiesImportBodyDataItemAddressLine3Max).nullish().describe('Company address line 3'),
  "zipcode": zod.string().min(companiesImportBodyDataItemZipcodeMin).max(companiesImportBodyDataItemZipcodeMax).describe('Company zipcode'),
  "city": zod.string().max(companiesImportBodyDataItemCityMax).describe('Company city'),
  "countryAlpha3": zod.string().describe('Company country alpha3'),
  "responsiblesUniqueCodes": zod.string().nullish().describe('User unique code(s) to link to the company, separated by \"|\" for multiple'),
  "typologyName": zod.string().nullish().describe('The typology name to which the company belongs'),
  "pointCoeff": zod.number().nullish().describe('Coefficient used to calculate points (depending conversion type)'),
  "comment": zod.string().nullish().describe('Comment about the company')
}))
})


/**
 * Update list of companies
 * @summary Update list of companies
 */
export const companiesBatchUpdateHeaderDryRunDefault = false;

export const companiesBatchUpdateHeader = zod.object({
  "dry-run": zod.boolean().optional().describe('Set to true to perform a dry run import (optional)')
})

export const companiesBatchUpdateBodyDataItemCompanyNameMax = 100;

export const companiesBatchUpdateBodyDataItemCompanyUniqueCodeMax = 50;


export const companiesBatchUpdateBodyDataItemCompanyUniqueCodeRegExp = new RegExp('^([a-zA-Z0-9]+)$');
export const companiesBatchUpdateBodyDataItemCompanySirenMax = 9;


export const companiesBatchUpdateBodyDataItemCompanySirenRegExp = new RegExp('^([0-9]*)$');
export const companiesBatchUpdateBodyDataItemCompanyTvaMax = 20;

export const companiesBatchUpdateBodyDataItemCompanyAddressLine1Min = 7;
export const companiesBatchUpdateBodyDataItemCompanyAddressLine1Max = 255;

export const companiesBatchUpdateBodyDataItemCompanyAddressLine2Max = 255;

export const companiesBatchUpdateBodyDataItemCompanyAddressLine3Max = 255;

export const companiesBatchUpdateBodyDataItemCompanyZipcodeMin = 4;
export const companiesBatchUpdateBodyDataItemCompanyZipcodeMax = 20;

export const companiesBatchUpdateBodyDataItemCompanyCityMax = 100;



export const companiesBatchUpdateBody = zod.object({
  "data": zod.array(zod.object({
  "id": zod.number().nullable().describe('ID of the company to update'),
  "company": zod.union([zod.object({
  "name": zod.string().max(companiesBatchUpdateBodyDataItemCompanyNameMax).describe('Company name'),
  "uniqueCode": zod.string().max(companiesBatchUpdateBodyDataItemCompanyUniqueCodeMax).regex(companiesBatchUpdateBodyDataItemCompanyUniqueCodeRegExp).describe('Company unique code (SIREN or TVA or whatever)'),
  "siren": zod.string().max(companiesBatchUpdateBodyDataItemCompanySirenMax).regex(companiesBatchUpdateBodyDataItemCompanySirenRegExp).nullish().describe('Company SIREN'),
  "tva": zod.string().max(companiesBatchUpdateBodyDataItemCompanyTvaMax).nullish().describe('Company TVA'),
  "addressLine1": zod.string().min(companiesBatchUpdateBodyDataItemCompanyAddressLine1Min).max(companiesBatchUpdateBodyDataItemCompanyAddressLine1Max).describe('Company address line 1'),
  "addressLine2": zod.string().max(companiesBatchUpdateBodyDataItemCompanyAddressLine2Max).nullish().describe('Company address line 2'),
  "addressLine3": zod.string().max(companiesBatchUpdateBodyDataItemCompanyAddressLine3Max).nullish().describe('Company address line 3'),
  "zipcode": zod.string().min(companiesBatchUpdateBodyDataItemCompanyZipcodeMin).max(companiesBatchUpdateBodyDataItemCompanyZipcodeMax).describe('Company zipcode'),
  "city": zod.string().max(companiesBatchUpdateBodyDataItemCompanyCityMax).describe('Company city'),
  "countryAlpha3": zod.string().optional().describe('Company country alpha3'),
  "responsiblesUniqueCodes": zod.string().nullish().describe('User unique code(s) to link to the company, separated by \"|\" for multiple'),
  "typologyName": zod.string().nullish().describe('The typology name to which the company belongs'),
  "pointCoeff": zod.number().nullish().describe('Coefficient used to calculate points (depending conversion type)'),
  "comment": zod.string().nullish().describe('Comment about the company')
}),zod.null()])
})).optional()
})

export const companiesBatchUpdateResponse = zod.object({
  "linesImported": zod.number().describe('Number of lines imported')
})


/**
 * Retrieves a Company resource.
 * @summary Retrieves a Company resource.
 */
export const apiAdmincompaniesIdGetParams = zod.object({
  "id": zod.string().describe('Company identifier')
})

export const apiAdmincompaniesIdGetResponseNameMax = 100;

export const apiAdmincompaniesIdGetResponseUniqueCodeMax = 50;


export const apiAdmincompaniesIdGetResponseUniqueCodeRegExp = new RegExp('^([a-zA-Z0-9]+)$');
export const apiAdmincompaniesIdGetResponseSirenMax = 9;


export const apiAdmincompaniesIdGetResponseSirenRegExp = new RegExp('^([0-9]*)$');
export const apiAdmincompaniesIdGetResponseTvaMax = 20;

export const apiAdmincompaniesIdGetResponseAddressLine1Min = 7;
export const apiAdmincompaniesIdGetResponseAddressLine1Max = 255;

export const apiAdmincompaniesIdGetResponseAddressLine2Max = 255;

export const apiAdmincompaniesIdGetResponseAddressLine3Max = 255;

export const apiAdmincompaniesIdGetResponseZipcodeMin = 4;
export const apiAdmincompaniesIdGetResponseZipcodeMax = 20;

export const apiAdmincompaniesIdGetResponseCityMax = 100;

export const apiAdmincompaniesIdGetResponseCountryAlpha3Min = 3;
export const apiAdmincompaniesIdGetResponseCountryAlpha3Max = 3;

export const apiAdmincompaniesIdGetResponseUserWorkspacesItemUserAvatarMax = 255;

export const apiAdmincompaniesIdGetResponseUserWorkspacesItemUniqueCodeMax = 50;


export const apiAdmincompaniesIdGetResponseUserWorkspacesItemUniqueCodeRegExp = new RegExp('^([a-zA-Z0-9]+)$');
export const apiAdmincompaniesIdGetResponseCompanyHistoryItemPropertyMax = 255;

export const apiAdmincompaniesIdGetResponseCompanyHistoryItemMadeByUserAvatarMax = 255;

export const apiAdmincompaniesIdGetResponseStatusDefault = "company.status.unregistered";export const apiAdmincompaniesIdGetResponseLogicStepHistoryItemLogicTypeStepNameMax = 50;

export const apiAdmincompaniesIdGetResponseTypologyNameMax = 100;

export const apiAdmincompaniesIdGetResponsePointsItemLabelMax = 255;

export const apiAdmincompaniesIdGetResponsePointsItemAddedByUserWorkspaceUserAvatarMax = 255;

export const apiAdmincompaniesIdGetResponsePointsItemAddedByUserWorkspaceUniqueCodeMax = 50;


export const apiAdmincompaniesIdGetResponsePointsItemAddedByUserWorkspaceUniqueCodeRegExp = new RegExp('^([a-zA-Z0-9]+)$');
export const apiAdmincompaniesIdGetResponsePointsItemValueDateDefault = "";export const apiAdmincompaniesIdGetResponseOrdersItemReferenceMax = 20;

export const apiAdmincompaniesIdGetResponseOrdersItemStatusMax = 50;

export const apiAdmincompaniesIdGetResponseOrdersItemTypeMax = 10;

export const apiAdmincompaniesIdGetResponseOrdersItemPointLabelMax = 255;

export const apiAdmincompaniesIdGetResponseOrdersItemPointAddedByUserWorkspaceUserAvatarMax = 255;

export const apiAdmincompaniesIdGetResponseOrdersItemPointAddedByUserWorkspaceUniqueCodeMax = 50;


export const apiAdmincompaniesIdGetResponseOrdersItemPointAddedByUserWorkspaceUniqueCodeRegExp = new RegExp('^([a-zA-Z0-9]+)$');
export const apiAdmincompaniesIdGetResponseOrdersItemPointValueDateDefault = "";export const apiAdmincompaniesIdGetResponseOrdersItemMadeByUserAvatarMax = 255;

export const apiAdmincompaniesIdGetResponseOrdersItemMadeByUniqueCodeMax = 50;


export const apiAdmincompaniesIdGetResponseOrdersItemMadeByUniqueCodeRegExp = new RegExp('^([a-zA-Z0-9]+)$');
export const apiAdmincompaniesIdGetResponseOrdersItemProductsCountDefault = 0;export const apiAdmincompaniesIdGetResponseOrdersItemShopsItemDisplayNameMax = 100;

export const apiAdmincompaniesIdGetResponseTargetStatusesItemLogicTypeTargetReferenceMax = 20;

export const apiAdmincompaniesIdGetResponseTargetStatusesItemValueDefault = 0;
export const apiAdmincompaniesIdGetResponseTargetStatusesItemValueMin = 0;

export const apiAdmincompaniesIdGetResponseTargetStatusesItemTargetValueMin = 0;

export const apiAdmincompaniesIdGetResponseTargetStatusesItemAchievedPercentageDefault = 0;export const apiAdmincompaniesIdGetResponseResponsiblesItemUserAvatarMax = 255;

export const apiAdmincompaniesIdGetResponseResponsiblesItemUniqueCodeMax = 50;


export const apiAdmincompaniesIdGetResponseResponsiblesItemUniqueCodeRegExp = new RegExp('^([a-zA-Z0-9]+)$');
export const apiAdmincompaniesIdGetResponseLastStepReachedNameMax = 50;



export const apiAdmincompaniesIdGetResponse = zod.object({
  "id": zod.number().describe('Company ID'),
  "name": zod.string().max(apiAdmincompaniesIdGetResponseNameMax).describe('Company name'),
  "uniqueCode": zod.string().max(apiAdmincompaniesIdGetResponseUniqueCodeMax).regex(apiAdmincompaniesIdGetResponseUniqueCodeRegExp).describe('Company unique code (SIREN or TVA or whatever)'),
  "siren": zod.string().max(apiAdmincompaniesIdGetResponseSirenMax).regex(apiAdmincompaniesIdGetResponseSirenRegExp).nullish().describe('Company SIREN'),
  "tva": zod.string().max(apiAdmincompaniesIdGetResponseTvaMax).nullish().describe('Company TVA'),
  "addressLine1": zod.string().min(apiAdmincompaniesIdGetResponseAddressLine1Min).max(apiAdmincompaniesIdGetResponseAddressLine1Max).describe('Company address line 1'),
  "addressLine2": zod.string().max(apiAdmincompaniesIdGetResponseAddressLine2Max).nullish().describe('Company address line 2'),
  "addressLine3": zod.string().max(apiAdmincompaniesIdGetResponseAddressLine3Max).nullish().describe('Company address line 3'),
  "zipcode": zod.string().min(apiAdmincompaniesIdGetResponseZipcodeMin).max(apiAdmincompaniesIdGetResponseZipcodeMax).describe('Company zipcode'),
  "city": zod.string().max(apiAdmincompaniesIdGetResponseCityMax).describe('Company city'),
  "country": zod.object({
  "alpha3": zod.string().min(apiAdmincompaniesIdGetResponseCountryAlpha3Min).max(apiAdmincompaniesIdGetResponseCountryAlpha3Max).describe('Country alpha3 code'),
  "name": zod.string().describe('Country name'),
  "currencyName": zod.string().describe('Country currency'),
  "currencySymbol": zod.string().describe('Country currency symbol')
}).optional(),
  "createdAt": zod.string().datetime({}).describe('Company creation date'),
  "userWorkspaces": zod.array(zod.object({
  "user": zod.object({
  "id": zod.number().describe('User ID'),
  "fullname": zod.string().describe('User fullname'),
  "avatar": zod.string().max(apiAdmincompaniesIdGetResponseUserWorkspacesItemUserAvatarMax).nullish().describe('User avatar'),
  "isDeleted": zod.boolean().describe('Whether the entity has been soft-deleted')
}),
  "maxRole": zod.enum(['ROLE_MEMBER', 'ROLE_MANAGER', 'ROLE_SALES_ADMIN', 'ROLE_ADMIN', 'ROLE_FIDDY_ADMIN']).optional().describe('User max role'),
  "uniqueCode": zod.string().min(1).max(apiAdmincompaniesIdGetResponseUserWorkspacesItemUniqueCodeMax).regex(apiAdmincompaniesIdGetResponseUserWorkspacesItemUniqueCodeRegExp).describe('User unique code')
})),
  "companyHistory": zod.array(zod.object({
  "property": zod.string().max(apiAdmincompaniesIdGetResponseCompanyHistoryItemPropertyMax).describe('Company field that was updated'),
  "previousValue": zod.string().describe('Company field old value'),
  "newValue": zod.string().describe('Company field new value'),
  "createdAt": zod.string().datetime({}).describe('History creation date'),
  "madeByUser": zod.object({
  "id": zod.number().describe('User ID'),
  "fullname": zod.string().describe('User fullname'),
  "avatar": zod.string().max(apiAdmincompaniesIdGetResponseCompanyHistoryItemMadeByUserAvatarMax).nullish().describe('User avatar'),
  "isDeleted": zod.boolean().describe('Whether the entity has been soft-deleted')
})
})),
  "status": zod.enum(['company.status.unregistered', 'company.status.registered', 'company.status.blocked', 'company.status.inactive']).describe('Company status (read-only, computed from managers statuses)'),
  "registeredAt": zod.string().datetime({}).nullish().describe('Datetime where the first managed completed registration was done'),
  "logicStepHistory": zod.array(zod.object({
  "logicTypeStep": zod.object({
  "id": zod.number().optional().describe('Step ID'),
  "name": zod.string().max(apiAdmincompaniesIdGetResponseLogicStepHistoryItemLogicTypeStepNameMax).describe('Step name')
}),
  "createdAt": zod.string().datetime({}).describe('Step history creation datetime')
})).optional(),
  "typology": zod.union([zod.object({
  "id": zod.number().describe('Typology ID'),
  "name": zod.string().max(apiAdmincompaniesIdGetResponseTypologyNameMax).describe('Name of the typology')
}),zod.null()]).optional(),
  "points": zod.array(zod.object({
  "amount": zod.number().describe('Points amount'),
  "label": zod.string().max(apiAdmincompaniesIdGetResponsePointsItemLabelMax).nullish().describe('Points label'),
  "addedByUserWorkspace": zod.union([zod.object({
  "user": zod.object({
  "id": zod.number().describe('User ID'),
  "fullname": zod.string().describe('User fullname'),
  "avatar": zod.string().max(apiAdmincompaniesIdGetResponsePointsItemAddedByUserWorkspaceUserAvatarMax).nullish().describe('User avatar'),
  "isDeleted": zod.boolean().describe('Whether the entity has been soft-deleted')
}),
  "maxRole": zod.enum(['ROLE_MEMBER', 'ROLE_MANAGER', 'ROLE_SALES_ADMIN', 'ROLE_ADMIN', 'ROLE_FIDDY_ADMIN']).optional().describe('User max role'),
  "uniqueCode": zod.string().min(1).max(apiAdmincompaniesIdGetResponsePointsItemAddedByUserWorkspaceUniqueCodeMax).regex(apiAdmincompaniesIdGetResponsePointsItemAddedByUserWorkspaceUniqueCodeRegExp).describe('User unique code')
}),zod.null()]).optional(),
  "valueDate": zod.string().datetime({}).describe('Points value date')
})),
  "pointsPerMonth": zod.array(zod.object({
  "value": zod.number().describe('Value in this month'),
  "month": zod.number().describe('Month of the year (1-12)'),
  "year": zod.number().describe('Year')
})),
  "caAmount": zod.number().describe('CA amount of the company'),
  "acquiredPoints": zod.number().describe('Total of acquired points'),
  "spentPoints": zod.number().describe('Total of spent points'),
  "perfsPerMonth": zod.array(zod.object({
  "value": zod.number().describe('Value in this month'),
  "month": zod.number().describe('Month of the year (1-12)'),
  "year": zod.number().describe('Year')
})),
  "orders": zod.array(zod.object({
  "id": zod.number().describe('Order ID'),
  "reference": zod.string().max(apiAdmincompaniesIdGetResponseOrdersItemReferenceMax).describe('Order reference'),
  "status": zod.enum(['order.status.pending', 'order.status.confirmed', 'order.status.completed', 'order.status.canceled', 'order.status.failed']).describe('Order status (label)'),
  "type": zod.enum(['provider', 'reward', 'custom']).describe('Order type'),
  "point": zod.union([zod.object({
  "amount": zod.number().describe('Points amount'),
  "label": zod.string().max(apiAdmincompaniesIdGetResponseOrdersItemPointLabelMax).nullish().describe('Points label'),
  "addedByUserWorkspace": zod.union([zod.object({
  "user": zod.object({
  "id": zod.number().describe('User ID'),
  "fullname": zod.string().describe('User fullname'),
  "avatar": zod.string().max(apiAdmincompaniesIdGetResponseOrdersItemPointAddedByUserWorkspaceUserAvatarMax).nullish().describe('User avatar'),
  "isDeleted": zod.boolean().describe('Whether the entity has been soft-deleted')
}),
  "maxRole": zod.enum(['ROLE_MEMBER', 'ROLE_MANAGER', 'ROLE_SALES_ADMIN', 'ROLE_ADMIN', 'ROLE_FIDDY_ADMIN']).optional().describe('User max role'),
  "uniqueCode": zod.string().min(1).max(apiAdmincompaniesIdGetResponseOrdersItemPointAddedByUserWorkspaceUniqueCodeMax).regex(apiAdmincompaniesIdGetResponseOrdersItemPointAddedByUserWorkspaceUniqueCodeRegExp).describe('User unique code')
}),zod.null()]).optional(),
  "valueDate": zod.string().datetime({}).describe('Points value date')
}),zod.null()]).optional(),
  "madeBy": zod.object({
  "user": zod.object({
  "id": zod.number().describe('User ID'),
  "fullname": zod.string().describe('User fullname'),
  "avatar": zod.string().max(apiAdmincompaniesIdGetResponseOrdersItemMadeByUserAvatarMax).nullish().describe('User avatar'),
  "isDeleted": zod.boolean().describe('Whether the entity has been soft-deleted')
}),
  "maxRole": zod.enum(['ROLE_MEMBER', 'ROLE_MANAGER', 'ROLE_SALES_ADMIN', 'ROLE_ADMIN', 'ROLE_FIDDY_ADMIN']).optional().describe('User max role'),
  "uniqueCode": zod.string().min(1).max(apiAdmincompaniesIdGetResponseOrdersItemMadeByUniqueCodeMax).regex(apiAdmincompaniesIdGetResponseOrdersItemMadeByUniqueCodeRegExp).describe('User unique code')
}),
  "createdAt": zod.string().datetime({}).describe('Order creation date'),
  "productsCount": zod.number().describe('Number of products in the order'),
  "shops": zod.array(zod.object({
  "displayName": zod.string().max(apiAdmincompaniesIdGetResponseOrdersItemShopsItemDisplayNameMax).describe('Shop display name')
}))
})).optional(),
  "targetStatuses": zod.array(zod.object({
  "id": zod.number().describe('Target Status ID'),
  "logicTypeTarget": zod.object({
  "reference": zod.string().max(apiAdmincompaniesIdGetResponseTargetStatusesItemLogicTypeTargetReferenceMax).describe('Target reference name'),
  "description": zod.string().nullish().describe('Target description (label)')
}).optional(),
  "value": zod.number().min(apiAdmincompaniesIdGetResponseTargetStatusesItemValueMin).describe('Current target value (in points or euros)'),
  "targetValue": zod.number().min(apiAdmincompaniesIdGetResponseTargetStatusesItemTargetValueMin).describe('Target value to achieve (in points or euros)'),
  "updatedAt": zod.string().datetime({}).optional().describe('Date of the last update'),
  "achievedAt": zod.string().datetime({}).nullish().describe('Date when the target was achieved'),
  "achievedPercentage": zod.number().optional()
})).optional(),
  "pointCoeff": zod.number().nullish().describe('Coefficient used to calculate points (depending conversion type)'),
  "comment": zod.string().nullish().describe('Comment about the company'),
  "responsibles": zod.array(zod.object({
  "user": zod.object({
  "id": zod.number().describe('User ID'),
  "fullname": zod.string().describe('User fullname'),
  "avatar": zod.string().max(apiAdmincompaniesIdGetResponseResponsiblesItemUserAvatarMax).nullish().describe('User avatar'),
  "isDeleted": zod.boolean().describe('Whether the entity has been soft-deleted')
}),
  "maxRole": zod.enum(['ROLE_MEMBER', 'ROLE_MANAGER', 'ROLE_SALES_ADMIN', 'ROLE_ADMIN', 'ROLE_FIDDY_ADMIN']).optional().describe('User max role'),
  "uniqueCode": zod.string().min(1).max(apiAdmincompaniesIdGetResponseResponsiblesItemUniqueCodeMax).regex(apiAdmincompaniesIdGetResponseResponsiblesItemUniqueCodeRegExp).describe('User unique code')
})).optional(),
  "lastStepReached": zod.union([zod.object({
  "id": zod.number().optional().describe('Step ID'),
  "name": zod.string().max(apiAdmincompaniesIdGetResponseLastStepReachedNameMax).describe('Step name')
}),zod.null()]).optional(),
  "balance": zod.number().describe('Balance of the company')
})


/**
 * Soft-delete a company and all its users
 * @summary Soft-delete a company
 */
export const apiAdmincompaniesIdDeleteParams = zod.object({
  "id": zod.string().describe('Company identifier')
})


/**
 * Updates the Company resource.
 * @summary Updates the Company resource.
 */
export const apiCompaniesIdPatchParams = zod.object({
  "id": zod.string().describe('Company identifier')
})

export const apiCompaniesIdPatchBodyNameMax = 100;

export const apiCompaniesIdPatchBodyUniqueCodeMax = 50;


export const apiCompaniesIdPatchBodyUniqueCodeRegExp = new RegExp('^([a-zA-Z0-9]+)$');
export const apiCompaniesIdPatchBodySirenMax = 9;


export const apiCompaniesIdPatchBodySirenRegExp = new RegExp('^([0-9]*)$');
export const apiCompaniesIdPatchBodyTvaMax = 20;

export const apiCompaniesIdPatchBodyAddressLine1Min = 7;
export const apiCompaniesIdPatchBodyAddressLine1Max = 255;

export const apiCompaniesIdPatchBodyAddressLine2Max = 255;

export const apiCompaniesIdPatchBodyAddressLine3Max = 255;

export const apiCompaniesIdPatchBodyZipcodeMin = 4;
export const apiCompaniesIdPatchBodyZipcodeMax = 20;

export const apiCompaniesIdPatchBodyCityMax = 100;



export const apiCompaniesIdPatchBody = zod.object({
  "name": zod.string().min(1).max(apiCompaniesIdPatchBodyNameMax).optional().describe('Company name'),
  "uniqueCode": zod.string().min(1).max(apiCompaniesIdPatchBodyUniqueCodeMax).regex(apiCompaniesIdPatchBodyUniqueCodeRegExp).optional().describe('Company unique code (SIREN or TVA or whatever)'),
  "siren": zod.string().max(apiCompaniesIdPatchBodySirenMax).regex(apiCompaniesIdPatchBodySirenRegExp).nullish().describe('Company SIREN'),
  "tva": zod.string().max(apiCompaniesIdPatchBodyTvaMax).nullish().describe('Company TVA'),
  "addressLine1": zod.string().min(apiCompaniesIdPatchBodyAddressLine1Min).max(apiCompaniesIdPatchBodyAddressLine1Max).optional().describe('Company address line 1'),
  "addressLine2": zod.string().max(apiCompaniesIdPatchBodyAddressLine2Max).nullish().describe('Company address line 2'),
  "addressLine3": zod.string().max(apiCompaniesIdPatchBodyAddressLine3Max).nullish().describe('Company address line 3'),
  "zipcode": zod.string().min(apiCompaniesIdPatchBodyZipcodeMin).max(apiCompaniesIdPatchBodyZipcodeMax).optional().describe('Company zipcode'),
  "city": zod.string().min(1).max(apiCompaniesIdPatchBodyCityMax).optional().describe('Company city'),
  "countryAlpha3": zod.string().optional().describe('Company country alpha3'),
  "responsiblesUniqueCodes": zod.string().nullish().describe('User unique code(s) to link to the company, separated by \"|\" for multiple'),
  "typologyName": zod.string().nullish().describe('The typology name to which the company belongs'),
  "pointCoeff": zod.number().nullish().describe('Coefficient used to calculate points (depending conversion type)'),
  "comment": zod.string().nullish().describe('Comment about the company')
})

export const apiCompaniesIdPatchResponseNameMax = 100;

export const apiCompaniesIdPatchResponseUniqueCodeMax = 50;


export const apiCompaniesIdPatchResponseUniqueCodeRegExp = new RegExp('^([a-zA-Z0-9]+)$');
export const apiCompaniesIdPatchResponseSirenMax = 9;


export const apiCompaniesIdPatchResponseSirenRegExp = new RegExp('^([0-9]*)$');
export const apiCompaniesIdPatchResponseTvaMax = 20;

export const apiCompaniesIdPatchResponseAddressLine1Min = 7;
export const apiCompaniesIdPatchResponseAddressLine1Max = 255;

export const apiCompaniesIdPatchResponseAddressLine2Max = 255;

export const apiCompaniesIdPatchResponseAddressLine3Max = 255;

export const apiCompaniesIdPatchResponseZipcodeMin = 4;
export const apiCompaniesIdPatchResponseZipcodeMax = 20;

export const apiCompaniesIdPatchResponseCityMax = 100;

export const apiCompaniesIdPatchResponseCountryAlpha3Min = 3;
export const apiCompaniesIdPatchResponseCountryAlpha3Max = 3;

export const apiCompaniesIdPatchResponseUserWorkspacesItemUserAvatarMax = 255;

export const apiCompaniesIdPatchResponseUserWorkspacesItemUniqueCodeMax = 50;


export const apiCompaniesIdPatchResponseUserWorkspacesItemUniqueCodeRegExp = new RegExp('^([a-zA-Z0-9]+)$');
export const apiCompaniesIdPatchResponseCompanyHistoryItemPropertyMax = 255;

export const apiCompaniesIdPatchResponseCompanyHistoryItemMadeByUserAvatarMax = 255;

export const apiCompaniesIdPatchResponseStatusDefault = "company.status.unregistered";export const apiCompaniesIdPatchResponseLogicStepHistoryItemLogicTypeStepNameMax = 50;

export const apiCompaniesIdPatchResponseTypologyNameMax = 100;

export const apiCompaniesIdPatchResponsePointsItemLabelMax = 255;

export const apiCompaniesIdPatchResponsePointsItemAddedByUserWorkspaceUserAvatarMax = 255;

export const apiCompaniesIdPatchResponsePointsItemAddedByUserWorkspaceUniqueCodeMax = 50;


export const apiCompaniesIdPatchResponsePointsItemAddedByUserWorkspaceUniqueCodeRegExp = new RegExp('^([a-zA-Z0-9]+)$');
export const apiCompaniesIdPatchResponsePointsItemValueDateDefault = "";export const apiCompaniesIdPatchResponseOrdersItemReferenceMax = 20;

export const apiCompaniesIdPatchResponseOrdersItemStatusMax = 50;

export const apiCompaniesIdPatchResponseOrdersItemTypeMax = 10;

export const apiCompaniesIdPatchResponseOrdersItemPointLabelMax = 255;

export const apiCompaniesIdPatchResponseOrdersItemPointAddedByUserWorkspaceUserAvatarMax = 255;

export const apiCompaniesIdPatchResponseOrdersItemPointAddedByUserWorkspaceUniqueCodeMax = 50;


export const apiCompaniesIdPatchResponseOrdersItemPointAddedByUserWorkspaceUniqueCodeRegExp = new RegExp('^([a-zA-Z0-9]+)$');
export const apiCompaniesIdPatchResponseOrdersItemPointValueDateDefault = "";export const apiCompaniesIdPatchResponseOrdersItemMadeByUserAvatarMax = 255;

export const apiCompaniesIdPatchResponseOrdersItemMadeByUniqueCodeMax = 50;


export const apiCompaniesIdPatchResponseOrdersItemMadeByUniqueCodeRegExp = new RegExp('^([a-zA-Z0-9]+)$');
export const apiCompaniesIdPatchResponseOrdersItemProductsCountDefault = 0;export const apiCompaniesIdPatchResponseOrdersItemShopsItemDisplayNameMax = 100;

export const apiCompaniesIdPatchResponseTargetStatusesItemLogicTypeTargetReferenceMax = 20;

export const apiCompaniesIdPatchResponseTargetStatusesItemValueDefault = 0;
export const apiCompaniesIdPatchResponseTargetStatusesItemValueMin = 0;

export const apiCompaniesIdPatchResponseTargetStatusesItemTargetValueMin = 0;

export const apiCompaniesIdPatchResponseTargetStatusesItemAchievedPercentageDefault = 0;export const apiCompaniesIdPatchResponseResponsiblesItemUserAvatarMax = 255;

export const apiCompaniesIdPatchResponseResponsiblesItemUniqueCodeMax = 50;


export const apiCompaniesIdPatchResponseResponsiblesItemUniqueCodeRegExp = new RegExp('^([a-zA-Z0-9]+)$');
export const apiCompaniesIdPatchResponseLastStepReachedNameMax = 50;



export const apiCompaniesIdPatchResponse = zod.object({
  "id": zod.number().describe('Company ID'),
  "name": zod.string().max(apiCompaniesIdPatchResponseNameMax).describe('Company name'),
  "uniqueCode": zod.string().max(apiCompaniesIdPatchResponseUniqueCodeMax).regex(apiCompaniesIdPatchResponseUniqueCodeRegExp).describe('Company unique code (SIREN or TVA or whatever)'),
  "siren": zod.string().max(apiCompaniesIdPatchResponseSirenMax).regex(apiCompaniesIdPatchResponseSirenRegExp).nullish().describe('Company SIREN'),
  "tva": zod.string().max(apiCompaniesIdPatchResponseTvaMax).nullish().describe('Company TVA'),
  "addressLine1": zod.string().min(apiCompaniesIdPatchResponseAddressLine1Min).max(apiCompaniesIdPatchResponseAddressLine1Max).describe('Company address line 1'),
  "addressLine2": zod.string().max(apiCompaniesIdPatchResponseAddressLine2Max).nullish().describe('Company address line 2'),
  "addressLine3": zod.string().max(apiCompaniesIdPatchResponseAddressLine3Max).nullish().describe('Company address line 3'),
  "zipcode": zod.string().min(apiCompaniesIdPatchResponseZipcodeMin).max(apiCompaniesIdPatchResponseZipcodeMax).describe('Company zipcode'),
  "city": zod.string().max(apiCompaniesIdPatchResponseCityMax).describe('Company city'),
  "country": zod.object({
  "alpha3": zod.string().min(apiCompaniesIdPatchResponseCountryAlpha3Min).max(apiCompaniesIdPatchResponseCountryAlpha3Max).describe('Country alpha3 code'),
  "name": zod.string().describe('Country name'),
  "currencyName": zod.string().describe('Country currency'),
  "currencySymbol": zod.string().describe('Country currency symbol')
}).optional(),
  "createdAt": zod.string().datetime({}).describe('Company creation date'),
  "userWorkspaces": zod.array(zod.object({
  "user": zod.object({
  "id": zod.number().describe('User ID'),
  "fullname": zod.string().describe('User fullname'),
  "avatar": zod.string().max(apiCompaniesIdPatchResponseUserWorkspacesItemUserAvatarMax).nullish().describe('User avatar'),
  "isDeleted": zod.boolean().describe('Whether the entity has been soft-deleted')
}),
  "maxRole": zod.enum(['ROLE_MEMBER', 'ROLE_MANAGER', 'ROLE_SALES_ADMIN', 'ROLE_ADMIN', 'ROLE_FIDDY_ADMIN']).optional().describe('User max role'),
  "uniqueCode": zod.string().min(1).max(apiCompaniesIdPatchResponseUserWorkspacesItemUniqueCodeMax).regex(apiCompaniesIdPatchResponseUserWorkspacesItemUniqueCodeRegExp).describe('User unique code')
})),
  "companyHistory": zod.array(zod.object({
  "property": zod.string().max(apiCompaniesIdPatchResponseCompanyHistoryItemPropertyMax).describe('Company field that was updated'),
  "previousValue": zod.string().describe('Company field old value'),
  "newValue": zod.string().describe('Company field new value'),
  "createdAt": zod.string().datetime({}).describe('History creation date'),
  "madeByUser": zod.object({
  "id": zod.number().describe('User ID'),
  "fullname": zod.string().describe('User fullname'),
  "avatar": zod.string().max(apiCompaniesIdPatchResponseCompanyHistoryItemMadeByUserAvatarMax).nullish().describe('User avatar'),
  "isDeleted": zod.boolean().describe('Whether the entity has been soft-deleted')
})
})),
  "status": zod.enum(['company.status.unregistered', 'company.status.registered', 'company.status.blocked', 'company.status.inactive']).describe('Company status (read-only, computed from managers statuses)'),
  "registeredAt": zod.string().datetime({}).nullish().describe('Datetime where the first managed completed registration was done'),
  "logicStepHistory": zod.array(zod.object({
  "logicTypeStep": zod.object({
  "id": zod.number().optional().describe('Step ID'),
  "name": zod.string().max(apiCompaniesIdPatchResponseLogicStepHistoryItemLogicTypeStepNameMax).describe('Step name')
}),
  "createdAt": zod.string().datetime({}).describe('Step history creation datetime')
})).optional(),
  "typology": zod.union([zod.object({
  "id": zod.number().describe('Typology ID'),
  "name": zod.string().max(apiCompaniesIdPatchResponseTypologyNameMax).describe('Name of the typology')
}),zod.null()]).optional(),
  "points": zod.array(zod.object({
  "amount": zod.number().describe('Points amount'),
  "label": zod.string().max(apiCompaniesIdPatchResponsePointsItemLabelMax).nullish().describe('Points label'),
  "addedByUserWorkspace": zod.union([zod.object({
  "user": zod.object({
  "id": zod.number().describe('User ID'),
  "fullname": zod.string().describe('User fullname'),
  "avatar": zod.string().max(apiCompaniesIdPatchResponsePointsItemAddedByUserWorkspaceUserAvatarMax).nullish().describe('User avatar'),
  "isDeleted": zod.boolean().describe('Whether the entity has been soft-deleted')
}),
  "maxRole": zod.enum(['ROLE_MEMBER', 'ROLE_MANAGER', 'ROLE_SALES_ADMIN', 'ROLE_ADMIN', 'ROLE_FIDDY_ADMIN']).optional().describe('User max role'),
  "uniqueCode": zod.string().min(1).max(apiCompaniesIdPatchResponsePointsItemAddedByUserWorkspaceUniqueCodeMax).regex(apiCompaniesIdPatchResponsePointsItemAddedByUserWorkspaceUniqueCodeRegExp).describe('User unique code')
}),zod.null()]).optional(),
  "valueDate": zod.string().datetime({}).describe('Points value date')
})),
  "pointsPerMonth": zod.array(zod.object({
  "value": zod.number().describe('Value in this month'),
  "month": zod.number().describe('Month of the year (1-12)'),
  "year": zod.number().describe('Year')
})),
  "caAmount": zod.number().describe('CA amount of the company'),
  "acquiredPoints": zod.number().describe('Total of acquired points'),
  "spentPoints": zod.number().describe('Total of spent points'),
  "perfsPerMonth": zod.array(zod.object({
  "value": zod.number().describe('Value in this month'),
  "month": zod.number().describe('Month of the year (1-12)'),
  "year": zod.number().describe('Year')
})),
  "orders": zod.array(zod.object({
  "id": zod.number().describe('Order ID'),
  "reference": zod.string().max(apiCompaniesIdPatchResponseOrdersItemReferenceMax).describe('Order reference'),
  "status": zod.enum(['order.status.pending', 'order.status.confirmed', 'order.status.completed', 'order.status.canceled', 'order.status.failed']).describe('Order status (label)'),
  "type": zod.enum(['provider', 'reward', 'custom']).describe('Order type'),
  "point": zod.union([zod.object({
  "amount": zod.number().describe('Points amount'),
  "label": zod.string().max(apiCompaniesIdPatchResponseOrdersItemPointLabelMax).nullish().describe('Points label'),
  "addedByUserWorkspace": zod.union([zod.object({
  "user": zod.object({
  "id": zod.number().describe('User ID'),
  "fullname": zod.string().describe('User fullname'),
  "avatar": zod.string().max(apiCompaniesIdPatchResponseOrdersItemPointAddedByUserWorkspaceUserAvatarMax).nullish().describe('User avatar'),
  "isDeleted": zod.boolean().describe('Whether the entity has been soft-deleted')
}),
  "maxRole": zod.enum(['ROLE_MEMBER', 'ROLE_MANAGER', 'ROLE_SALES_ADMIN', 'ROLE_ADMIN', 'ROLE_FIDDY_ADMIN']).optional().describe('User max role'),
  "uniqueCode": zod.string().min(1).max(apiCompaniesIdPatchResponseOrdersItemPointAddedByUserWorkspaceUniqueCodeMax).regex(apiCompaniesIdPatchResponseOrdersItemPointAddedByUserWorkspaceUniqueCodeRegExp).describe('User unique code')
}),zod.null()]).optional(),
  "valueDate": zod.string().datetime({}).describe('Points value date')
}),zod.null()]).optional(),
  "madeBy": zod.object({
  "user": zod.object({
  "id": zod.number().describe('User ID'),
  "fullname": zod.string().describe('User fullname'),
  "avatar": zod.string().max(apiCompaniesIdPatchResponseOrdersItemMadeByUserAvatarMax).nullish().describe('User avatar'),
  "isDeleted": zod.boolean().describe('Whether the entity has been soft-deleted')
}),
  "maxRole": zod.enum(['ROLE_MEMBER', 'ROLE_MANAGER', 'ROLE_SALES_ADMIN', 'ROLE_ADMIN', 'ROLE_FIDDY_ADMIN']).optional().describe('User max role'),
  "uniqueCode": zod.string().min(1).max(apiCompaniesIdPatchResponseOrdersItemMadeByUniqueCodeMax).regex(apiCompaniesIdPatchResponseOrdersItemMadeByUniqueCodeRegExp).describe('User unique code')
}),
  "createdAt": zod.string().datetime({}).describe('Order creation date'),
  "productsCount": zod.number().describe('Number of products in the order'),
  "shops": zod.array(zod.object({
  "displayName": zod.string().max(apiCompaniesIdPatchResponseOrdersItemShopsItemDisplayNameMax).describe('Shop display name')
}))
})).optional(),
  "targetStatuses": zod.array(zod.object({
  "id": zod.number().describe('Target Status ID'),
  "logicTypeTarget": zod.object({
  "reference": zod.string().max(apiCompaniesIdPatchResponseTargetStatusesItemLogicTypeTargetReferenceMax).describe('Target reference name'),
  "description": zod.string().nullish().describe('Target description (label)')
}).optional(),
  "value": zod.number().min(apiCompaniesIdPatchResponseTargetStatusesItemValueMin).describe('Current target value (in points or euros)'),
  "targetValue": zod.number().min(apiCompaniesIdPatchResponseTargetStatusesItemTargetValueMin).describe('Target value to achieve (in points or euros)'),
  "updatedAt": zod.string().datetime({}).optional().describe('Date of the last update'),
  "achievedAt": zod.string().datetime({}).nullish().describe('Date when the target was achieved'),
  "achievedPercentage": zod.number().optional()
})).optional(),
  "pointCoeff": zod.number().nullish().describe('Coefficient used to calculate points (depending conversion type)'),
  "comment": zod.string().nullish().describe('Comment about the company'),
  "responsibles": zod.array(zod.object({
  "user": zod.object({
  "id": zod.number().describe('User ID'),
  "fullname": zod.string().describe('User fullname'),
  "avatar": zod.string().max(apiCompaniesIdPatchResponseResponsiblesItemUserAvatarMax).nullish().describe('User avatar'),
  "isDeleted": zod.boolean().describe('Whether the entity has been soft-deleted')
}),
  "maxRole": zod.enum(['ROLE_MEMBER', 'ROLE_MANAGER', 'ROLE_SALES_ADMIN', 'ROLE_ADMIN', 'ROLE_FIDDY_ADMIN']).optional().describe('User max role'),
  "uniqueCode": zod.string().min(1).max(apiCompaniesIdPatchResponseResponsiblesItemUniqueCodeMax).regex(apiCompaniesIdPatchResponseResponsiblesItemUniqueCodeRegExp).describe('User unique code')
})).optional(),
  "lastStepReached": zod.union([zod.object({
  "id": zod.number().optional().describe('Step ID'),
  "name": zod.string().max(apiCompaniesIdPatchResponseLastStepReachedNameMax).describe('Step name')
}),zod.null()]).optional(),
  "balance": zod.number().describe('Balance of the company')
})


/**
 * Add a responsible to a company
 * @summary Add a responsible to a company
 */
export const apiAdmincompaniesCompanyIdresponsiblePostParams = zod.object({
  "companyId": zod.number().describe('Company identifier')
})

export const apiAdmincompaniesCompanyIdresponsiblePostBody = zod.object({
  "responsible": zod.string().describe('IRI of the responsible')
})


/**
 * Remove a responsible from a company
 * @summary Remove a responsible from a company
 */
export const apiAdmincompaniesCompanyIdresponsibleResponsibleIdDeleteParams = zod.object({
  "companyId": zod.number().describe('Company identifier'),
  "responsibleId": zod.number().describe('UserWorkspace identifier of the responsible to remove')
})


/**
 * Retrieves the collection of Config resources.
 * @summary Retrieves the collection of Config resources.
 */
export const apiAdminconfigsGetCollectionQueryParams = zod.object({
  "type": zod.string().optional(),
  "type[]": zod.array(zod.string()).optional(),
  "key": zod.string().optional(),
  "key[]": zod.array(zod.string()).optional()
})

export const apiAdminconfigsGetCollectionResponseTypeMax = 20;

export const apiAdminconfigsGetCollectionResponseKeyMax = 30;

export const apiAdminconfigsGetCollectionResponseTitleMax = 255;

export const apiAdminconfigsGetCollectionResponseDescriptionMax = 255;



export const apiAdminconfigsGetCollectionResponseItem = zod.object({
  "id": zod.number().optional().describe('Config ID'),
  "type": zod.enum(['core', 'media', 'style', 'shop', 'link']).describe('Config type'),
  "key": zod.string().max(apiAdminconfigsGetCollectionResponseKeyMax).describe('Config key'),
  "isPublic": zod.boolean().describe('If this config need to be used on public views (like auth page)'),
  "isSecret": zod.boolean().describe('If this config is secret (like API keys)'),
  "title": zod.string().max(apiAdminconfigsGetCollectionResponseTitleMax).describe('Config title'),
  "description": zod.string().max(apiAdminconfigsGetCollectionResponseDescriptionMax).describe('Config description')
})
export const apiAdminconfigsGetCollectionResponse = zod.array(apiAdminconfigsGetCollectionResponseItem)


/**
 * Creates a Config resource.
 * @summary Creates a Config resource.
 */
export const apiAdminconfigsPostBodyTypeMax = 20;

export const apiAdminconfigsPostBodyKeyMax = 30;

export const apiAdminconfigsPostBodyTitleMax = 255;

export const apiAdminconfigsPostBodyDescriptionMax = 255;



export const apiAdminconfigsPostBody = zod.object({
  "type": zod.enum(['core', 'media', 'style', 'shop', 'link']).describe('Config type'),
  "key": zod.string().max(apiAdminconfigsPostBodyKeyMax).describe('Config key'),
  "isPublic": zod.boolean().describe('If this config need to be used on public views (like auth page)'),
  "isSecret": zod.boolean().describe('If this config is secret (like API keys)'),
  "title": zod.string().max(apiAdminconfigsPostBodyTitleMax).describe('Config title'),
  "description": zod.string().max(apiAdminconfigsPostBodyDescriptionMax).describe('Config description')
})


/**
 * Creates a Country resource.
 * @summary Creates a Country resource.
 */
export const apiAdmincountriesPostBodyAlpha3Min = 3;
export const apiAdmincountriesPostBodyAlpha3Max = 3;



export const apiAdmincountriesPostBody = zod.object({
  "alpha3": zod.string().min(apiAdmincountriesPostBodyAlpha3Min).max(apiAdmincountriesPostBodyAlpha3Max).describe('Country alpha3 code')
})


/**
 * Retrieves the collection of Country resources.
 * @summary Retrieves the collection of Country resources.
 */
export const apiCountriesGetCollectionQueryPageDefault = 1;export const apiCountriesGetCollectionQueryPerPageDefault = 30;
export const apiCountriesGetCollectionQueryPerPageMin = 0;
export const apiCountriesGetCollectionQueryPerPageMax = 30;



export const apiCountriesGetCollectionQueryParams = zod.object({
  "page": zod.number().default(apiCountriesGetCollectionQueryPageDefault).describe('The collection page number'),
  "perPage": zod.number().min(apiCountriesGetCollectionQueryPerPageMin).max(apiCountriesGetCollectionQueryPerPageMax).default(apiCountriesGetCollectionQueryPerPageDefault).describe('The number of items per page')
})

export const apiCountriesGetCollectionResponseDataItemAlpha3Min = 3;
export const apiCountriesGetCollectionResponseDataItemAlpha3Max = 3;



export const apiCountriesGetCollectionResponse = zod.object({
  "data": zod.array(zod.unknown()),
  "pagination": zod.object({
  "first": zod.number(),
  "current": zod.number(),
  "last": zod.number(),
  "previous": zod.number(),
  "next": zod.number(),
  "totalItems": zod.number(),
  "perPage": zod.number()
})
}).and(zod.object({
  "data": zod.array(zod.object({
  "alpha3": zod.string().min(apiCountriesGetCollectionResponseDataItemAlpha3Min).max(apiCountriesGetCollectionResponseDataItemAlpha3Max).describe('Country alpha3 code'),
  "alpha2": zod.string().describe('Country alpha2 code'),
  "name": zod.string().describe('Country name'),
  "currencyName": zod.string().describe('Country currency'),
  "currencySymbol": zod.string().describe('Country currency symbol')
})).optional()
}))


/**
 * Retrieves a Country resource.
 * @summary Retrieves a Country resource.
 */
export const apiCountriesAlpha3GetParams = zod.object({
  "alpha3": zod.string().describe('Country identifier')
})

export const apiCountriesAlpha3GetResponseAlpha3Min = 3;
export const apiCountriesAlpha3GetResponseAlpha3Max = 3;



export const apiCountriesAlpha3GetResponse = zod.object({
  "alpha3": zod.string().min(apiCountriesAlpha3GetResponseAlpha3Min).max(apiCountriesAlpha3GetResponseAlpha3Max).describe('Country alpha3 code'),
  "alpha2": zod.string().describe('Country alpha2 code'),
  "name": zod.string().describe('Country name'),
  "currencyName": zod.string().describe('Country currency'),
  "currencySymbol": zod.string().describe('Country currency symbol')
})


/**
 * Paginated list of emails sent to users of the current workspace, sorted by sending date descending. Filterable by user workspace (userWorkspace.uniqueCode) or by company (userWorkspace.company.uniqueCode, userWorkspace.company.name), or by user fullname (user.fullname)
 * @summary Get emails sent to users of the current workspace
 */
export const apiAdminemailsGetCollectionQueryPageDefault = 1;export const apiAdminemailsGetCollectionQueryPerPageDefault = 30;
export const apiAdminemailsGetCollectionQueryPerPageMin = 0;
export const apiAdminemailsGetCollectionQueryPerPageMax = 30;

export const apiAdminemailsGetCollectionQueryOrderSentAtDefault = "asc";export const apiAdminemailsGetCollectionQueryOrderStatusUpdatedAtDefault = "asc";export const apiAdminemailsGetCollectionQueryOrderStatusDefault = "asc";

export const apiAdminemailsGetCollectionQueryParams = zod.object({
  "page": zod.number().default(apiAdminemailsGetCollectionQueryPageDefault).describe('The collection page number'),
  "perPage": zod.number().min(apiAdminemailsGetCollectionQueryPerPageMin).max(apiAdminemailsGetCollectionQueryPerPageMax).default(apiAdminemailsGetCollectionQueryPerPageDefault).describe('The number of items per page'),
  "subject": zod.string().optional(),
  "to": zod.string().optional(),
  "status": zod.string().optional(),
  "status[]": zod.array(zod.string()).optional(),
  "userWorkspace.uniqueCode": zod.string().optional(),
  "userWorkspace.uniqueCode[]": zod.array(zod.string()).optional(),
  "userWorkspace.company.uniqueCode": zod.string().optional(),
  "userWorkspace.company.uniqueCode[]": zod.array(zod.string()).optional(),
  "userWorkspace.company.name": zod.string().optional(),
  "sentAt[before]": zod.string().optional(),
  "sentAt[strictly_before]": zod.string().optional(),
  "sentAt[after]": zod.string().optional(),
  "sentAt[strictly_after]": zod.string().optional(),
  "statusUpdatedAt[before]": zod.string().optional(),
  "statusUpdatedAt[strictly_before]": zod.string().optional(),
  "statusUpdatedAt[after]": zod.string().optional(),
  "statusUpdatedAt[strictly_after]": zod.string().optional(),
  "order[sentAt]": zod.enum(['asc', 'desc']).default(apiAdminemailsGetCollectionQueryOrderSentAtDefault),
  "order[statusUpdatedAt]": zod.enum(['asc', 'desc']).default(apiAdminemailsGetCollectionQueryOrderStatusUpdatedAtDefault),
  "order[status]": zod.enum(['asc', 'desc']).default(apiAdminemailsGetCollectionQueryOrderStatusDefault),
  "user.fullname": zod.string().optional().describe('Search in concatenated fields: userWorkspace.user.firstname   userWorkspace.user.lastname')
})

export const apiAdminemailsGetCollectionResponseDataItemUserWorkspaceUserAvatarMax = 255;



export const apiAdminemailsGetCollectionResponse = zod.object({
  "data": zod.array(zod.unknown()),
  "pagination": zod.object({
  "first": zod.number(),
  "current": zod.number(),
  "last": zod.number(),
  "previous": zod.number(),
  "next": zod.number(),
  "totalItems": zod.number(),
  "perPage": zod.number()
})
}).and(zod.object({
  "data": zod.array(zod.object({
  "id": zod.number().describe('Email ID'),
  "to": zod.string().optional().describe('Email address of the user the email was sent to'),
  "subject": zod.string().nullish().describe('Subject of the email at sending time'),
  "userWorkspace": zod.union([zod.object({
  "user": zod.object({
  "fullname": zod.string().describe('User fullname'),
  "avatar": zod.string().max(apiAdminemailsGetCollectionResponseDataItemUserWorkspaceUserAvatarMax).nullish().describe('User avatar'),
  "isDeleted": zod.boolean().describe('Whether the entity has been soft-deleted')
})
}),zod.null()]).optional(),
  "sentAt": zod.string().datetime({}).nullish().describe('Date the email was sent'),
  "status": zod.string().nullish().describe('Last known status of the email (sent, opened, clicked, error)'),
  "statusUpdatedAt": zod.string().datetime({}).nullish().describe('Date of the last status update')
})).optional()
}))


/**
 * Add a new game
 * @summary Add a new game
 */
export const apiAdmingamesPostBodyLabelMax = 100;

export const apiAdmingamesPostBodyLinkMax = 255;



export const apiAdmingamesPostBody = zod.object({
  "label": zod.string().max(apiAdmingamesPostBodyLabelMax).describe('Game label'),
  "description": zod.string().nullish().describe('Game description'),
  "openingDate": zod.string().datetime({}).describe('Opening date of the game'),
  "closingDate": zod.string().datetime({}).describe('Closing date of the game'),
  "link": zod.string().url().max(apiAdmingamesPostBodyLinkMax).describe('Link to the game'),
  "cover": zod.string().describe('Media associated with the game')
})


/**
 * Removes the Game resource.
 * @summary Removes the Game resource.
 */
export const apiAdmingamesIdDeleteParams = zod.object({
  "id": zod.string().describe('Game identifier')
})


/**
 * Updates the Game resource.
 * @summary Updates the Game resource.
 */
export const apiAdmingamesIdPatchParams = zod.object({
  "id": zod.string().describe('Game identifier')
})

export const apiAdmingamesIdPatchBodyLabelMax = 100;

export const apiAdmingamesIdPatchBodyLinkMax = 255;



export const apiAdmingamesIdPatchBody = zod.object({
  "label": zod.string().min(1).max(apiAdmingamesIdPatchBodyLabelMax).optional().describe('Game label'),
  "description": zod.string().nullish().describe('Game description'),
  "openingDate": zod.string().datetime({}).optional().describe('Opening date of the game'),
  "closingDate": zod.string().datetime({}).optional().describe('Closing date of the game'),
  "link": zod.string().url().min(1).max(apiAdmingamesIdPatchBodyLinkMax).optional().describe('Link to the game'),
  "cover": zod.string().optional().describe('Media associated with the game')
})

export const apiAdmingamesIdPatchResponseLabelMax = 100;

export const apiAdmingamesIdPatchResponseLinkMax = 255;

export const apiAdmingamesIdPatchResponseCreatedByUserAvatarMax = 255;



export const apiAdmingamesIdPatchResponse = zod.object({
  "id": zod.number().describe('Game ID'),
  "label": zod.string().max(apiAdmingamesIdPatchResponseLabelMax).describe('Game label'),
  "description": zod.string().nullish().describe('Game description'),
  "openingDate": zod.string().datetime({}).describe('Opening date of the game'),
  "closingDate": zod.string().datetime({}).describe('Closing date of the game'),
  "status": zod.enum(['game.status.planned', 'game.status.active', 'game.status.finished', 'game.status.forbidden']).describe('Status of the game'),
  "link": zod.string().url().max(apiAdmingamesIdPatchResponseLinkMax).describe('Link to the game'),
  "cover": zod.object({
  "pathUri": zod.string().nullable().describe('Media path to S3')
}),
  "createdAt": zod.string().datetime({}).describe('Game creation date'),
  "createdBy": zod.object({
  "user": zod.object({
  "id": zod.number().describe('User ID'),
  "fullname": zod.string().describe('User fullname'),
  "avatar": zod.string().max(apiAdmingamesIdPatchResponseCreatedByUserAvatarMax).nullish().describe('User avatar'),
  "isDeleted": zod.boolean().describe('Whether the entity has been soft-deleted')
})
}).optional()
})


/**
 * Retrieves the collection of Game resources.
 * @summary Retrieves the collection of Game resources.
 */
export const apiGamesGetCollectionQueryOrderOpeningDateDefault = "asc";export const apiGamesGetCollectionQueryOrderClosingDateDefault = "asc";export const apiGamesGetCollectionQueryOrderCreatedAtDefault = "asc";

export const apiGamesGetCollectionQueryParams = zod.object({
  "order[openingDate]": zod.enum(['asc', 'desc']).default(apiGamesGetCollectionQueryOrderOpeningDateDefault),
  "order[closingDate]": zod.enum(['asc', 'desc']).default(apiGamesGetCollectionQueryOrderClosingDateDefault),
  "order[createdAt]": zod.enum(['asc', 'desc']).default(apiGamesGetCollectionQueryOrderCreatedAtDefault)
})

export const apiGamesGetCollectionResponseLabelMax = 100;

export const apiGamesGetCollectionResponseCreatedByUserAvatarMax = 255;

export const apiGamesGetCollectionResponseSegmentsCountDefault = 0;

export const apiGamesGetCollectionResponseItem = zod.object({
  "id": zod.number().describe('Game ID'),
  "label": zod.string().max(apiGamesGetCollectionResponseLabelMax).describe('Game label'),
  "description": zod.string().nullish().describe('Game description'),
  "openingDate": zod.string().datetime({}).describe('Opening date of the game'),
  "closingDate": zod.string().datetime({}).describe('Closing date of the game'),
  "status": zod.enum(['game.status.planned', 'game.status.active', 'game.status.finished', 'game.status.forbidden']).describe('Status of the game'),
  "cover": zod.object({
  "pathUri": zod.string().nullable().describe('Media path to S3')
}),
  "createdAt": zod.string().datetime({}).describe('Game creation date'),
  "createdBy": zod.object({
  "user": zod.object({
  "id": zod.number().describe('User ID'),
  "fullname": zod.string().describe('User fullname'),
  "avatar": zod.string().max(apiGamesGetCollectionResponseCreatedByUserAvatarMax).nullish().describe('User avatar'),
  "isDeleted": zod.boolean().describe('Whether the entity has been soft-deleted')
})
}).optional(),
  "segmentsCount": zod.number().optional().describe('Number of segments attached to the game (only exposed to admins, on the collection)')
})
export const apiGamesGetCollectionResponse = zod.array(apiGamesGetCollectionResponseItem)


/**
 * Retrieves a Game resource.
 * @summary Retrieves a Game resource.
 */
export const apiGamesIdGetParams = zod.object({
  "id": zod.string().describe('Game identifier')
})

export const apiGamesIdGetResponseLabelMax = 100;

export const apiGamesIdGetResponseLinkMax = 255;

export const apiGamesIdGetResponseCreatedByUserAvatarMax = 255;



export const apiGamesIdGetResponse = zod.object({
  "id": zod.number().describe('Game ID'),
  "label": zod.string().max(apiGamesIdGetResponseLabelMax).describe('Game label'),
  "description": zod.string().nullish().describe('Game description'),
  "openingDate": zod.string().datetime({}).describe('Opening date of the game'),
  "closingDate": zod.string().datetime({}).describe('Closing date of the game'),
  "status": zod.enum(['game.status.planned', 'game.status.active', 'game.status.finished', 'game.status.forbidden']).describe('Status of the game'),
  "link": zod.string().url().max(apiGamesIdGetResponseLinkMax).describe('Link to the game'),
  "cover": zod.object({
  "pathUri": zod.string().nullable().describe('Media path to S3')
}),
  "createdAt": zod.string().datetime({}).describe('Game creation date'),
  "createdBy": zod.object({
  "user": zod.object({
  "id": zod.number().describe('User ID'),
  "fullname": zod.string().describe('User fullname'),
  "avatar": zod.string().max(apiGamesIdGetResponseCreatedByUserAvatarMax).nullish().describe('User avatar'),
  "isDeleted": zod.boolean().describe('Whether the entity has been soft-deleted')
})
}).optional()
})


/**
 * Get insights for all companies
 * @summary Get insights for all companies
 */
export const apiAdmininsightscompaniesGetCollectionQueryParams = zod.object({
  "status[]": zod.array(zod.enum(['company.status.unregistered', 'company.status.registered', 'company.status.blocked', 'company.status.inactive'])).optional(),
  "typology[]": zod.array(zod.string()).optional(),
  "sales[]": zod.array(zod.string()).optional(),
  "from": zod.string().optional(),
  "to": zod.string().optional()
})

export const apiAdmininsightscompaniesGetCollectionResponseTotalCompaniesDefault = 0;export const apiAdmininsightscompaniesGetCollectionResponseTotalCompaniesRegisteredDefault = 0;

export const apiAdmininsightscompaniesGetCollectionResponse = zod.object({
  "totalCompanies": zod.number().describe('Total companies'),
  "totalCompaniesRegistered": zod.number().describe('Total companies registered'),
  "companiesPerStep": zod.array(zod.object({
  "id": zod.number(),
  "name": zod.string(),
  "totalCompanies": zod.number()
})).optional().describe('Companies per step')
})


/**
 * Get insights for active workspace
 * @summary Get insights for active workspace
 */
export const apiAdmininsightsdashboardGetCollectionResponseInsightCompanyTotalCompaniesDefault = 0;export const apiAdmininsightsdashboardGetCollectionResponseInsightCompanyTotalCompaniesRegisteredDefault = 0;export const apiAdmininsightsdashboardGetCollectionResponseInsightCompanyRankingItemNameMax = 100;

export const apiAdmininsightsdashboardGetCollectionResponseInsightPointTotalAcquiredPointsDefault = 0;export const apiAdmininsightsdashboardGetCollectionResponseInsightPointTotalAcquiredPointsRegisteredCompaniesDefault = 0;export const apiAdmininsightsdashboardGetCollectionResponseInsightPointTotalSpentPointsDefault = 0;export const apiAdmininsightsdashboardGetCollectionResponseInsightPointTotalBalanceDefault = 0;

export const apiAdmininsightsdashboardGetCollectionResponse = zod.object({
  "insightCompany": zod.object({
  "totalCompanies": zod.number().describe('Total companies'),
  "totalCompaniesRegistered": zod.number().describe('Total companies registered'),
  "companiesPerTypology": zod.array(zod.object({
  "typologyName": zod.string(),
  "totalCompanies": zod.number()
})).describe('Companies per typology'),
  "ranking": zod.array(zod.object({
  "id": zod.number().describe('Company ID'),
  "name": zod.string().max(apiAdmininsightsdashboardGetCollectionResponseInsightCompanyRankingItemNameMax).describe('Company name'),
  "acquiredPoints": zod.number().describe('Total of acquired points')
}))
}),
  "insightPoint": zod.object({
  "totalAcquiredPoints": zod.number().describe('Total acquired points'),
  "totalAcquiredPointsRegisteredCompanies": zod.number().describe('Total acquired points by registered companies'),
  "totalSpentPoints": zod.number().describe('Total spent points'),
  "totalBalance": zod.number().describe('Total balance (spendable points) of the companies')
})
})


/**
 * Get orders insights
 * @summary Get orders insights
 */
export const apiAdmininsightsordersGetCollectionQueryParams = zod.object({
  "status[]": zod.array(zod.enum(['company.status.unregistered', 'company.status.registered', 'company.status.blocked', 'company.status.inactive'])).optional(),
  "typology[]": zod.array(zod.string()).optional(),
  "sales[]": zod.array(zod.string()).optional(),
  "from": zod.string().optional(),
  "to": zod.string().optional()
})

export const apiAdmininsightsordersGetCollectionResponseTotalOrdersDefault = 0;export const apiAdmininsightsordersGetCollectionResponseTotalSpentPointsDefault = 0;export const apiAdmininsightsordersGetCollectionResponseInsightPointTotalAcquiredPointsDefault = 0;

export const apiAdmininsightsordersGetCollectionResponse = zod.object({
  "totalOrders": zod.number().describe('Total amount of orders'),
  "totalSpentPoints": zod.number().describe('Total points spent'),
  "insightPoint": zod.object({
  "totalAcquiredPoints": zod.number().describe('Total acquired points')
}),
  "totalOrdersPerMonth": zod.array(zod.object({
  "value": zod.number().describe('Value in this month'),
  "month": zod.number().describe('Month of the year (1-12)'),
  "year": zod.number().describe('Year')
})),
  "totalPointsSpentPerMonth": zod.array(zod.object({
  "value": zod.number().describe('Value in this month'),
  "month": zod.number().describe('Month of the year (1-12)'),
  "year": zod.number().describe('Year')
}))
})


/**
 * Get performances insights
 * @summary Get performances insights
 */
export const apiAdmininsightsperformancesGetCollectionQueryParams = zod.object({
  "status[]": zod.array(zod.enum(['company.status.unregistered', 'company.status.registered', 'company.status.blocked', 'company.status.inactive'])).optional(),
  "typology[]": zod.array(zod.string()).optional(),
  "sales[]": zod.array(zod.string()).optional(),
  "from": zod.string().optional(),
  "to": zod.string().optional()
})

export const apiAdmininsightsperformancesGetCollectionResponseAvgAmountByCompaniesDefault = 0;export const apiAdmininsightsperformancesGetCollectionResponseInsightCompanyRankingItemNameMax = 100;



export const apiAdmininsightsperformancesGetCollectionResponse = zod.object({
  "avgAmountByCompanies": zod.number().describe('Average amount by companies'),
  "totalAmountPerMonth": zod.array(zod.object({
  "value": zod.number().describe('Value in this month'),
  "month": zod.number().describe('Month of the year (1-12)'),
  "year": zod.number().describe('Year')
})),
  "insightCompany": zod.object({
  "ranking": zod.array(zod.object({
  "id": zod.number().describe('Company ID'),
  "name": zod.string().max(apiAdmininsightsperformancesGetCollectionResponseInsightCompanyRankingItemNameMax).describe('Company name'),
  "caAmount": zod.number().describe('CA amount of the company')
}))
})
})


/**
 * Get points insights
 * @summary Get points insights
 */
export const apiAdmininsightspointsGetCollectionQueryParams = zod.object({
  "status[]": zod.array(zod.enum(['company.status.unregistered', 'company.status.registered', 'company.status.blocked', 'company.status.inactive'])).optional(),
  "typology[]": zod.array(zod.string()).optional(),
  "sales[]": zod.array(zod.string()).optional(),
  "from": zod.string().optional(),
  "to": zod.string().optional()
})

export const apiAdmininsightspointsGetCollectionResponseAvgAcquiredPointsDefault = 0;export const apiAdmininsightspointsGetCollectionResponseInsightCompanyRankingItemNameMax = 100;



export const apiAdmininsightspointsGetCollectionResponse = zod.object({
  "avgAcquiredPoints": zod.number().describe('Average acquired points'),
  "totalPointsPerMonth": zod.array(zod.object({
  "value": zod.number().describe('Value in this month'),
  "month": zod.number().describe('Month of the year (1-12)'),
  "year": zod.number().describe('Year')
})),
  "insightCompany": zod.object({
  "ranking": zod.array(zod.object({
  "id": zod.number().describe('Company ID'),
  "name": zod.string().max(apiAdmininsightspointsGetCollectionResponseInsightCompanyRankingItemNameMax).describe('Company name'),
  "acquiredPoints": zod.number().describe('Total of acquired points')
}))
})
})


/**
 * Get insights for all users
 * @summary Get insights for all users
 */
export const apiAdmininsightsusersGetCollectionQueryParams = zod.object({
  "status[]": zod.array(zod.enum(['company.status.unregistered', 'company.status.registered', 'company.status.blocked', 'company.status.inactive'])).optional(),
  "typology[]": zod.array(zod.string()).optional(),
  "sales[]": zod.array(zod.string()).optional(),
  "from": zod.string().optional(),
  "to": zod.string().optional(),
  "maxRole[]": zod.array(zod.enum(['ROLE_MEMBER', 'ROLE_MANAGER', 'ROLE_SALES_ADMIN', 'ROLE_ADMIN', 'ROLE_FIDDY_ADMIN'])).optional().describe('Filter users by role')
})

export const apiAdmininsightsusersGetCollectionResponseTotalUsersDefault = 0;export const apiAdmininsightsusersGetCollectionResponseTotalUsersRegisteredDefault = 0;export const apiAdmininsightsusersGetCollectionResponseTotalLoginsDefault = 0;

export const apiAdmininsightsusersGetCollectionResponse = zod.object({
  "totalUsers": zod.number().describe('Total users'),
  "totalUsersRegistered": zod.number().describe('Total users registered'),
  "totalLogins": zod.number().describe('Total logins on the workspace for the current year')
})


/**
 * Get insights for user logged
 * @summary Get insights for user logged
 */
export const meInsightsQueryParams = zod.object({
  "from": zod.string().optional(),
  "to": zod.string().optional(),
  "referenceUniqueCode[]": zod.array(zod.string()).optional().describe('Filter by reference unique codes')
})

export const meInsightsResponseInsightPointsPointsHistoryItemLabelMax = 255;

export const meInsightsResponseInsightPointsPointsHistoryItemValueDateDefault = "";export const meInsightsResponseInsightPerformancePerformancesTargetHistoryItemAmountMin = 0;

export const meInsightsResponseInsightPerformancePerformancesTargetHistoryItemLabelMax = 255;

export const meInsightsResponseInsightPerformancePerformancesTargetHistoryItemLogicTypeTargetReferenceMax = 20;

export const meInsightsResponseInsightPerformancePerformancesTargetHistoryItemReferenceQuantityMin = 0;



export const meInsightsResponse = zod.object({
  "insightPoints": zod.object({
  "totalPointsPerMonth": zod.array(zod.object({
  "value": zod.number().describe('Value in this month'),
  "month": zod.number().describe('Month of the year (1-12)'),
  "year": zod.number().describe('Year')
})),
  "pointsHistory": zod.array(zod.object({
  "amount": zod.number().describe('Points amount'),
  "label": zod.string().max(meInsightsResponseInsightPointsPointsHistoryItemLabelMax).nullish().describe('Points label'),
  "typeLabel": zod.enum(['CORE', 'IMPORTED', 'SPENT', 'EXPIRED', 'CANCELED', 'BOOSTER']),
  "expirationDate": zod.string().datetime({}).nullish().describe('Points expiration date'),
  "valueDate": zod.string().datetime({}).describe('Points value date')
}))
}),
  "insightPerformance": zod.object({
  "targetsAmountPerMonth": zod.array(zod.object({
  "month": zod.number(),
  "year": zod.number(),
  "targets": zod.array(zod.object({
  "targetId": zod.number(),
  "targetReference": zod.string(),
  "totalAmount": zod.number()
}))
})).optional().describe('Total amount for each targets per month'),
  "performancesTargetHistory": zod.array(zod.object({
  "amount": zod.number().min(meInsightsResponseInsightPerformancePerformancesTargetHistoryItemAmountMin).optional().describe('Amount (in euros)'),
  "label": zod.string().max(meInsightsResponseInsightPerformancePerformancesTargetHistoryItemLabelMax).nullish().describe('Performance label'),
  "realizedAt": zod.string().datetime({}).describe('Performance realisation date'),
  "logicTypeTarget": zod.union([zod.object({
  "reference": zod.string().max(meInsightsResponseInsightPerformancePerformancesTargetHistoryItemLogicTypeTargetReferenceMax).describe('Target reference name')
}),zod.null()]).optional(),
  "referenceUniqueCode": zod.string().nullish().describe('Reference unique code'),
  "referenceQuantity": zod.number().min(meInsightsResponseInsightPerformancePerformancesTargetHistoryItemReferenceQuantityMin).nullish().describe('Reference quantity buyed')
})).optional()
}).optional()
})


/**
 * Get of locales for workspace (non-formatted)
 * @summary Get list of locales for workspace (non-formatted)
 */
export const adminLocalesQueryPageDefault = 1;export const adminLocalesQueryPerPageDefault = 30;
export const adminLocalesQueryPerPageMin = 0;
export const adminLocalesQueryPerPageMax = 30;



export const adminLocalesQueryParams = zod.object({
  "page": zod.number().default(adminLocalesQueryPageDefault).describe('The collection page number'),
  "perPage": zod.number().min(adminLocalesQueryPerPageMin).max(adminLocalesQueryPerPageMax).default(adminLocalesQueryPerPageDefault).describe('The number of items per page'),
  "country": zod.string().optional(),
  "country[]": zod.array(zod.string()).optional(),
  "label": zod.string().optional(),
  "content": zod.string().optional(),
  "search": zod.string().optional().describe('Search in label, content, localeCustoms.content'),
  "isCustom": zod.boolean().optional()
})

export const adminLocalesResponseDataItemLabelRegExp = new RegExp('^([a-z0-9._-]+)$');
export const adminLocalesResponseDataItemIsCustomDefault = false;

export const adminLocalesResponse = zod.object({
  "data": zod.array(zod.unknown()),
  "pagination": zod.object({
  "first": zod.number(),
  "current": zod.number(),
  "last": zod.number(),
  "previous": zod.number(),
  "next": zod.number(),
  "totalItems": zod.number(),
  "perPage": zod.number()
})
}).and(zod.object({
  "data": zod.array(zod.object({
  "id": zod.number().optional().describe('Locale ID'),
  "label": zod.string().regex(adminLocalesResponseDataItemLabelRegExp).describe('Label of the locale'),
  "content": zod.string().describe('Text of the locale'),
  "isoCode": zod.string().describe('ISO code of the locale'),
  "isPublic": zod.boolean(),
  "isCustom": zod.boolean().optional().describe('Is locale overrided by active workspace'),
  "defaultContent": zod.string().nullish().describe('Default content'),
  "isEditable": zod.boolean().describe('Is locale can be edited')
})).optional()
}))


/**
 * Create new default locale
 * @summary Create new default locale
 */
export const apiAdminlocalesPostBodyLabelRegExp = new RegExp('^([a-z0-9._-]+)$');


export const apiAdminlocalesPostBody = zod.object({
  "label": zod.string().regex(apiAdminlocalesPostBodyLabelRegExp).describe('Label of the locale'),
  "content": zod.string().describe('Text of the locale'),
  "country": zod.string().describe('Country IRI'),
  "isPublic": zod.boolean(),
  "isEditable": zod.boolean().describe('Is locale can be edited')
})


/**
 * Delete locale (and all locales custom associated to it)
 * @summary Delete locale (and all locales custom associated to it)
 */
export const apiAdminlocalesIdDeleteParams = zod.object({
  "id": zod.string().describe('Locale identifier')
})


/**
 * Update default locale
 * @summary Update default locale
 */
export const apiAdminlocalesIdPatchParams = zod.object({
  "id": zod.string().describe('Locale identifier')
})

export const apiAdminlocalesIdPatchBodyLabelRegExp = new RegExp('^([a-z0-9._-]+)$');


export const apiAdminlocalesIdPatchBody = zod.object({
  "label": zod.string().regex(apiAdminlocalesIdPatchBodyLabelRegExp).optional().describe('Label of the locale'),
  "content": zod.string().optional().describe('Text of the locale'),
  "country": zod.string().optional().describe('Country IRI'),
  "isPublic": zod.boolean().optional(),
  "isEditable": zod.boolean().optional().describe('Is locale can be edited')
})

export const apiAdminlocalesIdPatchResponseLabelRegExp = new RegExp('^([a-z0-9._-]+)$');
export const apiAdminlocalesIdPatchResponseIsCustomDefault = false;

export const apiAdminlocalesIdPatchResponse = zod.object({
  "id": zod.number().optional().describe('Locale ID'),
  "label": zod.string().regex(apiAdminlocalesIdPatchResponseLabelRegExp).describe('Label of the locale'),
  "content": zod.string().describe('Text of the locale'),
  "isoCode": zod.string().describe('ISO code of the locale'),
  "isPublic": zod.boolean(),
  "isCustom": zod.boolean().optional().describe('Is locale overrided by active workspace'),
  "defaultContent": zod.string().nullish().describe('Default content'),
  "isEditable": zod.boolean().describe('Is locale can be edited')
})


/**
 * Get locales
 * @summary Get locales
 */
export const apiLocalesGetCollectionQueryParams = zod.object({
  "country": zod.string().optional(),
  "country[]": zod.array(zod.string()).optional()
})

export const apiLocalesGetCollectionHeader = zod.object({
  "App-ID": zod.string().optional().describe('App-ID')
})

export const apiLocalesGetCollectionResponse = zod.object({
  "groupedLocales": zod.record(zod.string(), zod.object({
  "translations": zod.record(zod.string(), zod.string()).optional()
})).optional()
})


/**
 * Creates a LocaleCustom resource.
 * @summary Creates a LocaleCustom resource.
 */
export const apiAdminlocalescustomPostBody = zod.object({
  "locale": zod.string().describe('Locale IRI'),
  "content": zod.string().describe('Text of the locale overrided')
})


/**
 * Removes the LocaleCustom resource.
 * @summary Removes the LocaleCustom resource.
 */
export const apiAdminlocalescustomIdDeleteParams = zod.object({
  "id": zod.string().describe('LocaleCustom identifier')
})


/**
 * Updates the LocaleCustom resource.
 * @summary Updates the LocaleCustom resource.
 */
export const apiAdminlocalescustomIdPatchParams = zod.object({
  "id": zod.string().describe('LocaleCustom identifier')
})

export const apiAdminlocalescustomIdPatchBody = zod.object({
  "content": zod.string().optional().describe('Text of the locale overrided')
})

export const apiAdminlocalescustomIdPatchResponse = zod.object({
  "id": zod.number().optional().describe('Locale Custom ID'),
  "locale": zod.string().describe('Locale IRI'),
  "workspace": zod.string().describe('Workspace IRI'),
  "content": zod.string().describe('Text of the locale overrided')
})


/**
 * Get all logics
 * @summary Get all logics
 */
export const apiAdminlogicsGetCollectionResponseNameMax = 100;

export const apiAdminlogicsGetCollectionResponseDescriptionMax = 100;

export const apiAdminlogicsGetCollectionResponseTypeMax = 20;



export const apiAdminlogicsGetCollectionResponseItem = zod.object({
  "id": zod.number().describe('Logic ID'),
  "name": zod.string().max(apiAdminlogicsGetCollectionResponseNameMax).describe('Name (label) of the logic'),
  "description": zod.string().max(apiAdminlogicsGetCollectionResponseDescriptionMax).describe('Description (label) of the logic'),
  "type": zod.enum(['STEP', 'LINEAR', 'TARGET_PERF', 'TARGET_POINT'])
})
export const apiAdminlogicsGetCollectionResponse = zod.array(apiAdminlogicsGetCollectionResponseItem)


/**
 * Create a new logic
 * @summary Create a new logic
 */
export const apiAdminlogicsPostBodyNameMax = 100;

export const apiAdminlogicsPostBodyDescriptionMax = 100;

export const apiAdminlogicsPostBodyTypeMax = 20;



export const apiAdminlogicsPostBody = zod.object({
  "name": zod.string().max(apiAdminlogicsPostBodyNameMax).describe('Name (label) of the logic'),
  "description": zod.string().max(apiAdminlogicsPostBodyDescriptionMax).describe('Description (label) of the logic'),
  "type": zod.enum(['STEP', 'LINEAR', 'TARGET_PERF', 'TARGET_POINT'])
})


/**
 * Retrieves a LogicTypeStep resource.
 * @summary Retrieves a LogicTypeStep resource.
 */
export const apiAdminlogicTypeStepsIdGetParams = zod.object({
  "id": zod.string().describe('LogicTypeStep identifier')
})

export const apiAdminlogicTypeStepsIdGetResponseNameMax = 50;

export const apiAdminlogicTypeStepsIdGetResponseStepPointMin = 0;



export const apiAdminlogicTypeStepsIdGetResponse = zod.object({
  "id": zod.number().optional().describe('Step ID'),
  "name": zod.string().max(apiAdminlogicTypeStepsIdGetResponseNameMax).describe('Step name'),
  "description": zod.string().nullish().describe('Step description'),
  "stepPoint": zod.number().min(apiAdminlogicTypeStepsIdGetResponseStepPointMin).describe('Value to complete the step'),
  "createdAt": zod.string().datetime({}).optional().describe('Step creation datetime')
})


/**
 * Update the name and description of a step
 * @summary Update the name and description of a step
 */
export const apiAdminlogicTypeStepsIdPatchParams = zod.object({
  "id": zod.string().describe('LogicTypeStep identifier')
})

export const apiAdminlogicTypeStepsIdPatchBodyNameMax = 50;



export const apiAdminlogicTypeStepsIdPatchBody = zod.object({
  "name": zod.string().max(apiAdminlogicTypeStepsIdPatchBodyNameMax).optional().describe('Step name'),
  "description": zod.string().nullish().describe('Step description')
})

export const apiAdminlogicTypeStepsIdPatchResponseNameMax = 50;

export const apiAdminlogicTypeStepsIdPatchResponseStepPointMin = 0;



export const apiAdminlogicTypeStepsIdPatchResponse = zod.object({
  "id": zod.number().optional().describe('Step ID'),
  "name": zod.string().max(apiAdminlogicTypeStepsIdPatchResponseNameMax).describe('Step name'),
  "description": zod.string().nullish().describe('Step description'),
  "stepPoint": zod.number().min(apiAdminlogicTypeStepsIdPatchResponseStepPointMin).describe('Value to complete the step'),
  "createdAt": zod.string().datetime({}).optional().describe('Step creation datetime')
})


/**
 * Get all company steps (LogicTypeStepHistory) for the current workspace
 * @summary Get company steps
 */
export const apiAdminlogicTypeStepHistoriesGetCollectionQueryPageDefault = 1;export const apiAdminlogicTypeStepHistoriesGetCollectionQueryPerPageDefault = 30;
export const apiAdminlogicTypeStepHistoriesGetCollectionQueryPerPageMin = 0;
export const apiAdminlogicTypeStepHistoriesGetCollectionQueryPerPageMax = 30;

export const apiAdminlogicTypeStepHistoriesGetCollectionQueryOrderCompanyNameDefault = "asc";export const apiAdminlogicTypeStepHistoriesGetCollectionQueryOrderLogicTypeStepNameDefault = "asc";export const apiAdminlogicTypeStepHistoriesGetCollectionQueryOrderLogicTypeStepStepPointDefault = "asc";export const apiAdminlogicTypeStepHistoriesGetCollectionQueryOrderCreatedAtDefault = "asc";

export const apiAdminlogicTypeStepHistoriesGetCollectionQueryParams = zod.object({
  "page": zod.number().default(apiAdminlogicTypeStepHistoriesGetCollectionQueryPageDefault).describe('The collection page number'),
  "perPage": zod.number().min(apiAdminlogicTypeStepHistoriesGetCollectionQueryPerPageMin).max(apiAdminlogicTypeStepHistoriesGetCollectionQueryPerPageMax).default(apiAdminlogicTypeStepHistoriesGetCollectionQueryPerPageDefault).describe('The number of items per page'),
  "company.name": zod.string().optional(),
  "company.uniqueCode": zod.string().optional(),
  "logicTypeStep.name": zod.string().optional(),
  "order[company.name]": zod.enum(['asc', 'desc']).default(apiAdminlogicTypeStepHistoriesGetCollectionQueryOrderCompanyNameDefault),
  "order[logicTypeStep.name]": zod.enum(['asc', 'desc']).default(apiAdminlogicTypeStepHistoriesGetCollectionQueryOrderLogicTypeStepNameDefault),
  "order[logicTypeStep.stepPoint]": zod.enum(['asc', 'desc']).default(apiAdminlogicTypeStepHistoriesGetCollectionQueryOrderLogicTypeStepStepPointDefault),
  "order[createdAt]": zod.enum(['asc', 'desc']).default(apiAdminlogicTypeStepHistoriesGetCollectionQueryOrderCreatedAtDefault)
})

export const apiAdminlogicTypeStepHistoriesGetCollectionResponseDataItemLogicTypeStepNameMax = 50;

export const apiAdminlogicTypeStepHistoriesGetCollectionResponseDataItemLogicTypeStepStepPointMin = 0;

export const apiAdminlogicTypeStepHistoriesGetCollectionResponseDataItemCompanyNameMax = 100;

export const apiAdminlogicTypeStepHistoriesGetCollectionResponseDataItemCompanyUniqueCodeMax = 50;


export const apiAdminlogicTypeStepHistoriesGetCollectionResponseDataItemCompanyUniqueCodeRegExp = new RegExp('^([a-zA-Z0-9]+)$');


export const apiAdminlogicTypeStepHistoriesGetCollectionResponse = zod.object({
  "data": zod.array(zod.unknown()),
  "pagination": zod.object({
  "first": zod.number(),
  "current": zod.number(),
  "last": zod.number(),
  "previous": zod.number(),
  "next": zod.number(),
  "totalItems": zod.number(),
  "perPage": zod.number()
})
}).and(zod.object({
  "data": zod.array(zod.object({
  "id": zod.number().optional().describe('Step History ID'),
  "logicTypeStep": zod.object({
  "id": zod.number().optional().describe('Step ID'),
  "name": zod.string().max(apiAdminlogicTypeStepHistoriesGetCollectionResponseDataItemLogicTypeStepNameMax).describe('Step name'),
  "description": zod.string().nullish().describe('Step description'),
  "stepPoint": zod.number().min(apiAdminlogicTypeStepHistoriesGetCollectionResponseDataItemLogicTypeStepStepPointMin).describe('Value to complete the step')
}),
  "createdAt": zod.string().datetime({}).describe('Step history creation datetime'),
  "company": zod.object({
  "id": zod.number().describe('Company ID'),
  "name": zod.string().max(apiAdminlogicTypeStepHistoriesGetCollectionResponseDataItemCompanyNameMax).describe('Company name'),
  "uniqueCode": zod.string().max(apiAdminlogicTypeStepHistoriesGetCollectionResponseDataItemCompanyUniqueCodeMax).regex(apiAdminlogicTypeStepHistoriesGetCollectionResponseDataItemCompanyUniqueCodeRegExp).describe('Company unique code (SIREN or TVA or whatever)')
}).optional()
})).optional()
}))


/**
 * Get all company objectives (LogicTypeTargetStatus) for the current workspace
 * @summary Get company objectives
 */
export const apiAdmintargetsGetCollectionQueryPageDefault = 1;export const apiAdmintargetsGetCollectionQueryPerPageDefault = 30;
export const apiAdmintargetsGetCollectionQueryPerPageMin = 0;
export const apiAdmintargetsGetCollectionQueryPerPageMax = 30;

export const apiAdmintargetsGetCollectionQueryOrderCompanyNameDefault = "asc";export const apiAdmintargetsGetCollectionQueryOrderValueDefault = "asc";export const apiAdmintargetsGetCollectionQueryOrderTargetValueDefault = "asc";export const apiAdmintargetsGetCollectionQueryOrderUpdatedAtDefault = "asc";

export const apiAdmintargetsGetCollectionQueryParams = zod.object({
  "page": zod.number().default(apiAdmintargetsGetCollectionQueryPageDefault).describe('The collection page number'),
  "perPage": zod.number().min(apiAdmintargetsGetCollectionQueryPerPageMin).max(apiAdmintargetsGetCollectionQueryPerPageMax).default(apiAdmintargetsGetCollectionQueryPerPageDefault).describe('The number of items per page'),
  "company.name": zod.string().optional(),
  "company.uniqueCode": zod.string().optional(),
  "logicTypeTarget.reference": zod.string().optional(),
  "logicTypeTarget.reference[]": zod.array(zod.string()).optional(),
  "achieved": zod.string().optional().describe('Filter by achieved status (true = achieved, false = not achieved)'),
  "order[company.name]": zod.enum(['asc', 'desc']).default(apiAdmintargetsGetCollectionQueryOrderCompanyNameDefault),
  "order[value]": zod.enum(['asc', 'desc']).default(apiAdmintargetsGetCollectionQueryOrderValueDefault),
  "order[targetValue]": zod.enum(['asc', 'desc']).default(apiAdmintargetsGetCollectionQueryOrderTargetValueDefault),
  "order[updatedAt]": zod.enum(['asc', 'desc']).default(apiAdmintargetsGetCollectionQueryOrderUpdatedAtDefault),
  "order[achievedPercentage]": zod.enum(['asc', 'desc']).optional()
})

export const apiAdmintargetsGetCollectionResponseDataItemCompanyNameMax = 100;

export const apiAdmintargetsGetCollectionResponseDataItemCompanyUniqueCodeMax = 50;


export const apiAdmintargetsGetCollectionResponseDataItemCompanyUniqueCodeRegExp = new RegExp('^([a-zA-Z0-9]+)$');
export const apiAdmintargetsGetCollectionResponseDataItemLogicTypeTargetReferenceMax = 20;

export const apiAdmintargetsGetCollectionResponseDataItemValueDefault = 0;
export const apiAdmintargetsGetCollectionResponseDataItemValueMin = 0;

export const apiAdmintargetsGetCollectionResponseDataItemTargetValueMin = 0;

export const apiAdmintargetsGetCollectionResponseDataItemAchievedPercentageDefault = 0;

export const apiAdmintargetsGetCollectionResponse = zod.object({
  "data": zod.array(zod.unknown()),
  "pagination": zod.object({
  "first": zod.number(),
  "current": zod.number(),
  "last": zod.number(),
  "previous": zod.number(),
  "next": zod.number(),
  "totalItems": zod.number(),
  "perPage": zod.number()
})
}).and(zod.object({
  "data": zod.array(zod.object({
  "id": zod.number().describe('Target Status ID'),
  "company": zod.object({
  "id": zod.number().describe('Company ID'),
  "name": zod.string().max(apiAdmintargetsGetCollectionResponseDataItemCompanyNameMax).describe('Company name'),
  "uniqueCode": zod.string().max(apiAdmintargetsGetCollectionResponseDataItemCompanyUniqueCodeMax).regex(apiAdmintargetsGetCollectionResponseDataItemCompanyUniqueCodeRegExp).describe('Company unique code (SIREN or TVA or whatever)')
}),
  "logicTypeTarget": zod.object({
  "reference": zod.string().max(apiAdmintargetsGetCollectionResponseDataItemLogicTypeTargetReferenceMax).describe('Target reference name'),
  "description": zod.string().nullish().describe('Target description (label)')
}).optional(),
  "value": zod.number().min(apiAdmintargetsGetCollectionResponseDataItemValueMin).describe('Current target value (in points or euros)'),
  "targetValue": zod.number().min(apiAdmintargetsGetCollectionResponseDataItemTargetValueMin).describe('Target value to achieve (in points or euros)'),
  "updatedAt": zod.string().datetime({}).optional().describe('Date of the last update'),
  "achievedAt": zod.string().datetime({}).nullish().describe('Date when the target was achieved'),
  "achievedPercentage": zod.number().optional()
})).optional()
}))


/**
 * Import targets
 * @summary Import targets
 */
export const targetsImportHeaderDryRunDefault = false;

export const targetsImportHeader = zod.object({
  "dry-run": zod.boolean().optional().describe('Set to true to perform a dry run import (optional)')
})

export const targetsImportBodyDataItemTargetValueMin = 0;



export const targetsImportBody = zod.object({
  "data": zod.array(zod.object({
  "companyUniqueCode": zod.string().nullable().describe('Company unique code'),
  "targetReference": zod.string().nullable().describe('Target reference name'),
  "targetValue": zod.number().min(targetsImportBodyDataItemTargetValueMin).describe('Target value to achieve (in points or euros)')
}))
})


/**
 * Get all logic workspaces
 * @summary Get all logic workspaces
 */
export const apiAdminlogicsworkspacesGetCollectionQueryOrderCreatedAtDefault = "asc";export const apiAdminlogicsworkspacesGetCollectionQueryOrderStartAtDefault = "asc";export const apiAdminlogicsworkspacesGetCollectionQueryOrderEndAtDefault = "asc";

export const apiAdminlogicsworkspacesGetCollectionQueryParams = zod.object({
  "order[createdAt]": zod.enum(['asc', 'desc']).default(apiAdminlogicsworkspacesGetCollectionQueryOrderCreatedAtDefault),
  "order[startAt]": zod.enum(['asc', 'desc']).default(apiAdminlogicsworkspacesGetCollectionQueryOrderStartAtDefault),
  "order[endAt]": zod.enum(['asc', 'desc']).default(apiAdminlogicsworkspacesGetCollectionQueryOrderEndAtDefault)
})

export const apiAdminlogicsworkspacesGetCollectionResponseLogicNameMax = 100;

export const apiAdminlogicsworkspacesGetCollectionResponseLogicDescriptionMax = 100;

export const apiAdminlogicsworkspacesGetCollectionResponseLogicTypeMax = 20;

export const apiAdminlogicsworkspacesGetCollectionResponseStepsItemNameMax = 50;

export const apiAdminlogicsworkspacesGetCollectionResponseStepsItemStepPointMin = 0;

export const apiAdminlogicsworkspacesGetCollectionResponseTargetsItemReferenceMax = 20;

export const apiAdminlogicsworkspacesGetCollectionResponsePointExpirationDateMax = 100;



export const apiAdminlogicsworkspacesGetCollectionResponseItem = zod.object({
  "id": zod.number().describe('Logic Workspace ID'),
  "logic": zod.object({
  "id": zod.number().describe('Logic ID'),
  "name": zod.string().max(apiAdminlogicsworkspacesGetCollectionResponseLogicNameMax).describe('Name (label) of the logic'),
  "description": zod.string().max(apiAdminlogicsworkspacesGetCollectionResponseLogicDescriptionMax).describe('Description (label) of the logic'),
  "type": zod.enum(['STEP', 'LINEAR', 'TARGET_PERF', 'TARGET_POINT'])
}),
  "startAt": zod.string().datetime({}).describe('Start datetime of the logic workspace'),
  "endAt": zod.string().datetime({}).describe('End datetime of the logic workspace'),
  "steps": zod.array(zod.object({
  "id": zod.number().optional().describe('Step ID'),
  "name": zod.string().max(apiAdminlogicsworkspacesGetCollectionResponseStepsItemNameMax).describe('Step name'),
  "stepPoint": zod.number().min(apiAdminlogicsworkspacesGetCollectionResponseStepsItemStepPointMin).describe('Value to complete the step')
})).optional(),
  "targets": zod.array(zod.object({
  "reference": zod.string().max(apiAdminlogicsworkspacesGetCollectionResponseTargetsItemReferenceMax).describe('Target reference name'),
  "description": zod.string().nullish().describe('Target description (label)')
})).optional(),
  "pointExpirationDate": zod.string().max(apiAdminlogicsworkspacesGetCollectionResponsePointExpirationDateMax).describe('Point expiration date of the logic workspace')
})
export const apiAdminlogicsworkspacesGetCollectionResponse = zod.array(apiAdminlogicsworkspacesGetCollectionResponseItem)


/**
 * Create a new logic for workspace
 * @summary Create a new logic for workspace
 */
export const apiAdminlogicsworkspacesPostBodyStepsItemNameMax = 50;

export const apiAdminlogicsworkspacesPostBodyStepsItemStepPointMin = 0;

export const apiAdminlogicsworkspacesPostBodyTargetsItemReferenceMax = 20;

export const apiAdminlogicsworkspacesPostBodyPointExpirationDateMax = 100;



export const apiAdminlogicsworkspacesPostBody = zod.object({
  "logic": zod.string().describe('Logic ID'),
  "startAt": zod.string().datetime({}).describe('Start datetime of the logic workspace'),
  "endAt": zod.string().datetime({}).describe('End datetime of the logic workspace'),
  "steps": zod.array(zod.object({
  "name": zod.string().max(apiAdminlogicsworkspacesPostBodyStepsItemNameMax).optional().describe('Step name'),
  "description": zod.string().nullish().describe('Step description'),
  "stepPoint": zod.number().min(apiAdminlogicsworkspacesPostBodyStepsItemStepPointMin).optional().describe('Value to complete the step')
})).optional(),
  "targets": zod.array(zod.object({
  "reference": zod.string().max(apiAdminlogicsworkspacesPostBodyTargetsItemReferenceMax).describe('Target reference name'),
  "description": zod.string().nullish().describe('Target description (label)')
})).optional(),
  "pointExpirationDate": zod.string().max(apiAdminlogicsworkspacesPostBodyPointExpirationDateMax).describe('Point expiration date of the logic workspace')
})


/**
 * Creates a Media resource.
 * @summary Creates a Media resource.
 */
export const apiMediasPostBody = zod.object({
  "file": zod.instanceof(File),
  "type": zod.enum(['layout', 'legal', 'assets', 'external', 'proof'])
})


/**
 * Retrieves a Media resource.
 * @summary Retrieves a Media resource.
 */
export const apiMediasIdGetParams = zod.object({
  "id": zod.string().describe('Media identifier')
})

export const apiMediasIdGetResponse = zod.object({
  "id": zod.number().describe('Media ID'),
  "iri": zod.string().describe('Media IRI'),
  "pathUri": zod.string().nullable().describe('Media path to S3')
})


/**
 * Removes the Media resource.
 * @summary Removes the Media resource.
 */
export const apiMediasIdDeleteParams = zod.object({
  "id": zod.string().describe('Media identifier')
})


/**
 * Get orders
 * @summary Get orders
 */
export const apiOrdersGetCollectionQueryPageDefault = 1;export const apiOrdersGetCollectionQueryPerPageDefault = 30;
export const apiOrdersGetCollectionQueryPerPageMin = 0;
export const apiOrdersGetCollectionQueryPerPageMax = 30;

export const apiOrdersGetCollectionQueryOrderCreatedAtDefault = "asc";export const apiOrdersGetCollectionQueryOrderPointAmountDefault = "asc";export const apiOrdersGetCollectionQueryOrderStatusDefault = "asc";

export const apiOrdersGetCollectionQueryParams = zod.object({
  "page": zod.number().default(apiOrdersGetCollectionQueryPageDefault).describe('The collection page number'),
  "perPage": zod.number().min(apiOrdersGetCollectionQueryPerPageMin).max(apiOrdersGetCollectionQueryPerPageMax).default(apiOrdersGetCollectionQueryPerPageDefault).describe('The number of items per page'),
  "madeBy.uniqueCode": zod.string().optional(),
  "madeBy.user.email": zod.string().optional(),
  "company.uniqueCode": zod.string().optional(),
  "company.name": zod.string().optional(),
  "status": zod.string().optional(),
  "status[]": zod.array(zod.string()).optional(),
  "reference": zod.string().optional(),
  "orderProducts.product.shop.displayName": zod.string().optional(),
  "orderProducts.product.name": zod.string().optional(),
  "orderProducts.product.id": zod.number().optional(),
  "orderProducts.product.id[]": zod.array(zod.number()).optional(),
  "createdAt[before]": zod.string().optional(),
  "createdAt[strictly_before]": zod.string().optional(),
  "createdAt[after]": zod.string().optional(),
  "createdAt[strictly_after]": zod.string().optional(),
  "order[createdAt]": zod.enum(['asc', 'desc']).default(apiOrdersGetCollectionQueryOrderCreatedAtDefault),
  "order[point.amount]": zod.enum(['asc', 'desc']).default(apiOrdersGetCollectionQueryOrderPointAmountDefault),
  "order[status]": zod.enum(['asc', 'desc']).default(apiOrdersGetCollectionQueryOrderStatusDefault),
  "point.amount[between]": zod.string().optional(),
  "point.amount[gt]": zod.string().optional(),
  "point.amount[gte]": zod.string().optional(),
  "point.amount[lt]": zod.string().optional(),
  "point.amount[lte]": zod.string().optional(),
  "madeBy.user.fullname": zod.string().optional().describe('Search in concatenated fields: madeBy.user.firstname   madeBy.user.lastname'),
  "productsCount[gte]": zod.string().optional(),
  "productsCount[gt]": zod.string().optional(),
  "productsCount[lte]": zod.string().optional(),
  "productsCount[lt]": zod.string().optional(),
  "productsCount[between]": zod.string().optional(),
  "order[productsCount]": zod.enum(['asc', 'desc']).optional(),
  "order[orderProducts.product.shop.displayName]": zod.enum(['asc', 'desc']).optional()
})

export const apiOrdersGetCollectionResponseDataItemReferenceMax = 20;

export const apiOrdersGetCollectionResponseDataItemStatusMax = 50;

export const apiOrdersGetCollectionResponseDataItemTypeMax = 10;

export const apiOrdersGetCollectionResponseDataItemMadeByUserEmailMax = 255;

export const apiOrdersGetCollectionResponseDataItemMadeByUserAvatarMax = 255;

export const apiOrdersGetCollectionResponseDataItemMadeByUniqueCodeMax = 50;


export const apiOrdersGetCollectionResponseDataItemMadeByUniqueCodeRegExp = new RegExp('^([a-zA-Z0-9]+)$');
export const apiOrdersGetCollectionResponseDataItemMadeByPhoneMax = 20;

export const apiOrdersGetCollectionResponseDataItemCompanyNameMax = 100;

export const apiOrdersGetCollectionResponseDataItemCompanyUniqueCodeMax = 50;


export const apiOrdersGetCollectionResponseDataItemCompanyUniqueCodeRegExp = new RegExp('^([a-zA-Z0-9]+)$');
export const apiOrdersGetCollectionResponseDataItemOrderProductsItemProductNameMax = 150;

export const apiOrdersGetCollectionResponseDataItemOrderProductsItemProductIsDematDefault = false;export const apiOrdersGetCollectionResponseDataItemOrderProductsItemPointUnitPriceMin = 0;

export const apiOrdersGetCollectionResponseDataItemOrderProductsItemQuantityMin = 0;

export const apiOrdersGetCollectionResponseDataItemOrderProductsItemDynamicPriceAmountMin = 0;

export const apiOrdersGetCollectionResponseDataItemOrderProductsItemAmountUnitPriceDefault = 0;
export const apiOrdersGetCollectionResponseDataItemOrderProductsItemAmountUnitPriceMin = 0;

export const apiOrdersGetCollectionResponseDataItemProductsCountDefault = 0;export const apiOrdersGetCollectionResponseDataItemShopsItemDisplayNameMax = 100;



export const apiOrdersGetCollectionResponse = zod.object({
  "data": zod.array(zod.unknown()),
  "pagination": zod.object({
  "first": zod.number(),
  "current": zod.number(),
  "last": zod.number(),
  "previous": zod.number(),
  "next": zod.number(),
  "totalItems": zod.number(),
  "perPage": zod.number()
})
}).and(zod.object({
  "data": zod.array(zod.object({
  "id": zod.number().describe('Order ID'),
  "reference": zod.string().max(apiOrdersGetCollectionResponseDataItemReferenceMax).describe('Order reference'),
  "status": zod.enum(['order.status.pending', 'order.status.confirmed', 'order.status.completed', 'order.status.canceled', 'order.status.failed']).describe('Order status (label)'),
  "type": zod.enum(['provider', 'reward', 'custom']).describe('Order type'),
  "point": zod.union([zod.object({
  "amount": zod.number().describe('Points amount')
}),zod.null()]).optional(),
  "madeBy": zod.object({
  "user": zod.object({
  "id": zod.number().describe('User ID'),
  "email": zod.string().email().max(apiOrdersGetCollectionResponseDataItemMadeByUserEmailMax).describe('User email'),
  "fullname": zod.string().describe('User fullname'),
  "avatar": zod.string().max(apiOrdersGetCollectionResponseDataItemMadeByUserAvatarMax).nullish().describe('User avatar'),
  "isDeleted": zod.boolean().describe('Whether the entity has been soft-deleted')
}),
  "uniqueCode": zod.string().min(1).max(apiOrdersGetCollectionResponseDataItemMadeByUniqueCodeMax).regex(apiOrdersGetCollectionResponseDataItemMadeByUniqueCodeRegExp).optional().describe('User unique code'),
  "phone": zod.string().max(apiOrdersGetCollectionResponseDataItemMadeByPhoneMax).nullish().describe('User phone number')
}),
  "company": zod.object({
  "name": zod.string().max(apiOrdersGetCollectionResponseDataItemCompanyNameMax).describe('Company name'),
  "uniqueCode": zod.string().max(apiOrdersGetCollectionResponseDataItemCompanyUniqueCodeMax).regex(apiOrdersGetCollectionResponseDataItemCompanyUniqueCodeRegExp).describe('Company unique code (SIREN or TVA or whatever)')
}),
  "createdAt": zod.string().datetime({}).describe('Order creation date'),
  "orderProducts": zod.array(zod.object({
  "product": zod.object({
  "id": zod.number().describe('Product ID'),
  "name": zod.string().max(apiOrdersGetCollectionResponseDataItemOrderProductsItemProductNameMax).describe('Product name'),
  "isDemat": zod.boolean()
}),
  "pointUnitPrice": zod.number().min(apiOrdersGetCollectionResponseDataItemOrderProductsItemPointUnitPriceMin).describe('Point unit price'),
  "quantity": zod.number().min(apiOrdersGetCollectionResponseDataItemOrderProductsItemQuantityMin).describe('Quantity'),
  "dynamicPriceAmount": zod.number().min(apiOrdersGetCollectionResponseDataItemOrderProductsItemDynamicPriceAmountMin).nullish().describe('Dynamic price (euros). Used for pointUnitPrice calculation'),
  "amountUnitPrice": zod.number().min(apiOrdersGetCollectionResponseDataItemOrderProductsItemAmountUnitPriceMin).describe('Total price (euros) for one quantity')
})),
  "productsCount": zod.number().describe('Number of products in the order'),
  "shops": zod.array(zod.object({
  "displayName": zod.string().max(apiOrdersGetCollectionResponseDataItemShopsItemDisplayNameMax).describe('Shop display name'),
  "logo": zod.object({
  "pathUri": zod.string().nullable().describe('Media path to S3')
})
}))
})).optional()
}))


/**
 * Create a new order
 * @summary Create a new order
 */
export const apiOrdersPostBodyOrderProductsItemQuantityMin = 0;

export const apiOrdersPostBodyOrderProductsItemDynamicPriceAmountMin = 0;



export const apiOrdersPostBody = zod.object({
  "orderProducts": zod.array(zod.object({
  "product": zod.string().describe('Product shipped'),
  "quantity": zod.number().min(apiOrdersPostBodyOrderProductsItemQuantityMin).describe('Quantity'),
  "dynamicPriceAmount": zod.number().min(apiOrdersPostBodyOrderProductsItemDynamicPriceAmountMin).nullish().describe('Dynamic price (euros). Used for pointUnitPrice calculation')
}))
})


/**
 * Get an order
 * @summary Get an order
 */
export const apiOrdersIdGetParams = zod.object({
  "id": zod.string().describe('Order identifier')
})

export const apiOrdersIdGetResponseReferenceMax = 20;

export const apiOrdersIdGetResponseStatusMax = 50;

export const apiOrdersIdGetResponseTypeMax = 10;

export const apiOrdersIdGetResponseMadeByUserEmailMax = 255;

export const apiOrdersIdGetResponseMadeByUserAvatarMax = 255;

export const apiOrdersIdGetResponseMadeByPhoneMax = 20;

export const apiOrdersIdGetResponseCompanyNameMax = 100;

export const apiOrdersIdGetResponseCompanyAddressLine1Min = 7;
export const apiOrdersIdGetResponseCompanyAddressLine1Max = 255;

export const apiOrdersIdGetResponseCompanyAddressLine2Max = 255;

export const apiOrdersIdGetResponseCompanyAddressLine3Max = 255;

export const apiOrdersIdGetResponseCompanyZipcodeMin = 4;
export const apiOrdersIdGetResponseCompanyZipcodeMax = 20;

export const apiOrdersIdGetResponseCompanyCityMax = 100;

export const apiOrdersIdGetResponseCompanyTypologyNameMax = 100;

export const apiOrdersIdGetResponseCompanyResponsiblesItemUserEmailMax = 255;

export const apiOrdersIdGetResponseCompanyResponsiblesItemUserAvatarMax = 255;

export const apiOrdersIdGetResponseCompanyResponsiblesItemPhoneMax = 20;

export const apiOrdersIdGetResponseOrderProductsItemProductNameMax = 150;

export const apiOrdersIdGetResponseOrderProductsItemProductDynamicPriceDefault = false;export const apiOrdersIdGetResponseOrderProductsItemProductDesignationComMax = 255;

export const apiOrdersIdGetResponseOrderProductsItemProductEanMax = 20;

export const apiOrdersIdGetResponseOrderProductsItemProductIsDematDefault = false;export const apiOrdersIdGetResponseOrderProductsItemProductPublicMetadatasItemMetaKeyMax = 50;

export const apiOrdersIdGetResponseOrderProductsItemPointUnitPriceMin = 0;

export const apiOrdersIdGetResponseOrderProductsItemQuantityMin = 0;

export const apiOrdersIdGetResponseOrderProductsItemAmountUnitPriceDefault = 0;
export const apiOrdersIdGetResponseOrderProductsItemAmountUnitPriceMin = 0;

export const apiOrdersIdGetResponseProductsCountDefault = 0;export const apiOrdersIdGetResponseShopsItemDisplayNameMax = 100;



export const apiOrdersIdGetResponse = zod.object({
  "id": zod.number().describe('Order ID'),
  "reference": zod.string().max(apiOrdersIdGetResponseReferenceMax).describe('Order reference'),
  "status": zod.enum(['order.status.pending', 'order.status.confirmed', 'order.status.completed', 'order.status.canceled', 'order.status.failed']).describe('Order status (label)'),
  "type": zod.enum(['provider', 'reward', 'custom']).describe('Order type'),
  "point": zod.union([zod.object({
  "amount": zod.number().describe('Points amount')
}),zod.null()]).optional(),
  "madeBy": zod.object({
  "user": zod.object({
  "id": zod.number().describe('User ID'),
  "email": zod.string().email().max(apiOrdersIdGetResponseMadeByUserEmailMax).describe('User email'),
  "fullname": zod.string().describe('User fullname'),
  "avatar": zod.string().max(apiOrdersIdGetResponseMadeByUserAvatarMax).nullish().describe('User avatar'),
  "isDeleted": zod.boolean().describe('Whether the entity has been soft-deleted')
}),
  "phone": zod.string().max(apiOrdersIdGetResponseMadeByPhoneMax).nullish().describe('User phone number')
}),
  "company": zod.object({
  "id": zod.number().describe('Company ID'),
  "name": zod.string().max(apiOrdersIdGetResponseCompanyNameMax).describe('Company name'),
  "addressLine1": zod.string().min(apiOrdersIdGetResponseCompanyAddressLine1Min).max(apiOrdersIdGetResponseCompanyAddressLine1Max).describe('Company address line 1'),
  "addressLine2": zod.string().max(apiOrdersIdGetResponseCompanyAddressLine2Max).nullish().describe('Company address line 2'),
  "addressLine3": zod.string().max(apiOrdersIdGetResponseCompanyAddressLine3Max).nullish().describe('Company address line 3'),
  "zipcode": zod.string().min(apiOrdersIdGetResponseCompanyZipcodeMin).max(apiOrdersIdGetResponseCompanyZipcodeMax).describe('Company zipcode'),
  "city": zod.string().max(apiOrdersIdGetResponseCompanyCityMax).describe('Company city'),
  "country": zod.object({
  "name": zod.string().describe('Country name')
}).optional(),
  "typology": zod.union([zod.object({
  "name": zod.string().max(apiOrdersIdGetResponseCompanyTypologyNameMax).describe('Name of the typology')
}),zod.null()]).optional(),
  "responsibles": zod.array(zod.object({
  "user": zod.object({
  "id": zod.number().describe('User ID'),
  "email": zod.string().email().max(apiOrdersIdGetResponseCompanyResponsiblesItemUserEmailMax).describe('User email'),
  "fullname": zod.string().describe('User fullname'),
  "avatar": zod.string().max(apiOrdersIdGetResponseCompanyResponsiblesItemUserAvatarMax).nullish().describe('User avatar'),
  "isDeleted": zod.boolean().describe('Whether the entity has been soft-deleted')
}),
  "phone": zod.string().max(apiOrdersIdGetResponseCompanyResponsiblesItemPhoneMax).nullish().describe('User phone number')
})).optional()
}),
  "createdAt": zod.string().datetime({}).describe('Order creation date'),
  "orderProducts": zod.array(zod.object({
  "product": zod.object({
  "id": zod.number().describe('Product ID'),
  "name": zod.string().max(apiOrdersIdGetResponseOrderProductsItemProductNameMax).describe('Product name'),
  "description": zod.string().nullish().describe('Product description'),
  "dynamicPrice": zod.boolean().describe('Product dynamic price'),
  "images": zod.array(zod.object({
  "pathUri": zod.string().nullable().describe('Media path to S3')
})).optional(),
  "designationCom": zod.string().max(apiOrdersIdGetResponseOrderProductsItemProductDesignationComMax).nullish(),
  "ean": zod.string().max(apiOrdersIdGetResponseOrderProductsItemProductEanMax).nullish(),
  "isDemat": zod.boolean(),
  "publicMetadatas": zod.array(zod.object({
  "metaKey": zod.enum(['code', 'codeDetail', 'howtoUrl']).describe('Metadata key'),
  "metaValue": zod.string().describe('Metadata value')
})).optional()
}),
  "pointUnitPrice": zod.number().min(apiOrdersIdGetResponseOrderProductsItemPointUnitPriceMin).describe('Point unit price'),
  "quantity": zod.number().min(apiOrdersIdGetResponseOrderProductsItemQuantityMin).describe('Quantity'),
  "amountUnitPrice": zod.number().min(apiOrdersIdGetResponseOrderProductsItemAmountUnitPriceMin).describe('Total price (euros) for one quantity'),
  "orderProductCode": zod.union([zod.object({
  "code": zod.string(),
  "expiredAt": zod.string().datetime({}).nullish()
}),zod.null()]).optional()
})),
  "productsCount": zod.number().describe('Number of products in the order'),
  "shops": zod.array(zod.object({
  "displayName": zod.string().max(apiOrdersIdGetResponseShopsItemDisplayNameMax).describe('Shop display name'),
  "logo": zod.object({
  "pathUri": zod.string().nullable().describe('Media path to S3')
})
})),
  "trackingLink": zod.array(zod.string().nullable()).optional().describe('Tracking link')
})


/**
 * Retrieves the collection of Performance resources.
 * @summary Retrieves the collection of Performance resources.
 */
export const apiAdminperformancesGetCollectionQueryPageDefault = 1;export const apiAdminperformancesGetCollectionQueryPerPageDefault = 30;
export const apiAdminperformancesGetCollectionQueryPerPageMin = 0;
export const apiAdminperformancesGetCollectionQueryPerPageMax = 30;

export const apiAdminperformancesGetCollectionQueryOrderIdDefault = "asc";export const apiAdminperformancesGetCollectionQueryOrderRealizedAtDefault = "asc";export const apiAdminperformancesGetCollectionQueryOrderCreatedAtDefault = "asc";export const apiAdminperformancesGetCollectionQueryOrderReferenceQuantityDefault = "asc";export const apiAdminperformancesGetCollectionQueryOrderAmountDefault = "asc";export const apiAdminperformancesGetCollectionQueryOrderPointAmountDefault = "asc";

export const apiAdminperformancesGetCollectionQueryParams = zod.object({
  "page": zod.number().default(apiAdminperformancesGetCollectionQueryPageDefault).describe('The collection page number'),
  "perPage": zod.number().min(apiAdminperformancesGetCollectionQueryPerPageMin).max(apiAdminperformancesGetCollectionQueryPerPageMax).default(apiAdminperformancesGetCollectionQueryPerPageDefault).describe('The number of items per page'),
  "realizedByCompany.name": zod.string().optional(),
  "realizedByCompany.uniqueCode": zod.string().optional(),
  "label": zod.string().optional(),
  "logicTypeTarget.reference": zod.string().optional(),
  "logicTypeTarget.reference[]": zod.array(zod.string()).optional(),
  "referenceUniqueCode": zod.string().optional(),
  "referenceUniqueCode[]": zod.array(zod.string()).optional(),
  "addedByUserWorkspace.uniqueCode": zod.string().optional(),
  "realizedAt[before]": zod.string().optional(),
  "realizedAt[strictly_before]": zod.string().optional(),
  "realizedAt[after]": zod.string().optional(),
  "realizedAt[strictly_after]": zod.string().optional(),
  "createdAt[before]": zod.string().optional(),
  "createdAt[strictly_before]": zod.string().optional(),
  "createdAt[after]": zod.string().optional(),
  "createdAt[strictly_after]": zod.string().optional(),
  "referenceQuantity[between]": zod.string().optional(),
  "referenceQuantity[gt]": zod.string().optional(),
  "referenceQuantity[gte]": zod.string().optional(),
  "referenceQuantity[lt]": zod.string().optional(),
  "referenceQuantity[lte]": zod.string().optional(),
  "amount[gte]": zod.string().optional(),
  "amount[gt]": zod.string().optional(),
  "amount[lte]": zod.string().optional(),
  "amount[lt]": zod.string().optional(),
  "amount[between]": zod.string().optional(),
  "addedByUserWorkspace.user.fullname": zod.string().optional().describe('Search in concatenated fields: addedByUserWorkspace.user.firstname   addedByUserWorkspace.user.lastname'),
  "realizedBy.user.fullname": zod.string().optional().describe('Search in concatenated fields: realizedBy.user.firstname   realizedBy.user.lastname'),
  "order[id]": zod.enum(['asc', 'desc']).default(apiAdminperformancesGetCollectionQueryOrderIdDefault),
  "order[realizedAt]": zod.enum(['asc', 'desc']).default(apiAdminperformancesGetCollectionQueryOrderRealizedAtDefault),
  "order[createdAt]": zod.enum(['asc', 'desc']).default(apiAdminperformancesGetCollectionQueryOrderCreatedAtDefault),
  "order[referenceQuantity]": zod.enum(['asc', 'desc']).default(apiAdminperformancesGetCollectionQueryOrderReferenceQuantityDefault),
  "order[amount]": zod.enum(['asc', 'desc']).default(apiAdminperformancesGetCollectionQueryOrderAmountDefault),
  "order[point.amount]": zod.enum(['asc', 'desc']).default(apiAdminperformancesGetCollectionQueryOrderPointAmountDefault),
  "order[referenceUniqueCode]": zod.enum(['asc', 'desc']).optional()
})

export const apiAdminperformancesGetCollectionResponseDataItemAmountMin = 0;

export const apiAdminperformancesGetCollectionResponseDataItemLabelMax = 255;

export const apiAdminperformancesGetCollectionResponseDataItemRealizedByUserAvatarMax = 255;

export const apiAdminperformancesGetCollectionResponseDataItemRealizedByCompanyNameMax = 100;

export const apiAdminperformancesGetCollectionResponseDataItemRealizedByCompanyUniqueCodeMax = 50;


export const apiAdminperformancesGetCollectionResponseDataItemRealizedByCompanyUniqueCodeRegExp = new RegExp('^([a-zA-Z0-9]+)$');
export const apiAdminperformancesGetCollectionResponseDataItemLogicTypeTargetReferenceMax = 20;

export const apiAdminperformancesGetCollectionResponseDataItemAddedByUserWorkspaceUserAvatarMax = 255;

export const apiAdminperformancesGetCollectionResponseDataItemReferenceQuantityMin = 0;



export const apiAdminperformancesGetCollectionResponse = zod.object({
  "data": zod.array(zod.unknown()),
  "pagination": zod.object({
  "first": zod.number(),
  "current": zod.number(),
  "last": zod.number(),
  "previous": zod.number(),
  "next": zod.number(),
  "totalItems": zod.number(),
  "perPage": zod.number()
})
}).and(zod.object({
  "data": zod.array(zod.object({
  "id": zod.number().describe('Performance ID'),
  "amount": zod.number().min(apiAdminperformancesGetCollectionResponseDataItemAmountMin).optional().describe('Amount (in euros)'),
  "label": zod.string().max(apiAdminperformancesGetCollectionResponseDataItemLabelMax).nullish().describe('Performance label'),
  "realizedAt": zod.string().datetime({}).describe('Performance realisation date'),
  "createdAt": zod.string().datetime({}).describe('Points creation date'),
  "realizedBy": zod.union([zod.object({
  "user": zod.object({
  "id": zod.number().describe('User ID'),
  "fullname": zod.string().describe('User fullname'),
  "avatar": zod.string().max(apiAdminperformancesGetCollectionResponseDataItemRealizedByUserAvatarMax).nullish().describe('User avatar'),
  "isDeleted": zod.boolean().describe('Whether the entity has been soft-deleted')
})
}),zod.null()]),
  "point": zod.union([zod.object({
  "amount": zod.number().describe('Points amount')
}),zod.null()]).optional(),
  "realizedByCompany": zod.object({
  "id": zod.number().describe('Company ID'),
  "name": zod.string().max(apiAdminperformancesGetCollectionResponseDataItemRealizedByCompanyNameMax).describe('Company name'),
  "uniqueCode": zod.string().max(apiAdminperformancesGetCollectionResponseDataItemRealizedByCompanyUniqueCodeMax).regex(apiAdminperformancesGetCollectionResponseDataItemRealizedByCompanyUniqueCodeRegExp).describe('Company unique code (SIREN or TVA or whatever)')
}),
  "logicTypeTarget": zod.union([zod.object({
  "reference": zod.string().max(apiAdminperformancesGetCollectionResponseDataItemLogicTypeTargetReferenceMax).describe('Target reference name')
}),zod.null()]).optional(),
  "addedByUserWorkspace": zod.union([zod.object({
  "user": zod.object({
  "id": zod.number().describe('User ID'),
  "fullname": zod.string().describe('User fullname'),
  "avatar": zod.string().max(apiAdminperformancesGetCollectionResponseDataItemAddedByUserWorkspaceUserAvatarMax).nullish().describe('User avatar'),
  "isDeleted": zod.boolean().describe('Whether the entity has been soft-deleted')
})
}),zod.null()]).optional(),
  "referenceUniqueCode": zod.string().nullish().describe('Reference unique code'),
  "purchaseProof": zod.string().nullish().describe('Purchase proof linked to this performance'),
  "referenceQuantity": zod.number().min(apiAdminperformancesGetCollectionResponseDataItemReferenceQuantityMin).nullish().describe('Reference quantity buyed')
})).optional()
}))


/**
 * Add a performance
 * @summary Add a performance
 */
export const apiAdminperformancesPostBodyAmountMin = 0;

export const apiAdminperformancesPostBodyLabelMax = 255;

export const apiAdminperformancesPostBodyReferenceQuantityMin = 0;



export const apiAdminperformancesPostBody = zod.object({
  "amount": zod.number().min(apiAdminperformancesPostBodyAmountMin).optional().describe('Amount (in euros)'),
  "label": zod.string().max(apiAdminperformancesPostBodyLabelMax).nullish().describe('Performance label'),
  "realizedAt": zod.string().datetime({}).describe('Performance realisation date'),
  "userUniqueCode": zod.string().nullish().describe('User unique code who realized the performance'),
  "companyUniqueCode": zod.string().nullable().describe('Company unique code who realized the performance'),
  "targetReference": zod.string().nullish().describe('Target reference'),
  "referenceUniqueCode": zod.string().nullish().describe('Reference unique code'),
  "purchaseProof": zod.string().nullish().describe('Purchase proof linked to this performance'),
  "referenceQuantity": zod.number().min(apiAdminperformancesPostBodyReferenceQuantityMin).nullish().describe('Reference quantity buyed')
})


/**
 * Import performances
 * @summary Import performances
 */
export const perfsImportHeaderDryRunDefault = false;

export const perfsImportHeader = zod.object({
  "dry-run": zod.boolean().optional().describe('Set to true to perform a dry run import (optional)')
})

export const perfsImportBodyDataItemAmountMin = 0;

export const perfsImportBodyDataItemLabelMax = 255;

export const perfsImportBodyDataItemReferenceQuantityMin = 0;



export const perfsImportBody = zod.object({
  "data": zod.array(zod.object({
  "amount": zod.number().min(perfsImportBodyDataItemAmountMin).optional().describe('Amount (in euros)'),
  "label": zod.string().max(perfsImportBodyDataItemLabelMax).nullish().describe('Performance label'),
  "realizedAt": zod.string().datetime({}).describe('Performance realisation date'),
  "userUniqueCode": zod.string().nullish().describe('User unique code who realized the performance'),
  "companyUniqueCode": zod.string().nullable().describe('Company unique code who realized the performance'),
  "targetReference": zod.string().nullish().describe('Target reference'),
  "referenceUniqueCode": zod.string().nullish().describe('Reference unique code'),
  "purchaseProof": zod.string().nullish().describe('Purchase proof linked to this performance'),
  "referenceQuantity": zod.number().min(perfsImportBodyDataItemReferenceQuantityMin).nullish().describe('Reference quantity buyed')
}))
})


/**
 * Retrieves the collection of Point resources.
 * @summary Retrieves the collection of Point resources.
 */
export const apiAdminpointsGetCollectionQueryPageDefault = 1;export const apiAdminpointsGetCollectionQueryPerPageDefault = 30;
export const apiAdminpointsGetCollectionQueryPerPageMin = 0;
export const apiAdminpointsGetCollectionQueryPerPageMax = 30;

export const apiAdminpointsGetCollectionQueryOrderIdDefault = "asc";export const apiAdminpointsGetCollectionQueryOrderValueDateDefault = "asc";export const apiAdminpointsGetCollectionQueryOrderAmountDefault = "asc";export const apiAdminpointsGetCollectionQueryOrderCreatedAtDefault = "asc";

export const apiAdminpointsGetCollectionQueryParams = zod.object({
  "page": zod.number().default(apiAdminpointsGetCollectionQueryPageDefault).describe('The collection page number'),
  "perPage": zod.number().min(apiAdminpointsGetCollectionQueryPerPageMin).max(apiAdminpointsGetCollectionQueryPerPageMax).default(apiAdminpointsGetCollectionQueryPerPageDefault).describe('The number of items per page'),
  "attributedToCompany.name": zod.string().optional(),
  "attributedToCompany.uniqueCode": zod.string().optional(),
  "label": zod.string().optional(),
  "type": zod.number().optional(),
  "type[]": zod.array(zod.number()).optional(),
  "addedByUserWorkspace.uniqueCode": zod.string().optional(),
  "addedByUserWorkspace.uniqueCode[]": zod.array(zod.string()).optional(),
  "amount[between]": zod.string().optional(),
  "amount[gt]": zod.string().optional(),
  "amount[gte]": zod.string().optional(),
  "amount[lt]": zod.string().optional(),
  "amount[lte]": zod.string().optional(),
  "valueDate[before]": zod.string().optional(),
  "valueDate[strictly_before]": zod.string().optional(),
  "valueDate[after]": zod.string().optional(),
  "valueDate[strictly_after]": zod.string().optional(),
  "createdAt[before]": zod.string().optional(),
  "createdAt[strictly_before]": zod.string().optional(),
  "createdAt[after]": zod.string().optional(),
  "createdAt[strictly_after]": zod.string().optional(),
  "addedByUserWorkspace.user.fullname": zod.string().optional().describe('Search in concatenated fields: addedByUserWorkspace.user.firstname   addedByUserWorkspace.user.lastname'),
  "obtainedBy.user.fullname": zod.string().optional().describe('Search in concatenated fields: obtainedBy.user.firstname   obtainedBy.user.lastname'),
  "order[id]": zod.enum(['asc', 'desc']).default(apiAdminpointsGetCollectionQueryOrderIdDefault),
  "order[valueDate]": zod.enum(['asc', 'desc']).default(apiAdminpointsGetCollectionQueryOrderValueDateDefault),
  "order[amount]": zod.enum(['asc', 'desc']).default(apiAdminpointsGetCollectionQueryOrderAmountDefault),
  "order[createdAt]": zod.enum(['asc', 'desc']).default(apiAdminpointsGetCollectionQueryOrderCreatedAtDefault)
})

export const apiAdminpointsGetCollectionResponseDataItemObtainedByUserAvatarMax = 255;

export const apiAdminpointsGetCollectionResponseDataItemAttributedToCompanyNameMax = 100;

export const apiAdminpointsGetCollectionResponseDataItemAttributedToCompanyUniqueCodeMax = 50;


export const apiAdminpointsGetCollectionResponseDataItemAttributedToCompanyUniqueCodeRegExp = new RegExp('^([a-zA-Z0-9]+)$');
export const apiAdminpointsGetCollectionResponseDataItemLabelMax = 255;

export const apiAdminpointsGetCollectionResponseDataItemCreatedAtDefault = "";export const apiAdminpointsGetCollectionResponseDataItemAddedByUserWorkspaceUserAvatarMax = 255;

export const apiAdminpointsGetCollectionResponseDataItemValueDateDefault = "";export const apiAdminpointsGetCollectionResponseDataItemBoosterTitleMax = 255;



export const apiAdminpointsGetCollectionResponse = zod.object({
  "data": zod.array(zod.unknown()),
  "pagination": zod.object({
  "first": zod.number(),
  "current": zod.number(),
  "last": zod.number(),
  "previous": zod.number(),
  "next": zod.number(),
  "totalItems": zod.number(),
  "perPage": zod.number()
})
}).and(zod.object({
  "data": zod.array(zod.object({
  "id": zod.number().describe('Points ID'),
  "obtainedBy": zod.union([zod.object({
  "user": zod.object({
  "id": zod.number().describe('User ID'),
  "fullname": zod.string().describe('User fullname'),
  "avatar": zod.string().max(apiAdminpointsGetCollectionResponseDataItemObtainedByUserAvatarMax).nullish().describe('User avatar'),
  "isDeleted": zod.boolean().describe('Whether the entity has been soft-deleted')
})
}),zod.null()]).optional(),
  "attributedToCompany": zod.object({
  "id": zod.number().describe('Company ID'),
  "name": zod.string().max(apiAdminpointsGetCollectionResponseDataItemAttributedToCompanyNameMax).describe('Company name'),
  "uniqueCode": zod.string().max(apiAdminpointsGetCollectionResponseDataItemAttributedToCompanyUniqueCodeMax).regex(apiAdminpointsGetCollectionResponseDataItemAttributedToCompanyUniqueCodeRegExp).describe('Company unique code (SIREN or TVA or whatever)')
}),
  "amount": zod.number().describe('Points amount'),
  "label": zod.string().max(apiAdminpointsGetCollectionResponseDataItemLabelMax).nullish().describe('Points label'),
  "typeLabel": zod.enum(['CORE', 'IMPORTED', 'SPENT', 'EXPIRED', 'CANCELED', 'BOOSTER']),
  "expirationDate": zod.string().datetime({}).nullish().describe('Points expiration date'),
  "createdAt": zod.string().datetime({}).describe('Points creation date'),
  "addedByUserWorkspace": zod.union([zod.object({
  "user": zod.object({
  "id": zod.number().describe('User ID'),
  "fullname": zod.string().describe('User fullname'),
  "avatar": zod.string().max(apiAdminpointsGetCollectionResponseDataItemAddedByUserWorkspaceUserAvatarMax).nullish().describe('User avatar'),
  "isDeleted": zod.boolean().describe('Whether the entity has been soft-deleted')
})
}),zod.null()]).optional(),
  "valueDate": zod.string().datetime({}).describe('Points value date'),
  "logicTypeTarget": zod.string().nullish().describe('Logic target linked to the points'),
  "booster": zod.union([zod.object({
  "id": zod.number().describe('Booster ID'),
  "title": zod.string().max(apiAdminpointsGetCollectionResponseDataItemBoosterTitleMax).describe('Title of the booster')
}),zod.null()]).optional()
})).optional()
}))


/**
 * Add a point
 * @summary Add a point
 */
export const apiAdminpointsPostBodyLabelMax = 255;

export const apiAdminpointsPostBodyValueDateDefault = "";

export const apiAdminpointsPostBody = zod.object({
  "userUniqueCode": zod.string().nullish().describe('User unique code'),
  "companyUniqueCode": zod.string().nullable().describe('Company unique code'),
  "amount": zod.number().describe('Points amount'),
  "label": zod.string().max(apiAdminpointsPostBodyLabelMax).nullish().describe('Points label'),
  "typeLabel": zod.enum(['CORE', 'IMPORTED', 'SPENT', 'EXPIRED', 'CANCELED', 'BOOSTER']),
  "expirationDate": zod.string().datetime({}).nullish().describe('Points expiration date'),
  "valueDate": zod.string().datetime({}).describe('Points value date'),
  "targetReference": zod.string().nullish().describe('Target reference')
})


/**
 * Import points
 * @summary Import points
 */
export const pointsImportHeaderDryRunDefault = false;

export const pointsImportHeader = zod.object({
  "dry-run": zod.boolean().optional().describe('Set to true to perform a dry run import (optional)')
})

export const pointsImportBodyDataItemLabelMax = 255;

export const pointsImportBodyDataItemValueDateDefault = "";

export const pointsImportBody = zod.object({
  "data": zod.array(zod.object({
  "userUniqueCode": zod.string().nullish().describe('User unique code'),
  "companyUniqueCode": zod.string().nullable().describe('Company unique code'),
  "amount": zod.number().describe('Points amount'),
  "label": zod.string().max(pointsImportBodyDataItemLabelMax).nullish().describe('Points label'),
  "typeLabel": zod.enum(['CORE', 'IMPORTED', 'SPENT', 'EXPIRED', 'CANCELED', 'BOOSTER']),
  "expirationDate": zod.string().datetime({}).nullish().describe('Points expiration date'),
  "valueDate": zod.string().datetime({}).describe('Points value date'),
  "targetReference": zod.string().nullish().describe('Target reference')
}))
})


/**
 * Create new product
 * @summary Create new product
 */
export const apiAdminproductsPostBodyNameMax = 150;

export const apiAdminproductsPostBodyPriceMin = 0;

export const apiAdminproductsPostBodyDynamicPriceDefault = false;export const apiAdminproductsPostBodyMetadatasItemMetaKeyMax = 50;

export const apiAdminproductsPostBodyDesignationComMax = 255;

export const apiAdminproductsPostBodyEanMax = 20;

export const apiAdminproductsPostBodyIsDematDefault = false;export const apiAdminproductsPostBodyTvaDefault = 0;
export const apiAdminproductsPostBodyTvaMin = 0;

export const apiAdminproductsPostBodyShippingPriceDefault = 0;
export const apiAdminproductsPostBodyShippingPriceMin = 0;

export const apiAdminproductsPostBodyStockMin = 0;

export const apiAdminproductsPostBodyLowStockAlertMin = 0;



export const apiAdminproductsPostBody = zod.object({
  "name": zod.string().max(apiAdminproductsPostBodyNameMax).describe('Product name'),
  "description": zod.string().nullish().describe('Product description'),
  "price": zod.number().min(apiAdminproductsPostBodyPriceMin).nullish().describe('Product price'),
  "dynamicPrice": zod.boolean().describe('Product dynamic price'),
  "metadatas": zod.array(zod.object({
  "metaKey": zod.enum(['code', 'codeDetail', 'howtoUrl']).describe('Metadata key'),
  "metaValue": zod.string().describe('Metadata value')
})).optional(),
  "shop": zod.string().describe('Shop IRI'),
  "images": zod.array(zod.string()).optional().describe('Product images'),
  "designationCom": zod.string().max(apiAdminproductsPostBodyDesignationComMax).nullish(),
  "ean": zod.string().max(apiAdminproductsPostBodyEanMax).nullish(),
  "isDemat": zod.boolean(),
  "tva": zod.number().min(apiAdminproductsPostBodyTvaMin).describe('Product TVA'),
  "shippingPrice": zod.number().min(apiAdminproductsPostBodyShippingPriceMin).describe('Product shipping price'),
  "category": zod.string().nullish().describe('Product category'),
  "brand": zod.string().nullish().describe('Product brand'),
  "stock": zod.number().min(apiAdminproductsPostBodyStockMin).nullish().describe('Product stock'),
  "lowStockAlert": zod.number().min(apiAdminproductsPostBodyLowStockAlertMin).nullish().describe('Product low stock alert')
})


/**
 * Delete a product
 * @summary Delete a product
 */
export const apiAdminproductsIdDeleteParams = zod.object({
  "id": zod.string().describe('Product identifier')
})


/**
 * Update a product
 * @summary Update a product
 */
export const apiAdminshopsShopIdproductsIdPatchParams = zod.object({
  "id": zod.string().describe('Product identifier'),
  "shopId": zod.string().describe('Shop identifier')
})

export const apiAdminshopsShopIdproductsIdPatchBodyNameMax = 150;

export const apiAdminshopsShopIdproductsIdPatchBodyPriceMin = 0;

export const apiAdminshopsShopIdproductsIdPatchBodyMetadatasItemMetaKeyMax = 50;

export const apiAdminshopsShopIdproductsIdPatchBodyDesignationComMax = 255;

export const apiAdminshopsShopIdproductsIdPatchBodyEanMax = 20;

export const apiAdminshopsShopIdproductsIdPatchBodyIsDematDefault = false;export const apiAdminshopsShopIdproductsIdPatchBodyTvaDefault = 0;export const apiAdminshopsShopIdproductsIdPatchBodyShippingPriceDefault = 0;

export const apiAdminshopsShopIdproductsIdPatchBody = zod.object({
  "name": zod.string().min(1).max(apiAdminshopsShopIdproductsIdPatchBodyNameMax).optional().describe('Product name'),
  "description": zod.string().nullish().describe('Product description'),
  "price": zod.number().min(apiAdminshopsShopIdproductsIdPatchBodyPriceMin).nullish().describe('Product price'),
  "metadatas": zod.array(zod.object({
  "metaKey": zod.enum(['code', 'codeDetail', 'howtoUrl']).describe('Metadata key'),
  "metaValue": zod.string().describe('Metadata value')
})).optional(),
  "images": zod.array(zod.string()).optional().describe('Product images'),
  "designationCom": zod.string().max(apiAdminshopsShopIdproductsIdPatchBodyDesignationComMax).nullish(),
  "ean": zod.string().max(apiAdminshopsShopIdproductsIdPatchBodyEanMax).nullish(),
  "isDemat": zod.boolean().optional(),
  "tva": zod.number().optional().describe('Product TVA'),
  "shippingPrice": zod.number().optional().describe('Product shipping price'),
  "category": zod.string().nullish().describe('Product category'),
  "brand": zod.string().nullish().describe('Product brand'),
  "stock": zod.number().nullish().describe('Product stock'),
  "lowStockAlert": zod.number().nullish().describe('Product low stock alert')
})

export const apiAdminshopsShopIdproductsIdPatchResponseNameMax = 150;

export const apiAdminshopsShopIdproductsIdPatchResponsePriceMin = 0;

export const apiAdminshopsShopIdproductsIdPatchResponsePointUnitPriceDefault = 0;export const apiAdminshopsShopIdproductsIdPatchResponseDynamicPriceDefault = false;export const apiAdminshopsShopIdproductsIdPatchResponseMetadatasItemMetaKeyMax = 50;

export const apiAdminshopsShopIdproductsIdPatchResponseDesignationComMax = 255;

export const apiAdminshopsShopIdproductsIdPatchResponseEanMax = 20;

export const apiAdminshopsShopIdproductsIdPatchResponseIsArchivedDefault = false;export const apiAdminshopsShopIdproductsIdPatchResponseIsDematDefault = false;export const apiAdminshopsShopIdproductsIdPatchResponseTvaDefault = 0;
export const apiAdminshopsShopIdproductsIdPatchResponseTvaMin = 0;

export const apiAdminshopsShopIdproductsIdPatchResponseShippingPriceDefault = 0;
export const apiAdminshopsShopIdproductsIdPatchResponseShippingPriceMin = 0;

export const apiAdminshopsShopIdproductsIdPatchResponseCategoryLabelMax = 100;

export const apiAdminshopsShopIdproductsIdPatchResponseBrandNameMax = 255;

export const apiAdminshopsShopIdproductsIdPatchResponseBrandLabelMax = 100;

export const apiAdminshopsShopIdproductsIdPatchResponseStockMin = 0;

export const apiAdminshopsShopIdproductsIdPatchResponseLowStockAlertMin = 0;

export const apiAdminshopsShopIdproductsIdPatchResponsePublicMetadatasItemMetaKeyMax = 50;



export const apiAdminshopsShopIdproductsIdPatchResponse = zod.object({
  "id": zod.number().describe('Product ID'),
  "name": zod.string().max(apiAdminshopsShopIdproductsIdPatchResponseNameMax).describe('Product name'),
  "description": zod.string().nullish().describe('Product description'),
  "price": zod.number().min(apiAdminshopsShopIdproductsIdPatchResponsePriceMin).nullish().describe('Product price'),
  "pointUnitPrice": zod.number().describe('Product point unit'),
  "dynamicQuantity": zod.number().nullable().describe('Product dynamic quantity'),
  "dynamicPrice": zod.boolean().describe('Product dynamic price'),
  "createdAt": zod.string().datetime({}).describe('Date and time when the product was created'),
  "metadatas": zod.array(zod.object({
  "id": zod.number().describe('ProductMetadata ID'),
  "metaKey": zod.enum(['code', 'codeDetail', 'howtoUrl']).describe('Metadata key'),
  "metaValue": zod.string().describe('Metadata value')
})).optional(),
  "images": zod.array(zod.object({
  "pathUri": zod.string().nullable().describe('Media path to S3')
})).optional(),
  "designationCom": zod.string().max(apiAdminshopsShopIdproductsIdPatchResponseDesignationComMax).nullish(),
  "ean": zod.string().max(apiAdminshopsShopIdproductsIdPatchResponseEanMax).nullish(),
  "isArchived": zod.boolean().describe('Product archived status'),
  "isDemat": zod.boolean(),
  "tva": zod.number().min(apiAdminshopsShopIdproductsIdPatchResponseTvaMin).describe('Product TVA'),
  "shippingPrice": zod.number().min(apiAdminshopsShopIdproductsIdPatchResponseShippingPriceMin).describe('Product shipping price'),
  "category": zod.union([zod.object({
  "id": zod.number().describe('Product category ID'),
  "label": zod.string().max(apiAdminshopsShopIdproductsIdPatchResponseCategoryLabelMax).describe('Product category label')
}),zod.null()]).optional(),
  "brand": zod.union([zod.object({
  "id": zod.number().describe('Product brand ID'),
  "name": zod.string().max(apiAdminshopsShopIdproductsIdPatchResponseBrandNameMax).describe('Product brand name'),
  "label": zod.string().max(apiAdminshopsShopIdproductsIdPatchResponseBrandLabelMax).describe('Product brand label')
}),zod.null()]).optional(),
  "stock": zod.number().min(apiAdminshopsShopIdproductsIdPatchResponseStockMin).nullish().describe('Product stock'),
  "lowStockAlert": zod.number().min(apiAdminshopsShopIdproductsIdPatchResponseLowStockAlertMin).nullish().describe('Product low stock alert'),
  "publicMetadatas": zod.array(zod.object({
  "id": zod.number().describe('ProductMetadata ID'),
  "metaKey": zod.enum(['code', 'codeDetail', 'howtoUrl']).describe('Metadata key'),
  "metaValue": zod.string().describe('Metadata value')
})).optional()
})


/**
 * Update the status of a product
 * @summary Update the status of a product
 */
export const updateProductStatusParams = zod.object({
  "id": zod.string().describe('Product identifier'),
  "shopId": zod.string().describe('Shop identifier')
})

export const updateProductStatusBodyIsArchivedDefault = false;

export const updateProductStatusBody = zod.object({
  "isActive": zod.boolean().optional().describe('Product status (active or not)'),
  "isArchived": zod.boolean().optional().describe('Product archived status')
})

export const updateProductStatusResponseNameMax = 150;

export const updateProductStatusResponsePriceMin = 0;

export const updateProductStatusResponsePointUnitPriceDefault = 0;export const updateProductStatusResponseDynamicPriceDefault = false;export const updateProductStatusResponseDesignationComMax = 255;

export const updateProductStatusResponseEanMax = 20;

export const updateProductStatusResponseIsArchivedDefault = false;export const updateProductStatusResponseIsDematDefault = false;export const updateProductStatusResponseTvaDefault = 0;
export const updateProductStatusResponseTvaMin = 0;

export const updateProductStatusResponseShippingPriceDefault = 0;
export const updateProductStatusResponseShippingPriceMin = 0;

export const updateProductStatusResponseCategoryLabelMax = 100;

export const updateProductStatusResponseBrandNameMax = 255;

export const updateProductStatusResponseBrandLabelMax = 100;

export const updateProductStatusResponseStockMin = 0;

export const updateProductStatusResponseLowStockAlertMin = 0;

export const updateProductStatusResponsePublicMetadatasItemMetaKeyMax = 50;



export const updateProductStatusResponse = zod.object({
  "id": zod.number().describe('Product ID'),
  "name": zod.string().max(updateProductStatusResponseNameMax).describe('Product name'),
  "description": zod.string().nullish().describe('Product description'),
  "price": zod.number().min(updateProductStatusResponsePriceMin).nullish().describe('Product price'),
  "pointUnitPrice": zod.number().describe('Product point unit'),
  "dynamicQuantity": zod.number().nullable().describe('Product dynamic quantity'),
  "dynamicPrice": zod.boolean().describe('Product dynamic price'),
  "createdAt": zod.string().datetime({}).describe('Date and time when the product was created'),
  "images": zod.array(zod.object({
  "pathUri": zod.string().nullable().describe('Media path to S3')
})).optional(),
  "designationCom": zod.string().max(updateProductStatusResponseDesignationComMax).nullish(),
  "ean": zod.string().max(updateProductStatusResponseEanMax).nullish(),
  "isArchived": zod.boolean().describe('Product archived status'),
  "isDemat": zod.boolean(),
  "tva": zod.number().min(updateProductStatusResponseTvaMin).describe('Product TVA'),
  "shippingPrice": zod.number().min(updateProductStatusResponseShippingPriceMin).describe('Product shipping price'),
  "category": zod.union([zod.object({
  "id": zod.number().describe('Product category ID'),
  "label": zod.string().max(updateProductStatusResponseCategoryLabelMax).describe('Product category label')
}),zod.null()]).optional(),
  "brand": zod.union([zod.object({
  "id": zod.number().describe('Product brand ID'),
  "name": zod.string().max(updateProductStatusResponseBrandNameMax).describe('Product brand name'),
  "label": zod.string().max(updateProductStatusResponseBrandLabelMax).describe('Product brand label')
}),zod.null()]).optional(),
  "stock": zod.number().min(updateProductStatusResponseStockMin).nullish().describe('Product stock'),
  "lowStockAlert": zod.number().min(updateProductStatusResponseLowStockAlertMin).nullish().describe('Product low stock alert'),
  "publicMetadatas": zod.array(zod.object({
  "id": zod.number().describe('ProductMetadata ID'),
  "metaKey": zod.enum(['code', 'codeDetail', 'howtoUrl']).describe('Metadata key'),
  "metaValue": zod.string().describe('Metadata value')
})).optional()
})


/**
 * List products from shop
 * @summary List products from shop
 */
export const apiShopsShopIdproductsGetCollectionParams = zod.object({
  "shopId": zod.string().describe('Shop identifier')
})

export const apiShopsShopIdproductsGetCollectionQueryPageDefault = 1;export const apiShopsShopIdproductsGetCollectionQueryPerPageDefault = 30;
export const apiShopsShopIdproductsGetCollectionQueryPerPageMin = 0;
export const apiShopsShopIdproductsGetCollectionQueryPerPageMax = 30;

export const apiShopsShopIdproductsGetCollectionQueryOrderCreatedAtDefault = "asc";export const apiShopsShopIdproductsGetCollectionQueryOrderNameDefault = "asc";export const apiShopsShopIdproductsGetCollectionQueryOrderPriceDefault = "asc";

export const apiShopsShopIdproductsGetCollectionQueryParams = zod.object({
  "page": zod.number().default(apiShopsShopIdproductsGetCollectionQueryPageDefault).describe('The collection page number'),
  "perPage": zod.number().min(apiShopsShopIdproductsGetCollectionQueryPerPageMin).max(apiShopsShopIdproductsGetCollectionQueryPerPageMax).default(apiShopsShopIdproductsGetCollectionQueryPerPageDefault).describe('The number of items per page'),
  "name": zod.string().optional(),
  "category": zod.string().optional(),
  "category[]": zod.array(zod.string()).optional(),
  "brand": zod.string().optional(),
  "brand[]": zod.array(zod.string()).optional(),
  "isActive": zod.boolean().optional(),
  "order[createdAt]": zod.enum(['asc', 'desc']).default(apiShopsShopIdproductsGetCollectionQueryOrderCreatedAtDefault),
  "order[name]": zod.enum(['asc', 'desc']).default(apiShopsShopIdproductsGetCollectionQueryOrderNameDefault),
  "order[price]": zod.enum(['asc', 'desc']).default(apiShopsShopIdproductsGetCollectionQueryOrderPriceDefault),
  "search": zod.string().optional().describe('Search in name, description, category.label, brand.name'),
  "pointUnitPrice[gte]": zod.number().optional().describe('Filter products with a point unit price greater than or equal to this value'),
  "pointUnitPrice[lte]": zod.number().optional().describe('Filter products with a point unit price less than or equal to this value')
})

export const apiShopsShopIdproductsGetCollectionResponseDataItemNameMax = 150;

export const apiShopsShopIdproductsGetCollectionResponseDataItemPriceMin = 0;

export const apiShopsShopIdproductsGetCollectionResponseDataItemPointUnitPriceDefault = 0;export const apiShopsShopIdproductsGetCollectionResponseDataItemDynamicPriceDefault = false;export const apiShopsShopIdproductsGetCollectionResponseDataItemDesignationComMax = 255;

export const apiShopsShopIdproductsGetCollectionResponseDataItemEanMax = 20;

export const apiShopsShopIdproductsGetCollectionResponseDataItemIsArchivedDefault = false;export const apiShopsShopIdproductsGetCollectionResponseDataItemIsDematDefault = false;export const apiShopsShopIdproductsGetCollectionResponseDataItemTvaDefault = 0;
export const apiShopsShopIdproductsGetCollectionResponseDataItemTvaMin = 0;

export const apiShopsShopIdproductsGetCollectionResponseDataItemShippingPriceDefault = 0;
export const apiShopsShopIdproductsGetCollectionResponseDataItemShippingPriceMin = 0;

export const apiShopsShopIdproductsGetCollectionResponseDataItemCategoryLabelMax = 100;

export const apiShopsShopIdproductsGetCollectionResponseDataItemBrandNameMax = 255;

export const apiShopsShopIdproductsGetCollectionResponseDataItemBrandLabelMax = 100;

export const apiShopsShopIdproductsGetCollectionResponseDataItemStockMin = 0;

export const apiShopsShopIdproductsGetCollectionResponseDataItemLowStockAlertMin = 0;

export const apiShopsShopIdproductsGetCollectionResponseDataItemPublicMetadatasItemMetaKeyMax = 50;



export const apiShopsShopIdproductsGetCollectionResponse = zod.object({
  "data": zod.array(zod.unknown()),
  "pagination": zod.object({
  "first": zod.number(),
  "current": zod.number(),
  "last": zod.number(),
  "previous": zod.number(),
  "next": zod.number(),
  "totalItems": zod.number(),
  "perPage": zod.number()
})
}).and(zod.object({
  "data": zod.array(zod.object({
  "id": zod.number().describe('Product ID'),
  "name": zod.string().max(apiShopsShopIdproductsGetCollectionResponseDataItemNameMax).describe('Product name'),
  "description": zod.string().nullish().describe('Product description'),
  "price": zod.number().min(apiShopsShopIdproductsGetCollectionResponseDataItemPriceMin).nullish().describe('Product price'),
  "pointUnitPrice": zod.number().describe('Product point unit'),
  "dynamicQuantity": zod.number().nullable().describe('Product dynamic quantity'),
  "dynamicPrice": zod.boolean().describe('Product dynamic price'),
  "createdAt": zod.string().datetime({}).describe('Date and time when the product was created'),
  "images": zod.array(zod.object({
  "pathUri": zod.string().nullable().describe('Media path to S3')
})).optional(),
  "designationCom": zod.string().max(apiShopsShopIdproductsGetCollectionResponseDataItemDesignationComMax).nullish(),
  "ean": zod.string().max(apiShopsShopIdproductsGetCollectionResponseDataItemEanMax).nullish(),
  "isArchived": zod.boolean().describe('Product archived status'),
  "isDemat": zod.boolean(),
  "tva": zod.number().min(apiShopsShopIdproductsGetCollectionResponseDataItemTvaMin).describe('Product TVA'),
  "shippingPrice": zod.number().min(apiShopsShopIdproductsGetCollectionResponseDataItemShippingPriceMin).describe('Product shipping price'),
  "category": zod.union([zod.object({
  "id": zod.number().describe('Product category ID'),
  "label": zod.string().max(apiShopsShopIdproductsGetCollectionResponseDataItemCategoryLabelMax).describe('Product category label')
}),zod.null()]).optional(),
  "brand": zod.union([zod.object({
  "id": zod.number().describe('Product brand ID'),
  "name": zod.string().max(apiShopsShopIdproductsGetCollectionResponseDataItemBrandNameMax).describe('Product brand name'),
  "label": zod.string().max(apiShopsShopIdproductsGetCollectionResponseDataItemBrandLabelMax).describe('Product brand label')
}),zod.null()]).optional(),
  "stock": zod.number().min(apiShopsShopIdproductsGetCollectionResponseDataItemStockMin).nullish().describe('Product stock'),
  "lowStockAlert": zod.number().min(apiShopsShopIdproductsGetCollectionResponseDataItemLowStockAlertMin).nullish().describe('Product low stock alert'),
  "publicMetadatas": zod.array(zod.object({
  "id": zod.number().describe('ProductMetadata ID'),
  "metaKey": zod.enum(['code', 'codeDetail', 'howtoUrl']).describe('Metadata key'),
  "metaValue": zod.string().describe('Metadata value')
})).optional()
})).optional()
}))


/**
 * Get a product from shop
 * @summary Get a product from shop
 */
export const apiShopsShopIdproductsIdGetParams = zod.object({
  "id": zod.string().describe('Product identifier'),
  "shopId": zod.string().describe('Shop identifier')
})

export const apiShopsShopIdproductsIdGetResponseNameMax = 150;

export const apiShopsShopIdproductsIdGetResponsePriceMin = 0;

export const apiShopsShopIdproductsIdGetResponsePointUnitPriceDefault = 0;export const apiShopsShopIdproductsIdGetResponseDynamicPriceDefault = false;export const apiShopsShopIdproductsIdGetResponseDesignationComMax = 255;

export const apiShopsShopIdproductsIdGetResponseEanMax = 20;

export const apiShopsShopIdproductsIdGetResponseIsArchivedDefault = false;export const apiShopsShopIdproductsIdGetResponseIsDematDefault = false;export const apiShopsShopIdproductsIdGetResponseTvaDefault = 0;
export const apiShopsShopIdproductsIdGetResponseTvaMin = 0;

export const apiShopsShopIdproductsIdGetResponseShippingPriceDefault = 0;
export const apiShopsShopIdproductsIdGetResponseShippingPriceMin = 0;

export const apiShopsShopIdproductsIdGetResponseCategoryLabelMax = 100;

export const apiShopsShopIdproductsIdGetResponseBrandNameMax = 255;

export const apiShopsShopIdproductsIdGetResponseBrandLabelMax = 100;

export const apiShopsShopIdproductsIdGetResponseStockMin = 0;

export const apiShopsShopIdproductsIdGetResponseLowStockAlertMin = 0;

export const apiShopsShopIdproductsIdGetResponsePublicMetadatasItemMetaKeyMax = 50;



export const apiShopsShopIdproductsIdGetResponse = zod.object({
  "id": zod.number().describe('Product ID'),
  "name": zod.string().max(apiShopsShopIdproductsIdGetResponseNameMax).describe('Product name'),
  "description": zod.string().nullish().describe('Product description'),
  "price": zod.number().min(apiShopsShopIdproductsIdGetResponsePriceMin).nullish().describe('Product price'),
  "pointUnitPrice": zod.number().describe('Product point unit'),
  "dynamicQuantity": zod.number().nullable().describe('Product dynamic quantity'),
  "dynamicPrice": zod.boolean().describe('Product dynamic price'),
  "createdAt": zod.string().datetime({}).describe('Date and time when the product was created'),
  "images": zod.array(zod.object({
  "pathUri": zod.string().nullable().describe('Media path to S3')
})).optional(),
  "designationCom": zod.string().max(apiShopsShopIdproductsIdGetResponseDesignationComMax).nullish(),
  "ean": zod.string().max(apiShopsShopIdproductsIdGetResponseEanMax).nullish(),
  "isArchived": zod.boolean().describe('Product archived status'),
  "isDemat": zod.boolean(),
  "tva": zod.number().min(apiShopsShopIdproductsIdGetResponseTvaMin).describe('Product TVA'),
  "shippingPrice": zod.number().min(apiShopsShopIdproductsIdGetResponseShippingPriceMin).describe('Product shipping price'),
  "category": zod.union([zod.object({
  "id": zod.number().describe('Product category ID'),
  "label": zod.string().max(apiShopsShopIdproductsIdGetResponseCategoryLabelMax).describe('Product category label')
}),zod.null()]).optional(),
  "brand": zod.union([zod.object({
  "id": zod.number().describe('Product brand ID'),
  "name": zod.string().max(apiShopsShopIdproductsIdGetResponseBrandNameMax).describe('Product brand name'),
  "label": zod.string().max(apiShopsShopIdproductsIdGetResponseBrandLabelMax).describe('Product brand label')
}),zod.null()]).optional(),
  "stock": zod.number().min(apiShopsShopIdproductsIdGetResponseStockMin).nullish().describe('Product stock'),
  "lowStockAlert": zod.number().min(apiShopsShopIdproductsIdGetResponseLowStockAlertMin).nullish().describe('Product low stock alert'),
  "publicMetadatas": zod.array(zod.object({
  "id": zod.number().describe('ProductMetadata ID'),
  "metaKey": zod.enum(['code', 'codeDetail', 'howtoUrl']).describe('Metadata key'),
  "metaValue": zod.string().describe('Metadata value')
})).optional()
})


/**
 * List product brands from shop
 * @summary List product brands from shop
 */
export const adminBrandsParams = zod.object({
  "shopId": zod.string().describe('Shop identifier')
})

export const adminBrandsQueryParams = zod.object({
  "search": zod.string().optional().describe('Search in name, label')
})

export const adminBrandsResponseNameMax = 255;

export const adminBrandsResponseLabelMax = 100;



export const adminBrandsResponseItem = zod.object({
  "id": zod.number().describe('Product brand ID'),
  "name": zod.string().max(adminBrandsResponseNameMax).describe('Product brand name'),
  "label": zod.string().max(adminBrandsResponseLabelMax).describe('Product brand label')
})
export const adminBrandsResponse = zod.array(adminBrandsResponseItem)


/**
 * Create a product brand for a shop
 * @summary Create a product brand for a shop
 */
export const apiAdminshopsShopIdbrandsPostParams = zod.object({
  "shopId": zod.string().describe('Shop identifier')
})

export const apiAdminshopsShopIdbrandsPostBodyNameMax = 255;



export const apiAdminshopsShopIdbrandsPostBody = zod.object({
  "name": zod.string().max(apiAdminshopsShopIdbrandsPostBodyNameMax).describe('Product brand name')
})


/**
 * Update a product brand
 * @summary Update a product brand
 */
export const apiAdminshopsShopIdbrandsIdPatchParams = zod.object({
  "id": zod.string().describe('ProductBrand identifier'),
  "shopId": zod.string().describe('Shop identifier')
})

export const apiAdminshopsShopIdbrandsIdPatchBodyNameMax = 255;



export const apiAdminshopsShopIdbrandsIdPatchBody = zod.object({
  "name": zod.string().max(apiAdminshopsShopIdbrandsIdPatchBodyNameMax).optional().describe('Product brand name')
})

export const apiAdminshopsShopIdbrandsIdPatchResponseNameMax = 255;

export const apiAdminshopsShopIdbrandsIdPatchResponseLabelMax = 100;



export const apiAdminshopsShopIdbrandsIdPatchResponse = zod.object({
  "id": zod.number().describe('Product brand ID'),
  "name": zod.string().max(apiAdminshopsShopIdbrandsIdPatchResponseNameMax).describe('Product brand name'),
  "label": zod.string().max(apiAdminshopsShopIdbrandsIdPatchResponseLabelMax).describe('Product brand label')
})


/**
 * List product brands from shop
 * @summary List product brands from shop
 */
export const apiShopsShopIdbrandsGetCollectionParams = zod.object({
  "shopId": zod.string().describe('Shop identifier')
})

export const apiShopsShopIdbrandsGetCollectionQueryParams = zod.object({
  "products.category": zod.string().optional().describe('Retourne les marques ayant au moins un produit actif dans cette catégorie'),
  "products.category[]": zod.array(zod.string()).optional().describe('Retourne les marques ayant au moins un produit actif dans une de ces catégories'),
  "search": zod.string().optional().describe('Search in name, label')
})

export const apiShopsShopIdbrandsGetCollectionResponseNameMax = 255;

export const apiShopsShopIdbrandsGetCollectionResponseLabelMax = 100;



export const apiShopsShopIdbrandsGetCollectionResponseItem = zod.object({
  "id": zod.number().describe('Product brand ID'),
  "name": zod.string().max(apiShopsShopIdbrandsGetCollectionResponseNameMax).describe('Product brand name'),
  "label": zod.string().max(apiShopsShopIdbrandsGetCollectionResponseLabelMax).describe('Product brand label')
})
export const apiShopsShopIdbrandsGetCollectionResponse = zod.array(apiShopsShopIdbrandsGetCollectionResponseItem)


/**
 * List product categories from shop
 * @summary List product categories from shop
 */
export const adminGetCollectionParams = zod.object({
  "shopId": zod.string().describe('Shop identifier')
})

export const adminGetCollectionQueryPageDefault = 1;export const adminGetCollectionQueryPerPageDefault = 30;
export const adminGetCollectionQueryPerPageMin = 0;
export const adminGetCollectionQueryPerPageMax = 30;



export const adminGetCollectionQueryParams = zod.object({
  "page": zod.number().default(adminGetCollectionQueryPageDefault).describe('The collection page number'),
  "perPage": zod.number().min(adminGetCollectionQueryPerPageMin).max(adminGetCollectionQueryPerPageMax).default(adminGetCollectionQueryPerPageDefault).describe('The number of items per page'),
  "label": zod.string().optional(),
  "parent": zod.string().optional(),
  "parent[]": zod.array(zod.string()).optional()
})

export const adminGetCollectionResponseDataItemLabelMax = 100;



export const adminGetCollectionResponse = zod.object({
  "data": zod.array(zod.unknown()),
  "pagination": zod.object({
  "first": zod.number(),
  "current": zod.number(),
  "last": zod.number(),
  "previous": zod.number(),
  "next": zod.number(),
  "totalItems": zod.number(),
  "perPage": zod.number()
})
}).and(zod.object({
  "data": zod.array(zod.object({
  "id": zod.number().describe('Product category ID'),
  "label": zod.string().max(adminGetCollectionResponseDataItemLabelMax).describe('Product category label'),
  "parent": zod.union([zod.unknown(),zod.null()]).optional(),
  "childs": zod.array(zod.unknown()).optional()
})).optional()
}))


/**
 * Create a product category for a shop
 * @summary Create a product category for a shop
 */
export const apiAdminshopsShopIdcategoriesPostParams = zod.object({
  "shopId": zod.string().describe('Shop identifier')
})

export const apiAdminshopsShopIdcategoriesPostBodyLabelMax = 100;



export const apiAdminshopsShopIdcategoriesPostBody = zod.object({
  "label": zod.string().max(apiAdminshopsShopIdcategoriesPostBodyLabelMax).describe('Product category label'),
  "parent": zod.union([zod.unknown(),zod.null()]).optional()
})


/**
 * Update a product category
 * @summary Update a product category
 */
export const apiAdminshopsShopIdcategoriesIdPatchParams = zod.object({
  "id": zod.string().describe('ProductCategory identifier'),
  "shopId": zod.string().describe('Shop identifier')
})

export const apiAdminshopsShopIdcategoriesIdPatchBodyLabelMax = 100;

export const apiAdminshopsShopIdcategoriesIdPatchBodyParentLabelMax = 100;



export const apiAdminshopsShopIdcategoriesIdPatchBody = zod.object({
  "label": zod.string().max(apiAdminshopsShopIdcategoriesIdPatchBodyLabelMax).optional().describe('Product category label'),
  "parent": zod.union([zod.object({
  "label": zod.string().max(apiAdminshopsShopIdcategoriesIdPatchBodyParentLabelMax).describe('Product category label'),
  "parent": zod.union([zod.unknown(),zod.null()]).optional()
}),zod.null()]).optional()
})

export const apiAdminshopsShopIdcategoriesIdPatchResponseLabelMax = 100;



export const apiAdminshopsShopIdcategoriesIdPatchResponse = zod.object({
  "id": zod.number().describe('Product category ID'),
  "label": zod.string().max(apiAdminshopsShopIdcategoriesIdPatchResponseLabelMax).describe('Product category label'),
  "parent": zod.union([zod.unknown(),zod.null()]).optional(),
  "childs": zod.array(zod.unknown()).optional()
})


/**
 * List products categories from shop
 * @summary List products categories from shop
 */
export const apiShopsShopIdcategoriesGetCollectionParams = zod.object({
  "shopId": zod.string().describe('Shop identifier')
})

export const apiShopsShopIdcategoriesGetCollectionQueryParams = zod.object({
  "label": zod.string().optional(),
  "parent": zod.string().optional(),
  "parent[]": zod.array(zod.string()).optional()
})

export const apiShopsShopIdcategoriesGetCollectionResponseLabelMax = 100;



export const apiShopsShopIdcategoriesGetCollectionResponseItem = zod.object({
  "id": zod.number().describe('Product category ID'),
  "label": zod.string().max(apiShopsShopIdcategoriesGetCollectionResponseLabelMax).describe('Product category label'),
  "parent": zod.union([zod.unknown(),zod.null()]).optional(),
  "childs": zod.array(zod.unknown()).optional()
})
export const apiShopsShopIdcategoriesGetCollectionResponse = zod.array(apiShopsShopIdcategoriesGetCollectionResponseItem)


/**
 * Retrieves the collection of PurchaseProof resources.
 * @summary Retrieves the collection of PurchaseProof resources.
 */
export const apiAdminpurchaseProofsGetCollectionQueryPageDefault = 1;export const apiAdminpurchaseProofsGetCollectionQueryPerPageDefault = 30;
export const apiAdminpurchaseProofsGetCollectionQueryPerPageMin = 0;
export const apiAdminpurchaseProofsGetCollectionQueryPerPageMax = 30;

export const apiAdminpurchaseProofsGetCollectionQueryOrderFilenameDefault = "asc";export const apiAdminpurchaseProofsGetCollectionQueryOrderCreatedAtDefault = "asc";export const apiAdminpurchaseProofsGetCollectionQueryOrderStatusDefault = "asc";

export const apiAdminpurchaseProofsGetCollectionQueryParams = zod.object({
  "page": zod.number().default(apiAdminpurchaseProofsGetCollectionQueryPageDefault).describe('The collection page number'),
  "perPage": zod.number().min(apiAdminpurchaseProofsGetCollectionQueryPerPageMin).max(apiAdminpurchaseProofsGetCollectionQueryPerPageMax).default(apiAdminpurchaseProofsGetCollectionQueryPerPageDefault).describe('The number of items per page'),
  "filename": zod.string().optional(),
  "comment": zod.string().optional(),
  "createdBy.company.name": zod.string().optional(),
  "status": zod.string().optional(),
  "status[]": zod.array(zod.string()).optional(),
  "createdBy.user.fullname": zod.string().optional().describe('Search in concatenated fields: createdBy.user.firstname   createdBy.user.lastname'),
  "createdAt[before]": zod.string().optional(),
  "createdAt[strictly_before]": zod.string().optional(),
  "createdAt[after]": zod.string().optional(),
  "createdAt[strictly_after]": zod.string().optional(),
  "order[filename]": zod.enum(['asc', 'desc']).default(apiAdminpurchaseProofsGetCollectionQueryOrderFilenameDefault),
  "order[createdAt]": zod.enum(['asc', 'desc']).default(apiAdminpurchaseProofsGetCollectionQueryOrderCreatedAtDefault),
  "order[status]": zod.enum(['asc', 'desc']).default(apiAdminpurchaseProofsGetCollectionQueryOrderStatusDefault)
})

export const apiAdminpurchaseProofsGetCollectionResponseDataItemFilenameMax = 255;

export const apiAdminpurchaseProofsGetCollectionResponseDataItemStatusDefault = "pending";export const apiAdminpurchaseProofsGetCollectionResponseDataItemCreatedByUserAvatarMax = 255;

export const apiAdminpurchaseProofsGetCollectionResponseDataItemCreatedByCompanyNameMax = 100;



export const apiAdminpurchaseProofsGetCollectionResponse = zod.object({
  "data": zod.array(zod.unknown()),
  "pagination": zod.object({
  "first": zod.number(),
  "current": zod.number(),
  "last": zod.number(),
  "previous": zod.number(),
  "next": zod.number(),
  "totalItems": zod.number(),
  "perPage": zod.number()
})
}).and(zod.object({
  "data": zod.array(zod.object({
  "id": zod.number().describe('PurchaseProof ID'),
  "filename": zod.string().max(apiAdminpurchaseProofsGetCollectionResponseDataItemFilenameMax).describe('Filename of the proof'),
  "comment": zod.string().nullish().describe('Comment left by the user'),
  "status": zod.enum(['pending', 'approved', 'rejected', 'processing']).describe('Processing status of the proof'),
  "createdAt": zod.string().datetime({}).describe('Creation date of the proof'),
  "createdBy": zod.union([zod.object({
  "user": zod.object({
  "fullname": zod.string().describe('User fullname'),
  "avatar": zod.string().max(apiAdminpurchaseProofsGetCollectionResponseDataItemCreatedByUserAvatarMax).nullish().describe('User avatar'),
  "isDeleted": zod.boolean().describe('Whether the entity has been soft-deleted')
}),
  "company": zod.union([zod.object({
  "name": zod.string().max(apiAdminpurchaseProofsGetCollectionResponseDataItemCreatedByCompanyNameMax).describe('Company name')
}),zod.null()]).optional()
}),zod.null()]).optional()
})).optional()
}))


/**
 * Retrieves a PurchaseProof resource.
 * @summary Retrieves a PurchaseProof resource.
 */
export const apiAdminpurchaseProofsIdGetParams = zod.object({
  "id": zod.string().describe('PurchaseProof identifier')
})

export const apiAdminpurchaseProofsIdGetResponseFilenameMax = 255;

export const apiAdminpurchaseProofsIdGetResponseStatusDefault = "pending";export const apiAdminpurchaseProofsIdGetResponseCreatedByUserAvatarMax = 255;

export const apiAdminpurchaseProofsIdGetResponsePerformancesItemAmountMin = 0;

export const apiAdminpurchaseProofsIdGetResponsePerformancesItemLabelMax = 255;



export const apiAdminpurchaseProofsIdGetResponse = zod.object({
  "id": zod.number().describe('PurchaseProof ID'),
  "filename": zod.string().max(apiAdminpurchaseProofsIdGetResponseFilenameMax).describe('Filename of the proof'),
  "media": zod.object({
  "pathUri": zod.string().nullable().describe('Media path to S3')
}),
  "comment": zod.string().nullish().describe('Comment left by the user'),
  "status": zod.enum(['pending', 'approved', 'rejected', 'processing']).describe('Processing status of the proof'),
  "createdAt": zod.string().datetime({}).describe('Creation date of the proof'),
  "createdBy": zod.union([zod.object({
  "user": zod.object({
  "fullname": zod.string().describe('User fullname'),
  "avatar": zod.string().max(apiAdminpurchaseProofsIdGetResponseCreatedByUserAvatarMax).nullish().describe('User avatar'),
  "isDeleted": zod.boolean().describe('Whether the entity has been soft-deleted')
})
}),zod.null()]).optional(),
  "performances": zod.array(zod.object({
  "id": zod.number().describe('Performance ID'),
  "amount": zod.number().min(apiAdminpurchaseProofsIdGetResponsePerformancesItemAmountMin).optional().describe('Amount (in euros)'),
  "label": zod.string().max(apiAdminpurchaseProofsIdGetResponsePerformancesItemLabelMax).nullish().describe('Performance label'),
  "realizedAt": zod.string().datetime({}).describe('Performance realisation date')
})).optional()
})


/**
 * Updates the PurchaseProof resource.
 * @summary Updates the PurchaseProof resource.
 */
export const apiAdminpurchaseProofsIdPatchParams = zod.object({
  "id": zod.string().describe('PurchaseProof identifier')
})

export const apiAdminpurchaseProofsIdPatchBodyStatusDefault = "pending";

export const apiAdminpurchaseProofsIdPatchBody = zod.object({
  "status": zod.enum(['pending', 'approved', 'rejected', 'processing']).default(apiAdminpurchaseProofsIdPatchBodyStatusDefault).describe('Processing status of the proof')
})

export const apiAdminpurchaseProofsIdPatchResponseFilenameMax = 255;

export const apiAdminpurchaseProofsIdPatchResponseStatusDefault = "pending";export const apiAdminpurchaseProofsIdPatchResponseCreatedByUserAvatarMax = 255;

export const apiAdminpurchaseProofsIdPatchResponsePerformancesItemAmountMin = 0;

export const apiAdminpurchaseProofsIdPatchResponsePerformancesItemLabelMax = 255;



export const apiAdminpurchaseProofsIdPatchResponse = zod.object({
  "id": zod.number().describe('PurchaseProof ID'),
  "filename": zod.string().max(apiAdminpurchaseProofsIdPatchResponseFilenameMax).describe('Filename of the proof'),
  "media": zod.object({
  "pathUri": zod.string().nullable().describe('Media path to S3')
}),
  "comment": zod.string().nullish().describe('Comment left by the user'),
  "status": zod.enum(['pending', 'approved', 'rejected', 'processing']).describe('Processing status of the proof'),
  "createdAt": zod.string().datetime({}).describe('Creation date of the proof'),
  "createdBy": zod.union([zod.object({
  "user": zod.object({
  "fullname": zod.string().describe('User fullname'),
  "avatar": zod.string().max(apiAdminpurchaseProofsIdPatchResponseCreatedByUserAvatarMax).nullish().describe('User avatar'),
  "isDeleted": zod.boolean().describe('Whether the entity has been soft-deleted')
})
}),zod.null()]).optional(),
  "performances": zod.array(zod.object({
  "id": zod.number().describe('Performance ID'),
  "amount": zod.number().min(apiAdminpurchaseProofsIdPatchResponsePerformancesItemAmountMin).optional().describe('Amount (in euros)'),
  "label": zod.string().max(apiAdminpurchaseProofsIdPatchResponsePerformancesItemLabelMax).nullish().describe('Performance label'),
  "realizedAt": zod.string().datetime({}).describe('Performance realisation date')
})).optional()
})


/**
 * List the purchase proofs submitted by the current Front-User.
 * @summary List my purchase proofs
 */
export const userPurchaseProofsQueryPageDefault = 1;export const userPurchaseProofsQueryPerPageDefault = 30;
export const userPurchaseProofsQueryPerPageMin = 0;
export const userPurchaseProofsQueryPerPageMax = 30;



export const userPurchaseProofsQueryParams = zod.object({
  "page": zod.number().default(userPurchaseProofsQueryPageDefault).describe('The collection page number'),
  "perPage": zod.number().min(userPurchaseProofsQueryPerPageMin).max(userPurchaseProofsQueryPerPageMax).default(userPurchaseProofsQueryPerPageDefault).describe('The number of items per page')
})

export const userPurchaseProofsResponseDataItemFilenameMax = 255;

export const userPurchaseProofsResponseDataItemStatusDefault = "pending";export const userPurchaseProofsResponseDataItemCreatedByUserAvatarMax = 255;

export const userPurchaseProofsResponseDataItemCreatedByCompanyNameMax = 100;



export const userPurchaseProofsResponse = zod.object({
  "data": zod.array(zod.unknown()),
  "pagination": zod.object({
  "first": zod.number(),
  "current": zod.number(),
  "last": zod.number(),
  "previous": zod.number(),
  "next": zod.number(),
  "totalItems": zod.number(),
  "perPage": zod.number()
})
}).and(zod.object({
  "data": zod.array(zod.object({
  "id": zod.number().describe('PurchaseProof ID'),
  "filename": zod.string().max(userPurchaseProofsResponseDataItemFilenameMax).describe('Filename of the proof'),
  "comment": zod.string().nullish().describe('Comment left by the user'),
  "status": zod.enum(['pending', 'approved', 'rejected', 'processing']).describe('Processing status of the proof'),
  "createdAt": zod.string().datetime({}).describe('Creation date of the proof'),
  "createdBy": zod.union([zod.object({
  "user": zod.object({
  "fullname": zod.string().describe('User fullname'),
  "avatar": zod.string().max(userPurchaseProofsResponseDataItemCreatedByUserAvatarMax).nullish().describe('User avatar'),
  "isDeleted": zod.boolean().describe('Whether the entity has been soft-deleted')
}),
  "company": zod.union([zod.object({
  "name": zod.string().max(userPurchaseProofsResponseDataItemCreatedByCompanyNameMax).describe('Company name')
}),zod.null()]).optional()
}),zod.null()]).optional()
})).optional()
}))


/**
 * Submit a purchase proof from the Front-User. A notification email is sent to Fiddy.
 * @summary Submit a purchase proof
 */
export const apiPurchaseProofsPostBodyFilenameMax = 255;



export const apiPurchaseProofsPostBody = zod.object({
  "filename": zod.string().max(apiPurchaseProofsPostBodyFilenameMax).describe('Filename of the proof'),
  "media": zod.string().describe('Media file associated with the proof'),
  "comment": zod.string().nullish().describe('Comment left by the user')
})


/**
 * Import list of references
 * @summary Import list of references
 */
export const referencesImportHeaderDryRunDefault = false;

export const referencesImportHeader = zod.object({
  "dry-run": zod.boolean().optional().describe('Set to true to perform a dry run import (optional)')
})

export const referencesImportBodyDataItemBrandMax = 100;

export const referencesImportBodyDataItemProductLineMax = 100;

export const referencesImportBodyDataItemNameMax = 100;

export const referencesImportBodyDataItemUniqueCodeMax = 50;

export const referencesImportBodyDataItemPointValueMin = 0;



export const referencesImportBody = zod.object({
  "data": zod.array(zod.object({
  "brand": zod.string().max(referencesImportBodyDataItemBrandMax).describe('Brand of the reference'),
  "productLine": zod.string().max(referencesImportBodyDataItemProductLineMax).nullish().describe('Product line of the reference'),
  "name": zod.string().max(referencesImportBodyDataItemNameMax).describe('Name of the reference'),
  "uniqueCode": zod.string().max(referencesImportBodyDataItemUniqueCodeMax).describe('Unique code of the reference'),
  "pointValue": zod.number().min(referencesImportBodyDataItemPointValueMin).describe('Point amount given foreach quantity bought, adjusted by the current company\'s point coefficient. May be null in the GET /references response if the workspace hides reference points'),
  "tags": zod.array(zod.string()).optional().describe('List of keyword tags for this reference')
})).optional()
})

export const referencesImportResponse = zod.object({
  "linesImported": zod.number().describe('Number of lines imported')
})


/**
 * Get references collection
 * @summary Get references collection
 */
export const apiReferencesGetCollectionQueryPageDefault = 1;export const apiReferencesGetCollectionQueryPerPageDefault = 30;
export const apiReferencesGetCollectionQueryPerPageMin = 0;
export const apiReferencesGetCollectionQueryPerPageMax = 30;

export const apiReferencesGetCollectionQueryOrderBrandDefault = "asc";export const apiReferencesGetCollectionQueryOrderProductLineDefault = "asc";export const apiReferencesGetCollectionQueryOrderNameDefault = "asc";export const apiReferencesGetCollectionQueryOrderUniqueCodeDefault = "asc";export const apiReferencesGetCollectionQueryOrderPointValueDefault = "asc";

export const apiReferencesGetCollectionQueryParams = zod.object({
  "page": zod.number().default(apiReferencesGetCollectionQueryPageDefault).describe('The collection page number'),
  "perPage": zod.number().min(apiReferencesGetCollectionQueryPerPageMin).max(apiReferencesGetCollectionQueryPerPageMax).default(apiReferencesGetCollectionQueryPerPageDefault).describe('The number of items per page'),
  "order[brand]": zod.enum(['asc', 'desc']).default(apiReferencesGetCollectionQueryOrderBrandDefault),
  "order[productLine]": zod.enum(['asc', 'desc']).default(apiReferencesGetCollectionQueryOrderProductLineDefault),
  "order[name]": zod.enum(['asc', 'desc']).default(apiReferencesGetCollectionQueryOrderNameDefault),
  "order[uniqueCode]": zod.enum(['asc', 'desc']).default(apiReferencesGetCollectionQueryOrderUniqueCodeDefault),
  "order[pointValue]": zod.enum(['asc', 'desc']).default(apiReferencesGetCollectionQueryOrderPointValueDefault),
  "available[startDate]": zod.string().optional().describe('Exclude references already boosted from date'),
  "available[endDate]": zod.string().optional().describe('Exclude references already boosted until date'),
  "search": zod.string().optional().describe('Search in tags, brand, name, uniqueCode')
})

export const apiReferencesGetCollectionResponseDataItemBrandMax = 100;

export const apiReferencesGetCollectionResponseDataItemProductLineMax = 100;

export const apiReferencesGetCollectionResponseDataItemNameMax = 100;

export const apiReferencesGetCollectionResponseDataItemUniqueCodeMax = 50;

export const apiReferencesGetCollectionResponseDataItemPointValueMin = 0;

export const apiReferencesGetCollectionResponseDataItemActiveBoosterTiersItemMinQuantityDefault = 1;
export const apiReferencesGetCollectionResponseDataItemActiveBoosterTiersItemMinQuantityMin = 0;

export const apiReferencesGetCollectionResponseDataItemActiveBoosterTiersItemMaxQuantityMin = 0;

export const apiReferencesGetCollectionResponseDataItemActiveBoosterTiersItemCoefficientMin = 0;



export const apiReferencesGetCollectionResponse = zod.object({
  "data": zod.array(zod.unknown()),
  "pagination": zod.object({
  "first": zod.number(),
  "current": zod.number(),
  "last": zod.number(),
  "previous": zod.number(),
  "next": zod.number(),
  "totalItems": zod.number(),
  "perPage": zod.number()
})
}).and(zod.object({
  "data": zod.array(zod.object({
  "id": zod.number().describe('Reference ID'),
  "brand": zod.string().max(apiReferencesGetCollectionResponseDataItemBrandMax).describe('Brand of the reference'),
  "productLine": zod.string().max(apiReferencesGetCollectionResponseDataItemProductLineMax).nullish().describe('Product line of the reference'),
  "name": zod.string().max(apiReferencesGetCollectionResponseDataItemNameMax).describe('Name of the reference'),
  "uniqueCode": zod.string().max(apiReferencesGetCollectionResponseDataItemUniqueCodeMax).describe('Unique code of the reference'),
  "pointValue": zod.number().min(apiReferencesGetCollectionResponseDataItemPointValueMin).describe('Point amount given foreach quantity bought, adjusted by the current company\'s point coefficient. May be null in the GET /references response if the workspace hides reference points'),
  "tags": zod.array(zod.string()).optional().describe('List of keyword tags for this reference'),
  "activeBooster": zod.union([zod.object({
  "startDate": zod.string().datetime({}).describe('Start date of the booster'),
  "endDate": zod.string().datetime({}).describe('End date of the booster')
}),zod.null()]).optional(),
  "activeBoosterTiers": zod.array(zod.object({
  "minQuantity": zod.number().min(apiReferencesGetCollectionResponseDataItemActiveBoosterTiersItemMinQuantityMin).default(apiReferencesGetCollectionResponseDataItemActiveBoosterTiersItemMinQuantityDefault).describe('Minimum cumulated quantity (included) from which the coefficient applies'),
  "maxQuantity": zod.number().min(apiReferencesGetCollectionResponseDataItemActiveBoosterTiersItemMaxQuantityMin).nullish().describe('Maximum cumulated quantity (included) up to which the coefficient applies, null for no upper bound'),
  "coefficient": zod.number().min(apiReferencesGetCollectionResponseDataItemActiveBoosterTiersItemCoefficientMin).describe('Points multiplier applied on quantities of this tier, 0 gives no boosted points'),
  "boostedPointValue": zod.number().nullish()
})).optional()
})).optional()
}))


/**
 * Get rewards grouped by step
 * @summary Get rewards grouped by step
 */
export const apiAdminrewardsGetCollectionResponseStepNameMax = 50;

export const apiAdminrewardsGetCollectionResponseRewardsItemTypologyNameMax = 100;

export const apiAdminrewardsGetCollectionResponseRewardsItemProductNameMax = 150;



export const apiAdminrewardsGetCollectionResponseItem = zod.object({
  "step": zod.object({
  "id": zod.number().optional().describe('Step ID'),
  "name": zod.string().max(apiAdminrewardsGetCollectionResponseStepNameMax).describe('Step name')
}).optional(),
  "rewards": zod.array(zod.object({
  "id": zod.number().optional().describe('Reward ID'),
  "typology": zod.union([zod.object({
  "name": zod.string().max(apiAdminrewardsGetCollectionResponseRewardsItemTypologyNameMax).describe('Name of the typology')
}),zod.null()]).optional(),
  "product": zod.object({
  "id": zod.number().describe('Product ID'),
  "name": zod.string().max(apiAdminrewardsGetCollectionResponseRewardsItemProductNameMax).describe('Product name'),
  "description": zod.string().nullish().describe('Product description')
}),
  "status": zod.enum(['enabled', 'disabled']).describe('Status of the reward'),
  "isArchived": zod.boolean()
})).optional()
})
export const apiAdminrewardsGetCollectionResponse = zod.array(apiAdminrewardsGetCollectionResponseItem)


/**
 * Create new reward
 * @summary Create new reward
 */
export const apiAdminrewardsPostBody = zod.object({
  "typology": zod.string().nullish().describe('Typology of the reward'),
  "step": zod.string().describe('Step associated to the reward'),
  "product": zod.string().describe('Product associated to the reward')
})


/**
 * Update the product of a reward. The typology/step association cannot be changed. The product can be set to null (nothing to win for this step).
 * @summary Update the product of a reward
 */
export const apiAdminrewardsIdPatchParams = zod.object({
  "id": zod.string().describe('Reward identifier')
})

export const apiAdminrewardsIdPatchBody = zod.object({
  "product": zod.string().optional().describe('Product associated to the reward')
})

export const apiAdminrewardsIdPatchResponseTypologyNameMax = 100;

export const apiAdminrewardsIdPatchResponseStepNameMax = 50;

export const apiAdminrewardsIdPatchResponseProductNameMax = 150;



export const apiAdminrewardsIdPatchResponse = zod.object({
  "id": zod.number().optional().describe('Reward ID'),
  "typology": zod.union([zod.object({
  "name": zod.string().max(apiAdminrewardsIdPatchResponseTypologyNameMax).describe('Name of the typology')
}),zod.null()]).optional(),
  "step": zod.object({
  "id": zod.number().optional().describe('Step ID'),
  "name": zod.string().max(apiAdminrewardsIdPatchResponseStepNameMax).describe('Step name')
}),
  "product": zod.object({
  "id": zod.number().describe('Product ID'),
  "name": zod.string().max(apiAdminrewardsIdPatchResponseProductNameMax).describe('Product name'),
  "description": zod.string().nullish().describe('Product description')
}),
  "status": zod.enum(['enabled', 'disabled']).describe('Status of the reward'),
  "isArchived": zod.boolean()
})


/**
 * Create a new route
 * @summary Create a new route
 */
export const apiAdminroutesPostBodyPathMax = 50;



export const apiAdminroutesPostBody = zod.object({
  "path": zod.string().max(apiAdminroutesPostBodyPathMax).describe('Path of the route'),
  "forAdmin": zod.boolean().describe('Is the route for admin frontend or for user frontend'),
  "securityExpression": zod.string().describe('Security expression to verify route access')
})


/**
 * Get routes collection
 * @summary Get routes collection
 */
export const apiRoutesGetCollectionResponsePathMax = 50;



export const apiRoutesGetCollectionResponseItem = zod.object({
  "path": zod.string().max(apiRoutesGetCollectionResponsePathMax).describe('Path of the route')
})
export const apiRoutesGetCollectionResponse = zod.array(apiRoutesGetCollectionResponseItem)


/**
 * Get the sales hierarchies of the current workspace
 * @summary Get the sales hierarchies of the current workspace
 */
export const apiAdminsalesHierarchiesGetCollectionResponseNameMax = 50;

export const apiAdminsalesHierarchiesGetCollectionResponseParentsItemUniqueCodeMax = 50;


export const apiAdminsalesHierarchiesGetCollectionResponseParentsItemUniqueCodeRegExp = new RegExp('^([a-zA-Z0-9]+)$');
export const apiAdminsalesHierarchiesGetCollectionResponseSubordinatesCountDefault = 0;

export const apiAdminsalesHierarchiesGetCollectionResponseItem = zod.object({
  "id": zod.number().describe('Hierarchy ID'),
  "name": zod.string().max(apiAdminsalesHierarchiesGetCollectionResponseNameMax).describe('Hierarchy name'),
  "createdAt": zod.string().datetime({}).describe('Hierarchy creation date'),
  "parents": zod.array(zod.object({
  "user": zod.object({
  "fullname": zod.string().describe('User fullname')
}),
  "maxRole": zod.enum(['ROLE_MEMBER', 'ROLE_MANAGER', 'ROLE_SALES_ADMIN', 'ROLE_ADMIN', 'ROLE_FIDDY_ADMIN']).optional().describe('User max role'),
  "uniqueCode": zod.string().min(1).max(apiAdminsalesHierarchiesGetCollectionResponseParentsItemUniqueCodeMax).regex(apiAdminsalesHierarchiesGetCollectionResponseParentsItemUniqueCodeRegExp).optional().describe('User unique code')
})),
  "subordinatesCount": zod.number().describe('Number of sales placed in this hierarchy, excluding head(s)')
})
export const apiAdminsalesHierarchiesGetCollectionResponse = zod.array(apiAdminsalesHierarchiesGetCollectionResponseItem)


/**
 * Create a new sales hierarchy
 * @summary Create a new sales hierarchy
 */
export const apiAdminsalesHierarchiesPostBodyNameMax = 50;



export const apiAdminsalesHierarchiesPostBody = zod.object({
  "name": zod.string().max(apiAdminsalesHierarchiesPostBodyNameMax).describe('Hierarchy name')
})


/**
 * Get a sales hierarchy
 * @summary Get a sales hierarchy
 */
export const apiAdminsalesHierarchiesIdGetParams = zod.object({
  "id": zod.string().describe('SalesHierarchy identifier')
})

export const apiAdminsalesHierarchiesIdGetResponseNameMax = 50;

export const apiAdminsalesHierarchiesIdGetResponseParentsItemUniqueCodeMax = 50;


export const apiAdminsalesHierarchiesIdGetResponseParentsItemUniqueCodeRegExp = new RegExp('^([a-zA-Z0-9]+)$');
export const apiAdminsalesHierarchiesIdGetResponseSubordinatesCountDefault = 0;

export const apiAdminsalesHierarchiesIdGetResponse = zod.object({
  "id": zod.number().describe('Hierarchy ID'),
  "name": zod.string().max(apiAdminsalesHierarchiesIdGetResponseNameMax).describe('Hierarchy name'),
  "createdAt": zod.string().datetime({}).describe('Hierarchy creation date'),
  "parents": zod.array(zod.object({
  "user": zod.object({
  "fullname": zod.string().describe('User fullname')
}),
  "maxRole": zod.enum(['ROLE_MEMBER', 'ROLE_MANAGER', 'ROLE_SALES_ADMIN', 'ROLE_ADMIN', 'ROLE_FIDDY_ADMIN']).optional().describe('User max role'),
  "uniqueCode": zod.string().min(1).max(apiAdminsalesHierarchiesIdGetResponseParentsItemUniqueCodeMax).regex(apiAdminsalesHierarchiesIdGetResponseParentsItemUniqueCodeRegExp).optional().describe('User unique code')
})),
  "subordinatesCount": zod.number().describe('Number of sales placed in this hierarchy, excluding head(s)')
})


/**
 * Deletes the hierarchy along with every parent/child link it contains.
 * @summary Delete a sales hierarchy and all its links
 */
export const apiAdminsalesHierarchiesIdDeleteParams = zod.object({
  "id": zod.string().describe('SalesHierarchy identifier')
})


/**
 * Rename a sales hierarchy
 * @summary Rename a sales hierarchy
 */
export const apiAdminsalesHierarchiesIdPatchParams = zod.object({
  "id": zod.string().describe('SalesHierarchy identifier')
})

export const apiAdminsalesHierarchiesIdPatchBodyNameMax = 50;



export const apiAdminsalesHierarchiesIdPatchBody = zod.object({
  "name": zod.string().max(apiAdminsalesHierarchiesIdPatchBodyNameMax).optional().describe('Hierarchy name')
})

export const apiAdminsalesHierarchiesIdPatchResponseNameMax = 50;

export const apiAdminsalesHierarchiesIdPatchResponseParentsItemUniqueCodeMax = 50;


export const apiAdminsalesHierarchiesIdPatchResponseParentsItemUniqueCodeRegExp = new RegExp('^([a-zA-Z0-9]+)$');
export const apiAdminsalesHierarchiesIdPatchResponseSubordinatesCountDefault = 0;

export const apiAdminsalesHierarchiesIdPatchResponse = zod.object({
  "id": zod.number().describe('Hierarchy ID'),
  "name": zod.string().max(apiAdminsalesHierarchiesIdPatchResponseNameMax).describe('Hierarchy name'),
  "createdAt": zod.string().datetime({}).describe('Hierarchy creation date'),
  "parents": zod.array(zod.object({
  "user": zod.object({
  "fullname": zod.string().describe('User fullname')
}),
  "maxRole": zod.enum(['ROLE_MEMBER', 'ROLE_MANAGER', 'ROLE_SALES_ADMIN', 'ROLE_ADMIN', 'ROLE_FIDDY_ADMIN']).optional().describe('User max role'),
  "uniqueCode": zod.string().min(1).max(apiAdminsalesHierarchiesIdPatchResponseParentsItemUniqueCodeMax).regex(apiAdminsalesHierarchiesIdPatchResponseParentsItemUniqueCodeRegExp).optional().describe('User unique code')
})),
  "subordinatesCount": zod.number().describe('Number of sales placed in this hierarchy, excluding head(s)')
})


/**
 * Returns the nested tree of parent/child links for this hierarchy, one root node per head.
 * @summary Get the sales hierarchy tree for a given hierarchy
 */
export const salesHierarchyLinksTreeParams = zod.object({
  "id": zod.number().describe('SalesHierarchy identifier')
})

export const salesHierarchyLinksTreeResponseSubLinksItemSalesUniqueCodeMax = 50;


export const salesHierarchyLinksTreeResponseSubLinksItemSalesUniqueCodeRegExp = new RegExp('^([a-zA-Z0-9]+)$');
export const salesHierarchyLinksTreeResponseSalesUniqueCodeMax = 50;


export const salesHierarchyLinksTreeResponseSalesUniqueCodeRegExp = new RegExp('^([a-zA-Z0-9]+)$');


export const salesHierarchyLinksTreeResponseItem = zod.object({
  "id": zod.number().describe('Link ID'),
  "subLinks": zod.array(zod.object({
  "id": zod.number().describe('Link ID'),
  "subLinks": zod.array(zod.unknown()).optional(),
  "sales": zod.union([zod.object({
  "user": zod.object({
  "fullname": zod.string().describe('User fullname')
}),
  "maxRole": zod.enum(['ROLE_MEMBER', 'ROLE_MANAGER', 'ROLE_SALES_ADMIN', 'ROLE_ADMIN', 'ROLE_FIDDY_ADMIN']).optional().describe('User max role'),
  "uniqueCode": zod.string().min(1).max(salesHierarchyLinksTreeResponseSubLinksItemSalesUniqueCodeMax).regex(salesHierarchyLinksTreeResponseSubLinksItemSalesUniqueCodeRegExp).optional().describe('User unique code')
}),zod.null()]).optional()
})).optional(),
  "sales": zod.union([zod.object({
  "user": zod.object({
  "fullname": zod.string().describe('User fullname')
}),
  "maxRole": zod.enum(['ROLE_MEMBER', 'ROLE_MANAGER', 'ROLE_SALES_ADMIN', 'ROLE_ADMIN', 'ROLE_FIDDY_ADMIN']).optional().describe('User max role'),
  "uniqueCode": zod.string().min(1).max(salesHierarchyLinksTreeResponseSalesUniqueCodeMax).regex(salesHierarchyLinksTreeResponseSalesUniqueCodeRegExp).optional().describe('User unique code')
}),zod.null()]).optional()
})
export const salesHierarchyLinksTreeResponse = zod.array(salesHierarchyLinksTreeResponseItem)


/**
 * Creates the parent/child link. If the child already had a parent in the hierarchy, it is re-attached to the new parent only, the rest of its subtree is untouched.
 * @summary Attach a sales to its N-1 (parent) in the hierarchy
 */
export const apiAdminsalesHierarchyLinksPostBody = zod.object({
  "hierarchy": zod.string().describe('IRI of the sales hierarchy this link belongs to'),
  "parent": zod.string().describe('IRI of the N+1 (parent) user workspace'),
  "child": zod.string().describe('IRI of the N (child) user workspace being attached')
})


/**
 * By default, deletes the link along with every link in the subtree below it. Pass ?cascade=false to instead reattach the child's direct reports to its former parent (the "grandparent"), leaving the rest of their own subtrees untouched.
 * @summary Remove a link, cascading its subtree by default
 */
export const apiAdminsalesHierarchyLinksIdDeleteParams = zod.object({
  "id": zod.string().describe('SalesHierarchyLink identifier')
})

export const apiAdminsalesHierarchyLinksIdDeleteQueryCascadeDefault = true;

export const apiAdminsalesHierarchyLinksIdDeleteQueryParams = zod.object({
  "cascade": zod.boolean().default(apiAdminsalesHierarchyLinksIdDeleteQueryCascadeDefault).describe('true (default) cascade-deletes the whole subtree; false reattaches the child\'s direct reports to the grandparent instead.')
})


/**
 * Get all the scheduled tasks
 * @summary Get all the scheduled tasks
 */
export const apiAdminscheduledTasksGetCollectionResponseNameMax = 30;

export const apiAdminscheduledTasksGetCollectionResponseDescriptionMax = 255;



export const apiAdminscheduledTasksGetCollectionResponseItem = zod.object({
  "id": zod.number().describe('User scheduled task ID'),
  "name": zod.enum(['steps_export', 'targets_export']).describe('Task name'),
  "description": zod.string().max(apiAdminscheduledTasksGetCollectionResponseDescriptionMax).describe('Task description'),
  "currentUserScheduledTask": zod.union([zod.object({
  "id": zod.number().describe('User scheduled task ID')
}),zod.null()])
})
export const apiAdminscheduledTasksGetCollectionResponse = zod.array(apiAdminscheduledTasksGetCollectionResponseItem)


/**
 * Get a specific scheduled task
 * @summary Get a specific scheduled task
 */
export const apiAdminscheduledTasksIdGetParams = zod.object({
  "id": zod.string().describe('ScheduledTask identifier')
})

export const apiAdminscheduledTasksIdGetResponseNameMax = 30;

export const apiAdminscheduledTasksIdGetResponseDescriptionMax = 255;



export const apiAdminscheduledTasksIdGetResponse = zod.object({
  "id": zod.number().describe('User scheduled task ID'),
  "name": zod.enum(['steps_export', 'targets_export']).describe('Task name'),
  "description": zod.string().max(apiAdminscheduledTasksIdGetResponseDescriptionMax).describe('Task description'),
  "currentUserScheduledTask": zod.union([zod.object({
  "id": zod.number().describe('User scheduled task ID')
}),zod.null()])
})


/**
 * Get the list of segment links (in the current workspace) attached to one exact entity.
Each item's "id" is the link identifier, required to detach it via
DELETE /admin/segments/{segmentId}/entities/{id}.

 * @summary Get the segments attached to an entity
 */
export const segmentsForEntityParams = zod.object({
  "entityType": zod.string().describe('Short code of the entity\'s type'),
  "entityId": zod.number().describe('ID of the entity')
})

export const segmentsForEntityResponseSegmentNameMax = 255;



export const segmentsForEntityResponseItem = zod.object({
  "id": zod.number().describe('SegmentEntity link ID'),
  "segment": zod.object({
  "id": zod.number().describe('Segment ID'),
  "name": zod.string().max(segmentsForEntityResponseSegmentNameMax).describe('Name of the segment'),
  "description": zod.string().nullish().describe('Description of the segment')
}).optional(),
  "createdAt": zod.string().datetime({}).describe('Date the segment was attached to the entity')
})
export const segmentsForEntityResponse = zod.array(segmentsForEntityResponseItem)


/**
 * Get the list of segments available on the current workspace
 * @summary Get segments collection
 */
export const apiAdminsegmentsGetCollectionQueryPageDefault = 1;export const apiAdminsegmentsGetCollectionQueryPerPageDefault = 30;
export const apiAdminsegmentsGetCollectionQueryPerPageMin = 0;
export const apiAdminsegmentsGetCollectionQueryPerPageMax = 30;



export const apiAdminsegmentsGetCollectionQueryParams = zod.object({
  "page": zod.number().default(apiAdminsegmentsGetCollectionQueryPageDefault).describe('The collection page number'),
  "perPage": zod.number().min(apiAdminsegmentsGetCollectionQueryPerPageMin).max(apiAdminsegmentsGetCollectionQueryPerPageMax).default(apiAdminsegmentsGetCollectionQueryPerPageDefault).describe('The number of items per page'),
  "search": zod.string().optional().describe('Search in name, description')
})

export const apiAdminsegmentsGetCollectionResponseDataItemNameMax = 255;

export const apiAdminsegmentsGetCollectionResponseDataItemCreatedByUserAvatarMax = 255;

export const apiAdminsegmentsGetCollectionResponseDataItemRulesCountDefault = 0;

export const apiAdminsegmentsGetCollectionResponse = zod.object({
  "data": zod.array(zod.unknown()),
  "pagination": zod.object({
  "first": zod.number(),
  "current": zod.number(),
  "last": zod.number(),
  "previous": zod.number(),
  "next": zod.number(),
  "totalItems": zod.number(),
  "perPage": zod.number()
})
}).and(zod.object({
  "data": zod.array(zod.object({
  "id": zod.number().describe('Segment ID'),
  "name": zod.string().max(apiAdminsegmentsGetCollectionResponseDataItemNameMax).describe('Name of the segment'),
  "description": zod.string().nullish().describe('Description of the segment'),
  "createdAt": zod.string().datetime({}).describe('Creation date of the segment'),
  "createdBy": zod.object({
  "user": zod.object({
  "id": zod.number().describe('User ID'),
  "fullname": zod.string().describe('User fullname'),
  "avatar": zod.string().max(apiAdminsegmentsGetCollectionResponseDataItemCreatedByUserAvatarMax).nullish().describe('User avatar'),
  "isDeleted": zod.boolean().describe('Whether the entity has been soft-deleted')
})
}),
  "rulesCount": zod.number().describe('Number of rules attached to the segment')
})).optional()
}))


/**
 * Create a segment on the current workspace
 * @summary Create a segment
 */
export const apiAdminsegmentsPostBodyNameMax = 255;



export const apiAdminsegmentsPostBody = zod.object({
  "name": zod.string().max(apiAdminsegmentsPostBodyNameMax).describe('Name of the segment'),
  "description": zod.string().nullish().describe('Description of the segment')
})


/**
 * Get the list of fields available to build segment rules, with their type, allowed operators, and allowed values for choice fields
 * @summary Get available segment criteria
 */
export const apiAdminsegmentscriteriaGetCollectionResponseItem = zod.object({
  "field": zod.string().describe('Field identifier to use as the \"field\" of a SegmentRule'),
  "label": zod.string().describe('Translation key describing this criterion, always \"segment.criterion.{field}\"'),
  "type": zod.string().describe('Field type, determines which operators and value format are valid'),
  "operators": zod.array(zod.string()).describe('Operators allowed for this field, to use as the \"operator\" of a SegmentRule'),
  "choices": zod.array(zod.union([zod.record(zod.string(), zod.union([zod.number(),zod.string()])),zod.string()])).nullish().describe('Allowed values for \"choice\" type fields, to use as the \"value\" of a SegmentRule. Null for \"text\" type fields. For fixed (PHP enum) choice fields, each item is a plain string. For workspace-specific (dynamic) choice fields (e.g. company.typology.id), each item is an { id, name } object — submit \"id\" as the rule\'s value.')
})
export const apiAdminsegmentscriteriaGetCollectionResponse = zod.array(apiAdminsegmentscriteriaGetCollectionResponseItem)


/**
 * Estimate how many workspace members would match the given rules, without creating or updating a segment
 * @summary Preview the number of members matching a set of segment rules
 */
export const apiAdminsegmentspreviewPostBodyRulesItemValueMax = 255;



export const apiAdminsegmentspreviewPostBody = zod.object({
  "rules": zod.array(zod.object({
  "field": zod.enum(['status', 'company.zipcode', 'company.status', 'company.typology.id']).describe('Field identifier to use'),
  "operator": zod.enum(['equals', 'not_equals', 'starts_with', 'ends_with', 'contains']).describe('Operator to use'),
  "value": zod.string().max(apiAdminsegmentspreviewPostBodyRulesItemValueMax).describe('Value to compare to')
})).optional()
})

export const apiAdminsegmentspreviewPostResponseMatchingCountDefault = 0;

export const apiAdminsegmentspreviewPostResponse = zod.object({
  "matchingCount": zod.number().describe('Number of workspace members that would match all the given rules')
})


/**
 * Get a segment by ID, including its rules
 * @summary Get a segment by ID
 */
export const apiAdminsegmentsIdGetParams = zod.object({
  "id": zod.string().describe('Segment identifier')
})

export const apiAdminsegmentsIdGetResponseNameMax = 255;

export const apiAdminsegmentsIdGetResponseCreatedByUserAvatarMax = 255;

export const apiAdminsegmentsIdGetResponseRulesItemValueMax = 255;



export const apiAdminsegmentsIdGetResponse = zod.object({
  "id": zod.number().describe('Segment ID'),
  "name": zod.string().max(apiAdminsegmentsIdGetResponseNameMax).describe('Name of the segment'),
  "description": zod.string().nullish().describe('Description of the segment'),
  "createdAt": zod.string().datetime({}).describe('Creation date of the segment'),
  "createdBy": zod.object({
  "user": zod.object({
  "id": zod.number().describe('User ID'),
  "fullname": zod.string().describe('User fullname'),
  "avatar": zod.string().max(apiAdminsegmentsIdGetResponseCreatedByUserAvatarMax).nullish().describe('User avatar'),
  "isDeleted": zod.boolean().describe('Whether the entity has been soft-deleted')
})
}),
  "rules": zod.array(zod.object({
  "id": zod.number().optional(),
  "field": zod.enum(['status', 'company.zipcode', 'company.status', 'company.typology.id']).describe('Field identifier to use'),
  "operator": zod.enum(['equals', 'not_equals', 'starts_with', 'ends_with', 'contains']).describe('Operator to use'),
  "value": zod.string().max(apiAdminsegmentsIdGetResponseRulesItemValueMax).describe('Value to compare to')
})).optional()
})


/**
 * Delete a segment. Its rules are automatically removed with it.
 * @summary Delete a segment
 */
export const apiAdminsegmentsIdDeleteParams = zod.object({
  "id": zod.string().describe('Segment identifier')
})


/**
 * Update a segment's name and/or description, and replace all its rules
 * @summary Update a segment and its rules
 */
export const apiAdminsegmentsIdPatchParams = zod.object({
  "id": zod.string().describe('Segment identifier')
})

export const apiAdminsegmentsIdPatchBodyNameMax = 255;

export const apiAdminsegmentsIdPatchBodyRulesItemValueMax = 255;



export const apiAdminsegmentsIdPatchBody = zod.object({
  "name": zod.string().max(apiAdminsegmentsIdPatchBodyNameMax).optional().describe('Name of the segment'),
  "description": zod.string().nullish().describe('Description of the segment'),
  "rules": zod.array(zod.object({
  "field": zod.enum(['status', 'company.zipcode', 'company.status', 'company.typology.id']).describe('Field identifier to use'),
  "operator": zod.enum(['equals', 'not_equals', 'starts_with', 'ends_with', 'contains']).describe('Operator to use'),
  "value": zod.string().max(apiAdminsegmentsIdPatchBodyRulesItemValueMax).describe('Value to compare to')
})).optional()
})

export const apiAdminsegmentsIdPatchResponseNameMax = 255;

export const apiAdminsegmentsIdPatchResponseCreatedByUserAvatarMax = 255;

export const apiAdminsegmentsIdPatchResponseRulesItemValueMax = 255;



export const apiAdminsegmentsIdPatchResponse = zod.object({
  "id": zod.number().describe('Segment ID'),
  "name": zod.string().max(apiAdminsegmentsIdPatchResponseNameMax).describe('Name of the segment'),
  "description": zod.string().nullish().describe('Description of the segment'),
  "createdAt": zod.string().datetime({}).describe('Creation date of the segment'),
  "createdBy": zod.object({
  "user": zod.object({
  "id": zod.number().describe('User ID'),
  "fullname": zod.string().describe('User fullname'),
  "avatar": zod.string().max(apiAdminsegmentsIdPatchResponseCreatedByUserAvatarMax).nullish().describe('User avatar'),
  "isDeleted": zod.boolean().describe('Whether the entity has been soft-deleted')
})
}),
  "rules": zod.array(zod.object({
  "id": zod.number().optional(),
  "field": zod.enum(['status', 'company.zipcode', 'company.status', 'company.typology.id']).describe('Field identifier to use'),
  "operator": zod.enum(['equals', 'not_equals', 'starts_with', 'ends_with', 'contains']).describe('Operator to use'),
  "value": zod.string().max(apiAdminsegmentsIdPatchResponseRulesItemValueMax).describe('Value to compare to')
})).optional()
})


/**
 * Get the list of workspace members (UserWorkspace) matching all rules of a segment
 * @summary Get members matching a segment
 */
export const apiAdminsegmentsIdmembersGetCollectionParams = zod.object({
  "id": zod.number().describe('Segment identifier')
})

export const apiAdminsegmentsIdmembersGetCollectionQueryPageDefault = 1;export const apiAdminsegmentsIdmembersGetCollectionQueryPerPageDefault = 30;
export const apiAdminsegmentsIdmembersGetCollectionQueryPerPageMin = 0;
export const apiAdminsegmentsIdmembersGetCollectionQueryPerPageMax = 30;



export const apiAdminsegmentsIdmembersGetCollectionQueryParams = zod.object({
  "page": zod.number().default(apiAdminsegmentsIdmembersGetCollectionQueryPageDefault).describe('The collection page number'),
  "perPage": zod.number().min(apiAdminsegmentsIdmembersGetCollectionQueryPerPageMin).max(apiAdminsegmentsIdmembersGetCollectionQueryPerPageMax).default(apiAdminsegmentsIdmembersGetCollectionQueryPerPageDefault).describe('The number of items per page')
})

export const apiAdminsegmentsIdmembersGetCollectionResponseDataItemUserEmailMax = 255;

export const apiAdminsegmentsIdmembersGetCollectionResponseDataItemUserAvatarMax = 255;

export const apiAdminsegmentsIdmembersGetCollectionResponseDataItemCompanyNameMax = 100;

export const apiAdminsegmentsIdmembersGetCollectionResponseDataItemUniqueCodeMax = 50;


export const apiAdminsegmentsIdmembersGetCollectionResponseDataItemUniqueCodeRegExp = new RegExp('^([a-zA-Z0-9]+)$');


export const apiAdminsegmentsIdmembersGetCollectionResponse = zod.object({
  "data": zod.array(zod.unknown()),
  "pagination": zod.object({
  "first": zod.number(),
  "current": zod.number(),
  "last": zod.number(),
  "previous": zod.number(),
  "next": zod.number(),
  "totalItems": zod.number(),
  "perPage": zod.number()
})
}).and(zod.object({
  "data": zod.array(zod.object({
  "id": zod.number().optional(),
  "user": zod.object({
  "id": zod.number().describe('User ID'),
  "email": zod.string().email().max(apiAdminsegmentsIdmembersGetCollectionResponseDataItemUserEmailMax).describe('User email'),
  "fullname": zod.string().describe('User fullname'),
  "avatar": zod.string().max(apiAdminsegmentsIdmembersGetCollectionResponseDataItemUserAvatarMax).nullish().describe('User avatar'),
  "isDeleted": zod.boolean().describe('Whether the entity has been soft-deleted')
}),
  "company": zod.union([zod.object({
  "id": zod.number().describe('Company ID'),
  "name": zod.string().max(apiAdminsegmentsIdmembersGetCollectionResponseDataItemCompanyNameMax).describe('Company name')
}),zod.null()]).optional(),
  "uniqueCode": zod.string().min(1).max(apiAdminsegmentsIdmembersGetCollectionResponseDataItemUniqueCodeMax).regex(apiAdminsegmentsIdmembersGetCollectionResponseDataItemUniqueCodeRegExp).optional().describe('User unique code')
})).optional()
}))


/**
 * Attach a segment to an entity
 * @summary Attach a segment to an entity
 */
export const apiAdminsegmentsSegmentIdentitiesPostParams = zod.object({
  "segmentId": zod.number().describe('Segment identifier')
})

export const apiAdminsegmentsSegmentIdentitiesPostBodyEntityIdMin = 0;



export const apiAdminsegmentsSegmentIdentitiesPostBody = zod.object({
  "entityId": zod.number().min(apiAdminsegmentsSegmentIdentitiesPostBodyEntityIdMin).describe('ID of the target entity'),
  "type": zod.enum(['shop', 'widget', 'game']).describe('Short code of the target entity type')
})


/**
 * Detach a segment from an entity, removing the conditioning
 * @summary Detach a segment from an entity
 */
export const apiAdminsegmentsSegmentIdentitiesIdDeleteParams = zod.object({
  "segmentId": zod.number().describe('Segment identifier'),
  "id": zod.number().describe('SegmentEntity link identifier')
})


/**
 * Create a new shop
 * @summary Create a new shop
 */
export const apiAdminshopsPostBodyNameMax = 100;

export const apiAdminshopsPostBodyDisplayNameMax = 100;

export const apiAdminshopsPostBodyDescriptionMax = 255;

export const apiAdminshopsPostBodyTypeMax = 10;

export const apiAdminshopsPostBodyOperationalContactMax = 255;

export const apiAdminshopsPostBodyTechnicalContactMax = 255;



export const apiAdminshopsPostBody = zod.object({
  "name": zod.string().max(apiAdminshopsPostBodyNameMax).describe('Shop name'),
  "displayName": zod.string().max(apiAdminshopsPostBodyDisplayNameMax).describe('Shop display name'),
  "description": zod.string().max(apiAdminshopsPostBodyDescriptionMax).describe('Shop description (label)'),
  "type": zod.enum(['provider', 'reward', 'custom']).describe('Shop type'),
  "logo": zod.string().describe('Shop logo'),
  "banner": zod.string().nullish().describe('Shop banner'),
  "operationalContact": zod.string().email().max(apiAdminshopsPostBodyOperationalContactMax).nullish(),
  "technicalContact": zod.string().email().max(apiAdminshopsPostBodyTechnicalContactMax).nullish()
})


/**
 * Update a shop
 * @summary Update a shop
 */
export const apiAdminshopsIdPatchParams = zod.object({
  "id": zod.string().describe('Shop identifier')
})

export const apiAdminshopsIdPatchBodyNameMax = 100;

export const apiAdminshopsIdPatchBodyDisplayNameMax = 100;

export const apiAdminshopsIdPatchBodyDescriptionMax = 255;

export const apiAdminshopsIdPatchBodyOperationalContactMax = 255;

export const apiAdminshopsIdPatchBodyTechnicalContactMax = 255;



export const apiAdminshopsIdPatchBody = zod.object({
  "name": zod.string().min(1).max(apiAdminshopsIdPatchBodyNameMax).optional().describe('Shop name'),
  "displayName": zod.string().max(apiAdminshopsIdPatchBodyDisplayNameMax).optional().describe('Shop display name'),
  "description": zod.string().min(1).max(apiAdminshopsIdPatchBodyDescriptionMax).optional().describe('Shop description (label)'),
  "logo": zod.string().optional().describe('Shop logo'),
  "banner": zod.string().nullish().describe('Shop banner'),
  "isMaintenance": zod.boolean().optional().describe('Shop maintenance status'),
  "operationalContact": zod.string().email().max(apiAdminshopsIdPatchBodyOperationalContactMax).nullish(),
  "technicalContact": zod.string().email().max(apiAdminshopsIdPatchBodyTechnicalContactMax).nullish()
})

export const apiAdminshopsIdPatchResponseNameMax = 100;

export const apiAdminshopsIdPatchResponseDisplayNameMax = 100;

export const apiAdminshopsIdPatchResponseDescriptionMax = 255;

export const apiAdminshopsIdPatchResponseTypeMax = 10;

export const apiAdminshopsIdPatchResponseShopWorkspaceMinPointDefault = 0;
export const apiAdminshopsIdPatchResponseShopWorkspaceMinPointMin = 0;


export const apiAdminshopsIdPatchResponseShopWorkspaceIsActiveDefault = false;export const apiAdminshopsIdPatchResponseShopWorkspaceIsActivableDefault = true;export const apiAdminshopsIdPatchResponseOperationalContactMax = 255;

export const apiAdminshopsIdPatchResponseTechnicalContactMax = 255;



export const apiAdminshopsIdPatchResponse = zod.object({
  "id": zod.number().describe('Shop ID'),
  "name": zod.string().max(apiAdminshopsIdPatchResponseNameMax).describe('Shop name'),
  "displayName": zod.string().max(apiAdminshopsIdPatchResponseDisplayNameMax).describe('Shop display name'),
  "description": zod.string().max(apiAdminshopsIdPatchResponseDescriptionMax).describe('Shop description (label)'),
  "type": zod.enum(['provider', 'reward', 'custom']).describe('Shop type'),
  "logo": zod.object({
  "pathUri": zod.string().nullable().describe('Media path to S3')
}),
  "banner": zod.union([zod.object({
  "pathUri": zod.string().nullable().describe('Media path to S3')
}),zod.null()]).optional(),
  "shopWorkspace": zod.union([zod.object({
  "id": zod.number().describe('Shop Workspace ID'),
  "minPoint": zod.number().min(apiAdminshopsIdPatchResponseShopWorkspaceMinPointMin).optional().describe('Minimum point before provider can be used'),
  "coefficient": zod.number().min(1).optional().describe('Marge coefficient'),
  "shopOpeningDate": zod.string().datetime({}).nullish().describe('Shop opening date'),
  "shopClosingDate": zod.string().datetime({}).nullish().describe('Shop closing date'),
  "isActive": zod.boolean().describe('Shop workspace is active'),
  "isActivable": zod.boolean().default(apiAdminshopsIdPatchResponseShopWorkspaceIsActivableDefault)
}),zod.null()]).optional(),
  "isMaintenance": zod.boolean().describe('Shop maintenance status'),
  "operationalContact": zod.string().email().max(apiAdminshopsIdPatchResponseOperationalContactMax).nullish(),
  "technicalContact": zod.string().email().max(apiAdminshopsIdPatchResponseTechnicalContactMax).nullish()
})


/**
 * If user is admin, list all shops, otherwise list only shops accessible by user
 * @summary List all shops
 */
export const apiShopsGetCollectionQueryPageDefault = 1;export const apiShopsGetCollectionQueryPerPageDefault = 30;
export const apiShopsGetCollectionQueryPerPageMin = 0;
export const apiShopsGetCollectionQueryPerPageMax = 30;



export const apiShopsGetCollectionQueryParams = zod.object({
  "page": zod.number().default(apiShopsGetCollectionQueryPageDefault).describe('The collection page number'),
  "perPage": zod.number().min(apiShopsGetCollectionQueryPerPageMin).max(apiShopsGetCollectionQueryPerPageMax).default(apiShopsGetCollectionQueryPerPageDefault).describe('The number of items per page')
})

export const apiShopsGetCollectionResponseDataItemNameMax = 100;

export const apiShopsGetCollectionResponseDataItemDisplayNameMax = 100;

export const apiShopsGetCollectionResponseDataItemDescriptionMax = 255;

export const apiShopsGetCollectionResponseDataItemTypeMax = 10;

export const apiShopsGetCollectionResponseDataItemShopWorkspaceMinPointDefault = 0;
export const apiShopsGetCollectionResponseDataItemShopWorkspaceMinPointMin = 0;


export const apiShopsGetCollectionResponseDataItemShopWorkspaceIsActiveDefault = false;export const apiShopsGetCollectionResponseDataItemShopWorkspaceIsActivableDefault = true;export const apiShopsGetCollectionResponseDataItemOperationalContactMax = 255;

export const apiShopsGetCollectionResponseDataItemTechnicalContactMax = 255;



export const apiShopsGetCollectionResponse = zod.object({
  "data": zod.array(zod.unknown()),
  "pagination": zod.object({
  "first": zod.number(),
  "current": zod.number(),
  "last": zod.number(),
  "previous": zod.number(),
  "next": zod.number(),
  "totalItems": zod.number(),
  "perPage": zod.number()
})
}).and(zod.object({
  "data": zod.array(zod.object({
  "id": zod.number().describe('Shop ID'),
  "name": zod.string().max(apiShopsGetCollectionResponseDataItemNameMax).describe('Shop name'),
  "displayName": zod.string().max(apiShopsGetCollectionResponseDataItemDisplayNameMax).describe('Shop display name'),
  "description": zod.string().max(apiShopsGetCollectionResponseDataItemDescriptionMax).describe('Shop description (label)'),
  "type": zod.enum(['provider', 'reward', 'custom']).describe('Shop type'),
  "logo": zod.object({
  "pathUri": zod.string().nullable().describe('Media path to S3')
}),
  "banner": zod.union([zod.object({
  "pathUri": zod.string().nullable().describe('Media path to S3')
}),zod.null()]).optional(),
  "shopWorkspace": zod.union([zod.object({
  "id": zod.number().describe('Shop Workspace ID'),
  "minPoint": zod.number().min(apiShopsGetCollectionResponseDataItemShopWorkspaceMinPointMin).optional().describe('Minimum point before provider can be used'),
  "coefficient": zod.number().min(1).optional().describe('Marge coefficient'),
  "shopOpeningDate": zod.string().datetime({}).nullish().describe('Shop opening date'),
  "shopClosingDate": zod.string().datetime({}).nullish().describe('Shop closing date'),
  "isActive": zod.boolean().describe('Shop workspace is active'),
  "isActivable": zod.boolean().default(apiShopsGetCollectionResponseDataItemShopWorkspaceIsActivableDefault)
}),zod.null()]).optional(),
  "isMaintenance": zod.boolean().describe('Shop maintenance status'),
  "operationalContact": zod.string().email().max(apiShopsGetCollectionResponseDataItemOperationalContactMax).nullish(),
  "technicalContact": zod.string().email().max(apiShopsGetCollectionResponseDataItemTechnicalContactMax).nullish()
})).optional()
}))


/**
 * Rules are the same as for listing all shops
 * @summary List specific shop
 */
export const apiShopsIdGetParams = zod.object({
  "id": zod.string().describe('Shop identifier')
})

export const apiShopsIdGetResponseNameMax = 100;

export const apiShopsIdGetResponseDisplayNameMax = 100;

export const apiShopsIdGetResponseDescriptionMax = 255;

export const apiShopsIdGetResponseTypeMax = 10;

export const apiShopsIdGetResponseShopWorkspaceMinPointDefault = 0;
export const apiShopsIdGetResponseShopWorkspaceMinPointMin = 0;


export const apiShopsIdGetResponseShopWorkspaceIsActiveDefault = false;export const apiShopsIdGetResponseShopWorkspaceIsActivableDefault = true;export const apiShopsIdGetResponseOperationalContactMax = 255;

export const apiShopsIdGetResponseTechnicalContactMax = 255;



export const apiShopsIdGetResponse = zod.object({
  "id": zod.number().describe('Shop ID'),
  "name": zod.string().max(apiShopsIdGetResponseNameMax).describe('Shop name'),
  "displayName": zod.string().max(apiShopsIdGetResponseDisplayNameMax).describe('Shop display name'),
  "description": zod.string().max(apiShopsIdGetResponseDescriptionMax).describe('Shop description (label)'),
  "type": zod.enum(['provider', 'reward', 'custom']).describe('Shop type'),
  "logo": zod.object({
  "pathUri": zod.string().nullable().describe('Media path to S3')
}),
  "banner": zod.union([zod.object({
  "pathUri": zod.string().nullable().describe('Media path to S3')
}),zod.null()]).optional(),
  "shopWorkspace": zod.union([zod.object({
  "id": zod.number().describe('Shop Workspace ID'),
  "minPoint": zod.number().min(apiShopsIdGetResponseShopWorkspaceMinPointMin).optional().describe('Minimum point before provider can be used'),
  "coefficient": zod.number().min(1).optional().describe('Marge coefficient'),
  "shopOpeningDate": zod.string().datetime({}).nullish().describe('Shop opening date'),
  "shopClosingDate": zod.string().datetime({}).nullish().describe('Shop closing date'),
  "isActive": zod.boolean().describe('Shop workspace is active'),
  "isActivable": zod.boolean().default(apiShopsIdGetResponseShopWorkspaceIsActivableDefault)
}),zod.null()]).optional(),
  "isMaintenance": zod.boolean().describe('Shop maintenance status'),
  "operationalContact": zod.string().email().max(apiShopsIdGetResponseOperationalContactMax).nullish(),
  "technicalContact": zod.string().email().max(apiShopsIdGetResponseTechnicalContactMax).nullish()
})


/**
 * Link a shop to active workspace
 * @summary Link a shop to active workspace
 */
export const apiAdminshopWorkspacesPostBody = zod.object({
  "shop": zod.string().describe('Shop IRI')
})


/**
 * Delete a shopWorkspace
 * @summary Delete a shopWorkspace
 */
export const apiAdminshopWorkspacesIdDeleteParams = zod.object({
  "id": zod.string().describe('ShopWorkspace identifier')
})


/**
 * Update a shopWorkspace
 * @summary Update a shopWorkspace
 */
export const apiAdminshopWorkspacesIdPatchParams = zod.object({
  "id": zod.string().describe('ShopWorkspace identifier')
})

export const apiAdminshopWorkspacesIdPatchBodyMinPointDefault = 0;
export const apiAdminshopWorkspacesIdPatchBodyMinPointMin = 0;


export const apiAdminshopWorkspacesIdPatchBodyIsActiveDefault = false;

export const apiAdminshopWorkspacesIdPatchBody = zod.object({
  "minPoint": zod.number().min(apiAdminshopWorkspacesIdPatchBodyMinPointMin).optional().describe('Minimum point before provider can be used'),
  "coefficient": zod.number().min(1).optional().describe('Marge coefficient'),
  "shopOpeningDate": zod.string().datetime({}).nullish().describe('Shop opening date'),
  "shopClosingDate": zod.string().datetime({}).nullish().describe('Shop closing date'),
  "isActive": zod.boolean().optional().describe('Shop workspace is active')
})

export const apiAdminshopWorkspacesIdPatchResponseShopDisplayNameMax = 100;

export const apiAdminshopWorkspacesIdPatchResponseMinPointDefault = 0;
export const apiAdminshopWorkspacesIdPatchResponseMinPointMin = 0;


export const apiAdminshopWorkspacesIdPatchResponseIsActiveDefault = false;export const apiAdminshopWorkspacesIdPatchResponseIsActivableDefault = true;

export const apiAdminshopWorkspacesIdPatchResponse = zod.object({
  "id": zod.number().describe('Shop Workspace ID'),
  "shop": zod.object({
  "displayName": zod.string().max(apiAdminshopWorkspacesIdPatchResponseShopDisplayNameMax).describe('Shop display name')
}),
  "minPoint": zod.number().min(apiAdminshopWorkspacesIdPatchResponseMinPointMin).optional().describe('Minimum point before provider can be used'),
  "coefficient": zod.number().min(1).optional().describe('Marge coefficient'),
  "shopOpeningDate": zod.string().datetime({}).nullish().describe('Shop opening date'),
  "shopClosingDate": zod.string().datetime({}).nullish().describe('Shop closing date'),
  "isActive": zod.boolean().optional().describe('Shop workspace is active'),
  "isActivable": zod.boolean().default(apiAdminshopWorkspacesIdPatchResponseIsActivableDefault)
})


/**
 * List all typologies
 * @summary List all typologies
 */
export const apiAdmintypologiesGetCollectionQueryPageDefault = 1;export const apiAdmintypologiesGetCollectionQueryPerPageDefault = 30;
export const apiAdmintypologiesGetCollectionQueryPerPageMin = 0;
export const apiAdmintypologiesGetCollectionQueryPerPageMax = 30;



export const apiAdmintypologiesGetCollectionQueryParams = zod.object({
  "page": zod.number().default(apiAdmintypologiesGetCollectionQueryPageDefault).describe('The collection page number'),
  "perPage": zod.number().min(apiAdmintypologiesGetCollectionQueryPerPageMin).max(apiAdmintypologiesGetCollectionQueryPerPageMax).default(apiAdmintypologiesGetCollectionQueryPerPageDefault).describe('The number of items per page'),
  "name": zod.string().optional()
})

export const apiAdmintypologiesGetCollectionResponseDataItemNameMax = 100;

export const apiAdmintypologiesGetCollectionResponseDataItemPointCoeffMin = 0;



export const apiAdmintypologiesGetCollectionResponse = zod.object({
  "data": zod.array(zod.unknown()),
  "pagination": zod.object({
  "first": zod.number(),
  "current": zod.number(),
  "last": zod.number(),
  "previous": zod.number(),
  "next": zod.number(),
  "totalItems": zod.number(),
  "perPage": zod.number()
})
}).and(zod.object({
  "data": zod.array(zod.object({
  "id": zod.number().describe('Typology ID'),
  "name": zod.string().max(apiAdmintypologiesGetCollectionResponseDataItemNameMax).describe('Name of the typology'),
  "pointCoeff": zod.number().min(apiAdmintypologiesGetCollectionResponseDataItemPointCoeffMin).describe('Coefficient of the typology (conversion euros => points)'),
  "isDefault": zod.boolean().describe('Typology used by default'),
  "createdAt": zod.string().datetime({}).describe('Date of creation of the typology')
})).optional()
}))


/**
 * Create a new typology
 * @summary Create a new typology
 */
export const apiAdmintypologiesPostBodyNameMax = 100;

export const apiAdmintypologiesPostBodyPointCoeffMin = 0;



export const apiAdmintypologiesPostBody = zod.object({
  "name": zod.string().max(apiAdmintypologiesPostBodyNameMax).describe('Name of the typology'),
  "pointCoeff": zod.number().min(apiAdmintypologiesPostBodyPointCoeffMin).describe('Coefficient of the typology (conversion euros => points)'),
  "isDefault": zod.boolean().describe('Typology used by default')
})


/**
 * Get typologies by ID
 * @summary Get typologies by ID
 */
export const apiAdmintypologiesIdGetParams = zod.object({
  "id": zod.string().describe('Typology identifier')
})

export const apiAdmintypologiesIdGetResponseNameMax = 100;

export const apiAdmintypologiesIdGetResponsePointCoeffMin = 0;



export const apiAdmintypologiesIdGetResponse = zod.object({
  "id": zod.number().describe('Typology ID'),
  "name": zod.string().max(apiAdmintypologiesIdGetResponseNameMax).describe('Name of the typology'),
  "pointCoeff": zod.number().min(apiAdmintypologiesIdGetResponsePointCoeffMin).describe('Coefficient of the typology (conversion euros => points)'),
  "isDefault": zod.boolean().describe('Typology used by default'),
  "createdAt": zod.string().datetime({}).describe('Date of creation of the typology')
})


/**
 * Delete a typology. Companies linked to this typology are automatically transferred to the workspace default typology.
 * @summary Delete a typology
 */
export const apiAdmintypologiesIdDeleteParams = zod.object({
  "id": zod.string().describe('Typology identifier')
})


/**
 * Update a typology
 * @summary Update a typology
 */
export const apiAdmintypologiesIdPatchParams = zod.object({
  "id": zod.string().describe('Typology identifier')
})

export const apiAdmintypologiesIdPatchBodyNameMax = 100;

export const apiAdmintypologiesIdPatchBodyPointCoeffMin = 0;



export const apiAdmintypologiesIdPatchBody = zod.object({
  "name": zod.string().min(1).max(apiAdmintypologiesIdPatchBodyNameMax).optional().describe('Name of the typology'),
  "pointCoeff": zod.number().min(apiAdmintypologiesIdPatchBodyPointCoeffMin).optional().describe('Coefficient of the typology (conversion euros => points)'),
  "isDefault": zod.boolean().optional().describe('Typology used by default')
})

export const apiAdmintypologiesIdPatchResponseNameMax = 100;

export const apiAdmintypologiesIdPatchResponsePointCoeffMin = 0;



export const apiAdmintypologiesIdPatchResponse = zod.object({
  "id": zod.number().describe('Typology ID'),
  "name": zod.string().max(apiAdmintypologiesIdPatchResponseNameMax).describe('Name of the typology'),
  "pointCoeff": zod.number().min(apiAdmintypologiesIdPatchResponsePointCoeffMin).describe('Coefficient of the typology (conversion euros => points)'),
  "isDefault": zod.boolean().describe('Typology used by default'),
  "createdAt": zod.string().datetime({}).describe('Date of creation of the typology')
})


/**
 * Retrieves the collection of User resources.
 * @summary Retrieves the collection of User resources.
 */
export const apiAdminusersGetCollectionQueryPageDefault = 1;export const apiAdminusersGetCollectionQueryPerPageDefault = 30;
export const apiAdminusersGetCollectionQueryPerPageMin = 0;
export const apiAdminusersGetCollectionQueryPerPageMax = 30;

export const apiAdminusersGetCollectionQueryOrderFirstnameDefault = "asc";export const apiAdminusersGetCollectionQueryOrderLastnameDefault = "asc";export const apiAdminusersGetCollectionQueryOrderUserWorkspacesCreatedAtDefault = "asc";

export const apiAdminusersGetCollectionQueryParams = zod.object({
  "page": zod.number().default(apiAdminusersGetCollectionQueryPageDefault).describe('The collection page number'),
  "perPage": zod.number().min(apiAdminusersGetCollectionQueryPerPageMin).max(apiAdminusersGetCollectionQueryPerPageMax).default(apiAdminusersGetCollectionQueryPerPageDefault).describe('The number of items per page'),
  "fullname": zod.string().optional().describe('Search in concatenated fields: firstname   lastname'),
  "status[]": zod.array(zod.enum(['user.status.unregistered', 'user.status.registered', 'user.status.blocked', 'user.status.inactive'])).optional(),
  "phone": zod.string().optional().describe('Search by phone'),
  "userWorkspaces.registeredAt[after]": zod.string().optional(),
  "userWorkspaces.registeredAt[strictly_after]": zod.string().optional(),
  "userWorkspaces.registeredAt[before]": zod.string().optional(),
  "userWorkspaces.registeredAt[strictly_before]": zod.string().optional(),
  "order[userWorkspaces.registeredAt]": zod.enum(['asc', 'desc']).optional(),
  "order[commercial]": zod.enum(['asc', 'desc']).optional(),
  "search": zod.string().optional().describe('Search in firstname, lastname, email, userWorkspaces.uniqueCode'),
  "email": zod.string().optional(),
  "firstname": zod.string().optional(),
  "lastname": zod.string().optional(),
  "userWorkspaces.uniqueCode": zod.string().optional(),
  "userWorkspaces.company.name": zod.string().optional(),
  "userWorkspaces.comment": zod.string().optional(),
  "userWorkspaces.comment2": zod.string().optional(),
  "userWorkspaces.comment3": zod.string().optional(),
  "maxRole[]": zod.array(zod.enum(['ROLE_MEMBER', 'ROLE_MANAGER', 'ROLE_SALES_ADMIN', 'ROLE_ADMIN', 'ROLE_FIDDY_ADMIN'])).optional().describe('Filter users by role'),
  "responsible_fullname": zod.string().optional().describe('Search in concatenated fields: userWorkspaces.company.companyResponsibles.responsible.user.firstname   userWorkspaces.company.companyResponsibles.responsible.user.lastname'),
  "order[firstname]": zod.enum(['asc', 'desc']).default(apiAdminusersGetCollectionQueryOrderFirstnameDefault),
  "order[lastname]": zod.enum(['asc', 'desc']).default(apiAdminusersGetCollectionQueryOrderLastnameDefault),
  "order[userWorkspaces.createdAt]": zod.enum(['asc', 'desc']).default(apiAdminusersGetCollectionQueryOrderUserWorkspacesCreatedAtDefault),
  "userWorkspaces.createdAt[before]": zod.string().optional(),
  "userWorkspaces.createdAt[strictly_before]": zod.string().optional(),
  "userWorkspaces.createdAt[after]": zod.string().optional(),
  "userWorkspaces.createdAt[strictly_after]": zod.string().optional()
})

export const apiAdminusersGetCollectionResponseDataItemEmailMax = 255;

export const apiAdminusersGetCollectionResponseDataItemUserWorkspacesItemCompanyNameMax = 100;

export const apiAdminusersGetCollectionResponseDataItemUserWorkspacesItemCompanyUniqueCodeMax = 50;


export const apiAdminusersGetCollectionResponseDataItemUserWorkspacesItemCompanyUniqueCodeRegExp = new RegExp('^([a-zA-Z0-9]+)$');
export const apiAdminusersGetCollectionResponseDataItemUserWorkspacesItemUniqueCodeMax = 50;


export const apiAdminusersGetCollectionResponseDataItemUserWorkspacesItemUniqueCodeRegExp = new RegExp('^([a-zA-Z0-9]+)$');
export const apiAdminusersGetCollectionResponseDataItemUserWorkspacesItemCreatedAtDefault = "";export const apiAdminusersGetCollectionResponseDataItemUserWorkspacesItemStatusDefault = "user.status.unregistered";export const apiAdminusersGetCollectionResponseDataItemUserWorkspacesItemActiveDefault = false;export const apiAdminusersGetCollectionResponseDataItemUserWorkspacesItemPhoneMax = 20;

export const apiAdminusersGetCollectionResponseDataItemFirstnameMax = 50;

export const apiAdminusersGetCollectionResponseDataItemLastnameMax = 50;

export const apiAdminusersGetCollectionResponseDataItemAvatarMax = 255;



export const apiAdminusersGetCollectionResponse = zod.object({
  "data": zod.array(zod.unknown()),
  "pagination": zod.object({
  "first": zod.number(),
  "current": zod.number(),
  "last": zod.number(),
  "previous": zod.number(),
  "next": zod.number(),
  "totalItems": zod.number(),
  "perPage": zod.number()
})
}).and(zod.object({
  "data": zod.array(zod.object({
  "id": zod.number().describe('User ID'),
  "email": zod.string().email().max(apiAdminusersGetCollectionResponseDataItemEmailMax).describe('User email'),
  "userWorkspaces": zod.array(zod.object({
  "id": zod.number().optional(),
  "maxRole": zod.enum(['ROLE_MEMBER', 'ROLE_MANAGER', 'ROLE_SALES_ADMIN', 'ROLE_ADMIN', 'ROLE_FIDDY_ADMIN']).describe('User max role'),
  "company": zod.union([zod.object({
  "id": zod.number().describe('Company ID'),
  "name": zod.string().max(apiAdminusersGetCollectionResponseDataItemUserWorkspacesItemCompanyNameMax).describe('Company name'),
  "uniqueCode": zod.string().max(apiAdminusersGetCollectionResponseDataItemUserWorkspacesItemCompanyUniqueCodeMax).regex(apiAdminusersGetCollectionResponseDataItemUserWorkspacesItemCompanyUniqueCodeRegExp).describe('Company unique code (SIREN or TVA or whatever)'),
  "responsiblesFullName": zod.array(zod.string().nullable()).nullish().describe('Full names of the responsibles')
}),zod.null()]).optional(),
  "uniqueCode": zod.string().min(1).max(apiAdminusersGetCollectionResponseDataItemUserWorkspacesItemUniqueCodeMax).regex(apiAdminusersGetCollectionResponseDataItemUserWorkspacesItemUniqueCodeRegExp).describe('User unique code'),
  "createdAt": zod.string().datetime({}).describe('User creation date'),
  "status": zod.enum(['user.status.unregistered', 'user.status.registered', 'user.status.blocked', 'user.status.inactive']).default(apiAdminusersGetCollectionResponseDataItemUserWorkspacesItemStatusDefault).describe('User status'),
  "active": zod.boolean().describe('true if user is connected to the current workspace'),
  "phone": zod.string().max(apiAdminusersGetCollectionResponseDataItemUserWorkspacesItemPhoneMax).nullish().describe('User phone number'),
  "registeredAt": zod.string().datetime({}).nullable().describe('User registration date'),
  "comment": zod.string().nullish().describe('Comment about the user'),
  "comment2": zod.string().nullish().describe('Additional customizable comment about the user'),
  "comment3": zod.string().nullish().describe('Additional customizable comment about the user')
})),
  "firstname": zod.string().max(apiAdminusersGetCollectionResponseDataItemFirstnameMax).describe('User firstname'),
  "lastname": zod.string().max(apiAdminusersGetCollectionResponseDataItemLastnameMax).describe('User lastname'),
  "fullname": zod.string().describe('User fullname'),
  "avatar": zod.string().max(apiAdminusersGetCollectionResponseDataItemAvatarMax).nullish().describe('User avatar'),
  "isDeleted": zod.boolean().describe('Whether the entity has been soft-deleted')
})).optional()
}))


/**
 * Add a new user
 * @summary Add a new user
 */
export const apiAdminusersPostBodyEmailMax = 255;

export const apiAdminusersPostBodyPlainPasswordMin = 8;


export const apiAdminusersPostBodyPlainPasswordRegExp = new RegExp('^((?=.*[a-z])(?=.*[A-Z])(?=.*\\d).+)$');
export const apiAdminusersPostBodyUserWorkspaceUniqueCodeMax = 50;


export const apiAdminusersPostBodyUserWorkspaceUniqueCodeRegExp = new RegExp('^([a-zA-Z0-9]+)$');
export const apiAdminusersPostBodyUserWorkspacePhoneMax = 20;

export const apiAdminusersPostBodyFirstnameMax = 50;

export const apiAdminusersPostBodyLastnameMax = 50;

export const apiAdminusersPostBodyEmailNotificationDefault = false;

export const apiAdminusersPostBody = zod.object({
  "email": zod.string().email().max(apiAdminusersPostBodyEmailMax).describe('User email'),
  "plainPassword": zod.string().min(apiAdminusersPostBodyPlainPasswordMin).regex(apiAdminusersPostBodyPlainPasswordRegExp).nullable().describe('User plain password'),
  "userWorkspace": zod.object({
  "maxRole": zod.enum(['ROLE_MEMBER', 'ROLE_MANAGER', 'ROLE_SALES_ADMIN', 'ROLE_ADMIN', 'ROLE_FIDDY_ADMIN']).describe('User max role'),
  "companyUniqueCode": zod.string().nullish().describe('The company unique code to which the user belongs'),
  "uniqueCode": zod.string().min(1).max(apiAdminusersPostBodyUserWorkspaceUniqueCodeMax).regex(apiAdminusersPostBodyUserWorkspaceUniqueCodeRegExp).describe('User unique code'),
  "phone": zod.string().max(apiAdminusersPostBodyUserWorkspacePhoneMax).nullish().describe('User phone number'),
  "comment": zod.string().nullish().describe('Comment about the user'),
  "comment2": zod.string().nullish().describe('Additional customizable comment about the user'),
  "comment3": zod.string().nullish().describe('Additional customizable comment about the user')
}),
  "firstname": zod.string().max(apiAdminusersPostBodyFirstnameMax).describe('User firstname'),
  "lastname": zod.string().max(apiAdminusersPostBodyLastnameMax).describe('User lastname'),
  "emailNotification": zod.boolean().describe('Send welcome email if true (front user only)')
})


/**
 * Import list of users
 * @summary Import list of users
 */
export const usersImportHeaderDryRunDefault = false;

export const usersImportHeader = zod.object({
  "dry-run": zod.boolean().optional().describe('Set to true to perform a dry run import (optional)')
})

export const usersImportBodyDataItemEmailMax = 255;

export const usersImportBodyDataItemPlainPasswordMin = 8;


export const usersImportBodyDataItemPlainPasswordRegExp = new RegExp('^((?=.*[a-z])(?=.*[A-Z])(?=.*\\d).+)$');
export const usersImportBodyDataItemUserWorkspaceUniqueCodeMax = 50;


export const usersImportBodyDataItemUserWorkspaceUniqueCodeRegExp = new RegExp('^([a-zA-Z0-9]+)$');
export const usersImportBodyDataItemUserWorkspacePhoneMax = 20;

export const usersImportBodyDataItemFirstnameMax = 50;

export const usersImportBodyDataItemLastnameMax = 50;

export const usersImportBodyDataItemEmailNotificationDefault = false;

export const usersImportBody = zod.object({
  "data": zod.array(zod.object({
  "email": zod.string().email().max(usersImportBodyDataItemEmailMax).describe('User email'),
  "plainPassword": zod.string().min(usersImportBodyDataItemPlainPasswordMin).regex(usersImportBodyDataItemPlainPasswordRegExp).nullable().describe('User plain password'),
  "userWorkspace": zod.object({
  "maxRole": zod.enum(['ROLE_MEMBER', 'ROLE_MANAGER', 'ROLE_SALES_ADMIN', 'ROLE_ADMIN', 'ROLE_FIDDY_ADMIN']).describe('User max role'),
  "companyUniqueCode": zod.string().nullish().describe('The company unique code to which the user belongs'),
  "uniqueCode": zod.string().min(1).max(usersImportBodyDataItemUserWorkspaceUniqueCodeMax).regex(usersImportBodyDataItemUserWorkspaceUniqueCodeRegExp).describe('User unique code'),
  "phone": zod.string().max(usersImportBodyDataItemUserWorkspacePhoneMax).nullish().describe('User phone number'),
  "comment": zod.string().nullish().describe('Comment about the user'),
  "comment2": zod.string().nullish().describe('Additional customizable comment about the user'),
  "comment3": zod.string().nullish().describe('Additional customizable comment about the user')
}),
  "firstname": zod.string().max(usersImportBodyDataItemFirstnameMax).describe('User firstname'),
  "lastname": zod.string().max(usersImportBodyDataItemLastnameMax).describe('User lastname'),
  "emailNotification": zod.boolean().describe('Send welcome email if true (front user only)')
}))
})


/**
 * Switch from one workspace to another
 * @summary Switch from one workspace to another
 */
export const switchToWorkspaceBody = zod.object({
  "workspaceId": zod.number(),
  "uniqueCode": zod.string()
})

export const switchToWorkspaceResponse = zod.object({
  "token": zod.string(),
  "refreshToken": zod.string(),
  "refreshTokenExpiresAt": zod.number()
})


/**
 * Retrieves a User resource.
 * @summary Retrieves a User resource.
 */
export const apiAdminusersIdGetParams = zod.object({
  "id": zod.string().describe('User identifier')
})

export const apiAdminusersIdGetResponseEmailMax = 255;

export const apiAdminusersIdGetResponseUserWorkspacesItemCompanyNameMax = 100;

export const apiAdminusersIdGetResponseUserWorkspacesItemCompanyUniqueCodeMax = 50;


export const apiAdminusersIdGetResponseUserWorkspacesItemCompanyUniqueCodeRegExp = new RegExp('^([a-zA-Z0-9]+)$');
export const apiAdminusersIdGetResponseUserWorkspacesItemCompanyLogicStepHistoryItemLogicTypeStepNameMax = 50;

export const apiAdminusersIdGetResponseUserWorkspacesItemCompanyLastStepReachedNameMax = 50;

export const apiAdminusersIdGetResponseUserWorkspacesItemUniqueCodeMax = 50;


export const apiAdminusersIdGetResponseUserWorkspacesItemUniqueCodeRegExp = new RegExp('^([a-zA-Z0-9]+)$');
export const apiAdminusersIdGetResponseUserWorkspacesItemCreatedAtDefault = "";export const apiAdminusersIdGetResponseUserWorkspacesItemStatusDefault = "user.status.unregistered";export const apiAdminusersIdGetResponseUserWorkspacesItemPointsItemLabelMax = 255;

export const apiAdminusersIdGetResponseUserWorkspacesItemPointsItemCreatedAtDefault = "";export const apiAdminusersIdGetResponseUserWorkspacesItemPointsItemValueDateDefault = "";export const apiAdminusersIdGetResponseUserWorkspacesItemActiveDefault = false;export const apiAdminusersIdGetResponseUserWorkspacesItemPhoneMax = 20;

export const apiAdminusersIdGetResponseUserWorkspacesItemSalesHierarchyDirectReportsCountDefault = 0;export const apiAdminusersIdGetResponseUserWorkspacesItemLoginCountDefault = 0;export const apiAdminusersIdGetResponseUserWorkspacesItemAttachedCompaniesItemNameMax = 100;

export const apiAdminusersIdGetResponseUserWorkspacesItemAttachedCompaniesItemUniqueCodeMax = 50;


export const apiAdminusersIdGetResponseUserWorkspacesItemAttachedCompaniesItemUniqueCodeRegExp = new RegExp('^([a-zA-Z0-9]+)$');
export const apiAdminusersIdGetResponseUserWorkspacesItemAttachedCompaniesItemLogicStepHistoryItemLogicTypeStepNameMax = 50;

export const apiAdminusersIdGetResponseUserWorkspacesItemAttachedCompaniesItemLastStepReachedNameMax = 50;

export const apiAdminusersIdGetResponseFirstnameMax = 50;

export const apiAdminusersIdGetResponseLastnameMax = 50;

export const apiAdminusersIdGetResponseAvatarMax = 255;



export const apiAdminusersIdGetResponse = zod.object({
  "id": zod.number().describe('User ID'),
  "email": zod.string().email().max(apiAdminusersIdGetResponseEmailMax).describe('User email'),
  "userWorkspaces": zod.array(zod.object({
  "id": zod.number().optional(),
  "maxRole": zod.enum(['ROLE_MEMBER', 'ROLE_MANAGER', 'ROLE_SALES_ADMIN', 'ROLE_ADMIN', 'ROLE_FIDDY_ADMIN']).describe('User max role'),
  "company": zod.union([zod.object({
  "id": zod.number().describe('Company ID'),
  "name": zod.string().max(apiAdminusersIdGetResponseUserWorkspacesItemCompanyNameMax).describe('Company name'),
  "uniqueCode": zod.string().max(apiAdminusersIdGetResponseUserWorkspacesItemCompanyUniqueCodeMax).regex(apiAdminusersIdGetResponseUserWorkspacesItemCompanyUniqueCodeRegExp).describe('Company unique code (SIREN or TVA or whatever)'),
  "logicStepHistory": zod.array(zod.object({
  "logicTypeStep": zod.object({
  "id": zod.number().optional().describe('Step ID'),
  "name": zod.string().max(apiAdminusersIdGetResponseUserWorkspacesItemCompanyLogicStepHistoryItemLogicTypeStepNameMax).describe('Step name')
}),
  "createdAt": zod.string().datetime({}).describe('Step history creation datetime')
})).optional(),
  "lastStepReached": zod.union([zod.object({
  "id": zod.number().optional().describe('Step ID'),
  "name": zod.string().max(apiAdminusersIdGetResponseUserWorkspacesItemCompanyLastStepReachedNameMax).describe('Step name')
}),zod.null()]).optional()
}),zod.null()]).optional(),
  "uniqueCode": zod.string().min(1).max(apiAdminusersIdGetResponseUserWorkspacesItemUniqueCodeMax).regex(apiAdminusersIdGetResponseUserWorkspacesItemUniqueCodeRegExp).describe('User unique code'),
  "createdAt": zod.string().datetime({}).describe('User creation date'),
  "status": zod.enum(['user.status.unregistered', 'user.status.registered', 'user.status.blocked', 'user.status.inactive']).default(apiAdminusersIdGetResponseUserWorkspacesItemStatusDefault).describe('User status'),
  "points": zod.array(zod.object({
  "amount": zod.number().describe('Points amount'),
  "label": zod.string().max(apiAdminusersIdGetResponseUserWorkspacesItemPointsItemLabelMax).nullish().describe('Points label'),
  "typeLabel": zod.enum(['CORE', 'IMPORTED', 'SPENT', 'EXPIRED', 'CANCELED', 'BOOSTER']),
  "expirationDate": zod.string().datetime({}).nullish().describe('Points expiration date'),
  "createdAt": zod.string().datetime({}).describe('Points creation date'),
  "valueDate": zod.string().datetime({}).describe('Points value date')
})),
  "active": zod.boolean().describe('true if user is connected to the current workspace'),
  "phone": zod.string().max(apiAdminusersIdGetResponseUserWorkspacesItemPhoneMax).nullish().describe('User phone number'),
  "registeredAt": zod.string().datetime({}).nullable().describe('User registration date'),
  "salesHierarchyDirectReportsCount": zod.number().describe('Number of sales reporting directly to this user, across every sales hierarchy they lead'),
  "loginCount": zod.number().describe('Total number of logins for this user on this workspace'),
  "loginCountPerMonth": zod.array(zod.object({
  "value": zod.number().describe('Value in this month'),
  "month": zod.number().describe('Month of the year (1-12)'),
  "year": zod.number().describe('Year')
})),
  "comment": zod.string().nullish().describe('Comment about the user'),
  "comment2": zod.string().nullish().describe('Additional customizable comment about the user'),
  "comment3": zod.string().nullish().describe('Additional customizable comment about the user'),
  "attachedCompanies": zod.array(zod.object({
  "id": zod.number().describe('Company ID'),
  "name": zod.string().max(apiAdminusersIdGetResponseUserWorkspacesItemAttachedCompaniesItemNameMax).describe('Company name'),
  "uniqueCode": zod.string().max(apiAdminusersIdGetResponseUserWorkspacesItemAttachedCompaniesItemUniqueCodeMax).regex(apiAdminusersIdGetResponseUserWorkspacesItemAttachedCompaniesItemUniqueCodeRegExp).describe('Company unique code (SIREN or TVA or whatever)'),
  "logicStepHistory": zod.array(zod.object({
  "logicTypeStep": zod.object({
  "id": zod.number().optional().describe('Step ID'),
  "name": zod.string().max(apiAdminusersIdGetResponseUserWorkspacesItemAttachedCompaniesItemLogicStepHistoryItemLogicTypeStepNameMax).describe('Step name')
}),
  "createdAt": zod.string().datetime({}).describe('Step history creation datetime')
})).optional(),
  "lastStepReached": zod.union([zod.object({
  "id": zod.number().optional().describe('Step ID'),
  "name": zod.string().max(apiAdminusersIdGetResponseUserWorkspacesItemAttachedCompaniesItemLastStepReachedNameMax).describe('Step name')
}),zod.null()]).optional()
})).optional(),
  "passwordNeedToBeChanged": zod.boolean().optional()
})),
  "firstname": zod.string().max(apiAdminusersIdGetResponseFirstnameMax).describe('User firstname'),
  "lastname": zod.string().max(apiAdminusersIdGetResponseLastnameMax).describe('User lastname'),
  "fullname": zod.string().describe('User fullname'),
  "avatar": zod.string().max(apiAdminusersIdGetResponseAvatarMax).nullish().describe('User avatar'),
  "isDeleted": zod.boolean().describe('Whether the entity has been soft-deleted')
})


/**
 * Anonymize and soft-delete a user
 * @summary Soft-delete a user
 */
export const apiAdminusersIdDeleteParams = zod.object({
  "id": zod.string().describe('User identifier')
})


/**
 * Delete the previous magic link (if needed) and send a new one to the user
 * @summary Send a magic link to a user
 */
export const sendMagicLinkParams = zod.object({
  "id": zod.string().describe('User identifier')
})


/**
 * Send a first connexion email to a user
 * @summary Send a first connexion email to a user
 */
export const sendFirstConnexionHeader = zod.object({
  "App-ID": zod.string().optional().describe('App-ID')
})

export const sendFirstConnexionBodyEmailMax = 255;



export const sendFirstConnexionBody = zod.object({
  "email": zod.string().email().max(sendFirstConnexionBodyEmailMax).describe('User email')
})


/**
 * Retrieves a User resource.
 * @summary Retrieves a User resource.
 */
export const meResponseEmailMax = 255;

export const meResponseVisibleWorkspacesItemWorkspaceNameMax = 50;

export const meResponseVisibleWorkspacesItemWorkspaceStatusMax = 20;

export const meResponseVisibleWorkspacesItemCompanyNameMax = 100;

export const meResponseVisibleWorkspacesItemCompanyUniqueCodeMax = 50;


export const meResponseVisibleWorkspacesItemCompanyUniqueCodeRegExp = new RegExp('^([a-zA-Z0-9]+)$');
export const meResponseVisibleWorkspacesItemCompanySirenMax = 9;


export const meResponseVisibleWorkspacesItemCompanySirenRegExp = new RegExp('^([0-9]*)$');
export const meResponseVisibleWorkspacesItemCompanyTvaMax = 20;

export const meResponseVisibleWorkspacesItemCompanyAddressLine1Min = 7;
export const meResponseVisibleWorkspacesItemCompanyAddressLine1Max = 255;

export const meResponseVisibleWorkspacesItemCompanyAddressLine2Max = 255;

export const meResponseVisibleWorkspacesItemCompanyAddressLine3Max = 255;

export const meResponseVisibleWorkspacesItemCompanyZipcodeMin = 4;
export const meResponseVisibleWorkspacesItemCompanyZipcodeMax = 20;

export const meResponseVisibleWorkspacesItemCompanyCityMax = 100;

export const meResponseVisibleWorkspacesItemCompanyCountryAlpha3Min = 3;
export const meResponseVisibleWorkspacesItemCompanyCountryAlpha3Max = 3;

export const meResponseVisibleWorkspacesItemCompanyStatusDefault = "company.status.unregistered";export const meResponseVisibleWorkspacesItemCompanyLogicStepHistoryItemLogicTypeStepNameMax = 50;

export const meResponseVisibleWorkspacesItemCompanyTargetStatusesItemLogicTypeTargetReferenceMax = 20;

export const meResponseVisibleWorkspacesItemCompanyTargetStatusesItemValueDefault = 0;
export const meResponseVisibleWorkspacesItemCompanyTargetStatusesItemValueMin = 0;

export const meResponseVisibleWorkspacesItemCompanyTargetStatusesItemTargetValueMin = 0;

export const meResponseVisibleWorkspacesItemCompanyTargetStatusesItemAchievedPercentageDefault = 0;export const meResponseVisibleWorkspacesItemCompanyLastStepReachedNameMax = 50;

export const meResponseVisibleWorkspacesItemUniqueCodeMax = 50;


export const meResponseVisibleWorkspacesItemUniqueCodeRegExp = new RegExp('^([a-zA-Z0-9]+)$');
export const meResponseVisibleWorkspacesItemCreatedAtDefault = "";export const meResponseVisibleWorkspacesItemStatusDefault = "user.status.unregistered";export const meResponseVisibleWorkspacesItemPointsItemLabelMax = 255;

export const meResponseVisibleWorkspacesItemPointsItemCreatedAtDefault = "";export const meResponseVisibleWorkspacesItemPointsItemValueDateDefault = "";export const meResponseVisibleWorkspacesItemActiveDefault = false;export const meResponseVisibleWorkspacesItemPhoneMax = 20;

export const meResponseVisibleWorkspacesItemLoginCountDefault = 0;export const meResponseFirstnameMax = 50;

export const meResponseLastnameMax = 50;

export const meResponseAvatarMax = 255;



export const meResponse = zod.object({
  "id": zod.number().describe('User ID'),
  "email": zod.string().email().max(meResponseEmailMax).describe('User email'),
  "visibleWorkspaces": zod.array(zod.object({
  "id": zod.number().optional(),
  "workspace": zod.object({
  "id": zod.number().describe('Workspace ID'),
  "name": zod.string().max(meResponseVisibleWorkspacesItemWorkspaceNameMax).describe('Workspace name'),
  "status": zod.enum(['active', 'draft', 'misconfigured']).optional().describe('Workspace status')
}),
  "roles": zod.array(zod.string().nullable()).describe('User roles'),
  "maxRole": zod.enum(['ROLE_MEMBER', 'ROLE_MANAGER', 'ROLE_SALES_ADMIN', 'ROLE_ADMIN', 'ROLE_FIDDY_ADMIN']).describe('User max role'),
  "company": zod.union([zod.object({
  "id": zod.number().describe('Company ID'),
  "name": zod.string().max(meResponseVisibleWorkspacesItemCompanyNameMax).describe('Company name'),
  "uniqueCode": zod.string().max(meResponseVisibleWorkspacesItemCompanyUniqueCodeMax).regex(meResponseVisibleWorkspacesItemCompanyUniqueCodeRegExp).describe('Company unique code (SIREN or TVA or whatever)'),
  "siren": zod.string().max(meResponseVisibleWorkspacesItemCompanySirenMax).regex(meResponseVisibleWorkspacesItemCompanySirenRegExp).nullish().describe('Company SIREN'),
  "tva": zod.string().max(meResponseVisibleWorkspacesItemCompanyTvaMax).nullish().describe('Company TVA'),
  "addressLine1": zod.string().min(meResponseVisibleWorkspacesItemCompanyAddressLine1Min).max(meResponseVisibleWorkspacesItemCompanyAddressLine1Max).describe('Company address line 1'),
  "addressLine2": zod.string().max(meResponseVisibleWorkspacesItemCompanyAddressLine2Max).nullish().describe('Company address line 2'),
  "addressLine3": zod.string().max(meResponseVisibleWorkspacesItemCompanyAddressLine3Max).nullish().describe('Company address line 3'),
  "zipcode": zod.string().min(meResponseVisibleWorkspacesItemCompanyZipcodeMin).max(meResponseVisibleWorkspacesItemCompanyZipcodeMax).describe('Company zipcode'),
  "city": zod.string().max(meResponseVisibleWorkspacesItemCompanyCityMax).describe('Company city'),
  "country": zod.object({
  "alpha3": zod.string().min(meResponseVisibleWorkspacesItemCompanyCountryAlpha3Min).max(meResponseVisibleWorkspacesItemCompanyCountryAlpha3Max).describe('Country alpha3 code'),
  "name": zod.string().describe('Country name'),
  "currencyName": zod.string().describe('Country currency'),
  "currencySymbol": zod.string().describe('Country currency symbol')
}).optional(),
  "createdAt": zod.string().datetime({}).describe('Company creation date'),
  "status": zod.enum(['company.status.unregistered', 'company.status.registered', 'company.status.blocked', 'company.status.inactive']).describe('Company status (read-only, computed from managers statuses)'),
  "registeredAt": zod.string().datetime({}).nullish().describe('Datetime where the first managed completed registration was done'),
  "logicStepHistory": zod.array(zod.object({
  "logicTypeStep": zod.object({
  "id": zod.number().optional().describe('Step ID'),
  "name": zod.string().max(meResponseVisibleWorkspacesItemCompanyLogicStepHistoryItemLogicTypeStepNameMax).describe('Step name')
}),
  "createdAt": zod.string().datetime({}).describe('Step history creation datetime')
})).optional(),
  "caAmount": zod.number().describe('CA amount of the company'),
  "targetStatuses": zod.array(zod.object({
  "id": zod.number().describe('Target Status ID'),
  "logicTypeTarget": zod.object({
  "reference": zod.string().max(meResponseVisibleWorkspacesItemCompanyTargetStatusesItemLogicTypeTargetReferenceMax).describe('Target reference name'),
  "description": zod.string().nullish().describe('Target description (label)')
}).optional(),
  "value": zod.number().min(meResponseVisibleWorkspacesItemCompanyTargetStatusesItemValueMin).describe('Current target value (in points or euros)'),
  "targetValue": zod.number().min(meResponseVisibleWorkspacesItemCompanyTargetStatusesItemTargetValueMin).describe('Target value to achieve (in points or euros)'),
  "updatedAt": zod.string().datetime({}).optional().describe('Date of the last update'),
  "achievedAt": zod.string().datetime({}).nullish().describe('Date when the target was achieved'),
  "achievedPercentage": zod.number().optional()
})).optional(),
  "lastStepReached": zod.union([zod.object({
  "id": zod.number().optional().describe('Step ID'),
  "name": zod.string().max(meResponseVisibleWorkspacesItemCompanyLastStepReachedNameMax).describe('Step name')
}),zod.null()]).optional(),
  "balance": zod.number().describe('Balance of the company')
}),zod.null()]).optional(),
  "uniqueCode": zod.string().min(1).max(meResponseVisibleWorkspacesItemUniqueCodeMax).regex(meResponseVisibleWorkspacesItemUniqueCodeRegExp).describe('User unique code'),
  "createdAt": zod.string().datetime({}).describe('User creation date'),
  "status": zod.enum(['user.status.unregistered', 'user.status.registered', 'user.status.blocked', 'user.status.inactive']).default(meResponseVisibleWorkspacesItemStatusDefault).describe('User status'),
  "points": zod.array(zod.object({
  "amount": zod.number().describe('Points amount'),
  "label": zod.string().max(meResponseVisibleWorkspacesItemPointsItemLabelMax).nullish().describe('Points label'),
  "typeLabel": zod.enum(['CORE', 'IMPORTED', 'SPENT', 'EXPIRED', 'CANCELED', 'BOOSTER']),
  "expirationDate": zod.string().datetime({}).nullish().describe('Points expiration date'),
  "createdAt": zod.string().datetime({}).describe('Points creation date'),
  "valueDate": zod.string().datetime({}).describe('Points value date')
})),
  "active": zod.boolean().describe('true if user is connected to the current workspace'),
  "phone": zod.string().max(meResponseVisibleWorkspacesItemPhoneMax).nullish().describe('User phone number'),
  "registeredAt": zod.string().datetime({}).nullable().describe('User registration date'),
  "loginCount": zod.number().describe('Total number of logins for this user on this workspace'),
  "loginCountPerMonth": zod.array(zod.object({
  "value": zod.number().describe('Value in this month'),
  "month": zod.number().describe('Month of the year (1-12)'),
  "year": zod.number().describe('Year')
})),
  "passwordNeedToBeChanged": zod.boolean().optional()
})),
  "firstname": zod.string().max(meResponseFirstnameMax).describe('User firstname'),
  "lastname": zod.string().max(meResponseLastnameMax).describe('User lastname'),
  "fullname": zod.string().describe('User fullname'),
  "avatar": zod.string().max(meResponseAvatarMax).nullish().describe('User avatar'),
  "isDeleted": zod.boolean().describe('Whether the entity has been soft-deleted')
})


/**
 * Update password
 * @summary Update password
 */
export const passwordUpdateBody = zod.object({
  "newPassword": zod.string(),
  "currentPassword": zod.string().optional()
})

export const passwordUpdateResponseEmailMax = 255;

export const passwordUpdateResponseVisibleWorkspacesItemWorkspaceNameMax = 50;

export const passwordUpdateResponseVisibleWorkspacesItemWorkspaceStatusMax = 20;

export const passwordUpdateResponseVisibleWorkspacesItemCompanyNameMax = 100;

export const passwordUpdateResponseVisibleWorkspacesItemCompanyUniqueCodeMax = 50;


export const passwordUpdateResponseVisibleWorkspacesItemCompanyUniqueCodeRegExp = new RegExp('^([a-zA-Z0-9]+)$');
export const passwordUpdateResponseVisibleWorkspacesItemCompanySirenMax = 9;


export const passwordUpdateResponseVisibleWorkspacesItemCompanySirenRegExp = new RegExp('^([0-9]*)$');
export const passwordUpdateResponseVisibleWorkspacesItemCompanyTvaMax = 20;

export const passwordUpdateResponseVisibleWorkspacesItemCompanyAddressLine1Min = 7;
export const passwordUpdateResponseVisibleWorkspacesItemCompanyAddressLine1Max = 255;

export const passwordUpdateResponseVisibleWorkspacesItemCompanyAddressLine2Max = 255;

export const passwordUpdateResponseVisibleWorkspacesItemCompanyAddressLine3Max = 255;

export const passwordUpdateResponseVisibleWorkspacesItemCompanyZipcodeMin = 4;
export const passwordUpdateResponseVisibleWorkspacesItemCompanyZipcodeMax = 20;

export const passwordUpdateResponseVisibleWorkspacesItemCompanyCityMax = 100;

export const passwordUpdateResponseVisibleWorkspacesItemCompanyCountryAlpha3Min = 3;
export const passwordUpdateResponseVisibleWorkspacesItemCompanyCountryAlpha3Max = 3;

export const passwordUpdateResponseVisibleWorkspacesItemCompanyStatusDefault = "company.status.unregistered";export const passwordUpdateResponseVisibleWorkspacesItemCompanyLogicStepHistoryItemLogicTypeStepNameMax = 50;

export const passwordUpdateResponseVisibleWorkspacesItemCompanyTargetStatusesItemLogicTypeTargetReferenceMax = 20;

export const passwordUpdateResponseVisibleWorkspacesItemCompanyTargetStatusesItemValueDefault = 0;
export const passwordUpdateResponseVisibleWorkspacesItemCompanyTargetStatusesItemValueMin = 0;

export const passwordUpdateResponseVisibleWorkspacesItemCompanyTargetStatusesItemTargetValueMin = 0;

export const passwordUpdateResponseVisibleWorkspacesItemCompanyTargetStatusesItemAchievedPercentageDefault = 0;export const passwordUpdateResponseVisibleWorkspacesItemCompanyLastStepReachedNameMax = 50;

export const passwordUpdateResponseVisibleWorkspacesItemUniqueCodeMax = 50;


export const passwordUpdateResponseVisibleWorkspacesItemUniqueCodeRegExp = new RegExp('^([a-zA-Z0-9]+)$');
export const passwordUpdateResponseVisibleWorkspacesItemCreatedAtDefault = "";export const passwordUpdateResponseVisibleWorkspacesItemStatusDefault = "user.status.unregistered";export const passwordUpdateResponseVisibleWorkspacesItemPointsItemLabelMax = 255;

export const passwordUpdateResponseVisibleWorkspacesItemPointsItemCreatedAtDefault = "";export const passwordUpdateResponseVisibleWorkspacesItemPointsItemValueDateDefault = "";export const passwordUpdateResponseVisibleWorkspacesItemActiveDefault = false;export const passwordUpdateResponseVisibleWorkspacesItemPhoneMax = 20;

export const passwordUpdateResponseVisibleWorkspacesItemLoginCountDefault = 0;export const passwordUpdateResponseFirstnameMax = 50;

export const passwordUpdateResponseLastnameMax = 50;

export const passwordUpdateResponseAvatarMax = 255;



export const passwordUpdateResponse = zod.object({
  "id": zod.number().describe('User ID'),
  "email": zod.string().email().max(passwordUpdateResponseEmailMax).describe('User email'),
  "visibleWorkspaces": zod.array(zod.object({
  "id": zod.number().optional(),
  "workspace": zod.object({
  "id": zod.number().describe('Workspace ID'),
  "name": zod.string().max(passwordUpdateResponseVisibleWorkspacesItemWorkspaceNameMax).describe('Workspace name'),
  "status": zod.enum(['active', 'draft', 'misconfigured']).optional().describe('Workspace status')
}),
  "roles": zod.array(zod.string().nullable()).describe('User roles'),
  "maxRole": zod.enum(['ROLE_MEMBER', 'ROLE_MANAGER', 'ROLE_SALES_ADMIN', 'ROLE_ADMIN', 'ROLE_FIDDY_ADMIN']).describe('User max role'),
  "company": zod.union([zod.object({
  "id": zod.number().describe('Company ID'),
  "name": zod.string().max(passwordUpdateResponseVisibleWorkspacesItemCompanyNameMax).describe('Company name'),
  "uniqueCode": zod.string().max(passwordUpdateResponseVisibleWorkspacesItemCompanyUniqueCodeMax).regex(passwordUpdateResponseVisibleWorkspacesItemCompanyUniqueCodeRegExp).describe('Company unique code (SIREN or TVA or whatever)'),
  "siren": zod.string().max(passwordUpdateResponseVisibleWorkspacesItemCompanySirenMax).regex(passwordUpdateResponseVisibleWorkspacesItemCompanySirenRegExp).nullish().describe('Company SIREN'),
  "tva": zod.string().max(passwordUpdateResponseVisibleWorkspacesItemCompanyTvaMax).nullish().describe('Company TVA'),
  "addressLine1": zod.string().min(passwordUpdateResponseVisibleWorkspacesItemCompanyAddressLine1Min).max(passwordUpdateResponseVisibleWorkspacesItemCompanyAddressLine1Max).describe('Company address line 1'),
  "addressLine2": zod.string().max(passwordUpdateResponseVisibleWorkspacesItemCompanyAddressLine2Max).nullish().describe('Company address line 2'),
  "addressLine3": zod.string().max(passwordUpdateResponseVisibleWorkspacesItemCompanyAddressLine3Max).nullish().describe('Company address line 3'),
  "zipcode": zod.string().min(passwordUpdateResponseVisibleWorkspacesItemCompanyZipcodeMin).max(passwordUpdateResponseVisibleWorkspacesItemCompanyZipcodeMax).describe('Company zipcode'),
  "city": zod.string().max(passwordUpdateResponseVisibleWorkspacesItemCompanyCityMax).describe('Company city'),
  "country": zod.object({
  "alpha3": zod.string().min(passwordUpdateResponseVisibleWorkspacesItemCompanyCountryAlpha3Min).max(passwordUpdateResponseVisibleWorkspacesItemCompanyCountryAlpha3Max).describe('Country alpha3 code'),
  "name": zod.string().describe('Country name'),
  "currencyName": zod.string().describe('Country currency'),
  "currencySymbol": zod.string().describe('Country currency symbol')
}).optional(),
  "createdAt": zod.string().datetime({}).describe('Company creation date'),
  "status": zod.enum(['company.status.unregistered', 'company.status.registered', 'company.status.blocked', 'company.status.inactive']).describe('Company status (read-only, computed from managers statuses)'),
  "registeredAt": zod.string().datetime({}).nullish().describe('Datetime where the first managed completed registration was done'),
  "logicStepHistory": zod.array(zod.object({
  "logicTypeStep": zod.object({
  "id": zod.number().optional().describe('Step ID'),
  "name": zod.string().max(passwordUpdateResponseVisibleWorkspacesItemCompanyLogicStepHistoryItemLogicTypeStepNameMax).describe('Step name')
}),
  "createdAt": zod.string().datetime({}).describe('Step history creation datetime')
})).optional(),
  "caAmount": zod.number().describe('CA amount of the company'),
  "targetStatuses": zod.array(zod.object({
  "id": zod.number().describe('Target Status ID'),
  "logicTypeTarget": zod.object({
  "reference": zod.string().max(passwordUpdateResponseVisibleWorkspacesItemCompanyTargetStatusesItemLogicTypeTargetReferenceMax).describe('Target reference name'),
  "description": zod.string().nullish().describe('Target description (label)')
}).optional(),
  "value": zod.number().min(passwordUpdateResponseVisibleWorkspacesItemCompanyTargetStatusesItemValueMin).describe('Current target value (in points or euros)'),
  "targetValue": zod.number().min(passwordUpdateResponseVisibleWorkspacesItemCompanyTargetStatusesItemTargetValueMin).describe('Target value to achieve (in points or euros)'),
  "updatedAt": zod.string().datetime({}).optional().describe('Date of the last update'),
  "achievedAt": zod.string().datetime({}).nullish().describe('Date when the target was achieved'),
  "achievedPercentage": zod.number().optional()
})).optional(),
  "lastStepReached": zod.union([zod.object({
  "id": zod.number().optional().describe('Step ID'),
  "name": zod.string().max(passwordUpdateResponseVisibleWorkspacesItemCompanyLastStepReachedNameMax).describe('Step name')
}),zod.null()]).optional(),
  "balance": zod.number().describe('Balance of the company')
}),zod.null()]).optional(),
  "uniqueCode": zod.string().min(1).max(passwordUpdateResponseVisibleWorkspacesItemUniqueCodeMax).regex(passwordUpdateResponseVisibleWorkspacesItemUniqueCodeRegExp).describe('User unique code'),
  "createdAt": zod.string().datetime({}).describe('User creation date'),
  "status": zod.enum(['user.status.unregistered', 'user.status.registered', 'user.status.blocked', 'user.status.inactive']).default(passwordUpdateResponseVisibleWorkspacesItemStatusDefault).describe('User status'),
  "points": zod.array(zod.object({
  "amount": zod.number().describe('Points amount'),
  "label": zod.string().max(passwordUpdateResponseVisibleWorkspacesItemPointsItemLabelMax).nullish().describe('Points label'),
  "typeLabel": zod.enum(['CORE', 'IMPORTED', 'SPENT', 'EXPIRED', 'CANCELED', 'BOOSTER']),
  "expirationDate": zod.string().datetime({}).nullish().describe('Points expiration date'),
  "createdAt": zod.string().datetime({}).describe('Points creation date'),
  "valueDate": zod.string().datetime({}).describe('Points value date')
})),
  "active": zod.boolean().describe('true if user is connected to the current workspace'),
  "phone": zod.string().max(passwordUpdateResponseVisibleWorkspacesItemPhoneMax).nullish().describe('User phone number'),
  "registeredAt": zod.string().datetime({}).nullable().describe('User registration date'),
  "loginCount": zod.number().describe('Total number of logins for this user on this workspace'),
  "loginCountPerMonth": zod.array(zod.object({
  "value": zod.number().describe('Value in this month'),
  "month": zod.number().describe('Month of the year (1-12)'),
  "year": zod.number().describe('Year')
})),
  "passwordNeedToBeChanged": zod.boolean().optional()
})),
  "firstname": zod.string().max(passwordUpdateResponseFirstnameMax).describe('User firstname'),
  "lastname": zod.string().max(passwordUpdateResponseLastnameMax).describe('User lastname'),
  "fullname": zod.string().describe('User fullname'),
  "avatar": zod.string().max(passwordUpdateResponseAvatarMax).nullish().describe('User avatar'),
  "isDeleted": zod.boolean().describe('Whether the entity has been soft-deleted')
})


/**
 * Accept terms of use
 * @summary Accept terms of use
 */
export const profileUpdateBody = zod.object({

})


/**
 * Updates the User resource.
 * @summary Updates the User resource.
 */
export const apiUsersIdPatchParams = zod.object({
  "id": zod.string().describe('User identifier')
})

export const apiUsersIdPatchBodyEmailMax = 255;

export const apiUsersIdPatchBodyPlainPasswordMin = 8;


export const apiUsersIdPatchBodyPlainPasswordRegExp = new RegExp('^((?=.*[a-z])(?=.*[A-Z])(?=.*\\d).+)$');
export const apiUsersIdPatchBodyUserWorkspaceUniqueCodeMax = 50;


export const apiUsersIdPatchBodyUserWorkspaceUniqueCodeRegExp = new RegExp('^([a-zA-Z0-9]+)$');
export const apiUsersIdPatchBodyUserWorkspaceStatusDefault = "user.status.unregistered";export const apiUsersIdPatchBodyUserWorkspacePhoneMax = 20;

export const apiUsersIdPatchBodyFirstnameMax = 50;

export const apiUsersIdPatchBodyLastnameMax = 50;



export const apiUsersIdPatchBody = zod.object({
  "email": zod.string().email().min(1).max(apiUsersIdPatchBodyEmailMax).optional().describe('User email'),
  "plainPassword": zod.string().min(apiUsersIdPatchBodyPlainPasswordMin).regex(apiUsersIdPatchBodyPlainPasswordRegExp).nullish().describe('User plain password'),
  "userWorkspace": zod.object({
  "maxRole": zod.enum(['ROLE_MEMBER', 'ROLE_MANAGER', 'ROLE_SALES_ADMIN', 'ROLE_ADMIN', 'ROLE_FIDDY_ADMIN']).optional().describe('User max role'),
  "companyUniqueCode": zod.string().nullish().describe('The company unique code to which the user belongs'),
  "uniqueCode": zod.string().min(1).max(apiUsersIdPatchBodyUserWorkspaceUniqueCodeMax).regex(apiUsersIdPatchBodyUserWorkspaceUniqueCodeRegExp).optional().describe('User unique code'),
  "status": zod.enum(['user.status.unregistered', 'user.status.registered', 'user.status.blocked', 'user.status.inactive']).default(apiUsersIdPatchBodyUserWorkspaceStatusDefault).describe('User status'),
  "phone": zod.string().max(apiUsersIdPatchBodyUserWorkspacePhoneMax).nullish().describe('User phone number'),
  "comment": zod.string().nullish().describe('Comment about the user'),
  "comment2": zod.string().nullish().describe('Additional customizable comment about the user'),
  "comment3": zod.string().nullish().describe('Additional customizable comment about the user')
}).optional(),
  "firstname": zod.string().min(1).max(apiUsersIdPatchBodyFirstnameMax).optional().describe('User firstname'),
  "lastname": zod.string().min(1).max(apiUsersIdPatchBodyLastnameMax).optional().describe('User lastname')
})

export const apiUsersIdPatchResponseEmailMax = 255;

export const apiUsersIdPatchResponseUserWorkspacesItemCompanyNameMax = 100;

export const apiUsersIdPatchResponseUserWorkspacesItemCompanyUniqueCodeMax = 50;


export const apiUsersIdPatchResponseUserWorkspacesItemCompanyUniqueCodeRegExp = new RegExp('^([a-zA-Z0-9]+)$');
export const apiUsersIdPatchResponseUserWorkspacesItemCompanyLogicStepHistoryItemLogicTypeStepNameMax = 50;

export const apiUsersIdPatchResponseUserWorkspacesItemCompanyLastStepReachedNameMax = 50;

export const apiUsersIdPatchResponseUserWorkspacesItemUniqueCodeMax = 50;


export const apiUsersIdPatchResponseUserWorkspacesItemUniqueCodeRegExp = new RegExp('^([a-zA-Z0-9]+)$');
export const apiUsersIdPatchResponseUserWorkspacesItemCreatedAtDefault = "";export const apiUsersIdPatchResponseUserWorkspacesItemStatusDefault = "user.status.unregistered";export const apiUsersIdPatchResponseUserWorkspacesItemPointsItemLabelMax = 255;

export const apiUsersIdPatchResponseUserWorkspacesItemPointsItemCreatedAtDefault = "";export const apiUsersIdPatchResponseUserWorkspacesItemPointsItemValueDateDefault = "";export const apiUsersIdPatchResponseUserWorkspacesItemActiveDefault = false;export const apiUsersIdPatchResponseUserWorkspacesItemPhoneMax = 20;

export const apiUsersIdPatchResponseUserWorkspacesItemSalesHierarchyDirectReportsCountDefault = 0;export const apiUsersIdPatchResponseUserWorkspacesItemLoginCountDefault = 0;export const apiUsersIdPatchResponseUserWorkspacesItemAttachedCompaniesItemNameMax = 100;

export const apiUsersIdPatchResponseUserWorkspacesItemAttachedCompaniesItemUniqueCodeMax = 50;


export const apiUsersIdPatchResponseUserWorkspacesItemAttachedCompaniesItemUniqueCodeRegExp = new RegExp('^([a-zA-Z0-9]+)$');
export const apiUsersIdPatchResponseUserWorkspacesItemAttachedCompaniesItemLogicStepHistoryItemLogicTypeStepNameMax = 50;

export const apiUsersIdPatchResponseUserWorkspacesItemAttachedCompaniesItemLastStepReachedNameMax = 50;

export const apiUsersIdPatchResponseFirstnameMax = 50;

export const apiUsersIdPatchResponseLastnameMax = 50;

export const apiUsersIdPatchResponseAvatarMax = 255;



export const apiUsersIdPatchResponse = zod.object({
  "id": zod.number().describe('User ID'),
  "email": zod.string().email().max(apiUsersIdPatchResponseEmailMax).describe('User email'),
  "userWorkspaces": zod.array(zod.object({
  "id": zod.number().optional(),
  "maxRole": zod.enum(['ROLE_MEMBER', 'ROLE_MANAGER', 'ROLE_SALES_ADMIN', 'ROLE_ADMIN', 'ROLE_FIDDY_ADMIN']).describe('User max role'),
  "company": zod.union([zod.object({
  "id": zod.number().describe('Company ID'),
  "name": zod.string().max(apiUsersIdPatchResponseUserWorkspacesItemCompanyNameMax).describe('Company name'),
  "uniqueCode": zod.string().max(apiUsersIdPatchResponseUserWorkspacesItemCompanyUniqueCodeMax).regex(apiUsersIdPatchResponseUserWorkspacesItemCompanyUniqueCodeRegExp).describe('Company unique code (SIREN or TVA or whatever)'),
  "logicStepHistory": zod.array(zod.object({
  "logicTypeStep": zod.object({
  "id": zod.number().optional().describe('Step ID'),
  "name": zod.string().max(apiUsersIdPatchResponseUserWorkspacesItemCompanyLogicStepHistoryItemLogicTypeStepNameMax).describe('Step name')
}),
  "createdAt": zod.string().datetime({}).describe('Step history creation datetime')
})).optional(),
  "lastStepReached": zod.union([zod.object({
  "id": zod.number().optional().describe('Step ID'),
  "name": zod.string().max(apiUsersIdPatchResponseUserWorkspacesItemCompanyLastStepReachedNameMax).describe('Step name')
}),zod.null()]).optional()
}),zod.null()]).optional(),
  "uniqueCode": zod.string().min(1).max(apiUsersIdPatchResponseUserWorkspacesItemUniqueCodeMax).regex(apiUsersIdPatchResponseUserWorkspacesItemUniqueCodeRegExp).describe('User unique code'),
  "createdAt": zod.string().datetime({}).describe('User creation date'),
  "status": zod.enum(['user.status.unregistered', 'user.status.registered', 'user.status.blocked', 'user.status.inactive']).default(apiUsersIdPatchResponseUserWorkspacesItemStatusDefault).describe('User status'),
  "points": zod.array(zod.object({
  "amount": zod.number().describe('Points amount'),
  "label": zod.string().max(apiUsersIdPatchResponseUserWorkspacesItemPointsItemLabelMax).nullish().describe('Points label'),
  "typeLabel": zod.enum(['CORE', 'IMPORTED', 'SPENT', 'EXPIRED', 'CANCELED', 'BOOSTER']),
  "expirationDate": zod.string().datetime({}).nullish().describe('Points expiration date'),
  "createdAt": zod.string().datetime({}).describe('Points creation date'),
  "valueDate": zod.string().datetime({}).describe('Points value date')
})),
  "active": zod.boolean().describe('true if user is connected to the current workspace'),
  "phone": zod.string().max(apiUsersIdPatchResponseUserWorkspacesItemPhoneMax).nullish().describe('User phone number'),
  "registeredAt": zod.string().datetime({}).nullable().describe('User registration date'),
  "salesHierarchyDirectReportsCount": zod.number().describe('Number of sales reporting directly to this user, across every sales hierarchy they lead'),
  "loginCount": zod.number().describe('Total number of logins for this user on this workspace'),
  "loginCountPerMonth": zod.array(zod.object({
  "value": zod.number().describe('Value in this month'),
  "month": zod.number().describe('Month of the year (1-12)'),
  "year": zod.number().describe('Year')
})),
  "comment": zod.string().nullish().describe('Comment about the user'),
  "comment2": zod.string().nullish().describe('Additional customizable comment about the user'),
  "comment3": zod.string().nullish().describe('Additional customizable comment about the user'),
  "attachedCompanies": zod.array(zod.object({
  "id": zod.number().describe('Company ID'),
  "name": zod.string().max(apiUsersIdPatchResponseUserWorkspacesItemAttachedCompaniesItemNameMax).describe('Company name'),
  "uniqueCode": zod.string().max(apiUsersIdPatchResponseUserWorkspacesItemAttachedCompaniesItemUniqueCodeMax).regex(apiUsersIdPatchResponseUserWorkspacesItemAttachedCompaniesItemUniqueCodeRegExp).describe('Company unique code (SIREN or TVA or whatever)'),
  "logicStepHistory": zod.array(zod.object({
  "logicTypeStep": zod.object({
  "id": zod.number().optional().describe('Step ID'),
  "name": zod.string().max(apiUsersIdPatchResponseUserWorkspacesItemAttachedCompaniesItemLogicStepHistoryItemLogicTypeStepNameMax).describe('Step name')
}),
  "createdAt": zod.string().datetime({}).describe('Step history creation datetime')
})).optional(),
  "lastStepReached": zod.union([zod.object({
  "id": zod.number().optional().describe('Step ID'),
  "name": zod.string().max(apiUsersIdPatchResponseUserWorkspacesItemAttachedCompaniesItemLastStepReachedNameMax).describe('Step name')
}),zod.null()]).optional()
})).optional(),
  "passwordNeedToBeChanged": zod.boolean().optional()
})),
  "firstname": zod.string().max(apiUsersIdPatchResponseFirstnameMax).describe('User firstname'),
  "lastname": zod.string().max(apiUsersIdPatchResponseLastnameMax).describe('User lastname'),
  "fullname": zod.string().describe('User fullname'),
  "avatar": zod.string().max(apiUsersIdPatchResponseAvatarMax).nullish().describe('User avatar'),
  "isDeleted": zod.boolean().describe('Whether the entity has been soft-deleted')
})


/**
 * Get history for a user
 * @summary Get history for a user
 */
export const apiAdminusersIdhistoryGetCollectionParams = zod.object({
  "id": zod.string().describe('UserHistory identifier')
})

export const apiAdminusersIdhistoryGetCollectionQueryPageDefault = 1;export const apiAdminusersIdhistoryGetCollectionQueryPerPageDefault = 30;
export const apiAdminusersIdhistoryGetCollectionQueryPerPageMin = 0;
export const apiAdminusersIdhistoryGetCollectionQueryPerPageMax = 30;



export const apiAdminusersIdhistoryGetCollectionQueryParams = zod.object({
  "page": zod.number().default(apiAdminusersIdhistoryGetCollectionQueryPageDefault).describe('The collection page number'),
  "perPage": zod.number().min(apiAdminusersIdhistoryGetCollectionQueryPerPageMin).max(apiAdminusersIdhistoryGetCollectionQueryPerPageMax).default(apiAdminusersIdhistoryGetCollectionQueryPerPageDefault).describe('The number of items per page')
})

export const apiAdminusersIdhistoryGetCollectionResponseDataItemPropertyMax = 255;

export const apiAdminusersIdhistoryGetCollectionResponseDataItemCreatedAtDefault = "";export const apiAdminusersIdhistoryGetCollectionResponseDataItemMadeByUserAvatarMax = 255;



export const apiAdminusersIdhistoryGetCollectionResponse = zod.object({
  "data": zod.array(zod.unknown()),
  "pagination": zod.object({
  "first": zod.number(),
  "current": zod.number(),
  "last": zod.number(),
  "previous": zod.number(),
  "next": zod.number(),
  "totalItems": zod.number(),
  "perPage": zod.number()
})
}).and(zod.object({
  "data": zod.array(zod.object({
  "property": zod.string().max(apiAdminusersIdhistoryGetCollectionResponseDataItemPropertyMax).describe('User field that was updated'),
  "previousValue": zod.string().describe('User field old value'),
  "newValue": zod.string().describe('User field new value'),
  "createdAt": zod.string().datetime({}).describe('History creation date'),
  "madeByUser": zod.object({
  "fullname": zod.string().describe('User fullname'),
  "avatar": zod.string().max(apiAdminusersIdhistoryGetCollectionResponseDataItemMadeByUserAvatarMax).nullish().describe('User avatar'),
  "isDeleted": zod.boolean().describe('Whether the entity has been soft-deleted')
})
})).optional()
}))


/**
 * Get login history for a user
 * @summary Get login history for a user
 */
export const apiAdminusersIdloginHistoryGetCollectionParams = zod.object({
  "id": zod.string().describe('UserHistoryLogin identifier')
})

export const apiAdminusersIdloginHistoryGetCollectionQueryPageDefault = 1;export const apiAdminusersIdloginHistoryGetCollectionQueryPerPageDefault = 30;
export const apiAdminusersIdloginHistoryGetCollectionQueryPerPageMin = 0;
export const apiAdminusersIdloginHistoryGetCollectionQueryPerPageMax = 30;



export const apiAdminusersIdloginHistoryGetCollectionQueryParams = zod.object({
  "page": zod.number().default(apiAdminusersIdloginHistoryGetCollectionQueryPageDefault).describe('The collection page number'),
  "perPage": zod.number().min(apiAdminusersIdloginHistoryGetCollectionQueryPerPageMin).max(apiAdminusersIdloginHistoryGetCollectionQueryPerPageMax).default(apiAdminusersIdloginHistoryGetCollectionQueryPerPageDefault).describe('The number of items per page')
})

export const apiAdminusersIdloginHistoryGetCollectionResponse = zod.object({
  "data": zod.array(zod.unknown()),
  "pagination": zod.object({
  "first": zod.number(),
  "current": zod.number(),
  "last": zod.number(),
  "previous": zod.number(),
  "next": zod.number(),
  "totalItems": zod.number(),
  "perPage": zod.number()
})
}).and(zod.object({
  "data": zod.array(zod.object({
  "id": zod.number(),
  "connectedAt": zod.string().datetime({}).describe('Date of the connection')
})).optional()
}))


/**
 * Create a scheduled task for the current user
 * @summary Create a scheduled task for the current user
 */
export const apiAdminuserScheduledTasksPostBody = zod.object({
  "scheduledTask": zod.string().describe('Scheduled task IRI')
})


/**
 * Delete a scheduled task by id
 * @summary Delete a scheduled task by id
 */
export const apiAdminuserScheduledTasksIdDeleteParams = zod.object({
  "id": zod.string().describe('UserScheduledTask identifier')
})


/**
 * Get the list of video notices
 * @summary Get video notices collection
 */
export const apiAdminvideoNoticesGetCollectionQueryPageDefault = 1;export const apiAdminvideoNoticesGetCollectionQueryPerPageDefault = 30;
export const apiAdminvideoNoticesGetCollectionQueryPerPageMin = 0;
export const apiAdminvideoNoticesGetCollectionQueryPerPageMax = 30;



export const apiAdminvideoNoticesGetCollectionQueryParams = zod.object({
  "page": zod.number().default(apiAdminvideoNoticesGetCollectionQueryPageDefault).describe('The collection page number'),
  "perPage": zod.number().min(apiAdminvideoNoticesGetCollectionQueryPerPageMin).max(apiAdminvideoNoticesGetCollectionQueryPerPageMax).default(apiAdminvideoNoticesGetCollectionQueryPerPageDefault).describe('The number of items per page')
})

export const apiAdminvideoNoticesGetCollectionResponseDataItemTitleMax = 255;

export const apiAdminvideoNoticesGetCollectionResponseDataItemVideoUrlMax = 255;

export const apiAdminvideoNoticesGetCollectionResponseDataItemCategoryMax = 255;



export const apiAdminvideoNoticesGetCollectionResponse = zod.object({
  "data": zod.array(zod.unknown()),
  "pagination": zod.object({
  "first": zod.number(),
  "current": zod.number(),
  "last": zod.number(),
  "previous": zod.number(),
  "next": zod.number(),
  "totalItems": zod.number(),
  "perPage": zod.number()
})
}).and(zod.object({
  "data": zod.array(zod.object({
  "id": zod.number().describe('VideoNotice ID'),
  "title": zod.string().max(apiAdminvideoNoticesGetCollectionResponseDataItemTitleMax).describe('Title of the video notice'),
  "description": zod.string().nullish().describe('Description of the video notice'),
  "videoUrl": zod.string().url().max(apiAdminvideoNoticesGetCollectionResponseDataItemVideoUrlMax).describe('Link to the video'),
  "category": zod.string().max(apiAdminvideoNoticesGetCollectionResponseDataItemCategoryMax).nullish().describe('Category (tag) of the video notice'),
  "createdAt": zod.string().datetime({}).describe('Creation date of the video notice'),
  "updatedAt": zod.string().datetime({}).describe('Last update date of the video notice')
})).optional()
}))


/**
 * Create a video notice
 * @summary Create a video notice
 */
export const apiAdminvideoNoticesPostBodyTitleMax = 255;

export const apiAdminvideoNoticesPostBodyVideoUrlMax = 255;

export const apiAdminvideoNoticesPostBodyCategoryMax = 255;



export const apiAdminvideoNoticesPostBody = zod.object({
  "title": zod.string().max(apiAdminvideoNoticesPostBodyTitleMax).describe('Title of the video notice'),
  "description": zod.string().nullish().describe('Description of the video notice'),
  "videoUrl": zod.string().url().max(apiAdminvideoNoticesPostBodyVideoUrlMax).describe('Link to the video'),
  "category": zod.string().max(apiAdminvideoNoticesPostBodyCategoryMax).nullish().describe('Category (tag) of the video notice')
})


/**
 * Get a video notice by ID
 * @summary Get a video notice by ID
 */
export const apiAdminvideoNoticesIdGetParams = zod.object({
  "id": zod.string().describe('VideoNotice identifier')
})

export const apiAdminvideoNoticesIdGetResponseTitleMax = 255;

export const apiAdminvideoNoticesIdGetResponseVideoUrlMax = 255;

export const apiAdminvideoNoticesIdGetResponseCategoryMax = 255;



export const apiAdminvideoNoticesIdGetResponse = zod.object({
  "id": zod.number().describe('VideoNotice ID'),
  "title": zod.string().max(apiAdminvideoNoticesIdGetResponseTitleMax).describe('Title of the video notice'),
  "description": zod.string().nullish().describe('Description of the video notice'),
  "videoUrl": zod.string().url().max(apiAdminvideoNoticesIdGetResponseVideoUrlMax).describe('Link to the video'),
  "category": zod.string().max(apiAdminvideoNoticesIdGetResponseCategoryMax).nullish().describe('Category (tag) of the video notice'),
  "createdAt": zod.string().datetime({}).describe('Creation date of the video notice'),
  "updatedAt": zod.string().datetime({}).describe('Last update date of the video notice')
})


/**
 * Delete a video notice
 * @summary Delete a video notice
 */
export const apiAdminvideoNoticesIdDeleteParams = zod.object({
  "id": zod.string().describe('VideoNotice identifier')
})


/**
 * Update a video notice's title, description, video link and/or category
 * @summary Update a video notice
 */
export const apiAdminvideoNoticesIdPatchParams = zod.object({
  "id": zod.string().describe('VideoNotice identifier')
})

export const apiAdminvideoNoticesIdPatchBodyTitleMax = 255;

export const apiAdminvideoNoticesIdPatchBodyVideoUrlMax = 255;

export const apiAdminvideoNoticesIdPatchBodyCategoryMax = 255;



export const apiAdminvideoNoticesIdPatchBody = zod.object({
  "title": zod.string().max(apiAdminvideoNoticesIdPatchBodyTitleMax).optional().describe('Title of the video notice'),
  "description": zod.string().nullish().describe('Description of the video notice'),
  "videoUrl": zod.string().url().max(apiAdminvideoNoticesIdPatchBodyVideoUrlMax).optional().describe('Link to the video'),
  "category": zod.string().max(apiAdminvideoNoticesIdPatchBodyCategoryMax).nullish().describe('Category (tag) of the video notice')
})

export const apiAdminvideoNoticesIdPatchResponseTitleMax = 255;

export const apiAdminvideoNoticesIdPatchResponseVideoUrlMax = 255;

export const apiAdminvideoNoticesIdPatchResponseCategoryMax = 255;



export const apiAdminvideoNoticesIdPatchResponse = zod.object({
  "id": zod.number().describe('VideoNotice ID'),
  "title": zod.string().max(apiAdminvideoNoticesIdPatchResponseTitleMax).describe('Title of the video notice'),
  "description": zod.string().nullish().describe('Description of the video notice'),
  "videoUrl": zod.string().url().max(apiAdminvideoNoticesIdPatchResponseVideoUrlMax).describe('Link to the video'),
  "category": zod.string().max(apiAdminvideoNoticesIdPatchResponseCategoryMax).nullish().describe('Category (tag) of the video notice'),
  "createdAt": zod.string().datetime({}).describe('Creation date of the video notice'),
  "updatedAt": zod.string().datetime({}).describe('Last update date of the video notice')
})


/**
 * Retrieves the collection of WaitingList resources.
 * @summary Retrieves the collection of WaitingList resources.
 */
export const apiAdminwaitingListsGetCollectionQueryPageDefault = 1;export const apiAdminwaitingListsGetCollectionQueryPerPageDefault = 30;
export const apiAdminwaitingListsGetCollectionQueryPerPageMin = 0;
export const apiAdminwaitingListsGetCollectionQueryPerPageMax = 30;

export const apiAdminwaitingListsGetCollectionQueryOrderCreatedAtDefault = "asc";

export const apiAdminwaitingListsGetCollectionQueryParams = zod.object({
  "page": zod.number().default(apiAdminwaitingListsGetCollectionQueryPageDefault).describe('The collection page number'),
  "perPage": zod.number().min(apiAdminwaitingListsGetCollectionQueryPerPageMin).max(apiAdminwaitingListsGetCollectionQueryPerPageMax).default(apiAdminwaitingListsGetCollectionQueryPerPageDefault).describe('The number of items per page'),
  "email": zod.string().optional(),
  "firstname": zod.string().optional(),
  "lastname": zod.string().optional(),
  "companyName": zod.string().optional(),
  "createdBy.uniqueCode": zod.string().optional(),
  "status": zod.string().optional(),
  "status[]": zod.array(zod.string()).optional(),
  "createdAt[before]": zod.string().optional(),
  "createdAt[strictly_before]": zod.string().optional(),
  "createdAt[after]": zod.string().optional(),
  "createdAt[strictly_after]": zod.string().optional(),
  "order[createdAt]": zod.enum(['asc', 'desc']).default(apiAdminwaitingListsGetCollectionQueryOrderCreatedAtDefault)
})

export const apiAdminwaitingListsGetCollectionResponseDataItemCompanyNameMax = 100;

export const apiAdminwaitingListsGetCollectionResponseDataItemCompanyUniqueCodeMax = 50;

export const apiAdminwaitingListsGetCollectionResponseDataItemAddressLine1Max = 255;

export const apiAdminwaitingListsGetCollectionResponseDataItemAddressLine2Max = 255;

export const apiAdminwaitingListsGetCollectionResponseDataItemAddressLine3Max = 255;

export const apiAdminwaitingListsGetCollectionResponseDataItemZipcodeMax = 20;

export const apiAdminwaitingListsGetCollectionResponseDataItemCityMax = 100;

export const apiAdminwaitingListsGetCollectionResponseDataItemCountryAlpha3Min = 3;
export const apiAdminwaitingListsGetCollectionResponseDataItemCountryAlpha3Max = 3;

export const apiAdminwaitingListsGetCollectionResponseDataItemSirenMax = 9;

export const apiAdminwaitingListsGetCollectionResponseDataItemTvaMax = 20;

export const apiAdminwaitingListsGetCollectionResponseDataItemResponsibleUserAvatarMax = 255;

export const apiAdminwaitingListsGetCollectionResponseDataItemTypologyNameMax = 100;

export const apiAdminwaitingListsGetCollectionResponseDataItemPointCoeffMin = 0;

export const apiAdminwaitingListsGetCollectionResponseDataItemEmailMax = 255;

export const apiAdminwaitingListsGetCollectionResponseDataItemFirstnameMax = 50;

export const apiAdminwaitingListsGetCollectionResponseDataItemLastnameMax = 50;

export const apiAdminwaitingListsGetCollectionResponseDataItemUserUniqueCodeMax = 50;

export const apiAdminwaitingListsGetCollectionResponseDataItemRoleMax = 50;

export const apiAdminwaitingListsGetCollectionResponseDataItemStatusMax = 30;

export const apiAdminwaitingListsGetCollectionResponseDataItemCreatedByUserAvatarMax = 255;



export const apiAdminwaitingListsGetCollectionResponse = zod.object({
  "data": zod.array(zod.unknown()),
  "pagination": zod.object({
  "first": zod.number(),
  "current": zod.number(),
  "last": zod.number(),
  "previous": zod.number(),
  "next": zod.number(),
  "totalItems": zod.number(),
  "perPage": zod.number()
})
}).and(zod.object({
  "data": zod.array(zod.object({
  "id": zod.number().describe('WaitingList ID'),
  "companyName": zod.string().max(apiAdminwaitingListsGetCollectionResponseDataItemCompanyNameMax).nullish().describe('Company name'),
  "companyUniqueCode": zod.string().max(apiAdminwaitingListsGetCollectionResponseDataItemCompanyUniqueCodeMax).nullish().describe('Company unique code (SIREN or TVA or whatever)'),
  "addressLine1": zod.string().max(apiAdminwaitingListsGetCollectionResponseDataItemAddressLine1Max).nullish().describe('Company address line 1'),
  "addressLine2": zod.string().max(apiAdminwaitingListsGetCollectionResponseDataItemAddressLine2Max).nullish().describe('Company address line 2'),
  "addressLine3": zod.string().max(apiAdminwaitingListsGetCollectionResponseDataItemAddressLine3Max).nullish().describe('Company address line 3'),
  "zipcode": zod.string().max(apiAdminwaitingListsGetCollectionResponseDataItemZipcodeMax).nullish().describe('Company zipcode'),
  "city": zod.string().max(apiAdminwaitingListsGetCollectionResponseDataItemCityMax).nullish().describe('Company city'),
  "createdAt": zod.string().datetime({}).describe('Company creation date'),
  "country": zod.union([zod.object({
  "alpha3": zod.string().min(apiAdminwaitingListsGetCollectionResponseDataItemCountryAlpha3Min).max(apiAdminwaitingListsGetCollectionResponseDataItemCountryAlpha3Max).describe('Country alpha3 code'),
  "name": zod.string().describe('Country name')
}),zod.null()]).optional(),
  "siren": zod.string().max(apiAdminwaitingListsGetCollectionResponseDataItemSirenMax).nullish().describe('Company SIREN'),
  "tva": zod.string().max(apiAdminwaitingListsGetCollectionResponseDataItemTvaMax).nullish().describe('Company TVA'),
  "responsible": zod.union([zod.object({
  "user": zod.object({
  "id": zod.number().describe('User ID'),
  "fullname": zod.string().describe('User fullname'),
  "avatar": zod.string().max(apiAdminwaitingListsGetCollectionResponseDataItemResponsibleUserAvatarMax).nullish().describe('User avatar'),
  "isDeleted": zod.boolean().describe('Whether the entity has been soft-deleted')
})
}),zod.null()]).optional(),
  "typology": zod.union([zod.object({
  "name": zod.string().max(apiAdminwaitingListsGetCollectionResponseDataItemTypologyNameMax).describe('Name of the typology')
}),zod.null()]).optional(),
  "pointCoeff": zod.number().min(apiAdminwaitingListsGetCollectionResponseDataItemPointCoeffMin).nullish().describe('Coefficient used to calculate points (depending conversion type)'),
  "email": zod.string().email().max(apiAdminwaitingListsGetCollectionResponseDataItemEmailMax).nullish().describe('User email'),
  "firstname": zod.string().max(apiAdminwaitingListsGetCollectionResponseDataItemFirstnameMax).nullish().describe('User firstname'),
  "lastname": zod.string().max(apiAdminwaitingListsGetCollectionResponseDataItemLastnameMax).nullish().describe('User lastname'),
  "userUniqueCode": zod.string().max(apiAdminwaitingListsGetCollectionResponseDataItemUserUniqueCodeMax).nullish().describe('User unique code'),
  "role": zod.enum(['ROLE_MEMBER', 'ROLE_MANAGER']).nullish().describe('User role, front user role accepted'),
  "comment": zod.string().nullish().describe('Comment about the company in waiting list'),
  "status": zod.enum(['waiting.list.status.pending', 'waiting.list.status.approved', 'waiting.list.status.rejected']).describe('Waiting list status'),
  "createdBy": zod.object({
  "user": zod.object({
  "id": zod.number().describe('User ID'),
  "fullname": zod.string().describe('User fullname'),
  "avatar": zod.string().max(apiAdminwaitingListsGetCollectionResponseDataItemCreatedByUserAvatarMax).nullish().describe('User avatar'),
  "isDeleted": zod.boolean().describe('Whether the entity has been soft-deleted')
})
})
})).optional()
}))


/**
 * Create a new company in waiting list
 * @summary Create a new company in waiting list
 */
export const apiAdminwaitingListsPostBodyCompanyNameMax = 100;

export const apiAdminwaitingListsPostBodyCompanyUniqueCodeMax = 50;

export const apiAdminwaitingListsPostBodyAddressLine1Max = 255;

export const apiAdminwaitingListsPostBodyAddressLine2Max = 255;

export const apiAdminwaitingListsPostBodyAddressLine3Max = 255;

export const apiAdminwaitingListsPostBodyZipcodeMax = 20;

export const apiAdminwaitingListsPostBodyCityMax = 100;

export const apiAdminwaitingListsPostBodySirenMax = 9;

export const apiAdminwaitingListsPostBodyTvaMax = 20;

export const apiAdminwaitingListsPostBodyPointCoeffMin = 0;

export const apiAdminwaitingListsPostBodyEmailMax = 255;

export const apiAdminwaitingListsPostBodyFirstnameMax = 50;

export const apiAdminwaitingListsPostBodyLastnameMax = 50;

export const apiAdminwaitingListsPostBodyUserUniqueCodeMax = 50;

export const apiAdminwaitingListsPostBodyRoleMax = 50;



export const apiAdminwaitingListsPostBody = zod.object({
  "companyName": zod.string().max(apiAdminwaitingListsPostBodyCompanyNameMax).nullish().describe('Company name'),
  "companyUniqueCode": zod.string().max(apiAdminwaitingListsPostBodyCompanyUniqueCodeMax).nullish().describe('Company unique code (SIREN or TVA or whatever)'),
  "addressLine1": zod.string().max(apiAdminwaitingListsPostBodyAddressLine1Max).nullish().describe('Company address line 1'),
  "addressLine2": zod.string().max(apiAdminwaitingListsPostBodyAddressLine2Max).nullish().describe('Company address line 2'),
  "addressLine3": zod.string().max(apiAdminwaitingListsPostBodyAddressLine3Max).nullish().describe('Company address line 3'),
  "zipcode": zod.string().max(apiAdminwaitingListsPostBodyZipcodeMax).nullish().describe('Company zipcode'),
  "city": zod.string().max(apiAdminwaitingListsPostBodyCityMax).nullish().describe('Company city'),
  "country": zod.string().nullish().describe('Company country'),
  "siren": zod.string().max(apiAdminwaitingListsPostBodySirenMax).nullish().describe('Company SIREN'),
  "tva": zod.string().max(apiAdminwaitingListsPostBodyTvaMax).nullish().describe('Company TVA'),
  "responsible": zod.string().nullish().describe('Responsible linked to the company'),
  "typology": zod.string().nullish().describe('Company typology'),
  "pointCoeff": zod.number().min(apiAdminwaitingListsPostBodyPointCoeffMin).nullish().describe('Coefficient used to calculate points (depending conversion type)'),
  "email": zod.string().email().max(apiAdminwaitingListsPostBodyEmailMax).nullish().describe('User email'),
  "firstname": zod.string().max(apiAdminwaitingListsPostBodyFirstnameMax).nullish().describe('User firstname'),
  "lastname": zod.string().max(apiAdminwaitingListsPostBodyLastnameMax).nullish().describe('User lastname'),
  "userUniqueCode": zod.string().max(apiAdminwaitingListsPostBodyUserUniqueCodeMax).nullish().describe('User unique code'),
  "role": zod.enum(['ROLE_MEMBER', 'ROLE_MANAGER']).nullish().describe('User role, front user role accepted'),
  "comment": zod.string().nullish().describe('Comment about the company in waiting list')
})


/**
 * Retrieves a WaitingList resource.
 * @summary Retrieves a WaitingList resource.
 */
export const apiAdminwaitingListsIdGetParams = zod.object({
  "id": zod.string().describe('WaitingList identifier')
})

export const apiAdminwaitingListsIdGetResponseCompanyNameMax = 100;

export const apiAdminwaitingListsIdGetResponseCompanyUniqueCodeMax = 50;

export const apiAdminwaitingListsIdGetResponseAddressLine1Max = 255;

export const apiAdminwaitingListsIdGetResponseAddressLine2Max = 255;

export const apiAdminwaitingListsIdGetResponseAddressLine3Max = 255;

export const apiAdminwaitingListsIdGetResponseZipcodeMax = 20;

export const apiAdminwaitingListsIdGetResponseCityMax = 100;

export const apiAdminwaitingListsIdGetResponseCountryAlpha3Min = 3;
export const apiAdminwaitingListsIdGetResponseCountryAlpha3Max = 3;

export const apiAdminwaitingListsIdGetResponseSirenMax = 9;

export const apiAdminwaitingListsIdGetResponseTvaMax = 20;

export const apiAdminwaitingListsIdGetResponseResponsibleUserAvatarMax = 255;

export const apiAdminwaitingListsIdGetResponseTypologyNameMax = 100;

export const apiAdminwaitingListsIdGetResponsePointCoeffMin = 0;

export const apiAdminwaitingListsIdGetResponseEmailMax = 255;

export const apiAdminwaitingListsIdGetResponseFirstnameMax = 50;

export const apiAdminwaitingListsIdGetResponseLastnameMax = 50;

export const apiAdminwaitingListsIdGetResponseUserUniqueCodeMax = 50;

export const apiAdminwaitingListsIdGetResponseRoleMax = 50;

export const apiAdminwaitingListsIdGetResponseStatusMax = 30;

export const apiAdminwaitingListsIdGetResponseCreatedByUserAvatarMax = 255;



export const apiAdminwaitingListsIdGetResponse = zod.object({
  "id": zod.number().describe('WaitingList ID'),
  "companyName": zod.string().max(apiAdminwaitingListsIdGetResponseCompanyNameMax).nullish().describe('Company name'),
  "companyUniqueCode": zod.string().max(apiAdminwaitingListsIdGetResponseCompanyUniqueCodeMax).nullish().describe('Company unique code (SIREN or TVA or whatever)'),
  "addressLine1": zod.string().max(apiAdminwaitingListsIdGetResponseAddressLine1Max).nullish().describe('Company address line 1'),
  "addressLine2": zod.string().max(apiAdminwaitingListsIdGetResponseAddressLine2Max).nullish().describe('Company address line 2'),
  "addressLine3": zod.string().max(apiAdminwaitingListsIdGetResponseAddressLine3Max).nullish().describe('Company address line 3'),
  "zipcode": zod.string().max(apiAdminwaitingListsIdGetResponseZipcodeMax).nullish().describe('Company zipcode'),
  "city": zod.string().max(apiAdminwaitingListsIdGetResponseCityMax).nullish().describe('Company city'),
  "createdAt": zod.string().datetime({}).describe('Company creation date'),
  "country": zod.union([zod.object({
  "alpha3": zod.string().min(apiAdminwaitingListsIdGetResponseCountryAlpha3Min).max(apiAdminwaitingListsIdGetResponseCountryAlpha3Max).describe('Country alpha3 code'),
  "name": zod.string().describe('Country name')
}),zod.null()]).optional(),
  "siren": zod.string().max(apiAdminwaitingListsIdGetResponseSirenMax).nullish().describe('Company SIREN'),
  "tva": zod.string().max(apiAdminwaitingListsIdGetResponseTvaMax).nullish().describe('Company TVA'),
  "responsible": zod.union([zod.object({
  "user": zod.object({
  "id": zod.number().describe('User ID'),
  "fullname": zod.string().describe('User fullname'),
  "avatar": zod.string().max(apiAdminwaitingListsIdGetResponseResponsibleUserAvatarMax).nullish().describe('User avatar'),
  "isDeleted": zod.boolean().describe('Whether the entity has been soft-deleted')
})
}),zod.null()]).optional(),
  "typology": zod.union([zod.object({
  "name": zod.string().max(apiAdminwaitingListsIdGetResponseTypologyNameMax).describe('Name of the typology')
}),zod.null()]).optional(),
  "pointCoeff": zod.number().min(apiAdminwaitingListsIdGetResponsePointCoeffMin).nullish().describe('Coefficient used to calculate points (depending conversion type)'),
  "email": zod.string().email().max(apiAdminwaitingListsIdGetResponseEmailMax).nullish().describe('User email'),
  "firstname": zod.string().max(apiAdminwaitingListsIdGetResponseFirstnameMax).nullish().describe('User firstname'),
  "lastname": zod.string().max(apiAdminwaitingListsIdGetResponseLastnameMax).nullish().describe('User lastname'),
  "userUniqueCode": zod.string().max(apiAdminwaitingListsIdGetResponseUserUniqueCodeMax).nullish().describe('User unique code'),
  "role": zod.enum(['ROLE_MEMBER', 'ROLE_MANAGER']).nullish().describe('User role, front user role accepted'),
  "comment": zod.string().nullish().describe('Comment about the company in waiting list'),
  "status": zod.enum(['waiting.list.status.pending', 'waiting.list.status.approved', 'waiting.list.status.rejected']).describe('Waiting list status'),
  "createdBy": zod.object({
  "user": zod.object({
  "id": zod.number().describe('User ID'),
  "fullname": zod.string().describe('User fullname'),
  "avatar": zod.string().max(apiAdminwaitingListsIdGetResponseCreatedByUserAvatarMax).nullish().describe('User avatar'),
  "isDeleted": zod.boolean().describe('Whether the entity has been soft-deleted')
})
})
})


/**
 * Updates the WaitingList resource.
 * @summary Updates the WaitingList resource.
 */
export const apiAdminwaitingListsIdPatchParams = zod.object({
  "id": zod.string().describe('WaitingList identifier')
})

export const apiAdminwaitingListsIdPatchBodyCompanyNameMax = 100;

export const apiAdminwaitingListsIdPatchBodyCompanyUniqueCodeMax = 50;

export const apiAdminwaitingListsIdPatchBodyAddressLine1Max = 255;

export const apiAdminwaitingListsIdPatchBodyAddressLine2Max = 255;

export const apiAdminwaitingListsIdPatchBodyAddressLine3Max = 255;

export const apiAdminwaitingListsIdPatchBodyZipcodeMax = 20;

export const apiAdminwaitingListsIdPatchBodyCityMax = 100;

export const apiAdminwaitingListsIdPatchBodySirenMax = 9;

export const apiAdminwaitingListsIdPatchBodyTvaMax = 20;

export const apiAdminwaitingListsIdPatchBodyPointCoeffMin = 0;

export const apiAdminwaitingListsIdPatchBodyEmailMax = 255;

export const apiAdminwaitingListsIdPatchBodyFirstnameMax = 50;

export const apiAdminwaitingListsIdPatchBodyLastnameMax = 50;

export const apiAdminwaitingListsIdPatchBodyUserUniqueCodeMax = 50;

export const apiAdminwaitingListsIdPatchBodyRoleMax = 50;



export const apiAdminwaitingListsIdPatchBody = zod.object({
  "companyName": zod.string().max(apiAdminwaitingListsIdPatchBodyCompanyNameMax).nullish().describe('Company name'),
  "companyUniqueCode": zod.string().max(apiAdminwaitingListsIdPatchBodyCompanyUniqueCodeMax).nullish().describe('Company unique code (SIREN or TVA or whatever)'),
  "addressLine1": zod.string().max(apiAdminwaitingListsIdPatchBodyAddressLine1Max).nullish().describe('Company address line 1'),
  "addressLine2": zod.string().max(apiAdminwaitingListsIdPatchBodyAddressLine2Max).nullish().describe('Company address line 2'),
  "addressLine3": zod.string().max(apiAdminwaitingListsIdPatchBodyAddressLine3Max).nullish().describe('Company address line 3'),
  "zipcode": zod.string().max(apiAdminwaitingListsIdPatchBodyZipcodeMax).nullish().describe('Company zipcode'),
  "city": zod.string().max(apiAdminwaitingListsIdPatchBodyCityMax).nullish().describe('Company city'),
  "country": zod.string().nullish().describe('Company country'),
  "siren": zod.string().max(apiAdminwaitingListsIdPatchBodySirenMax).nullish().describe('Company SIREN'),
  "tva": zod.string().max(apiAdminwaitingListsIdPatchBodyTvaMax).nullish().describe('Company TVA'),
  "responsible": zod.string().nullish().describe('Responsible linked to the company'),
  "typology": zod.string().nullish().describe('Company typology'),
  "pointCoeff": zod.number().min(apiAdminwaitingListsIdPatchBodyPointCoeffMin).nullish().describe('Coefficient used to calculate points (depending conversion type)'),
  "email": zod.string().email().max(apiAdminwaitingListsIdPatchBodyEmailMax).nullish().describe('User email'),
  "firstname": zod.string().max(apiAdminwaitingListsIdPatchBodyFirstnameMax).nullish().describe('User firstname'),
  "lastname": zod.string().max(apiAdminwaitingListsIdPatchBodyLastnameMax).nullish().describe('User lastname'),
  "userUniqueCode": zod.string().max(apiAdminwaitingListsIdPatchBodyUserUniqueCodeMax).nullish().describe('User unique code'),
  "role": zod.enum(['ROLE_MEMBER', 'ROLE_MANAGER']).nullish().describe('User role, front user role accepted'),
  "comment": zod.string().nullish().describe('Comment about the company in waiting list')
})

export const apiAdminwaitingListsIdPatchResponseCompanyNameMax = 100;

export const apiAdminwaitingListsIdPatchResponseCompanyUniqueCodeMax = 50;

export const apiAdminwaitingListsIdPatchResponseAddressLine1Max = 255;

export const apiAdminwaitingListsIdPatchResponseAddressLine2Max = 255;

export const apiAdminwaitingListsIdPatchResponseAddressLine3Max = 255;

export const apiAdminwaitingListsIdPatchResponseZipcodeMax = 20;

export const apiAdminwaitingListsIdPatchResponseCityMax = 100;

export const apiAdminwaitingListsIdPatchResponseCountryAlpha3Min = 3;
export const apiAdminwaitingListsIdPatchResponseCountryAlpha3Max = 3;

export const apiAdminwaitingListsIdPatchResponseSirenMax = 9;

export const apiAdminwaitingListsIdPatchResponseTvaMax = 20;

export const apiAdminwaitingListsIdPatchResponseResponsibleUserAvatarMax = 255;

export const apiAdminwaitingListsIdPatchResponseTypologyNameMax = 100;

export const apiAdminwaitingListsIdPatchResponsePointCoeffMin = 0;

export const apiAdminwaitingListsIdPatchResponseEmailMax = 255;

export const apiAdminwaitingListsIdPatchResponseFirstnameMax = 50;

export const apiAdminwaitingListsIdPatchResponseLastnameMax = 50;

export const apiAdminwaitingListsIdPatchResponseUserUniqueCodeMax = 50;

export const apiAdminwaitingListsIdPatchResponseRoleMax = 50;

export const apiAdminwaitingListsIdPatchResponseStatusMax = 30;

export const apiAdminwaitingListsIdPatchResponseCreatedByUserAvatarMax = 255;



export const apiAdminwaitingListsIdPatchResponse = zod.object({
  "id": zod.number().describe('WaitingList ID'),
  "companyName": zod.string().max(apiAdminwaitingListsIdPatchResponseCompanyNameMax).nullish().describe('Company name'),
  "companyUniqueCode": zod.string().max(apiAdminwaitingListsIdPatchResponseCompanyUniqueCodeMax).nullish().describe('Company unique code (SIREN or TVA or whatever)'),
  "addressLine1": zod.string().max(apiAdminwaitingListsIdPatchResponseAddressLine1Max).nullish().describe('Company address line 1'),
  "addressLine2": zod.string().max(apiAdminwaitingListsIdPatchResponseAddressLine2Max).nullish().describe('Company address line 2'),
  "addressLine3": zod.string().max(apiAdminwaitingListsIdPatchResponseAddressLine3Max).nullish().describe('Company address line 3'),
  "zipcode": zod.string().max(apiAdminwaitingListsIdPatchResponseZipcodeMax).nullish().describe('Company zipcode'),
  "city": zod.string().max(apiAdminwaitingListsIdPatchResponseCityMax).nullish().describe('Company city'),
  "createdAt": zod.string().datetime({}).describe('Company creation date'),
  "country": zod.union([zod.object({
  "alpha3": zod.string().min(apiAdminwaitingListsIdPatchResponseCountryAlpha3Min).max(apiAdminwaitingListsIdPatchResponseCountryAlpha3Max).describe('Country alpha3 code'),
  "name": zod.string().describe('Country name')
}),zod.null()]).optional(),
  "siren": zod.string().max(apiAdminwaitingListsIdPatchResponseSirenMax).nullish().describe('Company SIREN'),
  "tva": zod.string().max(apiAdminwaitingListsIdPatchResponseTvaMax).nullish().describe('Company TVA'),
  "responsible": zod.union([zod.object({
  "user": zod.object({
  "id": zod.number().describe('User ID'),
  "fullname": zod.string().describe('User fullname'),
  "avatar": zod.string().max(apiAdminwaitingListsIdPatchResponseResponsibleUserAvatarMax).nullish().describe('User avatar'),
  "isDeleted": zod.boolean().describe('Whether the entity has been soft-deleted')
})
}),zod.null()]).optional(),
  "typology": zod.union([zod.object({
  "name": zod.string().max(apiAdminwaitingListsIdPatchResponseTypologyNameMax).describe('Name of the typology')
}),zod.null()]).optional(),
  "pointCoeff": zod.number().min(apiAdminwaitingListsIdPatchResponsePointCoeffMin).nullish().describe('Coefficient used to calculate points (depending conversion type)'),
  "email": zod.string().email().max(apiAdminwaitingListsIdPatchResponseEmailMax).nullish().describe('User email'),
  "firstname": zod.string().max(apiAdminwaitingListsIdPatchResponseFirstnameMax).nullish().describe('User firstname'),
  "lastname": zod.string().max(apiAdminwaitingListsIdPatchResponseLastnameMax).nullish().describe('User lastname'),
  "userUniqueCode": zod.string().max(apiAdminwaitingListsIdPatchResponseUserUniqueCodeMax).nullish().describe('User unique code'),
  "role": zod.enum(['ROLE_MEMBER', 'ROLE_MANAGER']).nullish().describe('User role, front user role accepted'),
  "comment": zod.string().nullish().describe('Comment about the company in waiting list'),
  "status": zod.enum(['waiting.list.status.pending', 'waiting.list.status.approved', 'waiting.list.status.rejected']).describe('Waiting list status'),
  "createdBy": zod.object({
  "user": zod.object({
  "id": zod.number().describe('User ID'),
  "fullname": zod.string().describe('User fullname'),
  "avatar": zod.string().max(apiAdminwaitingListsIdPatchResponseCreatedByUserAvatarMax).nullish().describe('User avatar'),
  "isDeleted": zod.boolean().describe('Whether the entity has been soft-deleted')
})
})
})


/**
 * Accept or reject a waiting list
 * @summary Accept or reject a waiting list
 */
export const submitWaitingListParams = zod.object({
  "id": zod.string().describe('WaitingList identifier')
})

export const submitWaitingListBodyStatusMax = 30;

export const submitWaitingListBodyEmailNotificationDefault = true;

export const submitWaitingListBody = zod.object({
  "status": zod.enum(['waiting.list.status.pending', 'waiting.list.status.approved', 'waiting.list.status.rejected']).optional().describe('Waiting list status'),
  "emailNotification": zod.boolean().default(submitWaitingListBodyEmailNotificationDefault).describe('Send the welcome email to the created user (used when status is approved)')
})

export const submitWaitingListResponseCompanyNameMax = 100;

export const submitWaitingListResponseCompanyUniqueCodeMax = 50;

export const submitWaitingListResponseAddressLine1Max = 255;

export const submitWaitingListResponseAddressLine2Max = 255;

export const submitWaitingListResponseAddressLine3Max = 255;

export const submitWaitingListResponseZipcodeMax = 20;

export const submitWaitingListResponseCityMax = 100;

export const submitWaitingListResponseCountryAlpha3Min = 3;
export const submitWaitingListResponseCountryAlpha3Max = 3;

export const submitWaitingListResponseSirenMax = 9;

export const submitWaitingListResponseTvaMax = 20;

export const submitWaitingListResponseResponsibleUserAvatarMax = 255;

export const submitWaitingListResponseTypologyNameMax = 100;

export const submitWaitingListResponsePointCoeffMin = 0;

export const submitWaitingListResponseEmailMax = 255;

export const submitWaitingListResponseFirstnameMax = 50;

export const submitWaitingListResponseLastnameMax = 50;

export const submitWaitingListResponseUserUniqueCodeMax = 50;

export const submitWaitingListResponseRoleMax = 50;

export const submitWaitingListResponseStatusMax = 30;

export const submitWaitingListResponseCreatedByUserAvatarMax = 255;



export const submitWaitingListResponse = zod.object({
  "id": zod.number().describe('WaitingList ID'),
  "companyName": zod.string().max(submitWaitingListResponseCompanyNameMax).nullish().describe('Company name'),
  "companyUniqueCode": zod.string().max(submitWaitingListResponseCompanyUniqueCodeMax).nullish().describe('Company unique code (SIREN or TVA or whatever)'),
  "addressLine1": zod.string().max(submitWaitingListResponseAddressLine1Max).nullish().describe('Company address line 1'),
  "addressLine2": zod.string().max(submitWaitingListResponseAddressLine2Max).nullish().describe('Company address line 2'),
  "addressLine3": zod.string().max(submitWaitingListResponseAddressLine3Max).nullish().describe('Company address line 3'),
  "zipcode": zod.string().max(submitWaitingListResponseZipcodeMax).nullish().describe('Company zipcode'),
  "city": zod.string().max(submitWaitingListResponseCityMax).nullish().describe('Company city'),
  "createdAt": zod.string().datetime({}).describe('Company creation date'),
  "country": zod.union([zod.object({
  "alpha3": zod.string().min(submitWaitingListResponseCountryAlpha3Min).max(submitWaitingListResponseCountryAlpha3Max).describe('Country alpha3 code'),
  "name": zod.string().describe('Country name')
}),zod.null()]).optional(),
  "siren": zod.string().max(submitWaitingListResponseSirenMax).nullish().describe('Company SIREN'),
  "tva": zod.string().max(submitWaitingListResponseTvaMax).nullish().describe('Company TVA'),
  "responsible": zod.union([zod.object({
  "user": zod.object({
  "id": zod.number().describe('User ID'),
  "fullname": zod.string().describe('User fullname'),
  "avatar": zod.string().max(submitWaitingListResponseResponsibleUserAvatarMax).nullish().describe('User avatar'),
  "isDeleted": zod.boolean().describe('Whether the entity has been soft-deleted')
})
}),zod.null()]).optional(),
  "typology": zod.union([zod.object({
  "name": zod.string().max(submitWaitingListResponseTypologyNameMax).describe('Name of the typology')
}),zod.null()]).optional(),
  "pointCoeff": zod.number().min(submitWaitingListResponsePointCoeffMin).nullish().describe('Coefficient used to calculate points (depending conversion type)'),
  "email": zod.string().email().max(submitWaitingListResponseEmailMax).nullish().describe('User email'),
  "firstname": zod.string().max(submitWaitingListResponseFirstnameMax).nullish().describe('User firstname'),
  "lastname": zod.string().max(submitWaitingListResponseLastnameMax).nullish().describe('User lastname'),
  "userUniqueCode": zod.string().max(submitWaitingListResponseUserUniqueCodeMax).nullish().describe('User unique code'),
  "role": zod.enum(['ROLE_MEMBER', 'ROLE_MANAGER']).nullish().describe('User role, front user role accepted'),
  "comment": zod.string().nullish().describe('Comment about the company in waiting list'),
  "status": zod.enum(['waiting.list.status.pending', 'waiting.list.status.approved', 'waiting.list.status.rejected']).describe('Waiting list status'),
  "createdBy": zod.object({
  "user": zod.object({
  "id": zod.number().describe('User ID'),
  "fullname": zod.string().describe('User fullname'),
  "avatar": zod.string().max(submitWaitingListResponseCreatedByUserAvatarMax).nullish().describe('User avatar'),
  "isDeleted": zod.boolean().describe('Whether the entity has been soft-deleted')
})
})
})


/**
 * Retrieves the collection of Widget resources.
 * @summary Retrieves the collection of Widget resources.
 */
export const apiAdminwidgetsGetCollectionResponseLabelMax = 50;

export const apiAdminwidgetsGetCollectionResponseKeyMax = 50;

export const apiAdminwidgetsGetCollectionResponseItemDefinitionsItemItemKeyMax = 100;

export const apiAdminwidgetsGetCollectionResponseItemDefinitionsItemItemTypeMax = 20;

export const apiAdminwidgetsGetCollectionResponseItemDefinitionsItemMaxLengthMax = 255;

export const apiAdminwidgetsGetCollectionResponseItemDefinitionsItemItemLabelMax = 255;

export const apiAdminwidgetsGetCollectionResponseItemDefinitionsItemItemDescriptionMax = 255;

export const apiAdminwidgetsGetCollectionResponseItemDefinitionsItemItemPlaceholderMax = 50;



export const apiAdminwidgetsGetCollectionResponseItem = zod.object({
  "id": zod.number().describe('WidgetConfig ID'),
  "label": zod.string().max(apiAdminwidgetsGetCollectionResponseLabelMax).describe('Widget label'),
  "key": zod.string().max(apiAdminwidgetsGetCollectionResponseKeyMax).describe('Widget unique key'),
  "itemDefinitions": zod.array(zod.object({
  "id": zod.number().optional().describe('Item definition unique identifier'),
  "itemKey": zod.string().max(apiAdminwidgetsGetCollectionResponseItemDefinitionsItemItemKeyMax).describe('Configuration field key'),
  "itemType": zod.enum(['string', 'text', 'media', 'url', 'hsl_color', 'select']).describe('Data type of the configuration field'),
  "isRequired": zod.boolean().describe('Is this field required in the configuration form'),
  "defaultValue": zod.string().nullish().describe('Default value for this field'),
  "maxLength": zod.number().max(apiAdminwidgetsGetCollectionResponseItemDefinitionsItemMaxLengthMax).nullish().describe('Maximum length for string fields'),
  "options": zod.array(zod.string()).nullish().describe('Allowed values, required for \"select\" items'),
  "itemLabel": zod.string().max(apiAdminwidgetsGetCollectionResponseItemDefinitionsItemItemLabelMax).describe('Label for the configuration field'),
  "itemDescription": zod.string().max(apiAdminwidgetsGetCollectionResponseItemDefinitionsItemItemDescriptionMax).nullish().describe('Description of the configuration field'),
  "itemPlaceholder": zod.string().max(apiAdminwidgetsGetCollectionResponseItemDefinitionsItemItemPlaceholderMax).nullish().describe('Placeholder text for the input field')
})).optional()
}).describe('Retrieve a list of widgets and their definitions')
export const apiAdminwidgetsGetCollectionResponse = zod.array(apiAdminwidgetsGetCollectionResponseItem)


/**
 * Create a new widget with definitions
 * @summary Create a new widget with definitions
 */
export const apiAdminwidgetsPostBodyLabelMax = 50;

export const apiAdminwidgetsPostBodyKeyMax = 50;

export const apiAdminwidgetsPostBodyItemDefinitionsItemItemKeyMax = 100;

export const apiAdminwidgetsPostBodyItemDefinitionsItemItemTypeMax = 20;

export const apiAdminwidgetsPostBodyItemDefinitionsItemMaxLengthMax = 255;

export const apiAdminwidgetsPostBodyItemDefinitionsItemItemLabelMax = 255;

export const apiAdminwidgetsPostBodyItemDefinitionsItemItemDescriptionMax = 255;

export const apiAdminwidgetsPostBodyItemDefinitionsItemItemPlaceholderMax = 50;



export const apiAdminwidgetsPostBody = zod.object({
  "label": zod.string().max(apiAdminwidgetsPostBodyLabelMax).describe('Widget label'),
  "key": zod.string().max(apiAdminwidgetsPostBodyKeyMax).describe('Widget unique key'),
  "itemDefinitions": zod.array(zod.object({
  "itemKey": zod.string().max(apiAdminwidgetsPostBodyItemDefinitionsItemItemKeyMax).describe('Configuration field key'),
  "itemType": zod.enum(['string', 'text', 'media', 'url', 'hsl_color', 'select']).describe('Data type of the configuration field'),
  "isRequired": zod.boolean().describe('Is this field required in the configuration form'),
  "defaultValue": zod.string().nullish().describe('Default value for this field'),
  "maxLength": zod.number().max(apiAdminwidgetsPostBodyItemDefinitionsItemMaxLengthMax).nullish().describe('Maximum length for string fields'),
  "options": zod.array(zod.string()).nullish().describe('Allowed values, required for \"select\" items'),
  "itemLabel": zod.string().max(apiAdminwidgetsPostBodyItemDefinitionsItemItemLabelMax).describe('Label for the configuration field'),
  "itemDescription": zod.string().max(apiAdminwidgetsPostBodyItemDefinitionsItemItemDescriptionMax).nullish().describe('Description of the configuration field'),
  "itemPlaceholder": zod.string().max(apiAdminwidgetsPostBodyItemDefinitionsItemItemPlaceholderMax).nullish().describe('Placeholder text for the input field')
})).optional()
})


/**
 * Updates the WidgetItemConfiguration resource.
 * @summary Updates the WidgetItemConfiguration resource.
 */
export const apiAdminwidgetItemConfigurationsIdPatchParams = zod.object({
  "id": zod.string().describe('WidgetItemConfiguration identifier')
})

export const apiAdminwidgetItemConfigurationsIdPatchBodySlideIndexDefault = 1;
export const apiAdminwidgetItemConfigurationsIdPatchBodySlideIndexMax = 3;



export const apiAdminwidgetItemConfigurationsIdPatchBody = zod.object({
  "slideIndex": zod.number().min(1).max(apiAdminwidgetItemConfigurationsIdPatchBodySlideIndexMax).default(apiAdminwidgetItemConfigurationsIdPatchBodySlideIndexDefault).describe('Slide position (1 = default flat display, 2-3 = slider)'),
  "configValue": zod.string().nullish().describe('Value of the configuration field (media IRI for media items)'),
  "media": zod.string().nullish().describe('Media IRI for the widget item configuration')
})

export const apiAdminwidgetItemConfigurationsIdPatchResponseSlideIndexDefault = 1;
export const apiAdminwidgetItemConfigurationsIdPatchResponseSlideIndexMax = 3;

export const apiAdminwidgetItemConfigurationsIdPatchResponseWidgetItemDefinitionItemKeyMax = 100;



export const apiAdminwidgetItemConfigurationsIdPatchResponse = zod.object({
  "id": zod.number().describe('Unique identifier for the widget item configuration'),
  "slideIndex": zod.number().min(1).max(apiAdminwidgetItemConfigurationsIdPatchResponseSlideIndexMax).describe('Slide position (1 = default flat display, 2-3 = slider)'),
  "computedKey": zod.string().nullish().describe('Derived key: itemKey for slide 1, itemKey.1 for slide 2, itemKey.2 for slide 3'),
  "configValue": zod.string().nullish().describe('Value of the configuration field (media IRI for media items)'),
  "widgetItemDefinition": zod.object({
  "id": zod.number().optional().describe('Item definition unique identifier'),
  "itemKey": zod.string().max(apiAdminwidgetItemConfigurationsIdPatchResponseWidgetItemDefinitionItemKeyMax).describe('Configuration field key')
})
})


/**
 * Link a widget to a workspace
 * @summary Link a widget to a workspace
 */
export const apiAdminwidgetWorkspacesPostBodyNameMax = 100;

export const apiAdminwidgetWorkspacesPostBodySortOrderMin = 0;



export const apiAdminwidgetWorkspacesPostBody = zod.object({
  "name": zod.string().max(apiAdminwidgetWorkspacesPostBodyNameMax).describe('Display name for this widget instance in the workspace'),
  "isActive": zod.boolean().describe('Whether the widget is active for this workspace'),
  "startAt": zod.string().datetime({}).nullish().describe('Display start date. Null = displayed as soon as the widget is saved.'),
  "endAt": zod.string().datetime({}).nullish().describe('Display end date. Null = displayed indefinitely.'),
  "sortOrder": zod.number().min(apiAdminwidgetWorkspacesPostBodySortOrderMin).optional().describe('Display order of the block (ascending). Omitted on creation = appended after the existing blocks.'),
  "widget": zod.string().describe('The widget associated with this workspace')
})


/**
 * Removes the WidgetWorkspace resource.
 * @summary Removes the WidgetWorkspace resource.
 */
export const apiAdminwidgetWorkspacesIdDeleteParams = zod.object({
  "id": zod.string().describe('WidgetWorkspace identifier')
})


/**
 * Provide `slideIndex` (1-3) and `patchConfigurations` to replace all configurations for that slide
 * @summary Update name, isActive, startAt/endAt, sortOrder, and/or all configs for one slide
 */
export const apiAdminwidgetWorkspacesIdPatchParams = zod.object({
  "id": zod.string().describe('WidgetWorkspace identifier')
})

export const apiAdminwidgetWorkspacesIdPatchBodyNameMax = 100;

export const apiAdminwidgetWorkspacesIdPatchBodySortOrderMin = 0;



export const apiAdminwidgetWorkspacesIdPatchBody = zod.object({
  "name": zod.string().max(apiAdminwidgetWorkspacesIdPatchBodyNameMax).optional().describe('Display name for this widget instance in the workspace'),
  "isActive": zod.boolean().optional().describe('Whether the widget is active for this workspace'),
  "startAt": zod.string().datetime({}).nullish().describe('Display start date. Null = displayed as soon as the widget is saved.'),
  "endAt": zod.string().datetime({}).nullish().describe('Display end date. Null = displayed indefinitely.'),
  "sortOrder": zod.number().min(apiAdminwidgetWorkspacesIdPatchBodySortOrderMin).optional().describe('Display order of the block (ascending). Omitted on creation = appended after the existing blocks.'),
  "slideIndex": zod.number().nullish().describe('PATCH only — slide to update (1-3). Must be paired with patchConfigurations.'),
  "patchConfigurations": zod.array(zod.object({
  "configValue": zod.string().nullish().describe('Value of the configuration field (media IRI for media items)'),
  "media": zod.string().nullish().describe('Media IRI for the widget item configuration'),
  "widgetItemDefinition": zod.string().optional().describe('Widget item definition IRI for the configuration')
})).optional()
})

export const apiAdminwidgetWorkspacesIdPatchResponseNameMax = 100;

export const apiAdminwidgetWorkspacesIdPatchResponseSortOrderMin = 0;

export const apiAdminwidgetWorkspacesIdPatchResponseWidgetLabelMax = 50;

export const apiAdminwidgetWorkspacesIdPatchResponseWidgetKeyMax = 50;

export const apiAdminwidgetWorkspacesIdPatchResponseWidgetItemConfigurationsItemSlideIndexDefault = 1;
export const apiAdminwidgetWorkspacesIdPatchResponseWidgetItemConfigurationsItemSlideIndexMax = 3;

export const apiAdminwidgetWorkspacesIdPatchResponseWidgetItemConfigurationsItemWidgetItemDefinitionItemKeyMax = 100;

export const apiAdminwidgetWorkspacesIdPatchResponseWidgetItemConfigurationsItemWidgetItemDefinitionItemTypeMax = 20;



export const apiAdminwidgetWorkspacesIdPatchResponse = zod.object({
  "id": zod.number().optional(),
  "name": zod.string().max(apiAdminwidgetWorkspacesIdPatchResponseNameMax).describe('Display name for this widget instance in the workspace'),
  "isActive": zod.boolean().describe('Whether the widget is active for this workspace'),
  "startAt": zod.string().datetime({}).nullish().describe('Display start date. Null = displayed as soon as the widget is saved.'),
  "endAt": zod.string().datetime({}).nullish().describe('Display end date. Null = displayed indefinitely.'),
  "sortOrder": zod.number().min(apiAdminwidgetWorkspacesIdPatchResponseSortOrderMin).optional().describe('Display order of the block (ascending). Omitted on creation = appended after the existing blocks.'),
  "widget": zod.object({
  "id": zod.number().describe('WidgetConfig ID'),
  "label": zod.string().max(apiAdminwidgetWorkspacesIdPatchResponseWidgetLabelMax).describe('Widget label'),
  "key": zod.string().max(apiAdminwidgetWorkspacesIdPatchResponseWidgetKeyMax).describe('Widget unique key')
}),
  "widgetItemConfigurations": zod.array(zod.object({
  "id": zod.number().describe('Unique identifier for the widget item configuration'),
  "slideIndex": zod.number().min(1).max(apiAdminwidgetWorkspacesIdPatchResponseWidgetItemConfigurationsItemSlideIndexMax).describe('Slide position (1 = default flat display, 2-3 = slider)'),
  "computedKey": zod.string().nullish().describe('Derived key: itemKey for slide 1, itemKey.1 for slide 2, itemKey.2 for slide 3'),
  "configValue": zod.string().nullish().describe('Value of the configuration field (media IRI for media items)'),
  "widgetItemDefinition": zod.object({
  "itemKey": zod.string().max(apiAdminwidgetWorkspacesIdPatchResponseWidgetItemConfigurationsItemWidgetItemDefinitionItemKeyMax).describe('Configuration field key'),
  "itemType": zod.enum(['string', 'text', 'media', 'url', 'hsl_color', 'select']).describe('Data type of the configuration field')
})
})).optional()
})


/**
 * Retrieves the collection of WidgetWorkspace resources.
 * @summary Retrieves the collection of WidgetWorkspace resources.
 */
export const apiWidgetWorkspacesGetCollectionResponseNameMax = 100;

export const apiWidgetWorkspacesGetCollectionResponseSortOrderMin = 0;

export const apiWidgetWorkspacesGetCollectionResponseWidgetLabelMax = 50;

export const apiWidgetWorkspacesGetCollectionResponseWidgetKeyMax = 50;

export const apiWidgetWorkspacesGetCollectionResponseWidgetItemConfigurationsItemSlideIndexDefault = 1;
export const apiWidgetWorkspacesGetCollectionResponseWidgetItemConfigurationsItemSlideIndexMax = 3;

export const apiWidgetWorkspacesGetCollectionResponseWidgetItemConfigurationsItemWidgetItemDefinitionItemKeyMax = 100;

export const apiWidgetWorkspacesGetCollectionResponseWidgetItemConfigurationsItemWidgetItemDefinitionItemTypeMax = 20;



export const apiWidgetWorkspacesGetCollectionResponseItem = zod.object({
  "id": zod.number().optional(),
  "name": zod.string().max(apiWidgetWorkspacesGetCollectionResponseNameMax).describe('Display name for this widget instance in the workspace'),
  "isActive": zod.boolean().describe('Whether the widget is active for this workspace'),
  "startAt": zod.string().datetime({}).nullish().describe('Display start date. Null = displayed as soon as the widget is saved.'),
  "endAt": zod.string().datetime({}).nullish().describe('Display end date. Null = displayed indefinitely.'),
  "sortOrder": zod.number().min(apiWidgetWorkspacesGetCollectionResponseSortOrderMin).optional().describe('Display order of the block (ascending). Omitted on creation = appended after the existing blocks.'),
  "widget": zod.object({
  "id": zod.number().describe('WidgetConfig ID'),
  "label": zod.string().max(apiWidgetWorkspacesGetCollectionResponseWidgetLabelMax).describe('Widget label'),
  "key": zod.string().max(apiWidgetWorkspacesGetCollectionResponseWidgetKeyMax).describe('Widget unique key')
}),
  "widgetItemConfigurations": zod.array(zod.object({
  "id": zod.number().describe('Unique identifier for the widget item configuration'),
  "slideIndex": zod.number().min(1).max(apiWidgetWorkspacesGetCollectionResponseWidgetItemConfigurationsItemSlideIndexMax).describe('Slide position (1 = default flat display, 2-3 = slider)'),
  "computedKey": zod.string().nullish().describe('Derived key: itemKey for slide 1, itemKey.1 for slide 2, itemKey.2 for slide 3'),
  "configValue": zod.string().nullish().describe('Value of the configuration field (media IRI for media items)'),
  "widgetItemDefinition": zod.object({
  "itemKey": zod.string().max(apiWidgetWorkspacesGetCollectionResponseWidgetItemConfigurationsItemWidgetItemDefinitionItemKeyMax).describe('Configuration field key'),
  "itemType": zod.enum(['string', 'text', 'media', 'url', 'hsl_color', 'select']).describe('Data type of the configuration field')
})
})).optional()
})
export const apiWidgetWorkspacesGetCollectionResponse = zod.array(apiWidgetWorkspacesGetCollectionResponseItem)


/**
 * Creates a Workspace resource.
 * @summary Creates a Workspace resource.
 */
export const inviteWorkspaceBodyNameMax = 50;

export const inviteWorkspaceBodyInvitedUserWorkspaceUniqueCodeMax = 50;


export const inviteWorkspaceBodyInvitedUserWorkspaceUniqueCodeRegExp = new RegExp('^([a-zA-Z0-9]+)$');
export const inviteWorkspaceBodyDomainMax = 255;


export const inviteWorkspaceBodyDomainRegExp = new RegExp('^((?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\\.)+[a-z0-9][a-z0-9-]{0,61}[a-z0-9])$');


export const inviteWorkspaceBody = zod.object({
  "name": zod.string().max(inviteWorkspaceBodyNameMax).describe('Workspace name'),
  "invitedUserWorkspace": zod.union([zod.object({
  "user": zod.string().describe('User IRI'),
  "uniqueCode": zod.string().min(1).max(inviteWorkspaceBodyInvitedUserWorkspaceUniqueCodeMax).regex(inviteWorkspaceBodyInvitedUserWorkspaceUniqueCodeRegExp).optional().describe('User unique code')
}),zod.null()]),
  "domain": zod.string().max(inviteWorkspaceBodyDomainMax).regex(inviteWorkspaceBodyDomainRegExp).describe('Workspace domain')
})


/**
 * Returns current logic workspace and the full logic collection for a given workspace
 * @summary Get workspace details (admin)
 */
export const getAdminWorkspaceParams = zod.object({
  "id": zod.string().describe('Workspace identifier')
})

export const getAdminWorkspaceResponseNameMax = 50;

export const getAdminWorkspaceResponseCurrentLogicWorkspaceLogicNameMax = 100;

export const getAdminWorkspaceResponseCurrentLogicWorkspaceLogicDescriptionMax = 100;

export const getAdminWorkspaceResponseCurrentLogicWorkspaceLogicTypeMax = 20;

export const getAdminWorkspaceResponseCurrentLogicWorkspaceStepsItemNameMax = 50;

export const getAdminWorkspaceResponseCurrentLogicWorkspaceStepsItemStepPointMin = 0;

export const getAdminWorkspaceResponseCurrentLogicWorkspaceTargetsItemReferenceMax = 20;

export const getAdminWorkspaceResponseCurrentLogicWorkspacePointExpirationDateMax = 100;

export const getAdminWorkspaceResponseDomainMax = 255;


export const getAdminWorkspaceResponseDomainRegExp = new RegExp('^((?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\\.)+[a-z0-9][a-z0-9-]{0,61}[a-z0-9])$');
export const getAdminWorkspaceResponsePreprodDomainDefault = "";export const getAdminWorkspaceResponseLogicsItemLogicNameMax = 100;

export const getAdminWorkspaceResponseLogicsItemLogicDescriptionMax = 100;

export const getAdminWorkspaceResponseLogicsItemLogicTypeMax = 20;

export const getAdminWorkspaceResponseLogicsItemStepsItemNameMax = 50;

export const getAdminWorkspaceResponseLogicsItemStepsItemStepPointMin = 0;

export const getAdminWorkspaceResponseLogicsItemTargetsItemReferenceMax = 20;

export const getAdminWorkspaceResponseLogicsItemPointExpirationDateMax = 100;

export const getAdminWorkspaceResponseStatusMax = 20;

export const getAdminWorkspaceResponseTypologiesItemNameMax = 100;

export const getAdminWorkspaceResponseActiveShopsItemDisplayNameMax = 100;



export const getAdminWorkspaceResponse = zod.object({
  "id": zod.number().describe('Workspace ID'),
  "name": zod.string().max(getAdminWorkspaceResponseNameMax).describe('Workspace name'),
  "currentLogicWorkspace": zod.union([zod.object({
  "id": zod.number().describe('Logic Workspace ID'),
  "logic": zod.object({
  "name": zod.string().max(getAdminWorkspaceResponseCurrentLogicWorkspaceLogicNameMax).describe('Name (label) of the logic'),
  "description": zod.string().max(getAdminWorkspaceResponseCurrentLogicWorkspaceLogicDescriptionMax).describe('Description (label) of the logic'),
  "type": zod.enum(['STEP', 'LINEAR', 'TARGET_PERF', 'TARGET_POINT'])
}),
  "startAt": zod.string().datetime({}).describe('Start datetime of the logic workspace'),
  "endAt": zod.string().datetime({}).describe('End datetime of the logic workspace'),
  "steps": zod.array(zod.object({
  "id": zod.number().optional().describe('Step ID'),
  "name": zod.string().max(getAdminWorkspaceResponseCurrentLogicWorkspaceStepsItemNameMax).describe('Step name'),
  "description": zod.string().nullish().describe('Step description'),
  "stepPoint": zod.number().min(getAdminWorkspaceResponseCurrentLogicWorkspaceStepsItemStepPointMin).describe('Value to complete the step')
})).optional(),
  "targets": zod.array(zod.object({
  "id": zod.number().optional().describe('Target ID'),
  "reference": zod.string().max(getAdminWorkspaceResponseCurrentLogicWorkspaceTargetsItemReferenceMax).describe('Target reference name'),
  "description": zod.string().nullish().describe('Target description (label)')
})).optional(),
  "pointExpirationDate": zod.string().max(getAdminWorkspaceResponseCurrentLogicWorkspacePointExpirationDateMax).describe('Point expiration date of the logic workspace')
}),zod.null()]).optional(),
  "isMaintenance": zod.boolean().optional(),
  "domain": zod.string().max(getAdminWorkspaceResponseDomainMax).regex(getAdminWorkspaceResponseDomainRegExp).describe('Workspace domain'),
  "preprodDomain": zod.string().optional().describe('Workspace preprod domain, used by the front-user preprod link'),
  "logics": zod.array(zod.object({
  "id": zod.number().describe('Logic Workspace ID'),
  "logic": zod.object({
  "name": zod.string().max(getAdminWorkspaceResponseLogicsItemLogicNameMax).describe('Name (label) of the logic'),
  "description": zod.string().max(getAdminWorkspaceResponseLogicsItemLogicDescriptionMax).describe('Description (label) of the logic'),
  "type": zod.enum(['STEP', 'LINEAR', 'TARGET_PERF', 'TARGET_POINT'])
}),
  "startAt": zod.string().datetime({}).describe('Start datetime of the logic workspace'),
  "endAt": zod.string().datetime({}).describe('End datetime of the logic workspace'),
  "steps": zod.array(zod.object({
  "id": zod.number().optional().describe('Step ID'),
  "name": zod.string().max(getAdminWorkspaceResponseLogicsItemStepsItemNameMax).describe('Step name'),
  "description": zod.string().nullish().describe('Step description'),
  "stepPoint": zod.number().min(getAdminWorkspaceResponseLogicsItemStepsItemStepPointMin).describe('Value to complete the step')
})).optional(),
  "targets": zod.array(zod.object({
  "id": zod.number().optional().describe('Target ID'),
  "reference": zod.string().max(getAdminWorkspaceResponseLogicsItemTargetsItemReferenceMax).describe('Target reference name'),
  "description": zod.string().nullish().describe('Target description (label)')
})).optional(),
  "pointExpirationDate": zod.string().max(getAdminWorkspaceResponseLogicsItemPointExpirationDateMax).describe('Point expiration date of the logic workspace')
})).optional(),
  "defaultEmailSender": zod.string().email().nullish().describe('Default email sender, used for sending emails'),
  "defaultHelpRecipient": zod.string().email().nullish().describe('Default help recipient, the email address where the help requests are sent'),
  "status": zod.enum(['active', 'draft', 'misconfigured']).optional().describe('Workspace status'),
  "typologies": zod.array(zod.object({
  "id": zod.number().describe('Typology ID'),
  "name": zod.string().max(getAdminWorkspaceResponseTypologiesItemNameMax).describe('Name of the typology')
})).optional(),
  "activeShops": zod.array(zod.object({
  "id": zod.number().describe('Shop ID'),
  "displayName": zod.string().max(getAdminWorkspaceResponseActiveShopsItemDisplayNameMax).describe('Shop display name')
})),
  "activeGamesCount": zod.number().describe('Number of active games')
})


/**
 * Replaces the Workspace resource.
 * @summary Replaces the Workspace resource.
 */
export const createWorkspaceParams = zod.object({
  "id": zod.string().describe('Workspace identifier')
})

export const createWorkspaceBodyNameMax = 50;

export const createWorkspaceBodyWorkspaceConfigsItemValueMax = 255;

export const createWorkspaceBodyCurrentLogicWorkspaceStepsItemNameMax = 50;

export const createWorkspaceBodyCurrentLogicWorkspaceStepsItemStepPointMin = 0;

export const createWorkspaceBodyCurrentLogicWorkspaceTargetsItemReferenceMax = 20;

export const createWorkspaceBodyCurrentLogicWorkspacePointExpirationDateMax = 100;

export const createWorkspaceBodyDomainMax = 255;


export const createWorkspaceBodyDomainRegExp = new RegExp('^((?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\\.)+[a-z0-9][a-z0-9-]{0,61}[a-z0-9])$');
export const createWorkspaceBodyStatusMax = 20;

export const createWorkspaceBodyTypologiesItemNameMax = 100;

export const createWorkspaceBodyTypologiesItemPointCoeffMin = 0;



export const createWorkspaceBody = zod.object({
  "name": zod.string().max(createWorkspaceBodyNameMax).describe('Workspace name'),
  "workspaceConfigs": zod.array(zod.object({
  "value": zod.string().max(createWorkspaceBodyWorkspaceConfigsItemValueMax).describe('WorkspaceConfig value'),
  "media": zod.string().nullish().describe('Media IRI linked to this config'),
  "config": zod.string().describe('Config IRI')
})).optional(),
  "currentLogicWorkspace": zod.union([zod.object({
  "logic": zod.string().describe('Logic ID'),
  "startAt": zod.string().datetime({}).describe('Start datetime of the logic workspace'),
  "endAt": zod.string().datetime({}).describe('End datetime of the logic workspace'),
  "steps": zod.array(zod.object({
  "name": zod.string().max(createWorkspaceBodyCurrentLogicWorkspaceStepsItemNameMax).optional().describe('Step name'),
  "description": zod.string().nullish().describe('Step description'),
  "stepPoint": zod.number().min(createWorkspaceBodyCurrentLogicWorkspaceStepsItemStepPointMin).optional().describe('Value to complete the step')
})).optional(),
  "targets": zod.array(zod.object({
  "reference": zod.string().max(createWorkspaceBodyCurrentLogicWorkspaceTargetsItemReferenceMax).describe('Target reference name'),
  "description": zod.string().nullish().describe('Target description (label)')
})).optional(),
  "pointExpirationDate": zod.string().max(createWorkspaceBodyCurrentLogicWorkspacePointExpirationDateMax).describe('Point expiration date of the logic workspace')
}),zod.null()]).optional(),
  "domain": zod.string().max(createWorkspaceBodyDomainMax).regex(createWorkspaceBodyDomainRegExp).describe('Workspace domain'),
  "defaultEmailSender": zod.string().email().nullish().describe('Default email sender, used for sending emails'),
  "defaultHelpRecipient": zod.string().email().nullish().describe('Default help recipient, the email address where the help requests are sent'),
  "status": zod.enum(['active', 'draft', 'misconfigured']).optional().describe('Workspace status'),
  "typologies": zod.array(zod.object({
  "name": zod.string().max(createWorkspaceBodyTypologiesItemNameMax).describe('Name of the typology'),
  "pointCoeff": zod.number().min(createWorkspaceBodyTypologiesItemPointCoeffMin).describe('Coefficient of the typology (conversion euros => points)'),
  "isDefault": zod.boolean().describe('Typology used by default')
})).optional()
})

export const createWorkspaceResponseNameMax = 50;

export const createWorkspaceResponseCurrentLogicWorkspaceLogicNameMax = 100;

export const createWorkspaceResponseCurrentLogicWorkspaceLogicDescriptionMax = 100;

export const createWorkspaceResponseCurrentLogicWorkspaceLogicTypeMax = 20;

export const createWorkspaceResponseCurrentLogicWorkspaceStepsItemNameMax = 50;

export const createWorkspaceResponseCurrentLogicWorkspaceStepsItemStepPointMin = 0;

export const createWorkspaceResponseCurrentLogicWorkspaceTargetsItemReferenceMax = 20;

export const createWorkspaceResponseCurrentLogicWorkspacePointExpirationDateMax = 100;

export const createWorkspaceResponseDomainMax = 255;


export const createWorkspaceResponseDomainRegExp = new RegExp('^((?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\\.)+[a-z0-9][a-z0-9-]{0,61}[a-z0-9])$');
export const createWorkspaceResponsePreprodDomainDefault = "";export const createWorkspaceResponseStatusMax = 20;

export const createWorkspaceResponseTypologiesItemNameMax = 100;

export const createWorkspaceResponseActiveShopsItemDisplayNameMax = 100;



export const createWorkspaceResponse = zod.object({
  "id": zod.number().describe('Workspace ID'),
  "name": zod.string().max(createWorkspaceResponseNameMax).describe('Workspace name'),
  "currentLogicWorkspace": zod.union([zod.object({
  "id": zod.number().describe('Logic Workspace ID'),
  "logic": zod.object({
  "name": zod.string().max(createWorkspaceResponseCurrentLogicWorkspaceLogicNameMax).describe('Name (label) of the logic'),
  "description": zod.string().max(createWorkspaceResponseCurrentLogicWorkspaceLogicDescriptionMax).describe('Description (label) of the logic'),
  "type": zod.enum(['STEP', 'LINEAR', 'TARGET_PERF', 'TARGET_POINT'])
}),
  "startAt": zod.string().datetime({}).describe('Start datetime of the logic workspace'),
  "endAt": zod.string().datetime({}).describe('End datetime of the logic workspace'),
  "steps": zod.array(zod.object({
  "id": zod.number().optional().describe('Step ID'),
  "name": zod.string().max(createWorkspaceResponseCurrentLogicWorkspaceStepsItemNameMax).describe('Step name'),
  "description": zod.string().nullish().describe('Step description'),
  "stepPoint": zod.number().min(createWorkspaceResponseCurrentLogicWorkspaceStepsItemStepPointMin).describe('Value to complete the step')
})).optional(),
  "targets": zod.array(zod.object({
  "id": zod.number().optional().describe('Target ID'),
  "reference": zod.string().max(createWorkspaceResponseCurrentLogicWorkspaceTargetsItemReferenceMax).describe('Target reference name'),
  "description": zod.string().nullish().describe('Target description (label)')
})).optional(),
  "pointExpirationDate": zod.string().max(createWorkspaceResponseCurrentLogicWorkspacePointExpirationDateMax).describe('Point expiration date of the logic workspace')
}),zod.null()]),
  "isMaintenance": zod.boolean().optional(),
  "domain": zod.string().max(createWorkspaceResponseDomainMax).regex(createWorkspaceResponseDomainRegExp).describe('Workspace domain'),
  "preprodDomain": zod.string().optional().describe('Workspace preprod domain, used by the front-user preprod link'),
  "status": zod.enum(['active', 'draft', 'misconfigured']).optional().describe('Workspace status'),
  "typologies": zod.array(zod.object({
  "id": zod.number().describe('Typology ID'),
  "name": zod.string().max(createWorkspaceResponseTypologiesItemNameMax).describe('Name of the typology')
})).optional(),
  "activeShops": zod.array(zod.object({
  "id": zod.number().describe('Shop ID'),
  "displayName": zod.string().max(createWorkspaceResponseActiveShopsItemDisplayNameMax).describe('Shop display name')
})),
  "activeGamesCount": zod.number().describe('Number of active games')
})


/**
 * Live DNS configuration of the workspace domain and email configuration of its default sender
 * @summary Get the DNS and email configurations of a workspace
 */
export const getWorkspaceConfigurationParams = zod.object({
  "id": zod.number().describe('Workspace identifier, must be the workspace the user is logged in')
})

export const getWorkspaceConfigurationResponse = zod.object({
  "status": zod.string().describe('Workspace status, aligned with the configurations when the workspace is published'),
  "dnsConfiguration": zod.object({
  "domain": zod.string().describe('Workspace domain'),
  "isValid": zod.boolean().describe('If the domain is resolving to the workspace website and verified'),
  "records": zod.array(zod.object({
  "purpose": zod.string().describe('What the record is used for'),
  "type": zod.string().describe('DNS record type'),
  "host": zod.string().describe('Record host, relative to the domain (\"@\" for the domain itself)'),
  "value": zod.string().describe('Expected record value'),
  "isValid": zod.boolean().describe('If the record is correctly set in the DNS zone')
}))
}),
  "emailConfiguration": zod.object({
  "domain": zod.string().describe('Domain authenticated on Brevo to send emails'),
  "isValid": zod.boolean().describe('If the domain is authenticated, all records are valid and the sender is active'),
  "isDomainAuthenticated": zod.boolean().describe('If Brevo has authenticated the domain'),
  "records": zod.array(zod.object({
  "purpose": zod.string().describe('What the record is used for'),
  "type": zod.string().describe('DNS record type'),
  "host": zod.string().describe('Record host, relative to the domain (\"@\" for the domain itself)'),
  "value": zod.string().describe('Expected record value'),
  "isValid": zod.boolean().describe('If the record is correctly set in the DNS zone')
})),
  "senderEmail": zod.string().nullable().describe('Default email sender of the workspace, null if not set'),
  "isSenderActive": zod.boolean().describe('If the default sender is active on Brevo')
})
}).describe('Live DNS and email configurations of a workspace, along with the workspace status they lead to')


/**
 * Active/Disable maintenance for current workspace
 * @summary Active/Disable maintenance for current workspace
 */
export const setMaintenanceParams = zod.object({
  "id": zod.string().describe('Workspace identifier')
})

export const setMaintenanceBody = zod.object({
  "isMaintenance": zod.boolean().optional()
})

export const setMaintenanceResponseNameMax = 50;

export const setMaintenanceResponseCurrentLogicWorkspaceLogicNameMax = 100;

export const setMaintenanceResponseCurrentLogicWorkspaceLogicDescriptionMax = 100;

export const setMaintenanceResponseCurrentLogicWorkspaceLogicTypeMax = 20;

export const setMaintenanceResponseCurrentLogicWorkspaceStepsItemNameMax = 50;

export const setMaintenanceResponseCurrentLogicWorkspaceStepsItemStepPointMin = 0;

export const setMaintenanceResponseCurrentLogicWorkspaceTargetsItemReferenceMax = 20;

export const setMaintenanceResponseCurrentLogicWorkspacePointExpirationDateMax = 100;

export const setMaintenanceResponseDomainMax = 255;


export const setMaintenanceResponseDomainRegExp = new RegExp('^((?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\\.)+[a-z0-9][a-z0-9-]{0,61}[a-z0-9])$');
export const setMaintenanceResponsePreprodDomainDefault = "";export const setMaintenanceResponseStatusMax = 20;

export const setMaintenanceResponseTypologiesItemNameMax = 100;

export const setMaintenanceResponseActiveShopsItemDisplayNameMax = 100;



export const setMaintenanceResponse = zod.object({
  "id": zod.number().describe('Workspace ID'),
  "name": zod.string().max(setMaintenanceResponseNameMax).describe('Workspace name'),
  "currentLogicWorkspace": zod.union([zod.object({
  "id": zod.number().describe('Logic Workspace ID'),
  "logic": zod.object({
  "name": zod.string().max(setMaintenanceResponseCurrentLogicWorkspaceLogicNameMax).describe('Name (label) of the logic'),
  "description": zod.string().max(setMaintenanceResponseCurrentLogicWorkspaceLogicDescriptionMax).describe('Description (label) of the logic'),
  "type": zod.enum(['STEP', 'LINEAR', 'TARGET_PERF', 'TARGET_POINT'])
}),
  "startAt": zod.string().datetime({}).describe('Start datetime of the logic workspace'),
  "endAt": zod.string().datetime({}).describe('End datetime of the logic workspace'),
  "steps": zod.array(zod.object({
  "id": zod.number().optional().describe('Step ID'),
  "name": zod.string().max(setMaintenanceResponseCurrentLogicWorkspaceStepsItemNameMax).describe('Step name'),
  "description": zod.string().nullish().describe('Step description'),
  "stepPoint": zod.number().min(setMaintenanceResponseCurrentLogicWorkspaceStepsItemStepPointMin).describe('Value to complete the step')
})).optional(),
  "targets": zod.array(zod.object({
  "id": zod.number().optional().describe('Target ID'),
  "reference": zod.string().max(setMaintenanceResponseCurrentLogicWorkspaceTargetsItemReferenceMax).describe('Target reference name'),
  "description": zod.string().nullish().describe('Target description (label)')
})).optional(),
  "pointExpirationDate": zod.string().max(setMaintenanceResponseCurrentLogicWorkspacePointExpirationDateMax).describe('Point expiration date of the logic workspace')
}),zod.null()]),
  "isMaintenance": zod.boolean().optional(),
  "domain": zod.string().max(setMaintenanceResponseDomainMax).regex(setMaintenanceResponseDomainRegExp).describe('Workspace domain'),
  "preprodDomain": zod.string().optional().describe('Workspace preprod domain, used by the front-user preprod link'),
  "status": zod.enum(['active', 'draft', 'misconfigured']).optional().describe('Workspace status'),
  "typologies": zod.array(zod.object({
  "id": zod.number().describe('Typology ID'),
  "name": zod.string().max(setMaintenanceResponseTypologiesItemNameMax).describe('Name of the typology')
})).optional(),
  "activeShops": zod.array(zod.object({
  "id": zod.number().describe('Shop ID'),
  "displayName": zod.string().max(setMaintenanceResponseActiveShopsItemDisplayNameMax).describe('Shop display name')
})),
  "activeGamesCount": zod.number().describe('Number of active games')
})


/**
 * Ask Vercel and Brevo to check the DNS records, then return the configurations like the GET endpoint
 * @summary Validate the DNS and email configurations of a workspace
 */
export const validateWorkspaceConfigurationParams = zod.object({
  "id": zod.number().describe('Workspace identifier, must be the workspace the user is logged in')
})

export const validateWorkspaceConfigurationBody = zod.object({

})

export const validateWorkspaceConfigurationResponse = zod.object({
  "status": zod.string().describe('Workspace status, aligned with the configurations when the workspace is published'),
  "dnsConfiguration": zod.object({
  "domain": zod.string().describe('Workspace domain'),
  "isValid": zod.boolean().describe('If the domain is resolving to the workspace website and verified'),
  "records": zod.array(zod.object({
  "purpose": zod.string().describe('What the record is used for'),
  "type": zod.string().describe('DNS record type'),
  "host": zod.string().describe('Record host, relative to the domain (\"@\" for the domain itself)'),
  "value": zod.string().describe('Expected record value'),
  "isValid": zod.boolean().describe('If the record is correctly set in the DNS zone')
}))
}),
  "emailConfiguration": zod.object({
  "domain": zod.string().describe('Domain authenticated on Brevo to send emails'),
  "isValid": zod.boolean().describe('If the domain is authenticated, all records are valid and the sender is active'),
  "isDomainAuthenticated": zod.boolean().describe('If Brevo has authenticated the domain'),
  "records": zod.array(zod.object({
  "purpose": zod.string().describe('What the record is used for'),
  "type": zod.string().describe('DNS record type'),
  "host": zod.string().describe('Record host, relative to the domain (\"@\" for the domain itself)'),
  "value": zod.string().describe('Expected record value'),
  "isValid": zod.boolean().describe('If the record is correctly set in the DNS zone')
})),
  "senderEmail": zod.string().nullable().describe('Default email sender of the workspace, null if not set'),
  "isSenderActive": zod.boolean().describe('If the default sender is active on Brevo')
})
}).describe('Live DNS and email configurations of a workspace, along with the workspace status they lead to')


/**
 * Retrieves a Workspace resource.
 * @summary Retrieves a Workspace resource.
 */
export const apiWorkspacesIdGetParams = zod.object({
  "id": zod.string().describe('Workspace identifier')
})

export const apiWorkspacesIdGetResponseNameMax = 50;

export const apiWorkspacesIdGetResponseCurrentLogicWorkspaceLogicNameMax = 100;

export const apiWorkspacesIdGetResponseCurrentLogicWorkspaceLogicDescriptionMax = 100;

export const apiWorkspacesIdGetResponseCurrentLogicWorkspaceLogicTypeMax = 20;

export const apiWorkspacesIdGetResponseCurrentLogicWorkspaceStepsItemNameMax = 50;

export const apiWorkspacesIdGetResponseCurrentLogicWorkspaceStepsItemStepPointMin = 0;

export const apiWorkspacesIdGetResponseCurrentLogicWorkspaceTargetsItemReferenceMax = 20;

export const apiWorkspacesIdGetResponseCurrentLogicWorkspacePointExpirationDateMax = 100;

export const apiWorkspacesIdGetResponseDomainMax = 255;


export const apiWorkspacesIdGetResponseDomainRegExp = new RegExp('^((?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\\.)+[a-z0-9][a-z0-9-]{0,61}[a-z0-9])$');
export const apiWorkspacesIdGetResponsePreprodDomainDefault = "";export const apiWorkspacesIdGetResponseStatusMax = 20;

export const apiWorkspacesIdGetResponseTypologiesItemNameMax = 100;

export const apiWorkspacesIdGetResponseActiveShopsItemDisplayNameMax = 100;



export const apiWorkspacesIdGetResponse = zod.object({
  "id": zod.number().describe('Workspace ID'),
  "name": zod.string().max(apiWorkspacesIdGetResponseNameMax).describe('Workspace name'),
  "currentLogicWorkspace": zod.union([zod.object({
  "id": zod.number().describe('Logic Workspace ID'),
  "logic": zod.object({
  "name": zod.string().max(apiWorkspacesIdGetResponseCurrentLogicWorkspaceLogicNameMax).describe('Name (label) of the logic'),
  "description": zod.string().max(apiWorkspacesIdGetResponseCurrentLogicWorkspaceLogicDescriptionMax).describe('Description (label) of the logic'),
  "type": zod.enum(['STEP', 'LINEAR', 'TARGET_PERF', 'TARGET_POINT'])
}),
  "startAt": zod.string().datetime({}).describe('Start datetime of the logic workspace'),
  "endAt": zod.string().datetime({}).describe('End datetime of the logic workspace'),
  "steps": zod.array(zod.object({
  "id": zod.number().optional().describe('Step ID'),
  "name": zod.string().max(apiWorkspacesIdGetResponseCurrentLogicWorkspaceStepsItemNameMax).describe('Step name'),
  "description": zod.string().nullish().describe('Step description'),
  "stepPoint": zod.number().min(apiWorkspacesIdGetResponseCurrentLogicWorkspaceStepsItemStepPointMin).describe('Value to complete the step')
})).optional(),
  "targets": zod.array(zod.object({
  "id": zod.number().optional().describe('Target ID'),
  "reference": zod.string().max(apiWorkspacesIdGetResponseCurrentLogicWorkspaceTargetsItemReferenceMax).describe('Target reference name'),
  "description": zod.string().nullish().describe('Target description (label)')
})).optional(),
  "pointExpirationDate": zod.string().max(apiWorkspacesIdGetResponseCurrentLogicWorkspacePointExpirationDateMax).describe('Point expiration date of the logic workspace')
}),zod.null()]),
  "isMaintenance": zod.boolean().optional(),
  "domain": zod.string().max(apiWorkspacesIdGetResponseDomainMax).regex(apiWorkspacesIdGetResponseDomainRegExp).describe('Workspace domain'),
  "preprodDomain": zod.string().optional().describe('Workspace preprod domain, used by the front-user preprod link'),
  "status": zod.enum(['active', 'draft', 'misconfigured']).optional().describe('Workspace status'),
  "typologies": zod.array(zod.object({
  "id": zod.number().describe('Typology ID'),
  "name": zod.string().max(apiWorkspacesIdGetResponseTypologiesItemNameMax).describe('Name of the typology')
})).optional(),
  "activeShops": zod.array(zod.object({
  "id": zod.number().describe('Shop ID'),
  "displayName": zod.string().max(apiWorkspacesIdGetResponseActiveShopsItemDisplayNameMax).describe('Shop display name')
})),
  "activeGamesCount": zod.number().describe('Number of active games')
})


/**
 * Get workspace configs paginated
 * @summary Get workspace configs paginated
 */
export const adminWorkspaceConfigsQueryPageDefault = 1;export const adminWorkspaceConfigsQueryPerPageDefault = 30;
export const adminWorkspaceConfigsQueryPerPageMin = 0;
export const adminWorkspaceConfigsQueryPerPageMax = 30;



export const adminWorkspaceConfigsQueryParams = zod.object({
  "page": zod.number().default(adminWorkspaceConfigsQueryPageDefault).describe('The collection page number'),
  "perPage": zod.number().min(adminWorkspaceConfigsQueryPerPageMin).max(adminWorkspaceConfigsQueryPerPageMax).default(adminWorkspaceConfigsQueryPerPageDefault).describe('The number of items per page'),
  "config.type": zod.string().optional(),
  "config.type[]": zod.array(zod.string()).optional(),
  "config.key": zod.string().optional(),
  "config.key[]": zod.array(zod.string()).optional()
})

export const adminWorkspaceConfigsResponseDataItemValueMax = 255;

export const adminWorkspaceConfigsResponseDataItemConfigTypeMax = 20;

export const adminWorkspaceConfigsResponseDataItemConfigKeyMax = 30;

export const adminWorkspaceConfigsResponseDataItemConfigTitleMax = 255;

export const adminWorkspaceConfigsResponseDataItemConfigDescriptionMax = 255;



export const adminWorkspaceConfigsResponse = zod.object({
  "data": zod.array(zod.unknown()),
  "pagination": zod.object({
  "first": zod.number(),
  "current": zod.number(),
  "last": zod.number(),
  "previous": zod.number(),
  "next": zod.number(),
  "totalItems": zod.number(),
  "perPage": zod.number()
})
}).and(zod.object({
  "data": zod.array(zod.object({
  "id": zod.number().describe('WorkspaceConfig ID'),
  "value": zod.string().max(adminWorkspaceConfigsResponseDataItemValueMax).describe('WorkspaceConfig value'),
  "media": zod.string().nullish().describe('Media IRI linked to this config'),
  "config": zod.object({
  "id": zod.number().optional().describe('Config ID'),
  "type": zod.enum(['core', 'media', 'style', 'shop', 'link']).describe('Config type'),
  "key": zod.string().max(adminWorkspaceConfigsResponseDataItemConfigKeyMax).describe('Config key'),
  "isPublic": zod.boolean().describe('If this config need to be used on public views (like auth page)'),
  "isSecret": zod.boolean().describe('If this config is secret (like API keys)'),
  "title": zod.string().max(adminWorkspaceConfigsResponseDataItemConfigTitleMax).describe('Config title'),
  "description": zod.string().max(adminWorkspaceConfigsResponseDataItemConfigDescriptionMax).describe('Config description')
})
})).optional()
}))


/**
 * Add new workspace config
 * @summary Add new workspace config
 */
export const apiAdminworkspaceConfigsPostBodyValueMax = 255;



export const apiAdminworkspaceConfigsPostBody = zod.object({
  "value": zod.string().max(apiAdminworkspaceConfigsPostBodyValueMax).describe('WorkspaceConfig value'),
  "media": zod.string().nullish().describe('Media IRI linked to this config'),
  "config": zod.string().describe('Config IRI')
})


/**
 * Delete workspace config
 * @summary Delete workspace config
 */
export const apiAdminworkspaceConfigsIdDeleteParams = zod.object({
  "id": zod.string().describe('WorkspaceConfig identifier')
})


/**
 * Update workspace config
 * @summary Update workspace config
 */
export const apiAdminworkspaceConfigsIdPatchParams = zod.object({
  "id": zod.string().describe('WorkspaceConfig identifier')
})

export const apiAdminworkspaceConfigsIdPatchBodyValueMax = 255;



export const apiAdminworkspaceConfigsIdPatchBody = zod.object({
  "value": zod.string().max(apiAdminworkspaceConfigsIdPatchBodyValueMax).optional().describe('WorkspaceConfig value'),
  "media": zod.string().nullish().describe('Media IRI linked to this config')
})

export const apiAdminworkspaceConfigsIdPatchResponseValueMax = 255;

export const apiAdminworkspaceConfigsIdPatchResponseConfigTypeMax = 20;

export const apiAdminworkspaceConfigsIdPatchResponseConfigKeyMax = 30;

export const apiAdminworkspaceConfigsIdPatchResponseConfigTitleMax = 255;

export const apiAdminworkspaceConfigsIdPatchResponseConfigDescriptionMax = 255;



export const apiAdminworkspaceConfigsIdPatchResponse = zod.object({
  "id": zod.number().describe('WorkspaceConfig ID'),
  "value": zod.string().max(apiAdminworkspaceConfigsIdPatchResponseValueMax).describe('WorkspaceConfig value'),
  "media": zod.string().nullish().describe('Media IRI linked to this config'),
  "config": zod.object({
  "id": zod.number().optional().describe('Config ID'),
  "type": zod.enum(['core', 'media', 'style', 'shop', 'link']).describe('Config type'),
  "key": zod.string().max(apiAdminworkspaceConfigsIdPatchResponseConfigKeyMax).describe('Config key'),
  "isPublic": zod.boolean().describe('If this config need to be used on public views (like auth page)'),
  "isSecret": zod.boolean().describe('If this config is secret (like API keys)'),
  "title": zod.string().max(apiAdminworkspaceConfigsIdPatchResponseConfigTitleMax).describe('Config title'),
  "description": zod.string().max(apiAdminworkspaceConfigsIdPatchResponseConfigDescriptionMax).describe('Config description')
})
})


/**
 * Updates styles of a workspace
 * @deprecated
 * @summary Updates styles of a workspace
 */
export const customizerBodyWorkspaceConfigsItemValueMax = 255;



export const customizerBody = zod.object({
  "workspaceConfigs": zod.array(zod.object({
  "value": zod.string().max(customizerBodyWorkspaceConfigsItemValueMax).describe('WorkspaceConfig value'),
  "media": zod.string().nullish().describe('Media IRI linked to this config'),
  "config": zod.string().describe('Config IRI')
})).optional()
})

export const customizerResponseNameMax = 50;

export const customizerResponseCurrentLogicWorkspaceLogicNameMax = 100;

export const customizerResponseCurrentLogicWorkspaceLogicDescriptionMax = 100;

export const customizerResponseCurrentLogicWorkspaceLogicTypeMax = 20;

export const customizerResponseCurrentLogicWorkspaceStepsItemNameMax = 50;

export const customizerResponseCurrentLogicWorkspaceStepsItemStepPointMin = 0;

export const customizerResponseCurrentLogicWorkspaceTargetsItemReferenceMax = 20;

export const customizerResponseCurrentLogicWorkspacePointExpirationDateMax = 100;

export const customizerResponseDomainMax = 255;


export const customizerResponseDomainRegExp = new RegExp('^((?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\\.)+[a-z0-9][a-z0-9-]{0,61}[a-z0-9])$');
export const customizerResponsePreprodDomainDefault = "";export const customizerResponseStatusMax = 20;

export const customizerResponseTypologiesItemNameMax = 100;

export const customizerResponseActiveShopsItemDisplayNameMax = 100;



export const customizerResponse = zod.object({
  "id": zod.number().describe('Workspace ID'),
  "name": zod.string().max(customizerResponseNameMax).describe('Workspace name'),
  "currentLogicWorkspace": zod.union([zod.object({
  "id": zod.number().describe('Logic Workspace ID'),
  "logic": zod.object({
  "name": zod.string().max(customizerResponseCurrentLogicWorkspaceLogicNameMax).describe('Name (label) of the logic'),
  "description": zod.string().max(customizerResponseCurrentLogicWorkspaceLogicDescriptionMax).describe('Description (label) of the logic'),
  "type": zod.enum(['STEP', 'LINEAR', 'TARGET_PERF', 'TARGET_POINT'])
}),
  "startAt": zod.string().datetime({}).describe('Start datetime of the logic workspace'),
  "endAt": zod.string().datetime({}).describe('End datetime of the logic workspace'),
  "steps": zod.array(zod.object({
  "id": zod.number().optional().describe('Step ID'),
  "name": zod.string().max(customizerResponseCurrentLogicWorkspaceStepsItemNameMax).describe('Step name'),
  "description": zod.string().nullish().describe('Step description'),
  "stepPoint": zod.number().min(customizerResponseCurrentLogicWorkspaceStepsItemStepPointMin).describe('Value to complete the step')
})).optional(),
  "targets": zod.array(zod.object({
  "id": zod.number().optional().describe('Target ID'),
  "reference": zod.string().max(customizerResponseCurrentLogicWorkspaceTargetsItemReferenceMax).describe('Target reference name'),
  "description": zod.string().nullish().describe('Target description (label)')
})).optional(),
  "pointExpirationDate": zod.string().max(customizerResponseCurrentLogicWorkspacePointExpirationDateMax).describe('Point expiration date of the logic workspace')
}),zod.null()]),
  "isMaintenance": zod.boolean().optional(),
  "domain": zod.string().max(customizerResponseDomainMax).regex(customizerResponseDomainRegExp).describe('Workspace domain'),
  "preprodDomain": zod.string().optional().describe('Workspace preprod domain, used by the front-user preprod link'),
  "status": zod.enum(['active', 'draft', 'misconfigured']).optional().describe('Workspace status'),
  "typologies": zod.array(zod.object({
  "id": zod.number().describe('Typology ID'),
  "name": zod.string().max(customizerResponseTypologiesItemNameMax).describe('Name of the typology')
})).optional(),
  "activeShops": zod.array(zod.object({
  "id": zod.number().describe('Shop ID'),
  "displayName": zod.string().max(customizerResponseActiveShopsItemDisplayNameMax).describe('Shop display name')
})),
  "activeGamesCount": zod.number().describe('Number of active games')
})


/**
 * Get workspace configs
 * @summary Get workspace configs
 */
export const apiWorkspaceConfigsGetCollectionHeader = zod.object({
  "App-ID": zod.string().optional().describe('App-ID')
})

export const apiWorkspaceConfigsGetCollectionResponse = zod.object({
  "groupedConfigs": zod.union([zod.record(zod.string(), zod.record(zod.string(), zod.string())),zod.null()])
})
